const translate = {
  id: {
    en: 'ID',
    es: 'ID',
    fr: 'ID',
    de: 'ID',
    pt: 'ID',
    pl: 'ID',
    nl: 'ID',
    el: 'Ταυτότητα',
    cs: 'ID',
    sv: 'ID',
    hu: 'Azonosító',
    da: 'ID',
    fi: 'ID',
    sk: 'ID',
    bg: 'Идент. номер',
    hr: 'ID',
    lt: 'ID',
    lv: 'ID',
    et: 'ID',
    sl: 'ID',
    ga: 'ID',
    mt: 'ID',
    cy: 'ID',
    ro: 'ID',
    it: 'ID',
    zh_cn: '编号',
    hi: 'आईडी',
    ar: 'الهوية',
    bn: 'আইডি',
    ru: 'ИД',
    ja: 'ID',
    tr: 'ID',
    ko: 'ID',
    vi: 'ID',
    id: 'ID',
    th: 'รหัส',
    ms: 'ID',
    ar_eg: 'الهوية',
    uk: 'ID',
  },
  name: {
    en: 'Name',
    es: 'Nombre',
    fr: 'Nom',
    de: 'Name',
    pt: 'Nome',
    pl: 'Nazwa',
    nl: 'Naam',
    el: 'Όνομα',
    cs: 'Jméno',
    sv: 'Namn',
    hu: 'Név',
    da: 'Navn',
    fi: 'Nimi',
    sk: 'Meno',
    bg: 'Име',
    hr: 'Ime',
    lt: 'Vardas',
    lv: 'Vārds',
    et: 'Nimi',
    sl: 'Ime',
    ga: 'Ainm',
    mt: 'Isem',
    cy: 'Enw',
    ro: 'Nume',
    it: 'Nome',
    zh_cn: '名称',
    hi: 'नाम',
    ar: 'الاسم',
    bn: 'নাম',
    ru: 'Имя',
    ja: '名前',
    tr: 'Ad',
    ko: '이름',
    vi: 'Tên',
    id: 'Nama',
    th: 'ชื่อ',
    ms: 'Nama',
    ar_eg: 'الاسم',
    uk: "Ім'я",
  },
  surname: {
    en: 'Surname',
    es: 'Apellido',
    fr: 'Nom de famille',
    de: 'Nachname',
    pt: 'Sobrenome',
    pl: 'Nazwisko',
    nl: 'Achternaam',
    el: 'Επώνυμο',
    cs: 'Příjmení',
    sv: 'Efternamn',
    hu: 'Vezetéknév',
    da: 'Efternavn',
    fi: 'Sukunimi',
    sk: 'Priezvisko',
    bg: 'Фамилия',
    hr: 'Prezime',
    lt: 'Pavardė',
    lv: 'Uzvārds',
    et: 'Perekonnanimi',
    sl: 'Priimek',
    ga: 'Sloinne',
    mt: 'Kunjom',
    cy: 'Cyfenw',
    ro: 'Prenume',
    it: 'Cognome',
    zh_cn: '姓',
    hi: 'उपनाम',
    ar: 'اللقب',
    bn: 'পদবী',
    ru: 'Фамилия',
    ja: '苗字',
    tr: 'Soyadı',
    ko: '성',
    vi: 'Họ',
    id: 'Nama Belakang',
    th: 'นามสกุล',
    ms: 'Nama Keluarga',
    ar_eg: 'اسم العائلة',
    uk: 'Прізвище',
  },
  status: {
    en: 'Status',
    es: 'Estado',
    fr: 'Statut',
    de: 'Status',
    pt: 'Estado',
    pl: 'Status',
    nl: 'Status',
    el: 'Κατάσταση',
    cs: 'Stav',
    sv: 'Status',
    hu: 'Állapot',
    da: 'Status',
    fi: 'Tila',
    sk: 'Stav',
    bg: 'Статус',
    hr: 'Status',
    lt: 'Būsena',
    lv: 'Statuss',
    et: 'Staatus',
    sl: 'Status',
    ga: 'Stádas',
    mt: 'Status',
    cy: 'Statws',
    ro: 'Stare',
    it: 'Stato',
    zh_cn: '状态',
    hi: 'स्थिति',
    ar: 'الحالة',
    bn: 'স্ট্যাটাস',
    ru: 'Статус',
    ja: 'ステータス',
    tr: 'Durum',
    ko: '상태',
    vi: 'Trạng thái',
    id: 'Status',
    th: 'สถานะ',
    ms: 'Status',
    ar_eg: 'الحالة',
    uk: 'Статус',
  },
  active: {
    en: 'Active',
    es: 'Activo',
    fr: 'Actif',
    de: 'Aktiv',
    pt: 'Ativo',
    pl: 'Aktywny',
    nl: 'Actief',
    el: 'Ενεργός',
    cs: 'Aktivní',
    sv: 'Aktiv',
    hu: 'Aktív',
    da: 'Aktiv',
    fi: 'Aktiivinen',
    sk: 'Aktívny',
    bg: 'Активен',
    hr: 'Aktivan',
    lt: 'Aktyvus',
    lv: 'Aktīvs',
    et: 'Aktiivne',
    sl: 'Aktiven',
    ga: 'Gníomhach',
    mt: 'Attiv',
    cy: 'Gweithgar',
    ro: 'Activ',
    it: 'Attivo',
    zh_cn: '活跃',
    hi: 'सक्रिय',
    ar: 'نشط',
    bn: 'সক্রিয়',
    ru: 'Активный',
    ja: 'アクティブ',
    tr: 'Aktif',
    ko: '활성',
    vi: 'Hoạt động',
    id: 'Aktif',
    th: 'ใช้งานอยู่',
    ms: 'Aktif',
    ar_eg: 'نشط',
    uk: 'Активний',
  },
  menu: {
    en: 'Menu',
    es: 'Menú',
    fr: 'Menu',
    de: 'Menü',
    pt: 'Menu',
    pl: 'Menu',
    nl: 'Menu',
    el: 'Μενού',
    cs: 'Menu',
    sv: 'Meny',
    hu: 'Menü',
    da: 'Menu',
    fi: 'Valikko',
    sk: 'Menu',
    bg: 'Меню',
    hr: 'Meni',
    lt: 'Meniu',
    lv: 'Ēdienkarte',
    et: 'Menüü',
    sl: 'Meni',
    ga: 'Roghchlár',
    mt: 'Menu',
    cy: 'Dewislen',
    ro: 'Meniu',
    it: 'Menu',
    zh_cn: '菜单',
    hi: 'मेन्यू',
    ar: 'القائمة',
    bn: 'মেনু',
    ru: 'Меню',
    ja: 'メニュー',
    tr: 'Menü',
    ko: '메뉴',
    vi: 'Thực đơn',
    id: 'Menu',
    th: 'เมนู',
    ms: 'Menu',
    ar_eg: 'قائمة',
    uk: 'Меню',
  },
  item: {
    en: 'Item',
    es: 'Artículo',
    fr: 'Article',
    de: 'Artikel',
    pt: 'Item',
    pl: 'Przedmiot',
    nl: 'Item',
    el: 'Αντικείμενο',
    cs: 'Položka',
    sv: 'Artikel',
    hu: 'Tétel',
    da: 'Vare',
    fi: 'Tuote',
    sk: 'Položka',
    bg: 'Артикул',
    hr: 'Stavka',
    lt: 'Prekė',
    lv: 'Vienums',
    et: 'Üksus',
    sl: 'Izdelek',
    ga: 'Mír',
    mt: 'Oġġett',
    cy: 'Eitem',
    ro: 'Articol',
    it: 'Voce',
    zh_cn: '项目',
    hi: 'आइटम',
    ar: 'عنصر',
    bn: 'আইটেম',
    ru: 'Пункт',
    ja: 'アイテム',
    tr: 'Öğe',
    ko: '항목',
    vi: 'Mục',
    id: 'Item',
    th: 'รายการ',
    ms: 'Item',
    ar_eg: 'عنصر',
    uk: 'Предмет',
  },
  modifier: {
    en: 'Modifier',
    es: 'Modificador',
    fr: 'Modificateur',
    de: 'Modifikator',
    pt: 'Modificador',
    pl: 'Modyfikator',
    nl: 'Modificator',
    el: 'Τροποποιητής',
    cs: 'Modifikátor',
    sv: 'Modifierare',
    hu: 'Módosító',
    da: 'Modifikator',
    fi: 'Muunnin',
    sk: 'Modifikátor',
    bg: 'Модификатор',
    hr: 'Modifikator',
    lt: 'Modifikatorius',
    lv: 'Modifikators',
    et: 'Modifikaator',
    sl: 'Modifikator',
    ga: 'Modhnóir',
    mt: 'Modifikatur',
    cy: 'Addasydd',
    ro: 'Modificator',
    it: 'Modificatore',
    zh_cn: '修饰符',
    hi: 'संशोधक',
    ar: 'معدل',
    bn: 'মডিফায়ার',
    ru: 'Модификатор',
    ja: '修正子',
    tr: 'Düzenleyici',
    ko: '수정자',
    vi: 'Bộ điều chỉnh',
    id: 'Modifikator',
    th: 'ตัวปรับแต่ง',
    ms: 'Pengubah suai',
    ar_eg: 'المعدل',
    uk: 'Модифікатор',
  },
  cancel: {
    en: 'Cancel',
    es: 'Cancelar',
    fr: 'Annuler',
    de: 'Abbrechen',
    pt: 'Cancelar',
    pl: 'Anuluj',
    nl: 'Annuleren',
    el: 'Ακύρωση',
    cs: 'Zrušit',
    sv: 'Avbryt',
    hu: 'Mégsem',
    da: 'Annuller',
    fi: 'Peruuta',
    sk: 'Zrušiť',
    bg: 'Отказ',
    hr: 'Otkaži',
    lt: 'Atšaukti',
    lv: 'Atcelt',
    et: 'Tühista',
    sl: 'Prekliči',
    ga: 'Cealaigh',
    mt: 'Ikkanċella',
    cy: 'Canslo',
    ro: 'Anulează',
    it: 'Annulla',
    zh_cn: '取消',
    hi: 'रद्द करें',
    ar: 'إلغاء',
    bn: 'বাতিল',
    ru: 'Отмена',
    ja: 'キャンセル',
    tr: 'İptal',
    ko: '취소',
    vi: 'Hủy',
    id: 'Batal',
    th: 'ยกเลิก',
    ms: 'Batal',
    ar_eg: 'إلغاء',
    uk: 'Скасувати',
  },
  save: {
    en: 'Save',
    es: 'Guardar',
    fr: 'Enregistrer',
    de: 'Speichern',
    pt: 'Salvar',
    pl: 'Zapisz',
    nl: 'Opslaan',
    el: 'Αποθήκευση',
    cs: 'Uložit',
    sv: 'Spara',
    hu: 'Mentés',
    da: 'Gem',
    fi: 'Tallenna',
    sk: 'Uložiť',
    bg: 'Запази',
    hr: 'Spremi',
    lt: 'Išsaugoti',
    lv: 'Saglabāt',
    et: 'Salvesta',
    sl: 'Shrani',
    ga: 'Sábháil',
    mt: 'Salva',
    cy: 'Arbed',
    ro: 'Salvează',
    it: 'Salva',
    zh_cn: '保存',
    hi: 'सहेजें',
    ar: 'حفظ',
    bn: 'সংরক্ষণ',
    ru: 'Сохранить',
    ja: '保存',
    tr: 'Kaydet',
    ko: '저장',
    vi: 'Lưu',
    id: 'Simpan',
    th: 'บันทึก',
    ms: 'Simpan',
    ar_eg: 'حفظ',
    uk: 'Зберегти',
  },
  update: {
    en: 'Update',
    es: 'Actualizar',
    fr: 'Mettre à jour',
    de: 'Aktualisieren',
    pt: 'Atualizar',
    pl: 'Aktualizuj',
    nl: 'Bijwerken',
    el: 'Ενημέρωση',
    cs: 'Aktualizovat',
    sv: 'Uppdatera',
    hu: 'Frissítés',
    da: 'Opdater',
    fi: 'Päivitä',
    sk: 'Aktualizovať',
    bg: 'Актуализация',
    hr: 'Ažuriraj',
    lt: 'Atnaujinti',
    lv: 'Atjaunot',
    et: 'Uuenda',
    sl: 'Posodobi',
    ga: 'Nuashonrú',
    mt: 'Aġġorna',
    cy: 'Diweddaru',
    ro: 'Actualizează',
    it: 'Aggiorna',
    zh_cn: '更新',
    hi: 'अपडेट करें',
    ar: 'تحديث',
    bn: 'হালনাগাদ',
    ru: 'Обновить',
    ja: '更新',
    tr: 'Güncelle',
    ko: '업데이트',
    vi: 'Cập nhật',
    id: 'Perbarui',
    th: 'อัปเดต',
    ms: 'Kemas kini',
    ar_eg: 'تحديث',
    uk: 'Оновити',
  },
  error: {
    en: 'Error',
    es: 'Error',
    fr: 'Erreur',
    de: 'Fehler',
    pt: 'Erro',
    pl: 'Błąd',
    nl: 'Fout',
    el: 'Σφάλμα',
    cs: 'Chyba',
    sv: 'Fel',
    hu: 'Hiba',
    da: 'Fejl',
    fi: 'Virhe',
    sk: 'Chyba',
    bg: 'Грешка',
    hr: 'Greška',
    lt: 'Klaida',
    lv: 'Kļūda',
    et: 'Viga',
    sl: 'Napaka',
    ga: 'Earráid',
    mt: 'Żball',
    cy: 'Gwall',
    ro: 'Eroare',
    it: 'Errore',
    zh_cn: '错误',
    hi: 'त्रुटि',
    ar: 'خطأ',
    bn: 'ভুল',
    ru: 'Ошибка',
    ja: 'エラー',
    tr: 'Hata',
    ko: '오류',
    vi: 'Lỗi',
    id: 'Kesalahan',
    th: 'ข้อผิดพลาด',
    ms: 'Ralat',
    ar_eg: 'خطأ',
    uk: 'Помилка',
  },
  errors: {
    max_file_size: {
      en: 'Please choose an image with the size lower than %s',
      es: 'Por favor, elija una imagen con un tamaño inferior a %s',
      fr: 'Veuillez choisir une image d’une taille inférieure à %s',
      de: 'Bitte wählen Sie ein Bild mit einer Größe unter %s',
      pt: 'Por favor, escolha uma imagem com tamanho inferior a %s',
      pl: 'Wybierz obraz o rozmiarze mniejszym niż %s',
      nl: 'Kies een afbeelding kleiner dan %s',
      el: 'Επιλέξτε μια εικόνα με μέγεθος μικρότερο από %s',
      cs: 'Vyberte prosím obrázek menší než %s',
      sv: 'Välj en bild som är mindre än %s',
      hu: 'Kérjük, válasszon egy képet, amely kisebb, mint %s',
      da: 'Vælg venligst et billede, der er mindre end %s',
      fi: 'Valitse kuva, jonka koko on alle %s',
      sk: 'Zvoľte obrázok s veľkosťou menšou ako %s',
      bg: 'Моля, изберете изображение с размер под %s',
      hr: 'Odaberite sliku veličine manje od %s',
      lt: 'Pasirinkite vaizdą, kurio dydis mažesnis nei %s',
      lv: 'Lūdzu, izvēlieties attēlu, kas ir mazāks par %s',
      et: 'Palun valige pilt, mille suurus on alla %s',
      sl: 'Izberite sliko, manjšo od %s',
      ga: 'Roghnaigh íomhá atá níos lú ná %s',
      mt: 'Jekk jogħġbok agħżel immaġni li hija iżgħar minn %s',
      cy: 'Dewiswch ddelwedd sy’n llai na %s',
      ro: 'Vă rugăm să alegeți o imagine mai mică decât %s',
      it: 'Scegli un’immagine con dimensioni inferiori a %s',
      zh_cn: '请选择小于 %s 的图片',
      hi: '%s से छोटी छवि चुनें',
      ar: 'يرجى اختيار صورة بحجم أقل من %s',
      bn: 'অনুগ্রহ করে %s এর চেয়ে ছোট একটি ছবি নির্বাচন করুন',
      ru: 'Пожалуйста, выберите изображение размером меньше %s',
      ja: '%s 未満の画像を選択してください',
      tr: 'Lütfen boyutu %s’den küçük bir görsel seçin',
      ko: '%s보다 작은 이미지를 선택해 주세요',
      vi: 'Vui lòng chọn hình ảnh có kích thước nhỏ hơn %s',
      id: 'Silakan pilih gambar dengan ukuran lebih kecil dari %s',
      th: 'โปรดเลือกภาพที่มีขนาดเล็กกว่า %s',
      ms: 'Sila pilih imej yang lebih kecil daripada %s',
      ar_eg: 'يرجى اختيار صورة بحجم أقل من %s',
      uk: 'Будь ласка, виберіть зображення розміром менше ніж %s',
    },
  },
  profile: {
    en: 'Profile',
    es: 'Perfil',
    fr: 'Profil',
    de: 'Profil',
    pt: 'Perfil',
    pl: 'Profil',
    nl: 'Profiel',
    el: 'Προφίλ',
    cs: 'Profil',
    sv: 'Profil',
    hu: 'Profil',
    da: 'Profil',
    fi: 'Profiili',
    sk: 'Profil',
    bg: 'Профил',
    hr: 'Profil',
    lt: 'Profilis',
    lv: 'Profils',
    et: 'Profiil',
    sl: 'Profil',
    ga: 'Próifíl',
    mt: 'Profil',
    cy: 'Proffil',
    ro: 'Profil',
    it: 'Profilo',
    zh_cn: '档案',
    hi: 'प्रोफाइल',
    ar: 'الملف الشخصي',
    bn: 'প্রোফাইল',
    ru: 'Профиль',
    ja: 'プロフィール',
    tr: 'Profil',
    ko: '프로필',
    vi: 'Hồ Sơ',
    id: 'Profil',
    th: 'โปรไฟล์',
    ms: 'Profil',
    ar_eg: 'الملف الشخصي',
    uk: 'Профіль',
  },
  profile_info: {
    en: 'Profile Info',
    es: 'Información de Perfil',
    fr: 'Infos Profil',
    de: 'Profilinfo',
    pt: 'Informações do Perfil',
    pl: 'Informacje o Profilu',
    nl: 'Profielinformatie',
    el: 'Πληροφορίες Προφίλ',
    cs: 'Informace o Profilu',
    sv: 'Profilinformation',
    hu: 'Profil Információ',
    da: 'Profiloplysninger',
    fi: 'Profiilitiedot',
    sk: 'Informácie o Profile',
    bg: 'Информация за Профила',
    hr: 'Informacije Profila',
    lt: 'Profilio Informacija',
    lv: 'Profila Informācija',
    et: 'Profiili Info',
    sl: 'Informacije o Profilu',
    ga: 'Eolas Próifíle',
    mt: 'Informazzjoni tal-Profil',
    cy: 'Gwybodaeth Proffil',
    ro: 'Informații Profil',
    it: 'Informazioni del Profilo',
    zh_cn: '个人资料',
    hi: 'प्रोफ़ाइल जानकारी',
    ar: 'معلومات الملف الشخصي',
    bn: 'প্রোফাইল তথ্য',
    ru: 'Информация профиля',
    ja: 'プロファイル情報',
    tr: 'Profil Bilgisi',
    ko: '프로필 정보',
    vi: 'Thông Tin Hồ Sơ',
    id: 'Info Profil',
    th: 'ข้อมูลโปรไฟล์',
    ms: 'Maklumat Profil',
    ar_eg: 'معلومات الملف الشخصي',
    uk: 'Інформація Профілю',
  },
  profile_settings: {
    en: 'Profile Settings',
    es: 'Configuración del Perfil',
    fr: 'Paramètres du Profil',
    de: 'Profil-Einstellungen',
    pt: 'Configurações do Perfil',
    pl: 'Ustawienia Profilu',
    nl: 'Profielinstellingen',
    el: 'Ρυθμίσεις Προφίλ',
    cs: 'Nastavení Profilu',
    sv: 'Profilinställningar',
    hu: 'Profilbeállítások',
    da: 'Profilindstillinger',
    fi: 'Profiiliasetukset',
    sk: 'Nastavenia Profilu',
    bg: 'Настройки на Профила',
    hr: 'Postavke Profila',
    lt: 'Profilio Nustatymai',
    lv: 'Profila Iestatījumi',
    et: 'Profiili Seaded',
    sl: 'Nastavitve Profila',
    ga: 'Socruithe Próifíle',
    mt: 'Settings tal-Profil',
    cy: 'Gosodiadau Proffil',
    ro: 'Setări Profil',
    it: 'Impostazioni del Profilo',
    zh_cn: '配置文件设置',
    hi: 'प्रोफ़ाइल सेटिंग्स',
    ar: 'إعدادات الملف الشخصي',
    bn: 'প্রোফাইল সেটিংস',
    ru: 'Настройки Профиля',
    ja: 'プロフィール設定',
    tr: 'Profil Ayarları',
    ko: '프로필 설정',
    vi: 'Cài đặt Hồ sơ',
    id: 'Pengaturan Profil',
    th: 'การตั้งค่าโปรไฟล์',
    ms: 'Tetapan Profil',
    ar_eg: 'إعدادات الملف الشخصي',
    uk: 'Налаштування Профілю',
  },
  first_name: {
    en: 'First Name',
    es: 'Nombre',
    fr: 'Prénom',
    de: 'Vorname',
    pt: 'Nome',
    pl: 'Imię',
    nl: 'Voornaam',
    el: 'Όνομα',
    cs: 'Jméno',
    sv: 'Förnamn',
    hu: 'Keresztnév',
    da: 'Fornavn',
    fi: 'Etunimi',
    sk: 'Meno',
    bg: 'Име',
    hr: 'Ime',
    lt: 'Vardas',
    lv: 'Vārds',
    et: 'Eesnimi',
    sl: 'Ime',
    ga: 'Céadainm',
    mt: 'Isem',
    cy: 'Enw Cyntaf',
    ro: 'Prenume',
    it: 'Nome',
    zh_cn: '名字',
    hi: 'पहला नाम',
    ar: 'الاسم الأول',
    bn: 'নামের প্রথম অংশ',
    ru: 'Имя',
    ja: '名',
    tr: 'Ad',
    ko: '이름',
    vi: 'Tên',
    id: 'Nama Depan',
    th: 'ชื่อจริง',
    ms: 'Nama Pertama',
    ar_eg: 'الاسم الأول',
    uk: 'Ім’я',
  },
  last_name: {
    en: 'Last Name',
    es: 'Apellido',
    fr: 'Nom de Famille',
    de: 'Nachname',
    pt: 'Sobrenome',
    pl: 'Nazwisko',
    nl: 'Achternaam',
    el: 'Επώνυμο',
    cs: 'Příjmení',
    sv: 'Efternamn',
    hu: 'Vezetéknév',
    da: 'Efternavn',
    fi: 'Sukunimi',
    sk: 'Priezvisko',
    bg: 'Фамилия',
    hr: 'Prezime',
    lt: 'Pavardė',
    lv: 'Uzvārds',
    et: 'Perekonnanimi',
    sl: 'Priimek',
    ga: 'Sloinne',
    mt: 'Kunjom',
    cy: 'Cyfenw',
    ro: 'Nume de Familie',
    it: 'Cognome',
    zh_cn: '姓氏',
    hi: 'अंतिम नाम',
    ar: 'الاسم الأخير',
    bn: 'শেষ নাম',
    ru: 'Фамилия',
    ja: '姓',
    tr: 'Soyadı',
    ko: '성',
    vi: 'Họ',
    id: 'Nama Belakang',
    th: 'นามสกุล',
    ms: 'Nama Akhir',
    ar_eg: 'الاسم الأخير',
    uk: 'Прізвище',
  },
  language: {
    en: 'Language',
    es: 'Idioma',
    fr: 'Langue',
    de: 'Sprache',
    pt: 'Língua',
    pl: 'Język',
    nl: 'Taal',
    el: 'Γλώσσα',
    cs: 'Jazyk',
    sv: 'Språk',
    hu: 'Nyelv',
    da: 'Sprog',
    fi: 'Kieli',
    sk: 'Jazyk',
    bg: 'Език',
    hr: 'Jezik',
    lt: 'Kalba',
    lv: 'Valoda',
    et: 'Keel',
    sl: 'Jezik',
    ga: 'Teanga',
    mt: 'Lingwa',
    cy: 'Iaith',
    ro: 'Limbă',
    it: 'Lingua',
    zh_cn: '语言',
    hi: 'भाषा',
    ar: 'اللغة',
    bn: 'ভাষা',
    ru: 'Язык',
    ja: '言語',
    tr: 'Dil',
    ko: '언어',
    vi: 'Ngôn ngữ',
    id: 'Bahasa',
    th: 'ภาษา',
    ms: 'Bahasa',
    ar_eg: 'اللغة',
    uk: 'Мова',
  },
  date_of_birth: {
    en: 'Date of Birth',
    es: 'Fecha de Nacimiento',
    fr: 'Date de Naissance',
    de: 'Geburtsdatum',
    pt: 'Data de Nascimento',
    pl: 'Data Urodzenia',
    nl: 'Geboortedatum',
    el: 'Ημερομηνία Γέννησης',
    cs: 'Datum Narození',
    sv: 'Födelsedatum',
    hu: 'Születési Dátum',
    da: 'Fødselsdato',
    fi: 'Syntymäaika',
    sk: 'Dátum Narodenia',
    bg: 'Дата на Раждане',
    hr: 'Datum Rođenja',
    lt: 'Gimimo Data',
    lv: 'Dzimšanas Datums',
    et: 'Sünnikuupäev',
    sl: 'Datum Rojstva',
    ga: 'Dáta Breithe',
    mt: 'Data tat-Twelid',
    cy: 'Dyddiad Geni',
    ro: 'Data Nașterii',
    it: 'Data di Nascita',
    zh_cn: '出生日期',
    hi: 'जन्म तिथि',
    ar: 'تاريخ الميلاد',
    bn: 'জন্ম তারিখ',
    ru: 'Дата Рождения',
    ja: '生年月日',
    tr: 'Doğum Tarihi',
    ko: '생년월일',
    vi: 'Ngày Sinh',
    id: 'Tanggal Lahir',
    th: 'วันเกิด',
    ms: 'Tarikh Lahir',
    ar_eg: 'تاريخ الميلاد',
    uk: 'Дата Народження',
  },
  close: {
    en: 'Close',
    es: 'Cerrar',
    fr: 'Fermer',
    de: 'Schließen',
    pt: 'Fechar',
    pl: 'Zamknij',
    nl: 'Sluiten',
    el: 'Κλείσιμο',
    cs: 'Zavřít',
    sv: 'Stäng',
    hu: 'Bezárás',
    da: 'Luk',
    fi: 'Sulje',
    sk: 'Zatvoriť',
    bg: 'Затвори',
    hr: 'Zatvori',
    lt: 'Uždaryti',
    lv: 'Aizvērt',
    et: 'Sulge',
    sl: 'Zapri',
    ga: 'Dún',
    mt: 'Agħlaq',
    cy: 'Cau',
    ro: 'Închide',
    it: 'Chiudi',
    zh_cn: '关闭',
    hi: 'बंद करें',
    ar: 'إغلاق',
    bn: 'বন্ধ করুন',
    ru: 'Закрыть',
    ja: '閉じる',
    tr: 'Kapat',
    ko: '닫기',
    vi: 'Đóng',
    id: 'Tutup',
    th: 'ปิด',
    ms: 'Tutup',
    ar_eg: 'إغلاق',
    uk: 'Закрити',
  },
  email: {
    en: 'Email',
    es: 'Correo electrónico',
    fr: 'Courriel',
    de: 'E-Mail',
    pt: 'E-mail',
    pl: 'E-mail',
    nl: 'E-mail',
    el: 'Ηλεκτρονικό Ταχυδρομείο',
    cs: 'E-mail',
    sv: 'E-post',
    hu: 'E-mail',
    da: 'E-mail',
    fi: 'Sähköposti',
    sk: 'E-mail',
    bg: 'Имейл',
    hr: 'E-pošta',
    lt: 'El. paštas',
    lv: 'E-pasts',
    et: 'E-post',
    sl: 'E-pošta',
    ga: 'Ríomhphost',
    mt: 'E-mail',
    cy: 'E-bost',
    ro: 'E-mail',
    it: 'Email',
    zh_cn: '电子邮件',
    hi: 'ईमेल',
    ar: 'البريد الإلكتروني',
    bn: 'ইমেইল',
    ru: 'Электронная почта',
    ja: 'メール',
    tr: 'E-posta',
    ko: '이메일',
    vi: 'Email',
    id: 'Email',
    th: 'อีเมล',
    ms: 'Emel',
    ar_eg: 'البريد الإلكتروني',
    uk: 'Електронна пошта',
  },
  contact_number: {
    en: 'Contact Number',
    es: 'Número de Contacto',
    fr: 'Numéro de Contact',
    de: 'Kontaktnummer',
    pt: 'Número de Contato',
    pl: 'Numer Kontaktowy',
    nl: 'Contactnummer',
    el: 'Αριθμός Επαφής',
    cs: 'Kontaktní Číslo',
    sv: 'Kontaktnummer',
    hu: 'Kapcsolattartó Szám',
    da: 'Kontaktnummer',
    fi: 'Yhteysnumero',
    sk: 'Kontaktné Číslo',
    bg: 'Контактен Номер',
    hr: 'Kontakt Broj',
    lt: 'Kontaktinis Numeris',
    lv: 'Kontakttālrunis',
    et: 'Kontaktnumber',
    sl: 'Kontaktna Številka',
    ga: 'Uimhir Teagmhála',
    mt: 'Numru ta’ Kuntatt',
    cy: 'Rhif Cyswllt',
    ro: 'Număr de Contact',
    it: 'Numero di Contatto',
    zh_cn: '联系电话',
    hi: 'संपर्क संख्या',
    ar: 'رقم الاتصال',
    bn: 'যোগাযোগ নম্বর',
    ru: 'Контактный Номер',
    ja: '連絡先番号',
    tr: 'İletişim Numarası',
    ko: '연락처 번호',
    vi: 'Số Liên Lạc',
    id: 'Nomor Kontak',
    th: 'หมายเลขติดต่อ',
    ms: 'Nombor Hubungan',
    ar_eg: 'رقم التواصل',
    uk: 'Контактний Номер',
  },
  address: {
    en: 'Address',
    es: 'Dirección',
    fr: 'Adresse',
    de: 'Adresse',
    pt: 'Endereço',
    pl: 'Adres',
    nl: 'Adres',
    el: 'Διεύθυνση',
    cs: 'Adresa',
    sv: 'Adress',
    hu: 'Cím',
    da: 'Adresse',
    fi: 'Osoite',
    sk: 'Adresa',
    bg: 'Адрес',
    hr: 'Adresa',
    lt: 'Adresas',
    lv: 'Adrese',
    et: 'Aadress',
    sl: 'Naslov',
    ga: 'Seoladh',
    mt: 'Indirizz',
    cy: 'Cyfeiriad',
    ro: 'Adresă',
    it: 'Indirizzo',
    zh_cn: '地址',
    hi: 'पता',
    ar: 'العنوان',
    bn: 'ঠিকানা',
    ru: 'Адрес',
    ja: '住所',
    tr: 'Adres',
    ko: '주소',
    vi: 'Địa chỉ',
    id: 'Alamat',
    th: 'ที่อยู่',
    ms: 'Alamat',
    ar_eg: 'العنوان',
    uk: 'Адреса',
  },
  no_address: {
    en: 'No address has been added!',
    es: '¡No se ha añadido ninguna dirección!',
    fr: 'Aucune adresse n’a été ajoutée !',
    de: 'Es wurde keine Adresse hinzugefügt!',
    pt: 'Nenhum endereço foi adicionado!',
    pl: 'Nie dodano żadnego adresu!',
    nl: 'Er is geen adres toegevoegd!',
    el: 'Δεν έχει προστεθεί διεύθυνση!',
    cs: 'Nebyla přidána žádná adresa!',
    sv: 'Ingen adress har lagts till!',
    hu: 'Nem lett cím hozzáadva!',
    da: 'Ingen adresse er blevet tilføjet!',
    fi: 'Osoitetta ei ole lisätty!',
    sk: 'Nebola pridaná žiadna adresa!',
    bg: 'Не е добавен адрес!',
    hr: 'Nije dodana nijedna adresa!',
    lt: 'Adresas nebuvo pridėtas!',
    lv: 'Nav pievienota adrese!',
    et: 'Aadressi ei ole lisatud!',
    sl: 'Ni bil dodan noben naslov!',
    ga: 'Níor cuireadh aon seoladh leis!',
    mt: 'Ebda indirizz ma ġie miżjud!',
    cy: 'Ni chafodd unrhyw gyfeiriad ei ychwanegu!',
    ro: 'Nu a fost adăugată nicio adresă!',
    it: 'Nessun indirizzo è stato aggiunto!',
    zh_cn: '尚未添加地址！',
    hi: 'कोई पता नहीं जोड़ा गया है!',
    ar: 'لم يتم إضافة أي عنوان!',
    bn: 'কোনও ঠিকানা যোগ করা হয়নি!',
    ru: 'Адрес не был добавлен!',
    ja: '住所が追加されていません！',
    tr: 'Adres eklenmedi!',
    ko: '주소가 추가되지 않았습니다!',
    vi: 'Chưa có địa chỉ nào được thêm!',
    id: 'Tidak ada alamat yang ditambahkan!',
    th: 'ยังไม่มีที่อยู่ถูกเพิ่ม!',
    ms: 'Tiada alamat telah ditambahkan!',
    ar_eg: 'لم يتم إضافة أي عنوان!',
    uk: 'Адресу не додано!',
  },
  address_line: {
    en: 'Address line %s',
    es: 'Línea de dirección',
    fr: "Ligne d'adresse",
    de: 'Adresszeile',
    pt: 'Linha de endereço',
    pl: 'Linia adresowa',
    nl: 'Adresregel',
    el: 'Γραμμή διεύθυνσης',
    cs: 'Adresní řádek',
    sv: 'Adressrad',
    hu: 'Címsor',
    da: 'Adresselinje',
    fi: 'Osoiterivi',
    sk: 'Adresný riadok',
    bg: 'Адресен ред',
    hr: 'Adresni red',
    lt: 'Adreso eilutė',
    lv: 'Adreses līnija',
    et: 'Aadressirida',
    sl: 'Naslovna vrstica',
    ga: 'Líne seolta',
    mt: 'Linja tal-indirizz',
    cy: 'Llinell cyfeiriad',
    ro: 'Linie de adresă',
    it: 'Riga dell’indirizzo',
    zh_cn: '地址栏',
    hi: 'पता पंक्ति',
    ar: 'سطر العنوان',
    bn: 'ঠিকানা লাইন',
    ru: 'Строка адреса',
    ja: '住所欄',
    tr: 'Adres satırı',
    ko: '주소 줄',
    vi: 'Dòng địa chỉ',
    id: 'Baris alamat',
    th: 'บรรทัดที่อยู่',
    ms: 'Baris alamat',
    ar_eg: 'سطر العنوان',
    uk: 'Рядок адреси',
  },
  city: {
    en: 'City',
    es: 'Ciudad',
    fr: 'Ville',
    de: 'Stadt',
    pt: 'Cidade',
    pl: 'Miasto',
    nl: 'Stad',
    el: 'Πόλη',
    cs: 'Město',
    sv: 'Stad',
    hu: 'Város',
    da: 'By',
    fi: 'Kaupunki',
    sk: 'Mesto',
    bg: 'Град',
    hr: 'Grad',
    lt: 'Miestas',
    lv: 'Pilsēta',
    et: 'Linn',
    sl: 'Mesto',
    ga: 'Cathair',
    mt: 'Belt',
    cy: 'Dinas',
    ro: 'Oraș',
    it: 'Città',
    zh_cn: '城市',
    hi: 'शहर',
    ar: 'مدينة',
    bn: 'শহর',
    ru: 'Город',
    ja: '市',
    tr: 'Şehir',
    ko: '도시',
    vi: 'Thành phố',
    id: 'Kota',
    th: 'เมือง',
    ms: 'Bandar',
    ar_eg: 'مدينة',
    uk: 'Місто',
  },
  country: {
    en: 'Country',
    es: 'País',
    fr: 'Pays',
    de: 'Land',
    pt: 'País',
    pl: 'Kraj',
    nl: 'Land',
    el: 'Χώρα',
    cs: 'Země',
    sv: 'Land',
    hu: 'Ország',
    da: 'Land',
    fi: 'Maa',
    sk: 'Krajina',
    bg: 'Държава',
    hr: 'Država',
    lt: 'Šalis',
    lv: 'Valsts',
    et: 'Riik',
    sl: 'Država',
    ga: 'Tír',
    mt: 'Pajjiż',
    cy: 'Gwlad',
    ro: 'Țară',
    it: 'Paese',
    zh_cn: '国家',
    hi: 'देश',
    ar: 'بلد',
    bn: 'দেশ',
    ru: 'Страна',
    ja: '国',
    tr: 'Ülke',
    ko: '나라',
    vi: 'Quốc gia',
    id: 'Negara',
    th: 'ประเทศ',
    ms: 'Negara',
    ar_eg: 'البلد',
    uk: 'Країна',
  },
  postcode: {
    en: 'Postcode',
    es: 'Código postal',
    fr: 'Code postal',
    de: 'Postleitzahl',
    pt: 'Código postal',
    pl: 'Kod pocztowy',
    nl: 'Postcode',
    el: 'Ταχυδρομικός κώδικας',
    cs: 'PSČ',
    sv: 'Postnummer',
    hu: 'Irányítószám',
    da: 'Postnummer',
    fi: 'Postinumero',
    sk: 'PSČ',
    bg: 'Пощенски код',
    hr: 'Poštanski broj',
    lt: 'Pašto kodas',
    lv: 'Pasta indekss',
    et: 'Postiindeks',
    sl: 'Poštna številka',
    ga: 'Cód poist',
    mt: 'Kodiċi postali',
    cy: 'Cod post',
    ro: 'Cod poștal',
    it: 'CAP',
    zh_cn: '邮政编码',
    hi: 'पिन कोड',
    ar: 'الرمز البريدي',
    bn: 'পোস্টকোড',
    ru: 'Почтовый индекс',
    ja: '郵便番号',
    tr: 'Posta kodu',
    ko: '우편번호',
    vi: 'Mã bưu chính',
    id: 'Kode pos',
    th: 'รหัสไปรษณีย์',
    ms: 'Poskod',
    ar_eg: 'الرمز البريدي',
    uk: 'Поштовий індекс',
  },
  delete: {
    en: 'Delete',
    es: 'Eliminar',
    fr: 'Supprimer',
    de: 'Löschen',
    pt: 'Excluir',
    pl: 'Usuń',
    nl: 'Verwijderen',
    el: 'Διαγραφή',
    cs: 'Smazat',
    sv: 'Radera',
    hu: 'Töröl',
    da: 'Slet',
    fi: 'Poista',
    sk: 'Zmazať',
    bg: 'Изтрий',
    hr: 'Izbriši',
    lt: 'Ištrinti',
    lv: 'Dzēst',
    et: 'Kustuta',
    sl: 'Izbriši',
    ga: 'Scrios',
    mt: 'Ħassar',
    cy: 'Dileu',
    ro: 'Șterge',
    it: 'Elimina',
    zh_cn: '删除',
    hi: 'हटाएं',
    ar: 'حذف',
    bn: 'মুছে ফেলা',
    ru: 'Удалить',
    ja: '削除',
    tr: 'Sil',
    ko: '삭제',
    vi: 'Xóa',
    id: 'Hapus',
    th: 'ลบ',
    ms: 'Padam',
    ar_eg: 'حذف',
    uk: 'Видалити',
  },
  on_hold: {
    en: 'On Hold',
    es: 'En Espera',
    fr: 'En Attente',
    de: 'In Wartestellung',
    pt: 'Em Espera',
    pl: 'Wstrzymany',
    nl: 'In de Wacht',
    el: 'Σε Αναμονή',
    cs: 'Pozastaveno',
    sv: 'På Vänt',
    hu: 'Függőben',
    da: 'På Hold',
    fi: 'Odottaa',
    sk: 'V Pauze',
    bg: 'На Изчакване',
    hr: 'Na Čekanju',
    lt: 'Sulaikyta',
    lv: 'Turēt Aizturētā',
    et: 'Ootel',
    sl: 'Na Čakanju',
    ga: 'Ar Feitheamh',
    mt: 'Mhux Attiv',
    cy: 'Ar Oedi',
    ro: 'În Așteptare',
    it: 'In Attesa',
    zh_cn: '挂起',
    hi: 'होल्ड पर',
    ar: 'في الانتظار',
    bn: 'স্থগিত',
    ru: 'На Удержании',
    ja: '保留中',
    tr: 'Beklemede',
    ko: '보류 중',
    vi: 'Tạm Hoãn',
    id: 'Ditahan',
    th: 'ระงับ',
    ms: 'Ditangguhkan',
    ar_eg: 'في الانتظار',
    uk: 'На Утриманні',
  },
  flat_number_building: {
    en: 'Flat Number/Building',
    es: 'Número de piso/Edificio',
    fr: 'Numéro d’appartement/Bâtiment',
    de: 'Wohnungsnummer/Gebäude',
    pt: 'Número do Apartamento/Edifício',
    pl: 'Numer mieszkania/Budynek',
    nl: 'Flatnummer/Gebouw',
    el: 'Αριθμός Διαμερίσματος/Κτίριο',
    cs: 'Číslo bytu/Budova',
    sv: 'Lägenhetsnummer/Byggnad',
    hu: 'Lakás szám/Épület',
    da: 'Lejlighedsnummer/Bygning',
    fi: 'Huoneiston numero/Rakennus',
    sk: 'Číslo bytu/Budova',
    bg: 'Номер на апартамент/Сграда',
    hr: 'Broj stana/Zgrada',
    lt: 'Butas/Namai',
    lv: 'Dzīvokļa numurs/Ēka',
    et: 'Korteri number/Hoone',
    sl: 'Številka stanovanja/Zgradba',
    ga: 'Uimhir Árasán/Foirgneamh',
    mt: 'Numru tal-Appartament/Bini',
    cy: 'Rhif Fflat/Adeilad',
    ro: 'Număr Apartament/Clădire',
    it: 'Numero Appartamento/Edificio',
    zh_cn: '公寓号/楼宇',
    hi: 'फ्लैट संख्या/इमारत',
    ar: 'رقم الشقة/المبنى',
    bn: 'ফ্ল্যাট নম্বর/বিল্ডিং',
    ru: 'Номер квартиры/Здание',
    ja: 'フラット番号/建物',
    tr: 'Daire Numarası/Bina',
    ko: '플랫 번호/건물',
    vi: 'Số căn hộ/Tòa nhà',
    id: 'Nomor Flat/Gedung',
    th: 'เลขที่ห้อง/อาคาร',
    ms: 'Nombor Pangsapuri/Bangunan',
    ar_eg: 'رقم الشقة/المبنى',
    uk: 'Номер квартири/Будинок',
  },
  street_name: {
    en: 'Street Name',
    es: 'Nombre de Calle',
    fr: 'Nom de Rue',
    de: 'Straßenname',
    pt: 'Nome da Rua',
    pl: 'Nazwa Ulicy',
    nl: 'Straatnaam',
    el: 'Οδός',
    cs: 'Název Ulice',
    sv: 'Gatunamn',
    hu: 'Utcanév',
    da: 'Gadenavn',
    fi: 'Kadunnimi',
    sk: 'Názov Ulice',
    bg: 'Име на Улица',
    hr: 'Naziv Ulice',
    lt: 'Gatvės Pavadinimas',
    lv: 'Ielas Nosaukums',
    et: 'Tänava Nimi',
    sl: 'Ime Ulice',
    ga: 'Ainm na Sráide',
    mt: 'Isem it-Triq',
    cy: 'Enw’r Stryd',
    ro: 'Numele Străzii',
    it: 'Nome della Strada',
    zh_cn: '街道名称',
    hi: 'सड़क का नाम',
    ar: 'اسم الشارع',
    bn: 'রাস্তার নাম',
    ru: 'Название Улицы',
    ja: '通りの名前',
    tr: 'Sokak Adı',
    ko: '거리 이름',
    vi: 'Tên Đường',
    id: 'Nama Jalan',
    th: 'ชื่อถนน',
    ms: 'Nama Jalan',
    ar_eg: 'اسم الشارع',
    uk: 'Назва Вулиці',
  },
  customers: {
    en: 'Customers',
    es: 'Clientes',
    fr: 'Clients',
    de: 'Kunden',
    pt: 'Clientes',
    pl: 'Klienci',
    nl: 'Klanten',
    el: 'Πελάτες',
    cs: 'Zákazníci',
    sv: 'Kunder',
    hu: 'Ügyfelek',
    da: 'Kunder',
    fi: 'Asiakkaat',
    sk: 'Zákazníci',
    bg: 'Клиенти',
    hr: 'Kupci',
    lt: 'Klientai',
    lv: 'Klienti',
    et: 'Kliendid',
    sl: 'Stranke',
    ga: 'Custaiméirí',
    mt: 'Klijenti',
    cy: 'Cwsmeriaid',
    ro: 'Clienți',
    it: 'Clienti',
    zh_cn: '顾客',
    hi: 'ग्राहक',
    ar: 'العملاء',
    bn: 'গ্রাহকরা',
    ru: 'Клиенты',
    ja: '顧客',
    tr: 'Müşteriler',
    ko: '고객',
    vi: 'Khách hàng',
    id: 'Pelanggan',
    th: 'ลูกค้า',
    ms: 'Pelanggan',
    ar_eg: 'العملاء',
    uk: 'Клієнти',
  },
  genders: {
    male: {
      en: 'Male',
      es: 'Masculino',
      fr: 'Masculin',
      de: 'Männlich',
      pt: 'Masculino',
      pl: 'Mężczyzna',
      nl: 'Man',
      el: 'Άρρεν',
      cs: 'Muž',
      sv: 'Man',
      hu: 'Férfi',
      da: 'Mand',
      fi: 'Mies',
      sk: 'Muž',
      bg: 'Мъж',
      hr: 'Muško',
      lt: 'Vyras',
      lv: 'Vīrietis',
      et: 'Mees',
      sl: 'Moški',
      ga: 'Fir',
      mt: 'Raġel',
      cy: 'Gwryw',
      ro: 'Masculin',
      it: 'Maschile',
      zh_cn: '男性',
      hi: 'पुरुष',
      ar: 'ذكر',
      bn: 'পুরুষ',
      ru: 'Мужской',
      ja: '男性',
      tr: 'Erkek',
      ko: '남성',
      vi: 'Nam',
      id: 'Laki-laki',
      th: 'ชาย',
      ms: 'Lelaki',
      ar_eg: 'ذكر',
      uk: 'Чоловік',
    },
    female: {
      en: 'Female',
      es: 'Femenino',
      fr: 'Féminin',
      de: 'Weiblich',
      pt: 'Feminino',
      pl: 'Kobieta',
      nl: 'Vrouw',
      el: 'Θηλυκό',
      cs: 'Žena',
      sv: 'Kvinna',
      hu: 'Nő',
      da: 'Kvinde',
      fi: 'Nainen',
      sk: 'Žena',
      bg: 'Жена',
      hr: 'Žensko',
      lt: 'Moteris',
      lv: 'Sieviete',
      et: 'Naine',
      sl: 'Ženska',
      ga: 'Baineann',
      mt: 'Femminil',
      cy: 'Benyw',
      ro: 'Feminin',
      it: 'Femminile',
      zh_cn: '女性',
      hi: 'महिला',
      ar: 'أنثى',
      bn: 'মহিলা',
      ru: 'Женский',
      ja: '女性',
      tr: 'Kadın',
      ko: '여성',
      vi: 'Nữ',
      id: 'Perempuan',
      th: 'หญิง',
      ms: 'Perempuan',
      ar_eg: 'أنثى',
      uk: 'Жінка',
    },
    other: {
      en: 'Other',
      es: 'Otro',
      fr: 'Autre',
      de: 'Andere',
      pt: 'Outro',
      pl: 'Inne',
      nl: 'Anders',
      el: 'Άλλο',
      cs: 'Jiné',
      sv: 'Annat',
      hu: 'Egyéb',
      da: 'Andet',
      fi: 'Muu',
      sk: 'Iné',
      bg: 'Друг',
      hr: 'Ostalo',
      lt: 'Kita',
      lv: 'Cits',
      et: 'Muu',
      sl: 'Drugo',
      ga: 'Eile',
      mt: 'Ieħor',
      cy: 'Arall',
      ro: 'Altul',
      it: 'Altro',
      zh_cn: '其他',
      hi: 'अन्य',
      ar: 'آخر',
      bn: 'অন্যান্য',
      ru: 'Другой',
      ja: 'その他',
      tr: 'Diğer',
      ko: '기타',
      vi: 'Khác',
      id: 'Lainnya',
      th: 'อื่นๆ',
      ms: 'Lain-lain',
      ar_eg: 'آخر',
      uk: 'Інше',
    },
  },
  titles: {
    mr: {
      en: 'Mr.',
      es: 'Sr.',
      fr: 'M.',
      de: 'Herr',
      pt: 'Sr.',
      pl: 'Pan',
      nl: 'Dhr.',
      el: 'Κος',
      cs: 'Pan',
      sv: 'Herr',
      hu: 'Úr',
      da: 'Hr.',
      fi: 'Herra',
      sk: 'Pán',
      bg: 'Г-н',
      hr: 'Gosp.',
      lt: 'Ponas',
      lv: 'Kungs',
      et: 'Hr',
      sl: 'Gospod',
      ga: 'An tUas.',
      mt: 'Is-Sur',
      cy: 'Mr',
      ro: 'Dl.',
      it: 'Sig.',
      zh_cn: '先生',
      hi: 'श्री',
      ar: 'السيد',
      bn: 'জনাব',
      ru: 'Г-н',
      ja: '氏',
      tr: 'Bay',
      ko: '씨',
      vi: 'Ông',
      id: 'Tuan',
      th: 'นาย',
      ms: 'Encik',
      ar_eg: 'السيد',
      uk: 'Пан',
    },
    mrs: {
      en: 'Mrs.',
      es: 'Sra.',
      fr: 'Mme.',
      de: 'Frau',
      pt: 'Sra.',
      pl: 'Pani',
      nl: 'Mevr.',
      el: 'Κα',
      cs: 'Paní',
      sv: 'Fru',
      hu: 'Asszony',
      da: 'Fru',
      fi: 'Rouva',
      sk: 'Pani',
      bg: 'Г-жа',
      hr: 'Gđa.',
      lt: 'Ponia',
      lv: 'Kundze',
      et: 'Proua',
      sl: 'Gospa',
      ga: 'Bean Uas.',
      mt: 'Is-Sinjura',
      cy: 'Mrs',
      ro: 'Dna.',
      it: 'Sig.ra',
      zh_cn: '女士',
      hi: 'श्रीमती',
      ar: 'السيدة',
      bn: 'বেগম',
      ru: 'Г-жа',
      ja: '夫人',
      tr: 'Bayan',
      ko: '부인',
      vi: 'Bà',
      id: 'Nyonya',
      th: 'นาง',
      ms: 'Puan',
      ar_eg: 'السيدة',
      uk: 'Пані',
    },
    ms: {
      en: 'Ms.',
      es: 'Sra.',
      fr: 'Mlle',
      de: 'Frau',
      pt: 'Sra.',
      pl: 'Panna',
      nl: 'Mevr.',
      el: 'Δις',
      cs: 'Slečna',
      sv: 'Fröken',
      hu: 'Hölgy',
      da: 'Frk.',
      fi: 'Neiti',
      sk: 'Slečna',
      bg: 'Г-ца',
      hr: 'Gđica',
      lt: 'Panelė',
      lv: 'Kundze',
      et: 'Preili',
      sl: 'Gospodična',
      ga: 'Ms',
      mt: 'Sinjorina',
      cy: 'Ms',
      ro: 'Dra.',
      it: 'Sig.na',
      zh_cn: '小姐',
      hi: 'सुश्री',
      ar: 'آنسة',
      bn: 'মিস',
      ru: 'Г-жа',
      ja: 'ミス',
      tr: 'Bayan',
      ko: '여사',
      vi: 'Cô',
      id: 'Nn.',
      th: 'นางสาว',
      ms: 'Cik',
      ar_eg: 'آنسة',
      uk: 'Пані',
    },
    miss: {
      en: 'Miss',
      es: 'Srta.',
      fr: 'Mlle',
      de: 'Fräulein',
      pt: 'Srta.',
      pl: 'Panna',
      nl: 'Juffrouw',
      el: 'Δεσποινίς',
      cs: 'Slečna',
      sv: 'Fröken',
      hu: 'Kisasszony',
      da: 'Frøken',
      fi: 'Neiti',
      sk: 'Slečna',
      bg: 'Госпожица',
      hr: 'Gospođica',
      lt: 'Mergina',
      lv: 'Jaunkundze',
      et: 'Preili',
      sl: 'Gospodična',
      ga: 'Iníon',
      mt: 'Fraulein',
      cy: 'Miss',
      ro: 'Domnișoară',
      it: 'Sig.na',
      zh_cn: '小姐',
      hi: 'कुमारी',
      ar: 'آنسة',
      bn: 'মিস',
      ru: 'Мисс',
      ja: 'ミス',
      tr: 'Bayan',
      ko: '양',
      vi: 'Cô',
      id: 'Nona',
      th: 'นางสาว',
      ms: 'Cik',
      ar_eg: 'آنسة',
      uk: 'Міс',
    },
    dr: {
      en: 'Dr.',
      es: 'Dr.',
      fr: 'Dr.',
      de: 'Dr.',
      pt: 'Dr.',
      pl: 'Dr.',
      nl: 'Dr.',
      el: 'Δρ.',
      cs: 'Dr.',
      sv: 'Dr.',
      hu: 'Dr.',
      da: 'Dr.',
      fi: 'Toht.',
      sk: 'Dr.',
      bg: 'Д-р',
      hr: 'Dr.',
      lt: 'Dr.',
      lv: 'Dr.',
      et: 'Dr.',
      sl: 'Dr.',
      ga: 'An Dr.',
      mt: 'Dr.',
      cy: 'Dr.',
      ro: 'Dr.',
      it: 'Dott.',
      zh_cn: '博士',
      hi: 'डॉ.',
      ar: 'د.',
      bn: 'ড.',
      ru: 'Д-р',
      ja: 'ドクター',
      tr: 'Dr.',
      ko: '박사',
      vi: 'Tiến sĩ',
      id: 'Dr.',
      th: 'ดร.',
      ms: 'Dr.',
      ar_eg: 'د.',
      uk: 'Д-р',
    },
    prof: {
      en: 'Prof.',
      es: 'Prof.',
      fr: 'Prof.',
      de: 'Prof.',
      pt: 'Prof.',
      pl: 'Prof.',
      nl: 'Prof.',
      el: 'Καθ.',
      cs: 'Prof.',
      sv: 'Prof.',
      hu: 'Prof.',
      da: 'Prof.',
      fi: 'Prof.',
      sk: 'Prof.',
      bg: 'Проф.',
      hr: 'Prof.',
      lt: 'Prof.',
      lv: 'Prof.',
      et: 'Prof.',
      sl: 'Prof.',
      ga: 'An tOll.',
      mt: 'Prof.',
      cy: 'Prof.',
      ro: 'Prof.',
      it: 'Prof.',
      zh_cn: '教授',
      hi: 'प्रोफ़.',
      ar: 'أ.د',
      bn: 'অধ্যাপক',
      ru: 'Проф.',
      ja: '教授',
      tr: 'Prof.',
      ko: '교수',
      vi: 'GS.',
      id: 'Prof.',
      th: 'ศ.ดร.',
      ms: 'Prof.',
      ar_eg: 'أ.د',
      uk: 'Проф.',
    },
    sir: {
      en: 'Sir',
      es: 'Señor',
      fr: 'Monsieur',
      de: 'Herr',
      pt: 'Senhor',
      pl: 'Pan',
      nl: 'Meneer',
      el: 'Κύριε',
      cs: 'Pane',
      sv: 'Herr',
      hu: 'Uram',
      da: 'Hr.',
      fi: 'Herra',
      sk: 'Pán',
      bg: 'Господин',
      hr: 'Gospodine',
      lt: 'Ponas',
      lv: 'Kungs',
      et: 'Härra',
      sl: 'Gospod',
      ga: 'A Thiarna',
      mt: 'Sur',
      cy: 'Syrr',
      ro: 'Domnule',
      it: 'Signore',
      zh_cn: '先生',
      hi: 'श्रीमान',
      ar: 'سيدي',
      bn: 'স্যার',
      ru: 'Сэр',
      ja: 'サー',
      tr: 'Beyefendi',
      ko: '선생님',
      vi: 'Ông',
      id: 'Tuan',
      th: 'คุณ',
      ms: 'Tuan',
      ar_eg: 'سيدي',
      uk: 'Сер',
    },
    lady: {
      en: 'Lady',
      es: 'Señora',
      fr: 'Dame',
      de: 'Dame',
      pt: 'Senhora',
      pl: 'Pani',
      nl: 'Dame',
      el: 'Κυρία',
      cs: 'Dáma',
      sv: 'Dam',
      hu: 'Hölgy',
      da: 'Dame',
      fi: 'Rouva',
      sk: 'Dáma',
      bg: 'Дама',
      hr: 'Dama',
      lt: 'Ponia',
      lv: 'Kundze',
      et: 'Daam',
      sl: 'Dama',
      ga: 'Bantiarna',
      mt: 'Sinjura',
      cy: 'Arglwyddes',
      ro: 'Doamnă',
      it: 'Signora',
      zh_cn: '女士',
      hi: 'महोदया',
      ar: 'سيدتي',
      bn: 'লেডি',
      ru: 'Леди',
      ja: 'レディ',
      tr: 'Hanımefendi',
      ko: '여사',
      vi: 'Quý bà',
      id: 'Nyonya',
      th: 'ท่านหญิง',
      ms: 'Puan',
      ar_eg: 'سيدتي',
      uk: 'Леді',
    },
  },
  title: {
    en: 'Title',
    es: 'Título',
    fr: 'Titre',
    de: 'Titel',
    pt: 'Título',
    pl: 'Tytuł',
    nl: 'Titel',
    el: 'Τίτλος',
    cs: 'Titul',
    sv: 'Titel',
    hu: 'Cím',
    da: 'Titel',
    fi: 'Nimike',
    sk: 'Titul',
    bg: 'Заглавие',
    hr: 'Titula',
    lt: 'Pavadinimas',
    lv: 'Nosaukums',
    et: 'Tiitel',
    sl: 'Naslov',
    ga: 'Teideal',
    mt: 'Titlu',
    cy: 'Teitl',
    ro: 'Titlu',
    it: 'Titolo',
    zh_cn: '标题',
    hi: 'शीर्षक',
    ar: 'اللقب',
    bn: 'শিরোনাম',
    ru: 'Заголовок',
    ja: 'タイトル',
    tr: 'Ünvan',
    ko: '제목',
    vi: 'Danh hiệu',
    id: 'Gelar',
    th: 'ชื่อ',
    ms: 'Tajuk',
    ar_eg: 'اللقب',
    uk: 'Звання',
  },
  gender: {
    en: 'Gender',
    es: 'Género',
    fr: 'Genre',
    de: 'Geschlecht',
    pt: 'Gênero',
    pl: 'Płeć',
    nl: 'Geslacht',
    el: 'Φύλο',
    cs: 'Pohlaví',
    sv: 'Kön',
    hu: 'Nem',
    da: 'Køn',
    fi: 'Sukupuoli',
    sk: 'Pohlavie',
    bg: 'Пол',
    hr: 'Spol',
    lt: 'Lytis',
    lv: 'Dzimums',
    et: 'Sugu',
    sl: 'Spol',
    ga: 'Inscne',
    mt: 'Ġeneru',
    cy: 'Rhyw',
    ro: 'Gen',
    it: 'Genere',
    zh_cn: '性别',
    hi: 'लिंग',
    ar: 'الجنس',
    bn: 'লিঙ্গ',
    ru: 'Пол',
    ja: '性別',
    tr: 'Cinsiyet',
    ko: '성별',
    vi: 'Giới tính',
    id: 'Jenis Kelamin',
    th: 'เพศ',
    ms: 'Jantina',
    ar_eg: 'النوع',
    uk: 'Стать',
  },
  optional: {
    en: 'Optional',
    es: 'Opcional',
    fr: 'Facultatif',
    de: 'Optional',
    pt: 'Opcional',
    pl: 'Opcjonalny',
    nl: 'Optioneel',
    el: 'Προαιρετικός',
    cs: 'Volitelný',
    sv: 'Frivillig',
    hu: 'Választható',
    da: 'Valgfri',
    fi: 'Valinnainen',
    sk: 'Voliteľný',
    bg: 'По избор',
    hr: 'Izborni',
    lt: 'Pasirinktinis',
    lv: 'Neobligāts',
    et: 'Valikuline',
    sl: 'Neobvezno',
    ga: 'Roghnach',
    mt: 'Fakultattiv',
    cy: 'Dewisol',
    ro: 'Opțional',
    it: 'Opzionale',
    zh_cn: '可选的',
    hi: 'ऐच्छिक',
    ar: 'اختياري',
    bn: 'ঐচ্ছিক',
    ru: 'Необязательный',
    ja: '任意',
    tr: 'İsteğe bağlı',
    ko: '선택 사항',
    vi: 'Không bắt buộc',
    id: 'Opsional',
    th: 'ไม่จำเป็น',
    ms: 'Pilihan',
    ar_eg: 'اختياري',
    uk: 'Необов’язковий',
  },
  note: {
    en: 'Note',
    es: 'Nota',
    fr: 'Note',
    de: 'Notiz',
    pt: 'Nota',
    pl: 'Notatka',
    nl: 'Notitie',
    el: 'Σημείωση',
    cs: 'Poznámka',
    sv: 'Anteckning',
    hu: 'Megjegyzés',
    da: 'Note',
    fi: 'Huomautus',
    sk: 'Poznámka',
    bg: 'Бележка',
    hr: 'Bilješka',
    lt: 'Pastaba',
    lv: 'Piezīme',
    et: 'Märkus',
    sl: 'Opomba',
    ga: 'Nóta',
    mt: 'Nota',
    cy: 'Nodyn',
    ro: 'Notă',
    it: 'Nota',
    zh_cn: '备注',
    hi: 'नोट',
    ar: 'ملاحظة',
    bn: 'নোট',
    ru: 'Примечание',
    ja: 'ノート',
    tr: 'Not',
    ko: '노트',
    vi: 'Ghi chú',
    id: 'Catatan',
    th: 'บันทึก',
    ms: 'Nota',
    ar_eg: 'ملاحظة',
    uk: 'Примітка',
  },
  contact_info: {
    en: 'Contact Info',
    es: 'Información de contacto',
    fr: 'Informations de contact',
    de: 'Kontaktinformation',
    pt: 'Informações de contato',
    pl: 'Informacje kontaktowe',
    nl: 'Contactgegevens',
    el: 'Στοιχεία επικοινωνίας',
    cs: 'Kontaktní informace',
    sv: 'Kontaktinformation',
    hu: 'Elérhetőségek',
    da: 'Kontaktinformation',
    fi: 'Yhteystiedot',
    sk: 'Kontaktné informácie',
    bg: 'Информация за контакт',
    hr: 'Kontakt informacije',
    lt: 'Kontaktinė informacija',
    lv: 'Kontaktinformācija',
    et: 'Kontaktteave',
    sl: 'Kontaktne informacije',
    ga: 'Eolas Teagmhála',
    mt: 'Informazzjoni ta’ kuntatt',
    cy: 'Gwybodaeth Gyswllt',
    ro: 'Informații de contact',
    it: 'Informazioni di contatto',
    zh_cn: '联系信息',
    hi: 'संपर्क जानकारी',
    ar: 'معلومات الاتصال',
    bn: 'যোগাযোগের তথ্য',
    ru: 'Контактная информация',
    ja: '連絡先情報',
    tr: 'İletişim bilgileri',
    ko: '연락처 정보',
    vi: 'Thông tin liên hệ',
    id: 'Info Kontak',
    th: 'ข้อมูลติดต่อ',
    ms: 'Maklumat Perhubungan',
    ar_eg: 'معلومات الاتصال',
    uk: 'Контактна інформація',
  },
  menu_management: {
    en: 'Menu Management',
    es: 'Gestión de Menús',
    fr: 'Gestion des Menus',
    de: 'Menüverwaltung',
    pt: 'Gestão de Menus',
    pl: 'Zarządzanie Menu',
    nl: 'Menu Beheer',
    el: 'Διαχείριση Μενού',
    cs: 'Správa Menu',
    sv: 'Menyhantering',
    hu: 'Menükezelés',
    da: 'Menuadministration',
    fi: 'Valikon Hallinta',
    sk: 'Manažment Menu',
    bg: 'Управление на Менюта',
    hr: 'Upravljanje Menijem',
    lt: 'Meniu Valdymas',
    lv: 'Ēdienkartes Pārvaldība',
    et: 'Menüü Haldus',
    sl: 'Upravljanje z Meniji',
    ga: 'Bainistíocht Roghchlár',
    mt: 'Ġestjoni tal-Menu',
    cy: 'Rheoli Dewislen',
    ro: 'Managementul Meniului',
    it: 'Gestione del Menu',
    zh_cn: '菜单管理',
    hi: 'मेनू प्रबंधन',
    ar: 'إدارة القائمة',
    bn: 'মেনু পরিচালনা',
    ru: 'Управление Меню',
    ja: 'メニュー管理',
    tr: 'Menü Yönetimi',
    ko: '메뉴 관리',
    vi: 'Quản lý Menu',
    id: 'Manajemen Menu',
    th: 'การจัดการเมนู',
    ms: 'Pengurusan Menu',
    ar_eg: 'إدارة القائمة',
    uk: 'Управління Меню',
  },
  image: {
    en: 'Image',
    es: 'Imagen',
    fr: 'Image',
    de: 'Bild',
    pt: 'Imagem',
    pl: 'Obraz',
    nl: 'Afbeelding',
    el: 'Εικόνα',
    cs: 'Obrázek',
    sv: 'Bild',
    hu: 'Kép',
    da: 'Billede',
    fi: 'Kuva',
    sk: 'Obrázok',
    bg: 'Изображение',
    hr: 'Slika',
    lt: 'Vaizdas',
    lv: 'Attēls',
    et: 'Pilt',
    sl: 'Slika',
    ga: 'Íomhá',
    mt: 'Immaġni',
    cy: 'Delwedd',
    ro: 'Imagine',
    it: 'Immagine',
    zh_cn: '图片',
    hi: 'छवि',
    ar: 'صورة',
    bn: 'চিত্র',
    ru: 'Изображение',
    ja: '画像',
    tr: 'Görüntü',
    ko: '이미지',
    vi: 'Hình ảnh',
    id: 'Gambar',
    th: 'ภาพ',
    ms: 'Imej',
    ar_eg: 'صورة',
    uk: 'Зображення',
  },
  pause: {
    en: 'Pause',
    es: 'Pausa',
    fr: 'Pause',
    de: 'Pausieren',
    pt: 'Pausar',
    pl: 'Pauza',
    nl: 'Pauzeren',
    el: 'Παύση',
    cs: 'Pozastavit',
    sv: 'Pausa',
    hu: 'Szünet',
    da: 'Pause',
    fi: 'Tauko',
    sk: 'Pauza',
    bg: 'Пауза',
    hr: 'Pauziraj',
    lt: 'Pauzė',
    lv: 'Pauze',
    et: 'Paus',
    sl: 'Premor',
    ga: 'Sos',
    mt: 'Pawża',
    cy: 'Oedi',
    ro: 'Pauză',
    it: 'Pausa',
    zh_cn: '暂停',
    hi: 'विराम',
    ar: 'توقف',
    bn: 'বিরতি',
    ru: 'Пауза',
    ja: '一時停止',
    tr: 'Duraklat',
    ko: '일시 정지',
    vi: 'Tạm dừng',
    id: 'Jeda',
    th: 'พัก',
    ms: 'Jeda',
    ar_eg: 'ايقاف مؤقت',
    uk: 'Пауза',
  },
  paused: {
    en: 'Paused',
    es: 'En pausa',
    fr: 'En pause',
    de: 'Pausiert',
    pt: 'Pausado',
    pl: 'Zapauzowane',
    nl: 'Gepauzeerd',
    el: 'Σε παύση',
    cs: 'Pozastaveno',
    sv: 'Pausad',
    hu: 'Szüneteltetve',
    da: 'Pauset',
    fi: 'Tauolla',
    sk: 'Pozastavené',
    bg: 'Паузирано',
    hr: 'Pauzirano',
    lt: 'Pauzėje',
    lv: 'Pauzēts',
    et: 'Pausil',
    sl: 'Zaustavljeno',
    ga: 'Curtha ar sos',
    mt: 'Ippawżat',
    cy: 'Wedi’i oedi',
    ro: 'Pauzat',
    it: 'In pausa',
    zh_cn: '已暂停',
    hi: 'रुका हुआ',
    ar: 'مُوقّف',
    bn: 'বিরতিতে',
    ru: 'На паузе',
    ja: '一時停止中',
    tr: 'Duraklatıldı',
    ko: '일시 정지됨',
    vi: 'Đã tạm dừng',
    id: 'Dijeda',
    th: 'หยุดชั่วคราว',
    ms: 'Dijeda',
    ar_eg: 'متوقف مؤقتاً',
    uk: 'На паузі',
  },
  quick_tip: {
    en: 'Quick Tip',
    es: 'Consejo rápido',
    fr: 'Astuce rapide',
    de: 'Schnelltipp',
    pt: 'Dica rápida',
    pl: 'Szybka wskazówka',
    nl: 'Snelle tip',
    el: 'Γρήγορη συμβουλή',
    cs: 'Rychlý tip',
    sv: 'Snabbtips',
    hu: 'Gyors tipp',
    da: 'Hurtigt tip',
    fi: 'Pikavinkki',
    sk: 'Rýchly tip',
    bg: 'Бърз съвет',
    hr: 'Brzi savjet',
    lt: 'Greita užuomina',
    lv: 'Ātrais padoms',
    et: 'Kiirnõuanne',
    sl: 'Hitri nasvet',
    ga: 'Leid gasta',
    mt: 'Tip malajr',
    cy: 'Awgrym cyflym',
    ro: 'Sfat rapid',
    it: 'Consiglio veloce',
    zh_cn: '快速提示',
    hi: 'त्वरित टिप',
    ar: 'نصيحة سريعة',
    bn: 'দ্রুত টিপ',
    ru: 'Быстрый совет',
    ja: 'クイックチップ',
    tr: 'Hızlı ipucu',
    ko: '빠른 팁',
    vi: 'Mẹo nhanh',
    id: 'Tips cepat',
    th: 'ทิปเร็ว',
    ms: 'Petua pantas',
    ar_eg: 'نصيحة سريعة',
    uk: 'Швидка порада',
  },
  create_new_menu: {
    en: 'Create New Menu',
    es: 'Crear nuevo menú',
    fr: 'Créer un nouveau menu',
    de: 'Neues Menü erstellen',
    pt: 'Criar novo menu',
    pl: 'Utwórz nowe menu',
    nl: 'Nieuw menu aanmaken',
    el: 'Δημιουργία νέου μενού',
    cs: 'Vytvořit nové menu',
    sv: 'Skapa ny meny',
    hu: 'Új menü létrehozása',
    da: 'Opret ny menu',
    fi: 'Luo uusi valikko',
    sk: 'Vytvoriť nové menu',
    bg: 'Създай ново меню',
    hr: 'Stvori novi jelovnik',
    lt: 'Sukurti naują meniu',
    lv: 'Izveidot jaunu izvēlni',
    et: 'Loo uus menüü',
    sl: 'Ustvari novo meni',
    ga: 'Cruthaigh roghchlár nua',
    mt: 'Oħloq menu ġdid',
    cy: 'Creu dewislen newydd',
    ro: 'Crează un meniu nou',
    it: 'Crea nuovo menu',
    zh_cn: '创建新菜单',
    hi: 'नई मेनू बनाएं',
    ar: 'إنشاء قائمة جديدة',
    bn: 'নতুন মেনু তৈরি করুন',
    ru: 'Создать новое меню',
    ja: '新しいメニューを作成',
    tr: 'Yeni Menü Oluştur',
    ko: '새 메뉴 만들기',
    vi: 'Tạo menu mới',
    id: 'Buat Menu Baru',
    th: 'สร้างเมนูใหม่',
    ms: 'Buat Menu Baru',
    ar_eg: 'إنشاء قائمة جديدة',
    uk: 'Створити нове меню',
  },
  duplicate: {
    en: 'Duplicate',
    es: 'Duplicar',
    fr: 'Dupliquer',
    de: 'Duplizieren',
    pt: 'Duplicar',
    pl: 'Duplikować',
    nl: 'Dupliceren',
    el: 'Αντιγράφω',
    cs: 'Duplikovat',
    sv: 'Duplicera',
    hu: 'Másol',
    da: 'Duplikér',
    fi: 'Kopioi',
    sk: 'Duplikovať',
    bg: 'Дублиране',
    hr: 'Dupliciraj',
    lt: 'Dubliuoti',
    lv: 'Dublēt',
    et: 'Dubleeri',
    sl: 'Podvoji',
    ga: 'Dúbailt',
    mt: 'Dupplikat',
    cy: 'Dyblygu',
    ro: 'Duplicare',
    it: 'Duplicare',
    zh_cn: '复制',
    hi: 'डुप्लिकेट',
    ar: 'تكرار',
    bn: 'নকল',
    ru: 'Дублировать',
    ja: '複製',
    tr: 'Çoğalt',
    ko: '복제',
    vi: 'Nhân bản',
    id: 'Duplikat',
    th: 'ทำซ้ำ',
    ms: 'Gandakan',
    ar_eg: 'تكرار',
    uk: 'Дублювати',
  },
  archive: {
    en: 'Archive',
    es: 'Archivar',
    fr: 'Archiver',
    de: 'Archivieren',
    pt: 'Arquivar',
    pl: 'Archiwizować',
    nl: 'Archiveren',
    el: 'Αρχειοθέτηση',
    cs: 'Archivovat',
    sv: 'Arkivera',
    hu: 'Archiválás',
    da: 'Arkivér',
    fi: 'Arkistoida',
    sk: 'Archivovať',
    bg: 'Архивиране',
    hr: 'Arhivirati',
    lt: 'Archyvuoti',
    lv: 'Arhivēt',
    et: 'Arhiveerida',
    sl: 'Arhiviraj',
    ga: 'Cartlannú',
    mt: 'Arkivja',
    cy: 'Archifo',
    ro: 'Arhiva',
    it: 'Archiviare',
    zh_cn: '归档',
    hi: 'संग्रहीत करें',
    ar: 'أرشفة',
    bn: 'আর্কাইভ',
    ru: 'Архивировать',
    ja: 'アーカイブ',
    tr: 'Arşivlemek',
    ko: '보관',
    vi: 'Lưu trữ',
    id: 'Arsipkan',
    th: 'เก็บถาวร',
    ms: 'Arkib',
    ar_eg: 'أرشيف',
    uk: 'Архівувати',
  },
  quick_actions: {
    en: 'Quick Actions',
    es: 'Acciones rápidas',
    fr: 'Actions rapides',
    de: 'Schnellaktionen',
    pt: 'Ações rápidas',
    pl: 'Szybkie akcje',
    nl: 'Snelle acties',
    el: 'Γρήγορες ενέργειες',
    cs: 'Rychlé akce',
    sv: 'Snabbåtgärder',
    hu: 'Gyorsműveletek',
    da: 'Hurtige handlinger',
    fi: 'Pikatoiminnot',
    sk: 'Rýchle akcie',
    bg: 'Бързи действия',
    hr: 'Brze akcije',
    lt: 'Greiti veiksmai',
    lv: 'Ātrās darbības',
    et: 'Kiirtegevused',
    sl: 'Hitre akcije',
    ga: 'Gníomhartha tapa',
    mt: 'Azzjonijiet mgħaġġla',
    cy: 'Gweithrediadau Cyflym',
    ro: 'Acțiuni rapide',
    it: 'Azioni rapide',
    zh_cn: '快速操作',
    hi: 'त्वरित क्रियाएँ',
    ar: 'إجراءات سريعة',
    bn: 'দ্রুত ক্রিয়াকলাপ',
    ru: 'Быстрые действия',
    ja: 'クイックアクション',
    tr: 'Hızlı İşlemler',
    ko: '빠른 작업',
    vi: 'Hành động nhanh',
    id: 'Tindakan Cepat',
    th: 'การกระทำอย่างรวดเร็ว',
    ms: 'Tindakan Pantas',
    ar_eg: 'إجراءات سريعة',
    uk: 'Швидкі дії',
  },
  items: {
    en: 'Items',
    es: 'Artículos',
    fr: 'Articles',
    de: 'Artikel',
    pt: 'Itens',
    pl: 'Przedmioty',
    nl: 'Items',
    el: 'Είδη',
    cs: 'Položky',
    sv: 'Artiklar',
    hu: 'Tételek',
    da: 'Varer',
    fi: 'Kohteet',
    sk: 'Položky',
    bg: 'Артикули',
    hr: 'Stavke',
    lt: 'Prekės',
    lv: 'Preces',
    et: 'Üksused',
    sl: 'Izdelki',
    ga: 'Míreanna',
    mt: 'Oġġetti',
    cy: 'Eitemau',
    ro: 'Articole',
    it: 'Elementi',
    zh_cn: '项目',
    hi: 'वस्तुएँ',
    ar: 'عناصر',
    bn: 'আইটেমস',
    ru: 'Пункты',
    ja: 'アイテムズ',
    tr: 'Öğeler',
    ko: '항목들',
    vi: 'Mục',
    id: 'Item-item',
    th: 'รายการ',
    ms: 'Item-item',
    ar_eg: 'عناصر',
    uk: 'Предмети',
  },
  setting: {
    en: 'Setting',
    es: 'Configuración',
    fr: 'Paramètre',
    de: 'Einstellung',
    pt: 'Configuração',
    pl: 'Ustawienie',
    nl: 'Instelling',
    el: 'Ρύθμιση',
    cs: 'Nastavení',
    sv: 'Inställning',
    hu: 'Beállítás',
    da: 'Indstilling',
    fi: 'Asetus',
    sk: 'Nastavenie',
    bg: 'Настройка',
    hr: 'Postavka',
    lt: 'Nustatymas',
    lv: 'Iestatījums',
    et: 'Seadistus',
    sl: 'Nastavitev',
    ga: 'Socrú',
    mt: 'Konfigurazzjoni',
    cy: 'Gosodiad',
    ro: 'Setare',
    it: 'Impostazione',
    zh_cn: '设置',
    hi: 'सेटिंग',
    ar: 'إعداد',
    bn: 'সেটিং',
    ru: 'Настройки',
    ja: '設定',
    tr: 'Ayar',
    ko: '설정',
    vi: 'Cài đặt',
    id: 'Pengaturan',
    th: 'การตั้งค่า',
    ms: 'Tetapan',
    ar_eg: 'إعداد',
    uk: 'Налаштування',
  },
  branch_name: {
    en: 'Branch Name',
    es: 'Nombre de la Sucursal',
    fr: 'Nom de la Succursale',
    de: 'Name der Filiale',
    pt: 'Nome da Filial',
    pl: 'Nazwa Oddziału',
    nl: 'Naam van de Vestiging',
    el: 'Όνομα Καταστήματος',
    cs: 'Název Pobočky',
    sv: 'Filialnamn',
    hu: 'Fiók Neve',
    da: 'Filialnavn',
    fi: 'Haaran Nimi',
    sk: 'Názov Pobočky',
    bg: 'Име на Клон',
    hr: 'Naziv Poslovnice',
    lt: 'Skyriaus Pavadinimas',
    lv: 'Filiāles Nosaukums',
    et: 'Haru Nimi',
    sl: 'Ime Podružnice',
    ga: 'Ainm na Brainse',
    mt: 'Isem tal-Fergħa',
    cy: 'Enw’r Gangen',
    ro: 'Numele Sucursalei',
    it: 'Nome della Filiale',
    zh_cn: '分店名称',
    hi: 'शाखा का नाम',
    ar: 'اسم الفرع',
    bn: 'শাখার নাম',
    ru: 'Название Филиала',
    ja: '支店名',
    tr: 'Şube Adı',
    ko: '지점 이름',
    vi: 'Tên Chi nhánh',
    id: 'Nama Cabang',
    th: 'ชื่อสาขา',
    ms: 'Nama Cawangan',
    ar_eg: 'اسم الفرع',
    uk: 'Назва Відділення',
  },
  branch_id: {
    en: 'Branch ID',
    es: 'ID de la Sucursal',
    fr: 'ID de la Succursale',
    de: 'Filial-ID',
    pt: 'ID da Filial',
    pl: 'ID Oddziału',
    nl: 'Vestigings-ID',
    el: 'Κωδικός Καταστήματος',
    cs: 'ID Pobočky',
    sv: 'Filial-ID',
    hu: 'Fiókazonosító',
    da: 'Filial-ID',
    fi: 'Haara-ID',
    sk: 'ID Pobočky',
    bg: 'ID на Клон',
    hr: 'ID Poslovnice',
    lt: 'Skyriaus ID',
    lv: 'Filiāles ID',
    et: 'Haru ID',
    sl: 'ID Podružnice',
    ga: 'Aitheantas Brainse',
    mt: 'ID tal-Fergħa',
    cy: 'ID y Gangen',
    ro: 'ID Sucursală',
    it: 'ID della Filiale',
    zh_cn: '分店 ID',
    hi: 'शाखा ID',
    ar: 'معرّف الفرع',
    bn: 'শাখার আইডি',
    ru: 'ID Филиала',
    ja: '支店ID',
    tr: 'Şube ID',
    ko: '지점 ID',
    vi: 'ID Chi nhánh',
    id: 'ID Cabang',
    th: 'รหัสสาขา',
    ms: 'ID Cawangan',
    ar_eg: 'معرّف الفرع',
    uk: 'ID Відділення',
  },
  select_availability: {
    en: 'Select Availability',
    es: 'Seleccionar Disponibilidad',
    fr: 'Sélectionner la Disponibilité',
    de: 'Verfügbarkeit Auswählen',
    pt: 'Selecionar Disponibilidade',
    pl: 'Wybierz Dostępność',
    nl: 'Beschikbaarheid Selecteren',
    el: 'Επιλογή Διαθεσιμότητας',
    cs: 'Vybrat Dostupnost',
    sv: 'Välj Tillgänglighet',
    hu: 'Elérhetőség Kiválasztása',
    da: 'Vælg Tilgængelighed',
    fi: 'Valitse Saatavuus',
    sk: 'Vybrať Dostupnosť',
    bg: 'Изберете Наличност',
    hr: 'Odaberite Raspoloživost',
    lt: 'Pasirinkite Prieinamumą',
    lv: 'Izvēlēties Pieejamību',
    et: 'Vali Saadavus',
    sl: 'Izberite Razpoložljivost',
    ga: 'Roghnaigh Infhaighteacht',
    mt: 'Agħżel Disponibbiltà',
    cy: 'Dewis Argaeledd',
    ro: 'Selectați Disponibilitatea',
    it: 'Seleziona Disponibilità',
    zh_cn: '选择可用性',
    hi: 'उपलब्धता चुनें',
    ar: 'اختر التوافر',
    bn: 'উপলব্ধতা নির্বাচন করুন',
    ru: 'Выбрать Наличие',
    ja: '利用可能を選択',
    tr: 'Kullanılabilirliği Seç',
    ko: '가용성 선택',
    vi: 'Chọn Khả năng Cung Cấp',
    id: 'Pilih Ketersediaan',
    th: 'เลือกความพร้อมใช้งาน',
    ms: 'Pilih Ketersediaan',
    ar_eg: 'اختر التوافر',
    uk: 'Вибрати Наявність',
  },
  reports: {
    en: 'Reports',
    es: 'Informes',
    fr: 'Rapports',
    de: 'Berichte',
    pt: 'Relatórios',
    pl: 'Raporty',
    nl: 'Rapporten',
    el: 'Αναφορές',
    cs: 'Zprávy',
    sv: 'Rapporter',
    hu: 'Jelentések',
    da: 'Rapporter',
    fi: 'Raportit',
    sk: 'Správy',
    bg: 'Отчети',
    hr: 'Izvješća',
    lt: 'Ataskaitos',
    lv: 'Pārskati',
    et: 'Aruanded',
    sl: 'Poročila',
    ga: 'Tuarascálacha',
    mt: 'Rapporti',
    cy: 'Adroddiadau',
    ro: 'Rapoarte',
    it: 'Rapporti',
    zh_cn: '报告',
    hi: 'रिपोर्ट्स',
    ar: 'التقارير',
    bn: 'রিপোর্ট',
    ru: 'Отчёты',
    ja: 'レポート',
    tr: 'Raporlar',
    ko: '보고서',
    vi: 'Báo cáo',
    id: 'Laporan',
    th: 'รายงาน',
    ms: 'Laporan',
    ar_eg: 'التقارير',
    uk: 'Звіти',
  },
  not_available: {
    en: 'Not Available',
    es: 'No Disponible',
    fr: 'Indisponible',
    de: 'Nicht Verfügbar',
    pt: 'Não Disponível',
    pl: 'Niedostępne',
    nl: 'Niet Beschikbaar',
    el: 'Μη Διαθέσιμο',
    cs: 'Nedostupné',
    sv: 'Ej Tillgänglig',
    hu: 'Nem Elérhető',
    da: 'Ikke Tilgængelig',
    fi: 'Ei Saatavilla',
    sk: 'Nedostupné',
    bg: 'Не е Налично',
    hr: 'Nije Dostupno',
    lt: 'Neprieinama',
    lv: 'Nav Pieejams',
    et: 'Pole Saadaval',
    sl: 'Ni na Voljo',
    ga: 'Níl Ar Fáil',
    mt: 'Mhux Disponibbli',
    cy: 'Ddim Ar Gael',
    ro: 'Indisponibil',
    it: 'Non Disponibile',
    zh_cn: '不可用',
    hi: 'उपलब्ध नहीं',
    ar: 'غير متاح',
    bn: 'অনুপলব্ধ',
    ru: 'Недоступно',
    ja: '利用不可',
    tr: 'Mevcut Değil',
    ko: '사용 불가능',
    vi: 'Không Khả Dụng',
    id: 'Tidak Tersedia',
    th: 'ไม่พร้อมใช้งาน',
    ms: 'Tidak Tersedia',
    ar_eg: 'غير متاح',
    uk: 'Не Доступно',
  },
  open: {
    en: 'Open',
    es: 'Abierto',
    fr: 'Ouvert',
    de: 'Offen',
    pt: 'Aberto',
    pl: 'Otwarte',
    nl: 'Open',
    el: 'Ανοικτό',
    cs: 'Otevřeno',
    sv: 'Öppet',
    hu: 'Nyitva',
    da: 'Åben',
    fi: 'Auki',
    sk: 'Otvorené',
    bg: 'Отворено',
    hr: 'Otvoreno',
    lt: 'Atidaryta',
    lv: 'Atvērts',
    et: 'Avatud',
    sl: 'Odprto',
    ga: 'Oscailte',
    mt: 'Miftuħ',
    cy: 'Agor',
    ro: 'Deschis',
    it: 'Aperto',
    zh_cn: '开放',
    hi: 'खुला हुआ',
    ar: 'مفتوح',
    bn: 'খোলা',
    ru: 'Открыто',
    ja: '開店',
    tr: 'Açık',
    ko: '오픈',
    vi: 'Mở cửa',
    id: 'Buka',
    th: 'เปิด',
    ms: 'Buka',
    ar_eg: 'مفتوح',
    uk: 'Відкрито',
  },
  closed: {
    en: 'Closed',
    es: 'Cerrado',
    fr: 'Fermé',
    de: 'Geschlossen',
    pt: 'Fechado',
    pl: 'Zamknięte',
    nl: 'Gesloten',
    el: 'Κλειστό',
    cs: 'Zavřeno',
    sv: 'Stängt',
    hu: 'Zárva',
    da: 'Lukket',
    fi: 'Suljettu',
    sk: 'Zatvorené',
    bg: 'Затворено',
    hr: 'Zatvoreno',
    lt: 'Uždaryta',
    lv: 'Slēgts',
    et: 'Suletud',
    sl: 'Zaprto',
    ga: 'Dúnta',
    mt: 'Magħluq',
    cy: 'Ar Gau',
    ro: 'Închis',
    it: 'Chiuso',
    zh_cn: '关闭',
    hi: 'बंद',
    ar: 'مغلق',
    bn: 'বন্ধ',
    ru: 'Закрыто',
    ja: '閉店',
    tr: 'Kapalı',
    ko: '닫힘',
    vi: 'Đóng cửa',
    id: 'Tutup',
    th: 'ปิด',
    ms: 'Tutup',
    ar_eg: 'مغلق',
    uk: 'Закрито',
  },
  edit: {
    en: 'Edit',
    es: 'Editar',
    fr: 'Modifier',
    de: 'Bearbeiten',
    pt: 'Editar',
    pl: 'Edytuj',
    nl: 'Bewerken',
    el: 'Επεξεργασία',
    cs: 'Upravit',
    sv: 'Redigera',
    hu: 'Szerkeszt',
    da: 'Rediger',
    fi: 'Muokkaa',
    sk: 'Upraviť',
    bg: 'Редактиране',
    hr: 'Uredi',
    lt: 'Redaguoti',
    lv: 'Rediģēt',
    et: 'Muuda',
    sl: 'Uredi',
    ga: 'Cuir in Eagar',
    mt: 'Editja',
    cy: 'Golygu',
    ro: 'Editează',
    it: 'Modifica',
    zh_cn: '编辑',
    hi: 'संपादित करें',
    ar: 'تحرير',
    bn: 'সম্পাদনা',
    ru: 'Редактировать',
    ja: '編集',
    tr: 'Düzenle',
    ko: '편집',
    vi: 'Chỉnh sửa',
    id: 'Edit',
    th: 'แก้ไข',
    ms: 'Edit',
    ar_eg: 'تحرير',
    uk: 'Редагувати',
  },
  quick_tips: {
    en: 'Quick Tips',
    es: 'Consejos Rápidos',
    fr: 'Astuces Rapides',
    de: 'Schnelle Tipps',
    pt: 'Dicas Rápidas',
    pl: 'Szybkie Wskazówki',
    nl: 'Snelle Tips',
    el: 'Γρήγορες Συμβουλές',
    cs: 'Rychlé Tip',
    sv: 'Snabba Tips',
    hu: 'Gyors Tippek',
    da: 'Hurtige Tips',
    fi: 'Pikavinkit',
    sk: 'Rýchle Tipy',
    bg: 'Бързи Съвети',
    hr: 'Brzi Savjeti',
    lt: 'Greiti Patarimai',
    lv: 'Ātrie Padomi',
    et: 'Kiirnõuanded',
    sl: 'Hitri Nasveti',
    ga: 'Leideanna Tapa',
    mt: 'Pariri Mgħaġġla',
    cy: 'Awgrymiadau Cyflym',
    ro: 'Sfaturi Rapide',
    it: 'Consigli Veloci',
    zh_cn: '快速提示',
    hi: 'त्वरित सुझाव',
    ar: 'نصائح سريعة',
    bn: 'দ্রুত পরামর্শ',
    ru: 'Быстрые Советы',
    ja: 'クイックヒント',
    tr: 'Hızlı İpuçları',
    ko: '빠른 팁',
    vi: 'Mẹo Nhanh',
    id: 'Tips Cepat',
    th: 'เคล็ดลับด่วน',
    ms: 'Petua Pantas',
    ar_eg: 'نصائح سريعة',
    uk: 'Швидкі Поради',
  },
  connect: {
    en: 'Connect',
    es: 'Conectar',
    fr: 'Connecter',
    de: 'Verbinden',
    pt: 'Conectar',
    pl: 'Połącz',
    nl: 'Verbinden',
    el: 'Συνδέστε',
    cs: 'Připojit',
    sv: 'Anslut',
    hu: 'Csatlakozás',
    da: 'Forbind',
    fi: 'Yhdistä',
    sk: 'Pripojiť',
    bg: 'Свържете',
    hr: 'Spoji',
    lt: 'Prisijungti',
    lv: 'Savienot',
    et: 'Ühenda',
    sl: 'Poveži',
    ga: 'Nasc',
    mt: 'Qabbad',
    cy: 'Cysylltu',
    ro: 'Conectează',
    it: 'Connetti',
    zh_cn: '连接',
    hi: 'जोड़ें',
    ar: 'اتصال',
    bn: 'সংযুক্ত করুন',
    ru: 'Подключить',
    ja: '接続する',
    tr: 'Bağlan',
    ko: '연결',
    vi: 'Kết nối',
    id: 'Sambungkan',
    th: 'เชื่อมต่อ',
    ms: 'Sambung',
    ar_eg: 'اتصال',
    uk: 'Підключити',
  },
  connected: {
    en: 'Connected',
    es: 'Conectado',
    fr: 'Connecté',
    de: 'Verbunden',
    pt: 'Conectado',
    pl: 'Połączony',
    nl: 'Verbonden',
    el: 'Συνδεδεμένος',
    cs: 'Připojeno',
    sv: 'Ansluten',
    hu: 'Csatlakoztatva',
    da: 'Tilsluttet',
    fi: 'Yhdistetty',
    sk: 'Pripojené',
    bg: 'Свързан',
    hr: 'Povezano',
    lt: 'Prijungtas',
    lv: 'Savienots',
    et: 'Ühendatud',
    sl: 'Povezan',
    ga: 'Nasctha',
    mt: 'Konnessi',
    cy: 'Cysylltiedig',
    ro: 'Conectat',
    it: 'Connesso',
    zh_cn: '已连接',
    hi: 'जुड़ा हुआ',
    ar: 'متصل',
    bn: 'সংযুক্ত',
    ru: 'Подключено',
    ja: '接続済み',
    tr: 'Bağlandı',
    ko: '연결됨',
    vi: 'Đã kết nối',
    id: 'Tersambung',
    th: 'เชื่อมต่อแล้ว',
    ms: 'Bersambung',
    ar_eg: 'متصل',
    uk: 'Підключено',
  },
  item_name: {
    en: 'Item Name',
    es: 'Nombre del Artículo',
    fr: "Nom de l'Article",
    de: 'Artikelname',
    pt: 'Nome do Item',
    pl: 'Nazwa Przedmiotu',
    nl: 'Productnaam',
    el: 'Όνομα Αντικειμένου',
    cs: 'Název Položky',
    sv: 'Artikelnamn',
    hu: 'Tétel Név',
    da: 'Varenavn',
    fi: 'Tuotenimi',
    sk: 'Názov Položky',
    bg: 'Име на Артикула',
    hr: 'Naziv Artikla',
    lt: 'Prekės Pavadinimas',
    lv: 'Preces Nosaukums',
    et: 'Kauba Nimetus',
    sl: 'Ime Artikla',
    ga: 'Ainm an Mhír',
    mt: 'Isem tal-Oġġett',
    cy: 'Enw Eitem',
    ro: 'Numele Articolului',
    it: "Nome dell'Oggetto",
    zh_cn: '项目名称',
    hi: 'वस्तु का नाम',
    ar: 'اسم الصنف',
    bn: 'আইটেমের নাম',
    ru: 'Название Товара',
    ja: '商品名',
    tr: 'Ürün Adı',
    ko: '품목명',
    vi: 'Tên Mục',
    id: 'Nama Barang',
    th: 'ชื่อรายการ',
    ms: 'Nama Item',
    ar_eg: 'اسم العنصر',
    uk: 'Назва Предмету',
  },
  unit: {
    en: 'Unit',
    es: 'Unidad',
    fr: 'Unité',
    de: 'Einheit',
    pt: 'Unidade',
    pl: 'Jednostka',
    nl: 'Eenheid',
    el: 'Μονάδα',
    cs: 'Jednotka',
    sv: 'Enhet',
    hu: 'Egység',
    da: 'Enhed',
    fi: 'Yksikkö',
    sk: 'Jednotka',
    bg: 'Единица',
    hr: 'Jedinica',
    lt: 'Vienetas',
    lv: 'Vienība',
    et: 'Ühik',
    sl: 'Enota',
    ga: 'Aonad',
    mt: 'Unità',
    cy: 'Uned',
    ro: 'Unitate',
    it: 'Unità',
    zh_cn: '单位',
    hi: 'इकाई',
    ar: 'وحدة',
    bn: 'একক',
    ru: 'Единица',
    ja: '単位',
    tr: 'Birim',
    ko: '단위',
    vi: 'Đơn vị',
    id: 'Satuan',
    th: 'หน่วย',
    ms: 'Unit',
    ar_eg: 'وحدة',
    uk: 'Одиниця',
  },
  price: {
    en: 'Price',
    es: 'Precio',
    fr: 'Prix',
    de: 'Preis',
    pt: 'Preço',
    pl: 'Cena',
    nl: 'Prijs',
    el: 'Τιμή',
    cs: 'Cena',
    sv: 'Pris',
    hu: 'Ár',
    da: 'Pris',
    fi: 'Hinta',
    sk: 'Cena',
    bg: 'Цена',
    hr: 'Cijena',
    lt: 'Kaina',
    lv: 'Cena',
    et: 'Hind',
    sl: 'Cena',
    ga: 'Praghas',
    mt: 'Prezz',
    cy: 'Pris',
    ro: 'Preț',
    it: 'Prezzo',
    zh_cn: '价格',
    hi: 'मूल्य',
    ar: 'السعر',
    bn: 'মূল্য',
    ru: 'Цена',
    ja: '価格',
    tr: 'Fiyat',
    ko: '가격',
    vi: 'Giá',
    id: 'Harga',
    th: 'ราคา',
    ms: 'Harga',
    ar_eg: 'السعر',
    uk: 'Ціна',
  },
  selection: {
    en: 'Selection',
    es: 'Selección',
    fr: 'Sélection',
    de: 'Auswahl',
    pt: 'Seleção',
    pl: 'Wybór',
    nl: 'Selectie',
    el: 'Επιλογή',
    cs: 'Výběr',
    sv: 'Urval',
    hu: 'Választék',
    da: 'Udvælgelse',
    fi: 'Valikoima',
    sk: 'Výber',
    bg: 'Избор',
    hr: 'Izbor',
    lt: 'Pasirinkimas',
    lv: 'Izvēle',
    et: 'Valik',
    sl: 'Izbira',
    ga: 'Roghnú',
    mt: 'Għażla',
    cy: 'Dewis',
    ro: 'Selecție',
    it: 'Selezione',
    zh_cn: '选择',
    hi: 'चयन',
    ar: 'اختيار',
    bn: 'নির্বাচন',
    ru: 'Выбор',
    ja: '選択',
    tr: 'Seçim',
    ko: '선택',
    vi: 'Lựa chọn',
    id: 'Pilihan',
    th: 'การเลือก',
    ms: 'Pemilihan',
    ar_eg: 'اختيار',
    uk: 'Вибір',
  },
  back: {
    en: 'Back',
    es: 'Atrás',
    fr: 'Retour',
    de: 'Zurück',
    pt: 'Voltar',
    pl: 'Wróć',
    nl: 'Terug',
    el: 'Πίσω',
    cs: 'Zpět',
    sv: 'Tillbaka',
    hu: 'Vissza',
    da: 'Tilbage',
    fi: 'Takaisin',
    sk: 'Späť',
    bg: 'Назад',
    hr: 'Natrag',
    lt: 'Atgal',
    lv: 'Atpakaļ',
    et: 'Tagasi',
    sl: 'Nazaj',
    ga: 'Ar ais',
    mt: 'Lura',
    cy: 'Yn ôl',
    ro: 'Înapoi',
    it: 'Indietro',
    zh_cn: '返回',
    hi: 'वापस',
    ar: 'عودة',
    bn: 'পেছনে',
    ru: 'Назад',
    ja: '戻る',
    tr: 'Geri',
    ko: '뒤로',
    vi: 'Trở lại',
    id: 'Kembali',
    th: 'กลับ',
    ms: 'Kembali',
    ar_eg: 'العودة',
    uk: 'Назад',
  },
  move: {
    en: 'Move',
    es: 'Mover',
    fr: 'Déplacer',
    de: 'Bewegen',
    pt: 'Mover',
    pl: 'Przenieś',
    nl: 'Verplaatsen',
    el: 'Μετακίνηση',
    cs: 'Přesunout',
    sv: 'Flytta',
    hu: 'Mozgat',
    da: 'Flyt',
    fi: 'Siirrä',
    sk: 'Presunúť',
    bg: 'Премести',
    hr: 'Premjestiti',
    lt: 'Perkelti',
    lv: 'Pārvietot',
    et: 'Liiguta',
    sl: 'Premakni',
    ga: 'Bog',
    mt: 'Mexxi',
    cy: 'Symud',
    ro: 'Mutare',
    it: 'Muovi',
    zh_cn: '移动',
    hi: 'ले जाएँ',
    ar: 'نقل',
    bn: 'সরান',
    ru: 'Переместить',
    ja: '移動',
    tr: 'Taşı',
    ko: '이동',
    vi: 'Di chuyển',
    id: 'Pindah',
    th: 'ย้าย',
    ms: 'Alih',
    ar_eg: 'انقل',
    uk: 'Перемістити',
  },
  icon: {
    en: 'Icon',
    es: 'Icono',
    fr: 'Icône',
    de: 'Symbol',
    pt: 'Ícone',
    pl: 'Ikona',
    nl: 'Icoon',
    el: 'Εικονίδιο',
    cs: 'Ikona',
    sv: 'Ikon',
    hu: 'Ikon',
    da: 'Ikon',
    fi: 'Ikoni',
    sk: 'Ikona',
    bg: 'Икона',
    hr: 'Ikona',
    lt: 'Piktograma',
    lv: 'Ikona',
    et: 'Ikoon',
    sl: 'Ikona',
    ga: 'Deilbhín',
    mt: 'Ikona',
    cy: 'Eicon',
    ro: 'Icoană',
    it: 'Icona',
    zh_cn: '图标',
    hi: 'आइकन',
    ar: 'أيقونة',
    bn: 'আইকন',
    ru: 'Иконка',
    ja: 'アイコン',
    tr: 'Simge',
    ko: '아이콘',
    vi: 'Biểu tượng',
    id: 'Ikon',
    th: 'ไอคอน',
    ms: 'Ikon',
    ar_eg: 'أيقونة',
    uk: 'Іконка',
  },
  no_image: {
    en: 'No Image',
    es: 'Sin Imagen',
    fr: "Pas d'Image",
    de: 'Kein Bild',
    pt: 'Sem Imagem',
    pl: 'Brak Obrazu',
    nl: 'Geen Afbeelding',
    el: 'Χωρίς Εικόνα',
    cs: 'Bez Obrázku',
    sv: 'Ingen Bild',
    hu: 'Nincs Kép',
    da: 'Intet Billede',
    fi: 'Ei Kuvaa',
    sk: 'Žiadny Obrázok',
    bg: 'Няма Изображение',
    hr: 'Nema Slike',
    lt: 'Be Vaizdo',
    lv: 'Nav Attēla',
    et: 'Pilt Puudub',
    sl: 'Brez Slike',
    ga: 'Gan Íomhá',
    mt: 'L-ebda Immaġni',
    cy: 'Dim Delwedd',
    ro: 'Fără Imagine',
    it: 'Nessuna Immagine',
    zh_cn: '无图片',
    hi: 'कोई छवि नहीं',
    ar: 'لا يوجد صورة',
    bn: 'কোনো ছবি নেই',
    ru: 'Нет Изображения',
    ja: '画像なし',
    tr: 'Resim Yok',
    ko: '이미지 없음',
    vi: 'Không Có Hình Ảnh',
    id: 'Tidak Ada Gambar',
    th: 'ไม่มีรูปภาพ',
    ms: 'Tiada Imej',
    ar_eg: 'لا توجد صورة',
    uk: 'Немає Зображення',
  },
  colour_code: {
    en: 'Colour Code',
    es: 'Código de Color',
    fr: 'Code Couleur',
    de: 'Farbcode',
    pt: 'Código de Cor',
    pl: 'Kod Koloru',
    nl: 'Kleurcode',
    el: 'Κωδικός Χρώματος',
    cs: 'Barevný Kód',
    sv: 'Färgkod',
    hu: 'Színkód',
    da: 'Farvekode',
    fi: 'Värikoodi',
    sk: 'Farebný Kód',
    bg: 'Цветов Код',
    hr: 'Kod Boje',
    lt: 'Spalvos Kodas',
    lv: 'Krāsu Kods',
    et: 'Värvikood',
    sl: 'Barvna Koda',
    ga: 'Cód Dath',
    mt: 'Kodiċi tal-Kulur',
    cy: 'Cod Lliw',
    ro: 'Cod de Culoare',
    it: 'Codice Colore',
    zh_cn: '颜色代码',
    hi: 'रंग कोड',
    ar: 'كود اللون',
    bn: 'রঙ কোড',
    ru: 'Цветовой Код',
    ja: 'カラーコード',
    tr: 'Renk Kodu',
    ko: '색상 코드',
    vi: 'Mã Màu',
    id: 'Kode Warna',
    th: 'รหัสสี',
    ms: 'Kod Warna',
    ar_eg: 'رمز اللون',
    uk: 'Кольоровий Код',
  },
  delete_warning: {
    en: 'Are You Sure You want to delete this?',
    es: '¿Estás seguro de que quieres eliminar esto?',
    fr: 'Êtes-vous sûr de vouloir supprimer ceci ?',
    de: 'Sind Sie sicher, dass Sie dies löschen möchten?',
    pt: 'Tem certeza de que deseja excluir isto?',
    pl: 'Czy na pewno chcesz to usunąć?',
    nl: 'Weet u zeker dat u dit wilt verwijderen?',
    el: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό;',
    cs: 'Jste si jisti, že chcete toto smazat?',
    sv: 'Är du säker på att du vill radera detta?',
    hu: 'Biztosan törölni szeretné ezt?',
    da: 'Er du sikker på, at du vil slette dette?',
    fi: 'Oletko varma, että haluat poistaa tämän?',
    sk: 'Ste si istí, že chcete toto odstrániť?',
    bg: 'Сигурни ли сте, че искате да изтриете това?',
    hr: 'Jeste li sigurni da želite izbrisati ovo?',
    lt: 'Ar tikrai norite ištrinti tai?',
    lv: 'Vai tiešām vēlaties izdzēst šo?',
    et: 'Kas olete kindel, et soovite selle kustutada?',
    sl: 'Ali ste prepričani, da želite izbrisati to?',
    ga: 'An bhfuil tú cinnte gur mhaith leat é seo a scrios?',
    mt: 'Żgur li trid tħassar dan?',
    cy: "Ydych chi'n siŵr eich bod am ddileu hyn?",
    ro: 'Sunteți sigur că doriți să ștergeți acest lucru?',
    it: 'Sei sicuro di voler eliminare questo?',
    zh_cn: '你确定要删除这个吗？',
    hi: 'क्या आप वाकई इसे हटाना चाहते हैं?',
    ar: 'هل أنت متأكد أنك تريد حذف هذا؟',
    bn: 'আপনি কি এটি মুছে ফেলতে চান?',
    ru: 'Вы уверены, что хотите удалить это?',
    ja: 'これを削除してもよろしいですか？',
    tr: 'Bunu silmek istediğinizden emin misiniz?',
    ko: '이것을 삭제하시겠습니까?',
    vi: 'Bạn có chắc chắn muốn xóa cái này không?',
    id: 'Apakah Anda yakin ingin menghapus ini?',
    th: 'คุณแน่ใจหรือว่าต้องการลบสิ่งนี้?',
    ms: 'Adakah anda pasti ingin memadam ini?',
    ar_eg: 'هل أنت متأكد أنك تريد حذف هذا؟',
    uk: 'Ви впевнені, що хочете видалити це?',
  },
  add_name: {
    en: 'Add Name',
    es: 'Añadir Nombre',
    fr: 'Ajouter un Nom',
    de: 'Namen Hinzufügen',
    pt: 'Adicionar Nome',
    pl: 'Dodaj Nazwę',
    nl: 'Naam Toevoegen',
    el: 'Προσθήκη Ονόματος',
    cs: 'Přidat Název',
    sv: 'Lägg Till Namn',
    hu: 'Név Hozzáadása',
    da: 'Tilføj Navn',
    fi: 'Lisää Nimi',
    sk: 'Pridať Názov',
    bg: 'Добавяне на Име',
    hr: 'Dodaj Ime',
    lt: 'Pridėti Pavadinimą',
    lv: 'Pievienot Nosaukumu',
    et: 'Lisa Nimi',
    sl: 'Dodaj Ime',
    ga: 'Cuir Ainm leis',
    mt: 'Żid Isem',
    cy: 'Ychwanegu Enw',
    ro: 'Adaugă Nume',
    it: 'Aggiungi Nome',
    zh_cn: '添加名称',
    hi: 'नाम जोड़ें',
    ar: 'أضف اسمًا',
    bn: 'নাম যোগ করুন',
    ru: 'Добавить Имя',
    ja: '名前を追加',
    tr: 'İsim Ekle',
    ko: '이름 추가',
    vi: 'Thêm Tên',
    id: 'Tambahkan Nama',
    th: 'เพิ่มชื่อ',
    ms: 'Tambah Nama',
    ar_eg: 'أضف اسمًا',
    uk: 'Додати Назву',
  },
  filter_branch: {
    en: 'Filter Branch',
    es: 'Filtrar Sucursal',
    fr: 'Filtrer la Succursale',
    de: 'Filiale Filtern',
    pt: 'Filtrar Filial',
    pl: 'Filtruj Oddział',
    nl: 'Vestiging Filteren',
    el: 'Φιλτράρισμα Καταστήματος',
    cs: 'Filtrovat Pobočku',
    sv: 'Filtrera Avdelning',
    hu: 'Fiók Szűrő',
    da: 'Filtrer Afdeling',
    fi: 'Suodata Toimipiste',
    sk: 'Filtrovať Pobočku',
    bg: 'Филтриране на Клон',
    hr: 'Filtriraj Poslovnicu',
    lt: 'Filtruoti Skyrių',
    lv: 'Filtrēt Filiāli',
    et: 'Filtreeri Haru',
    sl: 'Filtriraj Podružnico',
    ga: 'Scag Brainse',
    mt: 'Iffiltra l-Fergħa',
    cy: 'Hidlo Cangen',
    ro: 'Filtrează Sucursala',
    it: 'Filtra Filiale',
    zh_cn: '筛选分支',
    hi: 'शाखा फिल्टर करें',
    ar: 'تصفية الفرع',
    bn: 'শাখা ফিল্টার',
    ru: 'Фильтровать Отделение',
    ja: '支店をフィルター',
    tr: 'Şubeyi Filtrele',
    ko: '지점 필터',
    vi: 'Lọc Chi Nhánh',
    id: 'Saring Cabang',
    th: 'กรองสาขา',
    ms: 'Penapis Cawangan',
    ar_eg: 'تصفية الفرع',
    uk: 'Фільтр Відділення',
  },
  minute: {
    en: 'minute',
    es: 'minuto',
    fr: 'minute',
    de: 'Minute',
    pt: 'minuto',
    pl: 'minuta',
    nl: 'minuut',
    el: 'λεπτό',
    cs: 'minuta',
    sv: 'minut',
    hu: 'perc',
    da: 'minut',
    fi: 'minuutti',
    sk: 'minúta',
    bg: 'минута',
    hr: 'minuta',
    lt: 'minutė',
    lv: 'minūte',
    et: 'minut',
    sl: 'minuta',
    ga: 'nóiméad',
    mt: 'minuta',
    cy: 'munud',
    ro: 'minut',
    it: 'minuto',
    zh_cn: '分钟',
    hi: 'मिनट',
    ar: 'دقيقة',
    bn: 'মিনিট',
    ru: 'минута',
    ja: '分',
    tr: 'dakika',
    ko: '분',
    vi: 'phút',
    id: 'menit',
    th: 'นาที',
    ms: 'minit',
    ar_eg: 'دقيقة',
    uk: 'хвилина',
  },
  minutes: {
    en: 'minutes',
    es: 'minutos',
    fr: 'minutes',
    de: 'Minuten',
    pt: 'minutos',
    pl: 'minuty',
    nl: 'minuten',
    el: 'λεπτά',
    cs: 'minuty',
    sv: 'minuter',
    hu: 'percek',
    da: 'minutter',
    fi: 'minuuttia',
    sk: 'minúty',
    bg: 'минути',
    hr: 'minute',
    lt: 'minutės',
    lv: 'minūtes',
    et: 'minutid',
    sl: 'minute',
    ga: 'nóiméid',
    mt: 'minuti',
    cy: 'munudau',
    ro: 'minute',
    it: 'minuti',
    zh_cn: '分钟',
    hi: 'मिनट',
    ar: 'دقائق',
    bn: 'মিনিট',
    ru: 'минуты',
    ja: '分',
    tr: 'dakika',
    ko: '분',
    vi: 'phút',
    id: 'menit',
    th: 'นาที',
    ms: 'minit',
    ar_eg: 'دقائق',
    uk: 'хвилини',
  },
  days: {
    en: 'days',
    es: 'días',
    fr: 'jours',
    de: 'Tage',
    pt: 'dias',
    pl: 'dni',
    nl: 'dagen',
    el: 'ημέρες',
    cs: 'dny',
    sv: 'dagar',
    hu: 'nap',
    da: 'dage',
    fi: 'päivää',
    sk: 'dni',
    bg: 'дни',
    hr: 'dana',
    lt: 'dienos',
    lv: 'dienas',
    et: 'päeva',
    sl: 'dni',
    ga: 'laethanta',
    mt: 'jiem',
    cy: 'diwrnodau',
    ro: 'zile',
    it: 'giorni',
    zh_cn: '天',
    hi: 'दिन',
    ar: 'أيام',
    bn: 'দিন',
    ru: 'дни',
    ja: '日',
    tr: 'gün',
    ko: '일',
    vi: 'ngày',
    id: 'hari',
    th: 'วัน',
    ms: 'hari',
    ar_eg: 'أيام',
    uk: 'дні',
  },
  select: {
    en: 'Select',
    es: 'Seleccionar',
    fr: 'Sélectionner',
    de: 'Auswählen',
    pt: 'Selecionar',
    pl: 'Wybierz',
    nl: 'Selecteren',
    el: 'Επιλέξτε',
    cs: 'Vybrat',
    sv: 'Välj',
    hu: 'Kiválasztás',
    da: 'Vælg',
    fi: 'Valitse',
    sk: 'Vybrať',
    bg: 'Изберете',
    hr: 'Odaberi',
    lt: 'Pasirinkti',
    lv: 'Izvēlēties',
    et: 'Vali',
    sl: 'Izberi',
    ga: 'Roghnaigh',
    mt: 'Agħżel',
    cy: 'Dewis',
    ro: 'Selectați',
    it: 'Seleziona',
    zh_cn: '选择',
    hi: 'चुनें',
    ar: 'اختر',
    bn: 'নির্বাচন করা',
    ru: 'Выбрать',
    ja: '選択する',
    tr: 'Seç',
    ko: '선택',
    vi: 'Chọn',
    id: 'Pilih',
    th: 'เลือก',
    ms: 'Pilih',
    ar_eg: 'اختر',
    uk: 'Вибрати',
  },
  click: {
    en: 'click',
    es: 'clic',
    fr: 'cliquer',
    de: 'klicken',
    pt: 'clique',
    pl: 'kliknij',
    nl: 'klik',
    el: 'κλικ',
    cs: 'klikněte',
    sv: 'klicka',
    hu: 'kattintás',
    da: 'klik',
    fi: 'klikkaa',
    sk: 'kliknite',
    bg: 'кликнете',
    hr: 'kliknite',
    lt: 'spustelėkite',
    lv: 'noklikšķiniet',
    et: 'kliki',
    sl: 'kliknite',
    ga: 'cliceáil',
    mt: 'ikklikkja',
    cy: 'clicio',
    ro: 'click',
    it: 'clic',
    zh_cn: '点击',
    hi: 'क्लिक करें',
    ar: 'اضغط',
    bn: 'ক্লিক করুন',
    ru: 'нажмите',
    ja: 'クリック',
    tr: 'tıklayın',
    ko: '클릭',
    vi: 'nhấn',
    id: 'klik',
    th: 'คลิก',
    ms: 'klik',
    ar_eg: 'اضغط',
    uk: 'натисніть',
  },
  reject: {
    en: 'Reject',
    es: 'Rechazar',
    fr: 'Rejeter',
    de: 'Ablehnen',
    pt: 'Rejeitar',
    pl: 'Odrzuć',
    nl: 'Afwijzen',
    el: 'Απόρριψη',
    cs: 'Odmítnout',
    sv: 'Avvisa',
    hu: 'Elutasít',
    da: 'Afvis',
    fi: 'Hylkää',
    sk: 'Odmietnuť',
    bg: 'Отхвърляне',
    hr: 'Odbij',
    lt: 'Atmesti',
    lv: 'Noraidīt',
    et: 'Tagasi Lükata',
    sl: 'Zavrni',
    ga: 'Diúltaigh',
    mt: 'Iċħad',
    cy: 'Gwrthod',
    ro: 'Respinge',
    it: 'Rifiuta',
    zh_cn: '拒绝',
    hi: 'अस्वीकार करें',
    ar: 'رفض',
    bn: 'প্রত্যাখ্যান করা',
    ru: 'Отклонить',
    ja: '拒否',
    tr: 'Reddet',
    ko: '거부',
    vi: 'Từ Chối',
    id: 'Tolak',
    th: 'ปฏิเสธ',
    ms: 'Tolak',
    ar_eg: 'رفض',
    uk: 'Відхилити',
  },
  accept: {
    en: 'Accept',
    es: 'Aceptar',
    fr: 'Accepter',
    de: 'Akzeptieren',
    pt: 'Aceitar',
    pl: 'Zaakceptować',
    nl: 'Accepteren',
    el: 'Αποδοχή',
    cs: 'Přijmout',
    sv: 'Acceptera',
    hu: 'Elfogad',
    da: 'Accepter',
    fi: 'Hyväksy',
    sk: 'Prijímať',
    bg: 'Приемам',
    hr: 'Prihvati',
    lt: 'Priimti',
    lv: 'Pieņemt',
    et: 'Nõustu',
    sl: 'Sprejeti',
    ga: 'Glac le',
    mt: 'Aċċetta',
    cy: 'Derbyn',
    ro: 'Accepta',
    it: 'Accetta',
    zh_cn: '接受',
    hi: 'स्वीकार करें',
    ar: 'قبول',
    bn: 'গ্রহণ করুন',
    ru: 'Принять',
    ja: '承諾',
    tr: 'Kabul et',
    ko: '수락',
    vi: 'Chấp nhận',
    id: 'Terima',
    th: 'ยอมรับ',
    ms: 'Terima',
    ar_eg: 'قبول',
    uk: 'Прийняти',
  },
  pair: {
    en: 'Pair',
    es: 'Emparejar',
    fr: 'Associer',
    de: 'Koppeln',
    pt: 'Emparelhar',
    pl: 'Parować',
    nl: 'Koppelen',
    el: 'Συνδυάζω',
    cs: 'Spárovat',
    sv: 'Para ihop',
    hu: 'Párosítani',
    da: 'Parre',
    fi: 'Parittaa',
    sk: 'Spárovať',
    bg: 'Сдвоявам',
    hr: 'Upariti',
    lt: 'Suporuoti',
    lv: 'Savienot pārī',
    et: 'Paarima',
    sl: 'Seznaniti',
    ga: 'Péireáil',
    mt: 'Ipparjar',
    cy: 'Pârâ',
    ro: 'A asocia',
    it: 'Abbinare',
    zh_cn: '配对',
    hi: 'जोड़ना',
    ar: 'إقران',
    bn: 'জোড়া লাগানো',
    ru: 'Сопрягать',
    ja: 'ペアにする',
    tr: 'Eşleştirmek',
    ko: '페어링하다',
    vi: 'Ghép đôi',
    id: 'Memasangkan',
    th: 'จับคู่',
    ms: 'Padankan',
    ar_eg: 'إقران',
    uk: 'Спарювати',
  },
  paired: {
    en: 'Paired',
    es: 'Emparejado',
    fr: 'Apparié',
    de: 'Gekoppelt',
    pt: 'Emparelhado',
    pl: 'Sparowane',
    nl: 'Gekoppeld',
    el: 'Ζευγαρωμένο',
    cs: 'Spárováno',
    sv: 'Parad',
    hu: 'Párosítva',
    da: 'Paret',
    fi: 'Paritettu',
    sk: 'Spárované',
    bg: 'Сдвоен',
    hr: 'Upareno',
    lt: 'Suporuota',
    lv: 'Savienots',
    et: 'Paaritatud',
    sl: 'Sparjeno',
    ga: 'Péireáilte',
    mt: 'Ikkopplat',
    cy: 'Paru',
    ro: 'Asociat',
    it: 'Associato',
    zh_cn: '配对',
    hi: 'जोड़ा गया',
    ar: 'مقترن',
    bn: 'যুক্ত',
    ru: 'Связано',
    ja: 'ペアリング済み',
    tr: 'Eşleşti',
    ko: '페어링됨',
    vi: 'Đã ghép nối',
    id: 'Dipasangkan',
    th: 'จับคู่แล้ว',
    ms: 'Berpasangan',
    ar_eg: 'مقترن',
    uk: "З'єднано",
  },
  coming_soon: {
    en: 'Coming Soon',
    es: 'Próximamente',
    fr: 'Bientôt disponible',
    de: 'Demnächst',
    pt: 'Em breve',
    pl: 'Wkrótce',
    nl: 'Binnenkort',
    el: 'Σύντομα',
    cs: 'Již brzy',
    sv: 'Kommer snart',
    hu: 'Hamarosan',
    da: 'Kommer snart',
    fi: 'Tulossa pian',
    sk: 'Už čoskoro',
    bg: 'Очаквайте скоро',
    hr: 'Uskoro',
    lt: 'Netrukus',
    lv: 'Drīzumā',
    et: 'Peagi saadaval',
    sl: 'Kmalu',
    ga: 'Ag teacht go luath',
    mt: 'Dalwaqt',
    cy: 'Yn dod yn fuan',
    ro: 'În curând',
    it: 'Prossimamente',
    zh_cn: '即将推出',
    hi: 'जल्द आ रहा है',
    ar: 'قريبًا',
    bn: 'শীঘ্রই আসছে',
    ru: 'Скоро будет',
    ja: '近日公開',
    tr: 'Yakında',
    ko: '곧 출시',
    vi: 'Sắp ra mắt',
    id: 'Segera hadir',
    th: 'เร็วๆ นี้',
    ms: 'Akan Datang',
    ar_eg: 'قريبًا',
    uk: 'Скоро',
  },
  link_branches: {
    en: 'Link Branches',
    es: 'Vincular Sucursales',
    fr: 'Lier les Branches',
    de: 'Filialen verbinden',
    pt: 'Vincular Filiais',
    pl: 'Połącz Oddziały',
    nl: 'Vestigingen koppelen',
    el: 'Σύνδεση Κλάδων',
    cs: 'Propojit pobočky',
    sv: 'Länka Filialer',
    hu: 'Ágazatok összekapcsolása',
    da: 'Forbind Afdelinger',
    fi: 'Yhdistä Toimipisteet',
    sk: 'Prepojiť Pobočky',
    bg: 'Свържете Клонове',
    hr: 'Poveži Poslovnice',
    lt: 'Sujungti Filialus',
    lv: 'Savienot Filiāles',
    et: 'Ühenda Harud',
    sl: 'Poveži Podružnice',
    ga: 'Nasc Brainseacha',
    mt: 'Qabbad il-Fergħat',
    cy: 'Cysylltu Canghennau',
    ro: 'Conectează Sucursalele',
    it: 'Collega Filiali',
    zh_cn: '链接分支',
    hi: 'शाखाओं को लिंक करें',
    ar: 'ربط الفروع',
    bn: 'শাখা লিংক করুন',
    ru: 'Связать Филиалы',
    ja: '支店をリンク',
    tr: 'Şubeleri Bağla',
    ko: '지점 연결',
    vi: 'Liên kết Chi nhánh',
    id: 'Hubungkan Cabang',
    th: 'เชื่อมโยงสาขา',
    ms: 'Pautkan Cawangan',
    ar_eg: 'ربط الفروع',
    uk: "З'єднати Відділення",
  },
  item_library: {
    en: 'Item Library',
    es: 'Biblioteca de Artículos',
    fr: "Bibliothèque d'Articles",
    de: 'Artikelbibliothek',
    pt: 'Biblioteca de Itens',
    pl: 'Biblioteka Produktów',
    nl: 'Item Bibliotheek',
    el: 'Βιβλιοθήκη Αντικειμένων',
    cs: 'Knihovna položek',
    sv: 'Föremålsbibliotek',
    hu: 'Tárgykönyvtár',
    da: 'Varebibliotek',
    fi: 'Tuotekirjasto',
    sk: 'Knižnica položiek',
    bg: 'Библиотека за артикули',
    hr: 'Knjižnica stavki',
    lt: 'Prekių biblioteka',
    lv: 'Preču bibliotēka',
    et: 'Esemete teek',
    sl: 'Knjižnica predmetov',
    ga: 'Leabharlann Míreanna',
    mt: 'Librerija tal-Oġġetti',
    cy: 'Llyfrgell Eitemau',
    ro: 'Biblioteca de Articole',
    it: 'Libreria degli Articoli',
    zh_cn: '项目库',
    hi: 'आइटम लाइब्रेरी',
    ar: 'مكتبة العناصر',
    bn: 'আইটেম লাইব্রেরি',
    ru: 'Библиотека предметов',
    ja: 'アイテムライブラリ',
    tr: 'Ürün Kütüphanesi',
    ko: '항목 라이브러리',
    vi: 'Thư viện Mặt hàng',
    id: 'Perpustakaan Item',
    th: 'ไลบรารีไอเท็ม',
    ms: 'Perpustakaan Item',
    ar_eg: 'مكتبة العناصر',
    uk: 'Бібліотека предметів',
  },
  next: {
    en: 'Next',
    es: 'Siguiente',
    fr: 'Suivant',
    de: 'Weiter',
    pt: 'Próximo',
    pl: 'Następny',
    nl: 'Volgende',
    el: 'Επόμενο',
    cs: 'Další',
    sv: 'Nästa',
    hu: 'Következő',
    da: 'Næste',
    fi: 'Seuraava',
    sk: 'Ďalší',
    bg: 'Следващ',
    hr: 'Sljedeći',
    lt: 'Kitas',
    lv: 'Nākamais',
    et: 'Järgmine',
    sl: 'Naslednji',
    ga: 'Ar Aghaidh',
    mt: 'Li jmiss',
    cy: 'Nesaf',
    ro: 'Următor',
    it: 'Prossimo',
    zh_cn: '下一个',
    hi: 'अगला',
    ar: 'التالي',
    bn: 'পরবর্তী',
    ru: 'Следующий',
    ja: '次',
    tr: 'Sonraki',
    ko: '다음',
    vi: 'Tiếp theo',
    id: 'Berikutnya',
    th: 'ถัดไป',
    ms: 'Seterusnya',
    ar_eg: 'التالي',
    uk: 'Наступний',
  },
  branch: {
    en: 'Branch',
    es: 'Sucursal',
    fr: 'Branche',
    de: 'Filiale',
    pt: 'Filial',
    pl: 'Oddział',
    nl: 'Vestiging',
    el: 'Κλάδος',
    cs: 'Pobočka',
    sv: 'Filial',
    hu: 'Fiók',
    da: 'Afdeling',
    fi: 'Haara',
    sk: 'Pobočka',
    bg: 'Клон',
    hr: 'Poslovnica',
    lt: 'Skyrius',
    lv: 'Filiāle',
    et: 'Haru',
    sl: 'Podružnica',
    ga: 'Brainse',
    mt: 'Fergħa',
    cy: 'Cangen',
    ro: 'Sucursală',
    it: 'Filiale',
    zh_cn: '分支',
    hi: 'शाखा',
    ar: 'فرع',
    bn: 'শাখা',
    ru: 'Филиал',
    ja: '支店',
    tr: 'Şube',
    ko: '지점',
    vi: 'Chi nhánh',
    id: 'Cabang',
    th: 'สาขา',
    ms: 'Cawangan',
    ar_eg: 'فرع',
    uk: 'Філія',
  },
  branches: {
    en: 'Branches',
    es: 'Sucursales',
    fr: 'Succursales',
    de: 'Filialen',
    pt: 'Ramos',
    pl: 'Oddziały',
    nl: 'Vestigingen',
    el: 'Υποκαταστήματα',
    cs: 'Pobočky',
    sv: 'Förgreningar',
    hu: 'Ágak',
    da: 'Grene',
    fi: 'Haarat',
    sk: 'Pobočky',
    bg: 'Клонове',
    hr: 'Podružnice',
    lt: 'Filialai',
    lv: 'Filiāles',
    et: 'Filiaalid',
    sl: 'Podružnice',
    ga: 'Craobhacha',
    mt: 'Fergħat',
    cy: 'Canghennau',
    ro: 'Sucursale',
    it: 'Rami',
    zh_cn: '分支',
    hi: 'शाखाएँ',
    ar: 'الفروع',
    bn: 'শাখা',
    ru: 'Филиалы',
    ja: '支店',
    tr: 'Şubeler',
    ko: '지점',
    vi: 'Chi nhánh',
    id: 'Cabang',
    th: 'สาขา',
    ms: 'Cawangan',
    ar_eg: 'الفروع',
    uk: 'Філії',
  },
  request: {
    en: 'Request',
    es: 'Solicitar',
    fr: 'Demander',
    de: 'Anfordern',
    pt: 'Solicitar',
    pl: 'Żądanie',
    nl: 'Verzoek',
    el: 'Αίτηση',
    cs: 'Požadavek',
    sv: 'Begär',
    hu: 'Kérelem',
    da: 'Anmod',
    fi: 'Pyydä',
    sk: 'Žiadosť',
    bg: 'Заявка',
    hr: 'Zahtjev',
    lt: 'Prašymas',
    lv: 'Pieprasījums',
    et: 'Taotlus',
    sl: 'Zahteva',
    ga: 'Iarratas',
    mt: 'Talba',
    cy: 'Cais',
    ro: 'Cerere',
    it: 'Richiesta',
    zh_cn: '请求',
    hi: 'अनुरोध',
    ar: 'طلب',
    bn: 'অনুরোধ',
    ru: 'Запрос',
    ja: 'リクエスト',
    tr: 'İstek',
    ko: '요청',
    vi: 'Yêu cầu',
    id: 'Permintaan',
    th: 'ขอ',
    ms: 'Permintaan',
    ar_eg: 'طلب',
    uk: 'Запит',
  },
  branch_info: {
    en: 'Branch Info',
    es: 'Información de la Sucursal',
    fr: 'Infos de la Succursale',
    de: 'Filialinformationen',
    pt: 'Informações da Filial',
    pl: 'Informacje o Oddziale',
    nl: 'Vestigingsinformatie',
    el: 'Πληροφορίες Υποκαταστήματος',
    cs: 'Informace o Pobočce',
    sv: 'Filialinformation',
    hu: 'Fiók Információ',
    da: 'Afdelingsinfo',
    fi: 'Haaratiedot',
    sk: 'Informácie o Pobočke',
    bg: 'Информация за Клон',
    hr: 'Informacije o Podružnici',
    lt: 'Filio Informacija',
    lv: 'Filiāles Informācija',
    et: 'Haru Info',
    sl: 'Informacije o Podružnici',
    ga: 'Eolas ar an mBrainse',
    mt: 'Informazzjoni dwar il-Fergħa',
    cy: 'Gwybodaeth Cangen',
    ro: 'Informații Sucursală',
    it: 'Info sulla Filiale',
    zh_cn: '分支信息',
    hi: 'शाखा की जानकारी',
    ar: 'معلومات الفرع',
    bn: 'শাখার তথ্য',
    ru: 'Информация о Филиале',
    ja: '支店情報',
    tr: 'Şube Bilgisi',
    ko: '지점 정보',
    vi: 'Thông tin Chi nhánh',
    id: 'Info Cabang',
    th: 'ข้อมูลสาขา',
    ms: 'Info Cawangan',
    ar_eg: 'معلومات الفرع',
    uk: 'Інформація про Відділення',
  },
  inventory_management: {
    en: 'Inventory Management',
    es: 'Gestión de inventarios',
    fr: 'Gestion des stocks',
    de: 'Lagerverwaltung',
    pt: 'Gestão de Inventário',
    pl: 'Zarządzanie zapasami',
    nl: 'Voorraadbeheer',
    el: 'Διαχείριση αποθεμάτων',
    cs: 'Správa zásob',
    sv: 'Lagerhantering',
    hu: 'Készletgazdálkodás',
    da: 'Lagerstyring',
    fi: 'Varastonhallinta',
    sk: 'Správa zásob',
    bg: 'Управление на инвентара',
    hr: 'Upravljanje zalihama',
    lt: 'Inventoriaus valdymas',
    lv: 'Krājumu vadība',
    et: 'Laohaldus',
    sl: 'Upravljanje z zalogo',
    ga: 'Bainistíocht Fardail',
    mt: 'Ġestjoni tal-Inventarju',
    cy: 'Rheoli Stoc',
    ro: 'Gestionarea inventarului',
    it: 'Gestione dell’inventario',
    zh_cn: '库存管理',
    hi: 'इन्वेंटरी प्रबंधन',
    ar: 'إدارة المخزون',
    bn: 'ইনভেন্টরি ব্যবস্থাপনা',
    ru: 'Управление запасами',
    ja: '在庫管理',
    tr: 'Envanter Yönetimi',
    ko: '재고 관리',
    vi: 'Quản lý hàng tồn kho',
    id: 'Manajemen Inventaris',
    th: 'การจัดการสินค้าคงคลัง',
    ms: 'Pengurusan Inventori',
    ar_eg: 'إدارة المخزون',
    uk: 'Управління запасами',
  },
  min_required: {
    en: 'Min Required',
    es: 'Mín. requerido',
    fr: 'Min requis',
    de: 'Min erforderlich',
    pt: 'Mín. necessário',
    pl: 'Min wymagane',
    nl: 'Min vereist',
    el: 'Ελάχ. απαιτούμενο',
    cs: 'Min požadováno',
    sv: 'Min krävs',
    hu: 'Min szükséges',
    da: 'Min påkrævet',
    fi: 'Min vaadittu',
    sk: 'Min požadované',
    bg: 'Мин. изисква се',
    hr: 'Min potrebno',
    lt: 'Min reikalaujama',
    lv: 'Min nepieciešams',
    et: 'Min nõutud',
    sl: 'Min zahtevano',
    ga: 'Íosghá',
    mt: 'Min meħtieġ',
    cy: 'Isaf Angenrheidiol',
    ro: 'Min necesar',
    it: 'Min richiesto',
    zh_cn: '最小需求',
    hi: 'न्यूनतम आवश्यक',
    ar: 'الحد الأدنى المطلوب',
    bn: 'সর্বনিম্ন প্রয়োজন',
    ru: 'Мин необходимо',
    ja: '最小要件',
    tr: 'Min gerekli',
    ko: '최소 요구',
    vi: 'Tối thiểu yêu cầu',
    id: 'Min diperlukan',
    th: 'ต้องการขั้นต่ำ',
    ms: 'Min diperlukan',
    ar_eg: 'الحد الأدنى المطلوب',
    uk: 'Мін необхідно',
  },
  max_allowed: {
    en: 'Max Allowed',
    es: 'Máx. permitido',
    fr: 'Max autorisé',
    de: 'Max erlaubt',
    pt: 'Máx. permitido',
    pl: 'Max dozwolone',
    nl: 'Max toegestaan',
    el: 'Μέγ. επιτρεπτό',
    cs: 'Max povoleno',
    sv: 'Max tillåtet',
    hu: 'Max engedélyezett',
    da: 'Max tilladt',
    fi: 'Max sallittu',
    sk: 'Max povolené',
    bg: 'Макс. разрешено',
    hr: 'Max dopušteno',
    lt: 'Max leidžiama',
    lv: 'Max atļauts',
    et: 'Max lubatud',
    sl: 'Max dovoljeno',
    ga: 'Uas. Ceadaithe',
    mt: 'Massimu permess',
    cy: 'Max Caniateir',
    ro: 'Max permis',
    it: 'Max consentito',
    zh_cn: '最大允许',
    hi: 'अधिकतम अनुमति',
    ar: 'الحد الأقصى المسموح',
    bn: 'সর্বোচ্চ অনুমোদিত',
    ru: 'Макс разрешено',
    ja: '最大許容',
    tr: 'Maks izin verilir',
    ko: '최대 허용',
    vi: 'Tối đa cho phép',
    id: 'Maks. diizinkan',
    th: 'สูงสุดที่อนุญาต',
    ms: 'Maks. dibenarkan',
    ar_eg: 'الحد الأقصى المسموح',
    uk: 'Макс. дозволено',
  },
  min_qty: {
    en: 'Min Qty',
    es: 'Cant. mín.',
    fr: 'Qté min',
    de: 'Min Menge',
    pt: 'Qtde mín',
    pl: 'Min ilość',
    nl: 'Min hoev.',
    el: 'Ελάχ. ποσ.',
    cs: 'Min množství',
    sv: 'Min kvant',
    hu: 'Min menny.',
    da: 'Min antal',
    fi: 'Min määrä',
    sk: 'Min množ.',
    bg: 'Мин кол.',
    hr: 'Min količina',
    lt: 'Min kiekis',
    lv: 'Min daudz.',
    et: 'Min kogus',
    sl: 'Min količina',
    ga: 'Cainn íos',
    mt: 'Kwantità min',
    cy: 'Isaf Nifer',
    ro: 'Cant min',
    it: 'Qtà min',
    zh_cn: '最小数量',
    hi: 'न्यूनतम मात्रा',
    ar: 'الكمية الدنيا',
    bn: 'ন্যূনতম পরিমাণ',
    ru: 'Мин кол-во',
    ja: '最小数量',
    tr: 'Min miktar',
    ko: '최소 수량',
    vi: 'SL tối thiểu',
    id: 'Jml min',
    th: 'จำนวนขั้นต่ำ',
    ms: 'Kuantiti Min',
    ar_eg: 'الكمية الدنيا',
    uk: 'Мін к-сть',
  },
  max_qty: {
    en: 'Max Qty',
    es: 'Cant. máx.',
    fr: 'Qté max',
    de: 'Max Menge',
    pt: 'Qtde máx',
    pl: 'Max ilość',
    nl: 'Max hoev.',
    el: 'Μέγ. ποσ.',
    cs: 'Max množství',
    sv: 'Max kvant',
    hu: 'Max menny.',
    da: 'Max antal',
    fi: 'Max määrä',
    sk: 'Max množ.',
    bg: 'Макс кол.',
    hr: 'Max količina',
    lt: 'Max kiekis',
    lv: 'Max daudz.',
    et: 'Max kogus',
    sl: 'Max količina',
    ga: 'Uasmhéid',
    mt: 'Kwantità max',
    cy: 'Uchafswm Nifer',
    ro: 'Cant max',
    it: 'Qtà max',
    zh_cn: '最大数量',
    hi: 'अधिकतम मात्रा',
    ar: 'الكمية القصوى',
    bn: 'সর্বোচ্চ পরিমাণ',
    ru: 'Макс кол-во',
    ja: '最大数量',
    tr: 'Maks miktar',
    ko: '최대 수량',
    vi: 'SL tối đa',
    id: 'Jml maks',
    th: 'จำนวนสูงสุด',
    ms: 'Kuantiti Maks',
    ar_eg: 'الكمية القصوى',
    uk: 'Макс к-сть',
  },
  default_qty: {
    en: 'Default Qty',
    es: 'Cant. predeterminada',
    fr: 'Qté par défaut',
    de: 'Standardmenge',
    pt: 'Quant. padrão',
    pl: 'Ilość domyślna',
    nl: 'Standaard aantal',
    el: 'Προεπιλεγμένη ποσότητα',
    cs: 'Výchozí množství',
    sv: 'Standardkvantitet',
    hu: 'Alapértelmezett mennyiség',
    da: 'Standardmængde',
    fi: 'Oletusmäärä',
    sk: 'Predvolené množstvo',
    bg: 'Стандартно количество',
    hr: 'Zadana količina',
    lt: 'Numatytasis kiekis',
    lv: 'Noklusējuma daudzums',
    et: 'Vaikimisi kogus',
    sl: 'Privzeta količina',
    ga: 'Cainníocht réamhshocraithe',
    mt: 'Kwantità default',
    cy: 'Qty diofyn',
    ro: 'Cantitate implicită',
    it: 'Quantità predefinita',
    zh_cn: '默认数量',
    hi: 'डिफ़ॉल्ट मात्रा',
    ar: 'الكمية الافتراضية',
    bn: 'ডিফল্ট পরিমাণ',
    ru: 'Количество по умолчанию',
    ja: 'デフォルト数量',
    tr: 'Varsayılan Miktar',
    ko: '기본 수량',
    vi: 'Số lượng mặc định',
    id: 'Jumlah Standar',
    th: 'จำนวนตั้งต้น',
    ms: 'Kuantiti Lalai',
    ar_eg: 'الكمية الافتراضية',
    uk: 'Стандартна кількість',
  },
  inventory_item: {
    en: 'Inventory Item',
    es: 'Artículo de inventario',
    fr: 'Article d’inventaire',
    de: 'Inventarartikel',
    pt: 'Item de inventário',
    pl: 'Przedmiot inwentarzowy',
    nl: 'Inventarisitem',
    el: 'Είδος αποθέματος',
    cs: 'Položka inventáře',
    sv: 'Lagerartikel',
    hu: 'Készletcikk',
    da: 'Lagergenstand',
    fi: 'Varastoartikkeli',
    sk: 'Položka inventára',
    bg: 'Артикул от инвентара',
    hr: 'Stavka inventara',
    lt: 'Inventoriaus prekė',
    lv: 'Inventāra vienība',
    et: 'Inventari ese',
    sl: 'Inventarna postavka',
    ga: 'Mír fardail',
    mt: 'Oġġett tal-inventarju',
    cy: 'Eitem mewnolwg',
    ro: 'Articol de inventar',
    it: 'Articolo d’inventario',
    zh_cn: '库存物品',
    hi: 'सूची आइटम',
    ar: 'عنصر المخزون',
    bn: 'ইনভেন্টরি আইটেম',
    ru: 'Товар на складе',
    ja: '在庫品目',
    tr: 'Envanter Öğesi',
    ko: '재고 품목',
    vi: 'Mục hàng tồn kho',
    id: 'Item inventaris',
    th: 'รายการสินค้าคงคลัง',
    ms: 'Item inventori',
    ar_eg: 'عنصر المخزون',
    uk: 'Товар на складі',
  },
  modifier_category: {
    en: 'Modifier Category',
    es: 'Categoría de modificador',
    fr: 'Catégorie de modificateur',
    de: 'Modifikatorkategorie',
    pt: 'Categoria de modificador',
    pl: 'Kategoria modyfikatora',
    nl: 'Modificatiecategorie',
    el: 'Κατηγορία τροποποιητή',
    cs: 'Kategorie modifikátoru',
    sv: 'Modifieringskategori',
    hu: 'Módosító kategória',
    da: 'Modifieringskategori',
    fi: 'Muokkauskategoria',
    sk: 'Kategória modifikátora',
    bg: 'Категория модификатор',
    hr: 'Kategorija modifikatora',
    lt: 'Modifikatoriaus kategorija',
    lv: 'Modifikatora kategorija',
    et: 'Modifikaatori kategooria',
    sl: 'Kategorija modifikatorja',
    ga: 'Catagóir modhnóra',
    mt: 'Kategorija tal-modifikatur',
    cy: 'Categori Addasu',
    ro: 'Categorie modificator',
    it: 'Categoria del modificatore',
    zh_cn: '修饰符类别',
    hi: 'मॉडिफ़ायर श्रेणी',
    ar: 'فئة المعدّل',
    bn: 'মডিফায়ার বিভাগ',
    ru: 'Категория модификатора',
    ja: '修飾子カテゴリ',
    tr: 'Değiştirici Kategori',
    ko: '수정자 카테고리',
    vi: 'Danh mục điều chỉnh',
    id: 'Kategori Modifikator',
    th: 'หมวดหมู่ตัวปรับเปลี่ยน',
    ms: 'Kategori Pengubah',
    ar_eg: 'فئة المعدّل',
    uk: 'Категорія модифікатора',
  },
  non_inventory_item: {
    en: 'Non-Inventory Item',
    es: 'Artículo no inventariable',
    fr: 'Article hors inventaire',
    de: 'Nicht-Lagerartikel',
    pt: 'Item não inventariado',
    pl: 'Pozycja poza inwentarzem',
    nl: 'Niet-voorraadartikel',
    el: 'Είδος εκτός αποθέματος',
    cs: 'Položka mimo inventář',
    sv: 'Icke-lagerförd artikel',
    hu: 'Nem készleten szereplő tétel',
    da: 'Ikke-lagerført vare',
    fi: 'Ei varastoitava nimike',
    sk: 'Položka mimo inventár',
    bg: 'Артикул извън инвентара',
    hr: 'Stavka izvan inventara',
    lt: 'Neinventorizuota prekė',
    lv: 'Prece ārpus inventāra',
    et: 'Mitteinventari ese',
    sl: 'Izdelek izven zaloge',
    ga: 'Mír neamhfhardail',
    mt: 'Oġġett barra mill-inventarju',
    cy: "Eitem nad yw'n rhan o'r stoc",
    ro: 'Articol neinventariat',
    it: 'Articolo fuori inventario',
    zh_cn: '非库存商品',
    hi: 'गैर-इन्वेंटरी आइटम',
    ar: 'عنصر غير مخزن',
    bn: 'নন-ইনভেন্টরি আইটেম',
    ru: 'Неучтенный товар',
    ja: '非在庫品',
    tr: 'Stok Dışı Ürün',
    ko: '비재고 품목',
    vi: 'Mặt hàng không tồn kho',
    id: 'Barang Non-Inventori',
    th: 'สินค้านอกสต็อก',
    ms: 'Item Bukan Inventori',
    ar_eg: 'عنصر غير مخزن',
    uk: 'Позиція поза складом',
  },
  connected_modifier_group: {
    en: 'Connected Modifier Group',
    es: 'Grupo de modificadores conectado',
    fr: 'Groupe de modificateurs connecté',
    de: 'Verknüpfte Modifikatorgruppe',
    pt: 'Grupo de modificadores conectado',
    pl: 'Połączona grupa modyfikatorów',
    nl: 'Gekoppelde modifiergroep',
    el: 'Συνδεδεμένη ομάδα τροποποιητών',
    cs: 'Připojená skupina modifikátorů',
    sv: 'Ansluten modifierargrupp',
    hu: 'Kapcsolt módosítócsoport',
    da: 'Forbundet modifieringsgruppe',
    fi: 'Yhdistetty muokkaajaryhmä',
    sk: 'Pripojená skupina modifikátorov',
    bg: 'Свързана група модификатори',
    hr: 'Povezana grupa modifikatora',
    lt: 'Susieta modifikatorių grupė',
    lv: 'Savienotā modifikatoru grupa',
    et: 'Ühendatud modifikaatorite rühm',
    sl: 'Povezana skupina modifikatorjev',
    ga: 'Grúpa Modhnóirí Ceangailte',
    mt: 'Grupp ta’ Modifikaturi Konnessi',
    cy: 'Grŵp Addaswyr Cysylltiedig',
    ro: 'Grup de modificatori conectat',
    it: 'Gruppo di modificatori connesso',
    zh_cn: '已连接的修改组',
    hi: 'कनेक्टेड मोडिफ़ायर समूह',
    ar: 'مجموعة معدِّلات متصلة',
    bn: 'সংযুক্ত পরিবর্তক গ্রুপ',
    ru: 'Подключённая группа модификаторов',
    ja: '接続された修飾子グループ',
    tr: 'Bağlı Değiştirici Grubu',
    ko: '연결된 수정자 그룹',
    vi: 'Nhóm sửa đổi đã kết nối',
    id: 'Grup Pengubah yang Terhubung',
    th: 'กลุ่มตัวปรับแต่งที่เชื่อมต่อแล้ว',
    ms: 'Kumpulan Pengubah Bersambung',
    ar_eg: 'مجموعة معدّلات متوصلة',
    uk: 'Підключена група модифікаторів',
  },
  allergens: {
    en: 'Allergens',
    es: 'Alérgenos',
    fr: 'Allergènes',
    de: 'Allergene',
    pt: 'Alergênios',
    pl: 'Alergeny',
    nl: 'Allergenen',
    el: 'Αλλεργιογόνα',
    cs: 'Alergeny',
    sv: 'Allergener',
    hu: 'Allergének',
    da: 'Allergener',
    fi: 'Allergeenit',
    sk: 'Alergény',
    bg: 'Алергени',
    hr: 'Alergeni',
    lt: 'Alergenai',
    lv: 'Alergēni',
    et: 'Allergeenid',
    sl: 'Alergeni',
    ga: 'Ailléirgí',
    mt: 'Allerġeni',
    cy: 'Alergenau',
    ro: 'Alergeni',
    it: 'Allergeni',
    zh_cn: '过敏原',
    hi: 'एलर्जेन',
    ar: 'مسببات الحساسية',
    bn: 'অ্যালার্জেন',
    ru: 'Аллергены',
    ja: 'アレルゲン',
    tr: 'Alerjenler',
    ko: '알레르기 유발 물질',
    vi: 'Chất gây dị ứng',
    id: 'Alergen',
    th: 'สารก่อภูมิแพ้',
    ms: 'Alergen',
    ar_eg: 'مواد مسببة للحساسية',
    uk: 'Алергени',
  },
  select_category: {
    en: 'Select Category',
    es: 'Seleccionar categoría',
    fr: 'Sélectionner une catégorie',
    de: 'Kategorie auswählen',
    pt: 'Selecionar categoria',
    pl: 'Wybierz kategorię',
    nl: 'Selecteer categorie',
    el: 'Επιλέξτε κατηγορία',
    cs: 'Vyberte kategorii',
    sv: 'Välj kategori',
    hu: 'Kategória kiválasztása',
    da: 'Vælg kategori',
    fi: 'Valitse kategoria',
    sk: 'Vybrať kategóriu',
    bg: 'Изберете категория',
    hr: 'Odaberite kategoriju',
    lt: 'Pasirinkite kategoriją',
    lv: 'Izvēlieties kategoriju',
    et: 'Valige kategooria',
    sl: 'Izberite kategorijo',
    ga: 'Roghnaigh catagóir',
    mt: 'Agħżel Kategorija',
    cy: 'Dewiswch Gategori',
    ro: 'Selectați categoria',
    it: 'Seleziona categoria',
    zh_cn: '选择类别',
    hi: 'श्रेणी चुनें',
    ar: 'اختر الفئة',
    bn: 'বিভাগ নির্বাচন করুন',
    ru: 'Выберите категорию',
    ja: 'カテゴリーを選択',
    tr: 'Kategori Seç',
    ko: '카테고리 선택',
    vi: 'Chọn danh mục',
    id: 'Pilih Kategori',
    th: 'เลือกหมวดหมู่',
    ms: 'Pilih Kategori',
    ar_eg: 'اختار القسم',
    uk: 'Виберіть категорію',
  },
  category_name: {
    en: 'Category Name',
    es: 'Nombre de Categoría',
    fr: 'Nom de la Catégorie',
    de: 'Kategoriename',
    pt: 'Nome da Categoria',
    pl: 'Nazwa Kategorii',
    nl: 'Categorienaam',
    el: 'Όνομα Κατηγορίας',
    cs: 'Název Kategorie',
    sv: 'Kategorinamn',
    hu: 'Kategórianév',
    da: 'Kategorinavn',
    fi: 'Kategorianimi',
    sk: 'Názov Kategórie',
    bg: 'Име на Категория',
    hr: 'Naziv Kategorije',
    lt: 'Kategorijos Pavadinimas',
    lv: 'Kategorijas Nosaukums',
    et: 'Kategooria Nimi',
    sl: 'Ime Kategorije',
    ga: 'Ainm Catagóire',
    mt: 'Isem tal-Kategorija',
    cy: 'Enw Categori',
    ro: 'Nume Categoriei',
    it: 'Nome della Categoria',
    zh_cn: '类别名称',
    hi: 'श्रेणी नाम',
    ar: 'اسم الفئة',
    bn: 'বিভাগের নাম',
    ru: 'Название Категории',
    ja: 'カテゴリ名',
    tr: 'Kategori Adı',
    ko: '카테고리 이름',
    vi: 'Tên Danh Mục',
    id: 'Nama Kategori',
    th: 'ชื่อหมวดหมู่',
    ms: 'Nama Kategori',
    ar_eg: 'اسم التصنيف',
    uk: 'Назва Категорії',
  },
  minimum_required: {
    en: 'Minimum Required',
    es: 'Mínimo Requerido',
    fr: 'Minimum Requis',
    de: 'Mindestanforderung',
    pt: 'Mínimo Requerido',
    pl: 'Minimalna Wymagana',
    nl: 'Minimaal Vereist',
    el: 'Ελάχιστο Απαιτούμενο',
    cs: 'Minimální Požadované',
    sv: 'Minimikrav',
    hu: 'Minimálisan Szükséges',
    da: 'Minimumkrav',
    fi: 'Minimi Vaaditaan',
    sk: 'Minimálne Požadované',
    bg: 'Минимално Изискване',
    hr: 'Minimalno Potrebno',
    lt: 'Minimaliai Reikalingas',
    lv: 'Minimāli Nepieciešams',
    et: 'Minimaalne Vajalik',
    sl: 'Minimalno Zahtevano',
    ga: 'Íosriachtanas',
    mt: 'Minimu Meħtieġ',
    cy: 'Isafswm Angenrheidiol',
    ro: 'Minim Necesar',
    it: 'Minimo Richiesto',
    zh_cn: '最低要求',
    hi: 'न्यूनतम आवश्यक',
    ar: 'الحد الأدنى المطلوب',
    bn: 'সর্বনিম্ন প্রয়োজনীয়',
    ru: 'Минимально Требуемое',
    ja: '最低限必要',
    tr: 'Gerekli Minimum',
    ko: '최소 필요',
    vi: 'Yêu Cầu Tối Thiểu',
    id: 'Minimum Diperlukan',
    th: 'ต้องการขั้นต่ำ',
    ms: 'Minimum Diperlukan',
    ar_eg: 'الحد الأدنى المطلوب',
    uk: 'Мінімально Потрібно',
  },
  maximum_allowed: {
    en: 'Maximum Allowed',
    es: 'Máximo Permitido',
    fr: 'Maximum Autorisé',
    de: 'Maximal Erlaubt',
    pt: 'Máximo Permitido',
    pl: 'Maksymalna Dozwolona',
    nl: 'Maximaal Toegestaan',
    el: 'Μέγιστο Επιτρεπτό',
    cs: 'Maximální Povolené',
    sv: 'Maximalt Tillåtet',
    hu: 'Maximálisan Engedélyezett',
    da: 'Maksimum Tilladt',
    fi: 'Enimmäismäärä Sallittu',
    sk: 'Maximálne Povolené',
    bg: 'Максимално Допустимо',
    hr: 'Maksimalno Dopušteno',
    lt: 'Maksimaliai Leidžiama',
    lv: 'Maksimāli Atļauts',
    et: 'Maksimaalne Lubatud',
    sl: 'Največ Dovoljeno',
    ga: 'Uasmhéid Ceadaithe',
    mt: 'Massimu Permess',
    cy: 'Uchafswm a Ganiateir',
    ro: 'Maxim Permis',
    it: 'Massimo Consentito',
    zh_cn: '最多允许',
    hi: 'अधिकतम अनुमति',
    ar: 'الحد الأقصى المسموح به',
    bn: 'সর্বাধিক অনুমোদিত',
    ru: 'Максимально Допустимое',
    ja: '最大許容',
    tr: 'Maksimum İzin Verilen',
    ko: '최대 허용',
    vi: 'Tối Đa Cho Phép',
    id: 'Maksimum Diizinkan',
    th: 'สูงสุดที่อนุญาต',
    ms: 'Maksimum Dibenarkan',
    ar_eg: 'الحد الأقصى المسموح به',
    uk: 'Максимально Допустиме',
  },
  unlink: {
    en: 'Unlink',
    es: 'Desvincular',
    fr: 'Dissocier',
    de: 'Verknüpfung aufheben',
    pt: 'Desvincular',
    pl: 'Odłączyć',
    nl: 'Ontkoppelen',
    el: 'Αποσύνδεση',
    cs: 'Odpojit',
    sv: 'Koppla bort',
    hu: 'Kapcsolat megszüntetése',
    da: 'Fjern forbindelse',
    fi: 'Poista linkki',
    sk: 'Odpojiť',
    bg: 'Прекъсване на връзката',
    hr: 'Odspoji',
    lt: 'Atsieti',
    lv: 'Atvienot',
    et: 'Ühenda lahti',
    sl: 'Odstrani povezavo',
    ga: 'Dícheangail',
    mt: 'Illinkja',
    cy: 'Datgysylltu',
    ro: 'Dezlegare',
    it: 'Scollega',
    zh_cn: '取消链接',
    hi: 'अनलिंक करें',
    ar: 'إلغاء الربط',
    bn: 'আনলিঙ্ক',
    ru: 'Отвязать',
    ja: 'リンクを解除',
    tr: 'Bağlantıyı kaldır',
    ko: '연결 해제',
    vi: 'Hủy liên kết',
    id: 'Putuskan tautan',
    th: 'ยกเลิกการเชื่อมต่อ',
    ms: 'Nyah paut',
    ar_eg: 'إلغاء الربط',
    uk: "Від'єднати",
  },
  disconnect: {
    en: 'Disconnect',
    es: 'Desconectar',
    fr: 'Déconnecter',
    de: 'Trennen',
    pt: 'Desconectar',
    pl: 'Odłącz',
    nl: 'Verbinding verbreken',
    el: 'Αποσύνδεση',
    cs: 'Odpojit',
    sv: 'Koppla bort',
    hu: 'Leválasztás',
    da: 'Afbryd',
    fi: 'Katkaise yhteys',
    sk: 'Odpojiť',
    bg: 'Прекъсване на връзката',
    hr: 'Odspoji',
    lt: 'Atsijungti',
    lv: 'Atvienot',
    et: 'Ühenda lahti',
    sl: 'Odklopi',
    ga: 'Dícheangail',
    mt: 'Illinkja',
    cy: 'Datgysylltu',
    ro: 'Deconectare',
    it: 'Scollega',
    zh_cn: '断开连接',
    hi: 'डिस्कनेक्ट करें',
    ar: 'قطع الاتصال',
    bn: 'সংযোগ বিচ্ছিন্ন করুন',
    ru: 'Отключить',
    ja: '切断',
    tr: 'Bağlantıyı kes',
    ko: '연결 해제',
    vi: 'Ngắt kết nối',
    id: 'Putuskan sambungan',
    th: 'ตัดการเชื่อมต่อ',
    ms: 'Putuskan sambungan',
    ar_eg: 'قطع الاتصال',
    uk: "Від'єднати",
  },
  linked_branches: {
    en: 'Linked Branches',
    es: 'Sucursales Vinculadas',
    fr: 'Branches Liées',
    de: 'Verknüpfte Filialen',
    pt: 'Filiais Vinculadas',
    pl: 'Powiązane Oddziały',
    nl: 'Gekoppelde vestigingen',
    el: 'Συνδεδεμένα Υποκαταστήματα',
    cs: 'Propojené pobočky',
    sv: 'Länkade filialer',
    hu: 'Kapcsolt fiókok',
    da: 'Tilknyttede filialer',
    fi: 'Yhdistetyt haarat',
    sk: 'Prepojené pobočky',
    bg: 'Свързани клонове',
    hr: 'Povezane podružnice',
    lt: 'Susieti filialai',
    lv: 'Saistītās filiāles',
    et: 'Seotud filiaalid',
    sl: 'Povezane podružnice',
    ga: 'Brainse Ceangailte',
    mt: 'Fergħat Marbuta',
    cy: 'Canghennau cysylltiedig',
    ro: 'Filiale legate',
    it: 'Filiali collegate',
    zh_cn: '关联分支机构',
    hi: 'लिंक्ड शाखाएं',
    ar: 'الفروع المرتبطة',
    bn: 'লিঙ্ক করা শাখা',
    ru: 'Связанные филиалы',
    ja: 'リンクされた支店',
    tr: 'Bağlantılı Şubeler',
    ko: '연결된 지점',
    vi: 'Chi nhánh đã liên kết',
    id: 'Cabang Tertaut',
    th: 'สาขาที่เชื่อมโยง',
    ms: 'Cawangan Pautan',
    ar_eg: 'الفروع المرتبطة',
    uk: "Пов'язані філії",
  },
  branches_linked: {
    en: 'Branches Linked',
    es: 'Sucursales Vinculadas',
    fr: 'Agences Liées',
    de: 'Verbundene Filialen',
    pt: 'Filiais Ligadas',
    pl: 'Połączone Oddziały',
    nl: 'Gekoppelde Vestigingen',
    el: 'Συνδεδεμένα Υποκαταστήματα',
    cs: 'Propojené Pobočky',
    sv: 'Länkade Filialer',
    hu: 'Kapcsolódó Fiókok',
    da: 'Forbundne Filialer',
    fi: 'Yhdistetyt Sivuliikkeet',
    sk: 'Prepojené Pobočky',
    bg: 'Свързани Клонове',
    hr: 'Povezane Podružnice',
    lt: 'Susietos Filialai',
    lv: 'Saistītās Filiāles',
    et: 'Seotud Filiaalid',
    sl: 'Povezane Podružnice',
    ga: 'Brainse Ceangailte',
    mt: 'Fergħat Ikkollegati',
    cy: 'Canghennau Cysylltiedig',
    ro: 'Sucursale Legate',
    it: 'Filiali Collegate',
    zh_cn: '关联分支机构',
    hi: 'शाखाएँ जुड़ी हुई हैं',
    ar: 'الفروع المرتبطة',
    bn: 'শাখাসমূহ সংযুক্ত',
    ru: 'Связанные филиалы',
    ja: 'リンクされた支店',
    tr: 'Bağlı Şubeler',
    ko: '연결된 지점',
    vi: 'Chi nhánh được liên kết',
    id: 'Cabang Terhubung',
    th: 'สาขาที่เชื่อมโยง',
    ms: 'Cawangan Dihubungkan',
    ar_eg: 'الفروع المرتبطة',
    uk: "Пов'язані філії",
  },
  dont_need_integration: {
    en: 'Don’t need your %s integration',
    es: 'No necesita su integración con %s',
    fr: 'Pas besoin de votre intégration %s',
    de: 'Brauchen Sie Ihre %s-Integration nicht',
    pt: 'Não precisa da sua integração com %s',
    pl: 'Nie potrzebujesz integracji %s',
    nl: 'Heeft u uw %s-integratie niet nodig',
    el: 'Δεν χρειάζεστε την ενσωμάτωση %s',
    cs: 'Nepotřebujete svou %s integraci',
    sv: 'Behöver du inte din %s-integration',
    hu: 'Nincs szüksége a %s integrációra',
    da: 'Behøver du ikke din %s-integration',
    fi: 'Et tarvitse %s-integraatiota',
    sk: 'Nepotrebujete svoju %s integráciu',
    bg: 'Не се нуждаете от вашата %s интеграция',
    hr: 'Ne trebate integraciju s %s',
    lt: 'Nepageidaujate %s integracijos',
    lv: 'Nepieciešama %s integrācija',
    et: 'Te ei vaja oma %s integratsiooni',
    sl: 'Ne potrebujete integracije %s',
    ga: 'Ní gá duit do chomhtháthú %s',
    mt: 'Ma għandekx bżonn l-integrazzjoni tiegħek %s',
    cy: 'Nid oes angen eich integreiddio %s',
    ro: 'Nu ai nevoie de integrarea %s',
    it: 'Non hai bisogno della tua integrazione %s',
    zh_cn: '不需要您的%s集成',
    hi: 'आपको अपने %s एकीकरण की आवश्यकता नहीं है',
    ar: 'لست بحاجة إلى تكامل %s الخاص بك',
    bn: 'আপনার %s ইন্টিগ্রেশন প্রয়োজন নেই',
    ru: 'Не нуждаетесь в интеграции %s',
    ja: '%s 統合は不要',
    tr: '%s entegrasyonuna ihtiyacınız yok',
    ko: '%s 통합이 필요하지 않음',
    vi: 'Không cần tích hợp %s của bạn',
    id: 'Tidak perlu integrasi %s Anda',
    th: 'ไม่ต้องการการรวม %s ของคุณ',
    ms: 'Tidak memerlukan penyepaduan %s anda',
    ar_eg: 'لست بحاجة إلى تكامل %s الخاص بك',
    uk: 'Не потрібно інтеграції %s',
  },
  bulk_actions: {
    en: 'Bulk Actions',
    es: 'Acciones masivas',
    fr: 'Actions groupées',
    de: 'Massenaktionen',
    pt: 'Ações em massa',
    pl: 'Działania zbiorcze',
    nl: 'Bulkacties',
    el: 'Μαζικές ενέργειες',
    cs: 'Hromadné akce',
    sv: 'Massåtgärder',
    hu: 'Tömeges műveletek',
    da: 'Massehandlinger',
    fi: 'Joukkotoimet',
    sk: 'Hromadné akcie',
    bg: 'Групови действия',
    hr: 'Skupne radnje',
    lt: 'Grupinės veiklos',
    lv: 'Masveida darbības',
    et: 'Hulgi toimingud',
    sl: 'Skupinska dejanja',
    ga: 'Gníomhartha Bulc',
    mt: 'Azzjonijiet bl-ingrossa',
    cy: 'Gweithredoedd Swmp',
    ro: 'Acțiuni în masă',
    it: 'Azioni collettive',
    zh_cn: '批量操作',
    hi: 'थोक क्रियाएँ',
    ar: 'إجراءات جماعية',
    bn: 'বাল্ক অ্যাকশন',
    ru: 'Массовые действия',
    ja: '一括操作',
    tr: 'Toplu İşlemler',
    ko: '대량 작업',
    vi: 'Hành động hàng loạt',
    id: 'Aksi Massal',
    th: 'การดำเนินการจำนวนมาก',
    ms: 'Tindakan Pukal',
    ar_eg: 'إجراءات جماعية',
    uk: 'Масові дії',
  },
  select_all: {
    en: 'Select All',
    es: 'Seleccionar todo',
    fr: 'Tout sélectionner',
    de: 'Alle auswählen',
    pt: 'Selecionar todos',
    pl: 'Zaznacz wszystko',
    nl: 'Alles selecteren',
    el: 'Επιλογή όλων',
    cs: 'Vybrat vše',
    sv: 'Välj alla',
    hu: 'Összes kijelölése',
    da: 'Vælg alle',
    fi: 'Valitse kaikki',
    sk: 'Vybrať všetko',
    bg: 'Избери всичко',
    hr: 'Odaberi sve',
    lt: 'Pasirinkti viską',
    lv: 'Izvēlēties visu',
    et: 'Vali kõik',
    sl: 'Izberi vse',
    ga: 'Roghnaigh Gach',
    mt: 'Agħżel Kollox',
    cy: 'Dewis Pob Un',
    ro: 'Selectează tot',
    it: 'Seleziona tutto',
    zh_cn: '全选',
    hi: 'सभी चुनें',
    ar: 'اختر الكل',
    bn: 'সব নির্বাচন করুন',
    ru: 'Выбрать все',
    ja: 'すべて選択',
    tr: 'Hepsini seç',
    ko: '모두 선택',
    vi: 'Chọn tất cả',
    id: 'Pilih Semua',
    th: 'เลือกทั้งหมด',
    ms: 'Pilih Semua',
    ar_eg: 'اختر الكل',
    uk: 'Вибрати всі',
  },
  publish: {
    en: 'Publish',
    es: 'Publicar',
    fr: 'Publier',
    de: 'Veröffentlichen',
    pt: 'Publicar',
    pl: 'Opublikuj',
    nl: 'Publiceren',
    el: 'Δημοσίευση',
    cs: 'Publikovat',
    sv: 'Publicera',
    hu: 'Közzététel',
    da: 'Udgiv',
    fi: 'Julkaise',
    sk: 'Zverejniť',
    bg: 'Публикувай',
    hr: 'Objavi',
    lt: 'Publikuoti',
    lv: 'Publicēt',
    et: 'Avalda',
    sl: 'Objavi',
    ga: 'Foilsigh',
    mt: 'Ippubblika',
    cy: 'Cyhoeddi',
    ro: 'Publică',
    it: 'Pubblica',
    zh_cn: '发布',
    hi: 'प्रकाशित करें',
    ar: 'نشر',
    bn: 'প্রকাশ করুন',
    ru: 'Опубликовать',
    ja: '公開する',
    tr: 'Yayınla',
    ko: '게시',
    vi: 'Xuất bản',
    id: 'Terbitkan',
    th: 'เผยแพร่',
    ms: 'Terbitkan',
    ar_eg: 'نشر',
    uk: 'Опублікувати',
  },
  add: {
    en: 'Add',
    es: 'Agregar',
    fr: 'Ajouter',
    de: 'Hinzufügen',
    pt: 'Adicionar',
    pl: 'Dodaj',
    nl: 'Toevoegen',
    el: 'Προσθήκη',
    cs: 'Přidat',
    sv: 'Lägg till',
    hu: 'Hozzáad',
    da: 'Tilføj',
    fi: 'Lisää',
    sk: 'Pridať',
    bg: 'Добавяне',
    hr: 'Dodaj',
    lt: 'Pridėti',
    lv: 'Pievienot',
    et: 'Lisa',
    sl: 'Dodaj',
    ga: 'Cuir leis',
    mt: 'Żid',
    cy: 'Ychwanegu',
    ro: 'Adăuga',
    it: 'Aggiungi',
    zh_cn: '添加',
    hi: 'जोड़ें',
    ar: 'إضافة',
    bn: 'যোগ করুন',
    ru: 'Добавить',
    ja: '追加',
    tr: 'Ekle',
    ko: '추가',
    vi: 'Thêm',
    id: 'Tambah',
    th: 'เพิ่ม',
    ms: 'Tambah',
    ar_eg: 'إضافة',
    uk: 'Додати',
  },
  new: {
    en: 'New',
    es: 'Nuevo',
    fr: 'Nouveau',
    de: 'Neu',
    pt: 'Novo',
    pl: 'Nowy',
    nl: 'Nieuw',
    el: 'Νέος',
    cs: 'Nový',
    sv: 'Ny',
    hu: 'Új',
    da: 'Ny',
    fi: 'Uusi',
    sk: 'Nový',
    bg: 'Нов',
    hr: 'Novi',
    lt: 'Naujas',
    lv: 'Jauns',
    et: 'Uus',
    sl: 'Nov',
    ga: 'Nua',
    mt: 'Ġdid',
    cy: 'Newydd',
    ro: 'Nou',
    it: 'Nuovo',
    zh_cn: '新',
    hi: 'नया',
    ar: 'جديد',
    bn: 'নতুন',
    ru: 'Новый',
    ja: '新しい',
    tr: 'Yeni',
    ko: '새로운',
    vi: 'Mới',
    id: 'Baru',
    th: 'ใหม่',
    ms: 'Baru',
    ar_eg: 'جديد',
    uk: 'Новий',
  },
  link: {
    en: 'Link',
    es: 'Enlace',
    fr: 'Lien',
    de: 'Verknüpfen',
    pt: 'Vincular',
    pl: 'Połącz',
    nl: 'Koppelen',
    el: 'Σύνδεσμος',
    cs: 'Propojit',
    sv: 'Länk',
    hu: 'Csatolás',
    da: 'Link',
    fi: 'Yhdistä',
    sk: 'Pripojiť',
    bg: 'Връзка',
    hr: 'Poveži',
    lt: 'Nuoroda',
    lv: 'Saite',
    et: 'Link',
    sl: 'Povezava',
    ga: 'Nasc',
    mt: 'Rabta',
    cy: 'Cyswllt',
    ro: 'Link',
    it: 'Collegare',
    zh_cn: '链接',
    hi: 'लिंक',
    ar: 'رابط',
    bn: 'লিঙ্ক',
    ru: 'Связать',
    ja: 'リンク',
    tr: 'Bağlantı',
    ko: '링크',
    vi: 'Liên kết',
    id: 'Tautan',
    th: 'ลิงก์',
    ms: 'Pautan',
    ar_eg: 'رابط',
    uk: "Зв'язати",
  },
  linked: {
    en: 'Linked',
    es: 'Vinculado',
    fr: 'Lié',
    de: 'Verbunden',
    pt: 'Vinculado',
    pl: 'Połączone',
    nl: 'Gekoppeld',
    el: 'Συνδεδεμένο',
    cs: 'Propojeno',
    sv: 'Länkad',
    hu: 'Összekapcsolva',
    da: 'Forbundet',
    fi: 'Linkitetty',
    sk: 'Prepojené',
    bg: 'Свързано',
    hr: 'Povezano',
    lt: 'Susieta',
    lv: 'Savienots',
    et: 'Lingitud',
    sl: 'Povezan',
    ga: 'Nasc',
    mt: 'Marbut',
    cy: 'Cysylltiedig',
    ro: 'Legat',
    it: 'Collegato',
    zh_cn: '已连接',
    hi: 'लिंक किया गया',
    ar: 'مرتبط',
    bn: 'সংযুক্ত',
    ru: 'Связано',
    ja: 'リンク済み',
    tr: 'Bağlı',
    ko: '연결됨',
    vi: 'Đã liên kết',
    id: 'Tertaut',
    th: 'เชื่อมโยงแล้ว',
    ms: 'Dihubungkan',
    ar_eg: 'مرتبط',
    uk: 'Пов’язано',
  },
  link_branch: {
    en: 'Link Branch',
    es: 'Vincular Sucursal',
    fr: 'Lier la Succursale',
    de: 'Filiale verknüpfen',
    pt: 'Vincular Filial',
    pl: 'Połącz Oddział',
    nl: 'Koppel Filiaal',
    el: 'Σύνδεση Καταστήματος',
    cs: 'Propojit Pobočku',
    sv: 'Länka Filial',
    hu: 'Fiók összekapcsolása',
    da: 'Link Afdeling',
    fi: 'Yhdistä Haara',
    sk: 'Prepojiť Pobočku',
    bg: 'Свързване на Клон',
    hr: 'Poveži Podružnicu',
    lt: 'Susieti Filialą',
    lv: 'Savienot Filiāli',
    et: 'Seosta Filiaal',
    sl: 'Poveži Podružnico',
    ga: 'Nasc Brainse',
    mt: 'Rabta Fergħa',
    cy: 'Cysylltu Cangen',
    ro: 'Legare Filială',
    it: 'Collega Filiale',
    zh_cn: '链接分支',
    hi: 'शाखा लिंक करें',
    ar: 'ربط الفرع',
    bn: 'শাখা সংযুক্ত করুন',
    ru: 'Связать филиал',
    ja: '支店をリンクする',
    tr: 'Şubeyi Bağla',
    ko: '지점 연결',
    vi: 'Liên kết Chi nhánh',
    id: 'Tautkan Cabang',
    th: 'ลิงก์สาขา',
    ms: 'Pautkan Cawangan',
    ar_eg: 'ربط الفرع',
    uk: 'Пов’язати філію',
  },
  submit: {
    en: 'Submit',
    es: 'Enviar',
    fr: 'Soumettre',
    de: 'Einreichen',
    pt: 'Enviar',
    pl: 'Zatwierdź',
    nl: 'Indienen',
    el: 'Υποβολή',
    cs: 'Odeslat',
    sv: 'Skicka in',
    hu: 'Beküldés',
    da: 'Indsend',
    fi: 'Lähetä',
    sk: 'Odoslať',
    bg: 'Изпрати',
    hr: 'Pošalji',
    lt: 'Pateikti',
    lv: 'Iesniegt',
    et: 'Esita',
    sl: 'Pošlji',
    ga: 'Cuir isteach',
    mt: 'Issottometti',
    cy: 'Cyflwyno',
    ro: 'Trimite',
    it: 'Invia',
    zh_cn: '提交',
    hi: 'प्रस्तुत करें',
    ar: 'إرسال',
    bn: 'জমা দিন',
    ru: 'Отправить',
    ja: '提出',
    tr: 'Gönder',
    ko: '제출',
    vi: 'Gửi',
    id: 'Kirim',
    th: 'ส่ง',
    ms: 'Hantar',
    ar_eg: 'إرسال',
    uk: 'Надіслати',
  },
  accounting: {
    en: 'Accounting',
    es: 'Contabilidad',
    fr: 'Comptabilité',
    de: 'Buchhaltung',
    pt: 'Contabilidade',
    pl: 'Księgowość',
    nl: 'Boekhouding',
    el: 'Λογιστική',
    cs: 'Účetnictví',
    sv: 'Redovisning',
    hu: 'Könyvelés',
    da: 'Regnskab',
    fi: 'Kirjanpito',
    sk: 'Účtovníctvo',
    bg: 'Счетоводство',
    hr: 'Računovodstvo',
    lt: 'Apskaita',
    lv: 'Grāmatvedība',
    et: 'Raamatupidamine',
    sl: 'Računovodstvo',
    ga: 'Cuntasaíocht',
    mt: 'Kontabbiltà',
    cy: 'Cyfrifeg',
    ro: 'Contabilitate',
    it: 'Contabilità',
    zh_cn: '会计',
    hi: 'लेखांकन',
    ar: 'محاسبة',
    bn: 'হিসাবরক্ষণ',
    ru: 'Бухгалтерия',
    ja: '会計',
    tr: 'Muhasebe',
    ko: '회계',
    vi: 'Kế toán',
    id: 'Akuntansi',
    th: 'การบัญชี',
    ms: 'Perakaunan',
    ar_eg: 'محاسبة',
    uk: 'Бухгалтерія',
  },
  account_name: {
    en: 'Account Name',
    es: 'Nombre de la Cuenta',
    fr: 'Nom du Compte',
    de: 'Kontoname',
    pt: 'Nome da Conta',
    pl: 'Nazwa Konta',
    nl: 'Accountnaam',
    el: 'Όνομα Λογαριασμού',
    cs: 'Název Účtu',
    sv: 'Kontonamn',
    hu: 'Számla Neve',
    da: 'Kontonavn',
    fi: 'Tilin Nimi',
    sk: 'Názov Účtu',
    bg: 'Име на Акаунта',
    hr: 'Naziv Računa',
    lt: 'Sąskaitos Pavadinimas',
    lv: 'Konta Nosaukums',
    et: 'Konto Nimi',
    sl: 'Ime Računa',
    ga: 'Ainm an Chuntais',
    mt: 'Isem tal-Kont',
    cy: 'Enw Cyfrif',
    ro: 'Numele Contului',
    it: "Nome dell'Account",
    zh_cn: '账户名称',
    hi: 'खाते का नाम',
    ar: 'اسم الحساب',
    bn: 'অ্যাকাউন্টের নাম',
    ru: 'Имя Аккаунта',
    ja: 'アカウント名',
    tr: 'Hesap Adı',
    ko: '계정 이름',
    vi: 'Tên Tài khoản',
    id: 'Nama Akun',
    th: 'ชื่อบัญชี',
    ms: 'Nama Akaun',
    ar_eg: 'اسم الحساب',
    uk: 'Назва Рахунку',
  },
  currency: {
    en: 'Currency',
    es: 'Moneda',
    fr: 'Devise',
    de: 'Währung',
    pt: 'Moeda',
    pl: 'Waluta',
    nl: 'Valuta',
    el: 'Νόμισμα',
    cs: 'Měna',
    sv: 'Valuta',
    hu: 'Pénznem',
    da: 'Valuta',
    fi: 'Valuutta',
    sk: 'Mena',
    bg: 'Валута',
    hr: 'Valuta',
    lt: 'Valiuta',
    lv: 'Valūta',
    et: 'Valuuta',
    sl: 'Valuta',
    ga: 'Airgeadra',
    mt: 'Munita',
    cy: 'Arian Cyfred',
    ro: 'Monedă',
    it: 'Valuta',
    zh_cn: '货币',
    hi: 'मुद्रा',
    ar: 'عملة',
    bn: 'মুদ্রা',
    ru: 'Валюта',
    ja: '通貨',
    tr: 'Para Birimi',
    ko: '통화',
    vi: 'Tiền tệ',
    id: 'Mata Uang',
    th: 'สกุลเงิน',
    ms: 'Mata Wang',
    ar_eg: 'عملة',
    uk: 'Валюта',
  },
  date: {
    en: 'Date',
    es: 'Fecha',
    fr: 'Date',
    de: 'Datum',
    pt: 'Data',
    pl: 'Data',
    nl: 'Datum',
    el: 'Ημερομηνία',
    cs: 'Datum',
    sv: 'Datum',
    hu: 'Dátum',
    da: 'Dato',
    fi: 'Päivämäärä',
    sk: 'Dátum',
    bg: 'Дата',
    hr: 'Datum',
    lt: 'Data',
    lv: 'Datums',
    et: 'Kuupäev',
    sl: 'Datum',
    ga: 'Dáta',
    mt: 'Data',
    cy: 'Dyddiad',
    ro: 'Dată',
    it: 'Data',
    zh_cn: '日期',
    hi: 'तारीख',
    ar: 'التاريخ',
    bn: 'তারিখ',
    ru: 'Дата',
    ja: '日付',
    tr: 'Tarih',
    ko: '날짜',
    vi: 'Ngày',
    id: 'Tanggal',
    th: 'วันที่',
    ms: 'Tarikh',
    ar_eg: 'التاريخ',
    uk: 'Дата',
  },
  debit: {
    en: 'Debit',
    es: 'Débito',
    fr: 'Débit',
    de: 'Soll',
    pt: 'Débito',
    pl: 'Debet',
    nl: 'Debet',
    el: 'Χρέωση',
    cs: 'Debet',
    sv: 'Debet',
    hu: 'Tartozás',
    da: 'Debet',
    fi: 'Debet',
    sk: 'Debet',
    bg: 'Дебит',
    hr: 'Dugovna Strana',
    lt: 'Debetas',
    lv: 'Debets',
    et: 'Deebet',
    sl: 'Bremenitev',
    ga: 'Dochreidte',
    mt: 'Debitu',
    cy: 'Debyd',
    ro: 'Debit',
    it: 'Addebito',
    zh_cn: '借方',
    hi: 'डेबिट',
    ar: 'مدين',
    bn: 'ডেবিট',
    ru: 'Дебет',
    ja: '借方',
    tr: 'Borç',
    ko: '차변',
    vi: 'Ghi nợ',
    id: 'Debet',
    th: 'หักบัญชี',
    ms: 'Debit',
    ar_eg: 'مدين',
    uk: 'Дебет',
  },
  credit: {
    en: 'Credit',
    es: 'Crédito',
    fr: 'Crédit',
    de: 'Haben',
    pt: 'Crédito',
    pl: 'Kredyt',
    nl: 'Credit',
    el: 'Πίστωση',
    cs: 'Kredit',
    sv: 'Kredit',
    hu: 'Hitel',
    da: 'Kredit',
    fi: 'Kredit',
    sk: 'Kredit',
    bg: 'Кредит',
    hr: 'Potraživanje',
    lt: 'Kreditas',
    lv: 'Kredīts',
    et: 'Krediit',
    sl: 'Kredit',
    ga: 'Creidmheas',
    mt: 'Kreditu',
    cy: 'Credyd',
    ro: 'Credit',
    it: 'Credito',
    zh_cn: '贷方',
    hi: 'क्रेडिट',
    ar: 'ائتمان',
    bn: 'ক্রেডিট',
    ru: 'Кредит',
    ja: 'クレジット',
    tr: 'Kredi',
    ko: '신용',
    vi: 'Ghi có',
    id: 'Kredit',
    th: 'เครดิต',
    ms: 'Kredit',
    ar_eg: 'ائتمان',
    uk: 'Кредит',
  },
  balance: {
    en: 'Balance',
    es: 'Saldo',
    fr: 'Solde',
    de: 'Saldo',
    pt: 'Saldo',
    pl: 'Saldo',
    nl: 'Balans',
    el: 'Υπόλοιπο',
    cs: 'Zůstatek',
    sv: 'Saldo',
    hu: 'Egyenleg',
    da: 'Saldo',
    fi: 'Saldo',
    sk: 'Zostatok',
    bg: 'Баланс',
    hr: 'Saldo',
    lt: 'Balansas',
    lv: 'Bilance',
    et: 'Saldo',
    sl: 'Stanje',
    ga: 'Iarmhéid',
    mt: 'Bilanċ',
    cy: 'Balans',
    ro: 'Sold',
    it: 'Saldo',
    zh_cn: '余额',
    hi: 'शेष',
    ar: 'الرصيد',
    bn: 'ব্যালেন্স',
    ru: 'Баланс',
    ja: '残高',
    tr: 'Bakiye',
    ko: '잔액',
    vi: 'Số dư',
    id: 'Saldo',
    th: 'ยอดคงเหลือ',
    ms: 'Baki',
    ar_eg: 'الرصيد',
    uk: 'Баланс',
  },
  account_code: {
    en: 'Account Code',
    es: 'Código de Cuenta',
    fr: 'Code de Compte',
    de: 'Kontocode',
    pt: 'Código da Conta',
    pl: 'Kod Konta',
    nl: 'Rekeningcode',
    el: 'Κωδικός Λογαριασμού',
    cs: 'Kód Účtu',
    sv: 'Kontokod',
    hu: 'Számlakód',
    da: 'Kontokode',
    fi: 'Tilin Koodi',
    sk: 'Kód Účtu',
    bg: 'Код на Акаунта',
    hr: 'Šifra Računa',
    lt: 'Sąskaitos Kodas',
    lv: 'Konta Kods',
    et: 'Kontokood',
    sl: 'Koda Računa',
    ga: 'Cód an Chuntais',
    mt: 'Kodiċi tal-Kont',
    cy: 'Cod Cyfrif',
    ro: 'Cod Cont',
    it: 'Codice del Conto',
    zh_cn: '账户代码',
    hi: 'खाता कोड',
    ar: 'رمز الحساب',
    bn: 'অ্যাকাউন্ট কোড',
    ru: 'Код Аккаунта',
    ja: 'アカウントコード',
    tr: 'Hesap Kodu',
    ko: '계정 코드',
    vi: 'Mã Tài khoản',
    id: 'Kode Akun',
    th: 'รหัสบัญชี',
    ms: 'Kod Akaun',
    ar_eg: 'رمز الحساب',
    uk: 'Код Рахунку',
  },
  description: {
    en: 'Description',
    es: 'Descripción',
    fr: 'Description',
    de: 'Beschreibung',
    pt: 'Descrição',
    pl: 'Opis',
    nl: 'Beschrijving',
    el: 'Περιγραφή',
    cs: 'Popis',
    sv: 'Beskrivning',
    hu: 'Leírás',
    da: 'Beskrivelse',
    fi: 'Kuvaus',
    sk: 'Popis',
    bg: 'Описание',
    hr: 'Opis',
    lt: 'Aprašymas',
    lv: 'Apraksts',
    et: 'Kirjeldus',
    sl: 'Opis',
    ga: 'Cur Síos',
    mt: 'Deskrizzjoni',
    cy: 'Disgrifiad',
    ro: 'Descriere',
    it: 'Descrizione',
    zh_cn: '描述',
    hi: 'विवरण',
    ar: 'الوصف',
    bn: 'বর্ণনা',
    ru: 'Описание',
    ja: '説明',
    tr: 'Açıklama',
    ko: '설명',
    vi: 'Mô tả',
    id: 'Deskripsi',
    th: 'คำอธิบาย',
    ms: 'Penerangan',
    ar_eg: 'الوصف',
    uk: 'Опис',
  },
  journal_id: {
    en: 'Journal ID',
    es: 'ID del Diario',
    fr: 'ID du Journal',
    de: 'Journal-ID',
    pt: 'ID do Diário',
    pl: 'ID Dziennika',
    nl: 'Journaal-ID',
    el: 'Ταυτότητα Ημερολογίου',
    cs: 'ID Deníku',
    sv: 'Journal-ID',
    hu: 'Naplóazonosító',
    da: 'Journal-ID',
    fi: 'Päiväkirjan ID',
    sk: 'ID Denníka',
    bg: 'ID на Дневника',
    hr: 'ID Dnevnika',
    lt: 'Žurnalo ID',
    lv: 'Žurnāla ID',
    et: 'Päeviku ID',
    sl: 'ID Dnevnika',
    ga: 'Aitheantas Iris',
    mt: "ID ta' Ġurnal",
    cy: 'ID Cyfnodolyn',
    ro: 'ID Jurnal',
    it: 'ID del Giornale',
    zh_cn: '日志ID',
    hi: 'जर्नल आईडी',
    ar: 'معرف اليومية',
    bn: 'জার্নাল আইডি',
    ru: 'ID Журнала',
    ja: 'ジャーナルID',
    tr: 'Günlük Kimliği',
    ko: '저널 ID',
    vi: 'ID Nhật ký',
    id: 'ID Jurnal',
    th: 'ID บันทึก',
    ms: 'ID Jurnal',
    ar_eg: 'معرف اليومية',
    uk: 'Ідентифікатор Журналу',
  },
  journal_details: {
    en: 'Journal Details',
    es: 'Detalles del Diario',
    fr: 'Détails du Journal',
    de: 'Journaldetails',
    pt: 'Detalhes do Diário',
    pl: 'Szczegóły dziennika',
    nl: 'Journaalgegevens',
    el: 'Λεπτομέρειες Ημερολογίου',
    cs: 'Podrobnosti deníku',
    sv: 'Journalinformation',
    hu: 'Napló részletei',
    da: 'Journaloplysninger',
    fi: 'Päiväkirjan tiedot',
    sk: 'Podrobnosti denníka',
    bg: 'Подробности за дневника',
    hr: 'Detalji dnevnika',
    lt: 'Žurnalo informacija',
    lv: 'Žurnāla informācija',
    et: 'Päeviku üksikasjad',
    sl: 'Podrobnosti dnevnika',
    ga: 'Mionsonraí an Irise',
    mt: 'Dettalji tal-Ġurnal',
    cy: 'Manylion y Dyddlyfr',
    ro: 'Detalii jurnal',
    it: 'Dettagli del Giornale',
    zh_cn: '日记详情',
    hi: 'जर्नल विवरण',
    ar: 'تفاصيل اليومية',
    bn: 'জার্নালের বিবরণ',
    ru: 'Детали журнала',
    ja: 'ジャーナルの詳細',
    tr: 'Günlük Detayları',
    ko: '저널 세부정보',
    vi: 'Chi tiết nhật ký',
    id: 'Detail Jurnal',
    th: 'รายละเอียดสมุดรายวัน',
    ms: 'Butiran Jurnal',
    ar_eg: 'تفاصيل اليومية',
    uk: 'Деталі журналу',
  },
  no_journal_data: {
    en: 'No Journal data is available',
    es: 'No hay datos del diario disponibles',
    fr: 'Aucune donnée de journal disponible',
    de: 'Keine Journaldaten verfügbar',
    pt: 'Nenhum dado de diário disponível',
    pl: 'Brak dostępnych danych dziennika',
    nl: 'Geen journaalgegevens beschikbaar',
    el: 'Δεν υπάρχουν διαθέσιμα δεδομένα ημερολογίου',
    cs: 'Nejsou k dispozici žádná data deníku',
    sv: 'Ingen journaldata tillgänglig',
    hu: 'Nincs elérhető naplóadat',
    da: 'Ingen journalddata tilgængelig',
    fi: 'Päiväkirjatietoja ei ole saatavilla',
    sk: 'Denníkové údaje nie sú k dispozícii',
    bg: 'Няма налични данни от дневника',
    hr: 'Nema dostupnih podataka dnevnika',
    lt: 'Nėra žurnalo duomenų',
    lv: 'Žurnāla dati nav pieejami',
    et: 'Päevikute andmed pole saadaval',
    sl: 'Podatki dnevnika niso na voljo',
    ga: 'Níl sonraí an irise ar fáil',
    mt: 'M’hemmx dejta tal-ġurnal disponibbli',
    cy: 'Nid oes data dyddlyfr ar gael',
    ro: 'Nu sunt disponibile date din jurnal',
    it: 'Nessun dato di registro disponibile',
    zh_cn: '无可用的日志数据',
    hi: 'कोई जर्नल डेटा उपलब्ध नहीं है',
    ar: 'لا توجد بيانات دفتر اليومية متاحة',
    bn: 'কোনো জার্নাল তথ্য উপলব্ধ নেই',
    ru: 'Данные журнала недоступны',
    ja: '利用可能なジャーナルデータはありません',
    tr: 'Kullanılabilir günlük verisi yok',
    ko: '사용 가능한 저널 데이터가 없습니다',
    vi: 'Không có dữ liệu nhật ký nào',
    id: 'Data jurnal tidak tersedia',
    th: 'ไม่มีข้อมูลวารสาร',
    ms: 'Tiada data jurnal tersedia',
    ar_eg: 'لا توجد بيانات دفتر اليومية متاحة',
    uk: 'Дані журналу недоступні',
  },
  subsidiary_ledgers: {
    en: 'Subsidiary Ledgers',
    es: 'Libros Auxiliares',
    fr: 'Journaux Auxiliaires',
    de: 'Nebenbücher',
    pt: 'Livros Auxiliares',
    pl: 'Księgi Pomocnicze',
    nl: 'Subadministraties',
    el: 'Βοηθητικά Καθολικά',
    cs: 'Podřízené Knihy',
    sv: 'Underliggande Böcker',
    hu: 'Alárendelt Főkönyvek',
    da: 'Underordnede Bøger',
    fi: 'Alatilikirjat',
    sk: 'Podriadené Knihy',
    bg: 'Подчинени Книги',
    hr: 'Pomoćne Knjige',
    lt: 'Papildomos Knygos',
    lv: 'Papildu Grāmatas',
    et: 'Abiraamatud',
    sl: 'Pomožne Knjige',
    ga: 'Leabhair Fhochuideachta',
    mt: 'Kotba Sussidjarji',
    cy: 'Llyfrau Isadran',
    ro: 'Registrele Secundare',
    it: 'Libri Sussidiari',
    zh_cn: '附属分类账',
    hi: 'सहायक खाता-बही',
    ar: 'دفاتر الأستاذ الفرعية',
    bn: 'সহায়ক লেজার',
    ru: 'Вспомогательные Книги',
    ja: '補助元帳',
    tr: 'Yardımcı Defterler',
    ko: '보조 원장',
    vi: 'Sổ cái phụ',
    id: 'Buku Pembantu',
    th: 'บัญชีย่อย',
    ms: 'Lejar Subsidiari',
    ar_eg: 'دفاتر الأستاذ الفرعية',
    uk: 'Допоміжні книги',
  },
  sub_ledgers: {
    en: 'Sub-ledgers',
    es: 'Libros Auxiliares',
    fr: 'Sous-journaux',
    de: 'Nebenbücher',
    pt: 'Subdiários',
    pl: 'Księgi pomocnicze',
    nl: 'Subgrootboeken',
    el: 'Υποκαθολικά',
    cs: 'Podřízené knihy',
    sv: 'Underliggande böcker',
    hu: 'Alárendelt főkönyvek',
    da: 'Underordnede bøger',
    fi: 'Alatilikirjat',
    sk: 'Podriadené knihy',
    bg: 'Подчинени книги',
    hr: 'Pomoćne knjige',
    lt: 'Papildomos knygos',
    lv: 'Papildu grāmatas',
    et: 'Abiraamatud',
    sl: 'Pomožne knjige',
    ga: 'Fo-leabhair',
    mt: 'Kotba Sussidjarji',
    cy: 'Is-lyfrau',
    ro: 'Registrele secundare',
    it: 'Libri sussidiari',
    zh_cn: '子分类账',
    hi: 'उप-लेखाजोखा',
    ar: 'الدفاتر الفرعية',
    bn: 'সাব-লেজার',
    ru: 'Вспомогательные книги',
    ja: '補助元帳',
    tr: 'Alt defterler',
    ko: '보조 원장',
    vi: 'Sổ cái phụ',
    id: 'Buku pembantu',
    th: 'บัญชีย่อย',
    ms: 'Lejar Sub',
    ar_eg: 'الدفاتر الفرعية',
    uk: 'Допоміжні книги',
  },
  select_date: {
    en: 'Select Date',
    es: 'Seleccionar fecha',
    fr: 'Sélectionner la date',
    de: 'Datum auswählen',
    pt: 'Selecionar data',
    pl: 'Wybierz datę',
    nl: 'Selecteer datum',
    el: 'Επιλέξτε ημερομηνία',
    cs: 'Vyberte datum',
    sv: 'Välj datum',
    hu: 'Válassza ki a dátumot',
    da: 'Vælg dato',
    fi: 'Valitse päivämäärä',
    sk: 'Vyberte dátum',
    bg: 'Изберете дата',
    hr: 'Odaberite datum',
    lt: 'Pasirinkite datą',
    lv: 'Izvēlieties datumu',
    et: 'Valige kuupäev',
    sl: 'Izberite datum',
    ga: 'Roghnaigh Dáta',
    mt: 'Agħżel Data',
    cy: 'Dewiswch Dyddiad',
    ro: 'Selectați data',
    it: 'Seleziona data',
    zh_cn: '选择日期',
    hi: 'तारीख़ चुनें',
    ar: 'اختر التاريخ',
    bn: 'তারিখ নির্বাচন করুন',
    ru: 'Выберите дату',
    ja: '日付を選択',
    tr: 'Tarih seç',
    ko: '날짜 선택',
    vi: 'Chọn ngày',
    id: 'Pilih Tanggal',
    th: 'เลือกวันที่',
    ms: 'Pilih Tarikh',
    ar_eg: 'اختر التاريخ',
  },
  type: {
    en: 'Type',
    es: 'Tipo',
    fr: 'Type',
    de: 'Art',
    pt: 'Tipo',
    pl: 'Typ',
    nl: 'Type',
    el: 'Τύπος',
    cs: 'Typ',
    sv: 'Typ',
    hu: 'Típus',
    da: 'Type',
    fi: 'Tyyppi',
    sk: 'Typ',
    bg: 'Тип',
    hr: 'Vrsta',
    lt: 'Tipas',
    lv: 'Tips',
    et: 'Tüüp',
    sl: 'Vrsta',
    ga: 'Cineál',
    mt: 'Tip',
    cy: 'Math',
    ro: 'Tip',
    it: 'Tipo',
    zh_cn: '类型',
    hi: 'प्रकार',
    ar: 'نوع',
    bn: 'ধরন',
    ru: 'Тип',
    ja: 'タイプ',
    tr: 'Tür',
    ko: '유형',
    vi: 'Loại',
    id: 'Tipe',
    th: 'ประเภท',
    ms: 'Jenis',
    ar_eg: 'نوع',
    uk: 'Тип',
  },
  subsidiary: {
    en: 'Subsidiary',
    es: 'Subsidiaria',
    fr: 'Filiale',
    de: 'Tochtergesellschaft',
    pt: 'Subsidiária',
    pl: 'Filia',
    nl: 'Dochteronderneming',
    el: 'Θυγατρική',
    cs: 'Dceřiná společnost',
    sv: 'Dotterbolag',
    hu: 'Leányvállalat',
    da: 'Datterselskab',
    fi: 'Tytäryhtiö',
    sk: 'Dcérska spoločnosť',
    bg: 'Дъщерно дружество',
    hr: 'Podružnica',
    lt: 'Dukterinė įmonė',
    lv: 'Meitasuzņēmums',
    et: 'Tütarettevõte',
    sl: 'Hčerinska družba',
    ga: 'Fochuideachta',
    mt: 'Sussidjarja',
    cy: 'Is-gwmni',
    ro: 'Filială',
    it: 'Sussidiaria',
    zh_cn: '子公司',
    hi: 'सहायक',
    ar: 'تابعة',
    bn: 'সহায়ক',
    ru: 'Дочерняя компания',
    ja: '子会社',
    tr: 'Bağlı ortaklık',
    ko: '자회사',
    vi: 'Công ty con',
    id: 'Anak perusahaan',
    th: 'บริษัทสาขา',
    ms: 'Anak syarikat',
    ar_eg: 'شركة تابعة',
    uk: 'Дочірня компанія',
  },
  reference: {
    en: 'Reference',
    es: 'Referencia',
    fr: 'Référence',
    de: 'Referenz',
    pt: 'Referência',
    pl: 'Odniesienie',
    nl: 'Referentie',
    el: 'Αναφορά',
    cs: 'Odkaz',
    sv: 'Referens',
    hu: 'Hivatkozás',
    da: 'Reference',
    fi: 'Viite',
    sk: 'Referencia',
    bg: 'Референция',
    hr: 'Referenca',
    lt: 'Nuoroda',
    lv: 'Atsauce',
    et: 'Viide',
    sl: 'Sklic',
    ga: 'Tagairt',
    mt: 'Referenza',
    cy: 'Cyfeirnod',
    ro: 'Referință',
    it: 'Riferimento',
    zh_cn: '参考',
    hi: 'संदर्भ',
    ar: 'مرجع',
    bn: 'রেফারেন্স',
    ru: 'Ссылка',
    ja: '参照',
    tr: 'Referans',
    ko: '참조',
    vi: 'Tham chiếu',
    id: 'Referensi',
    th: 'การอ้างอิง',
    ms: 'Rujukan',
    ar_eg: 'مرجع',
    uk: 'Посилання',
  },
  time: {
    en: 'Time',
    es: 'Hora',
    fr: 'Heure',
    de: 'Zeit',
    pt: 'Hora',
    pl: 'Czas',
    nl: 'Tijd',
    el: 'Ώρα',
    cs: 'Čas',
    sv: 'Tid',
    hu: 'Idő',
    da: 'Tid',
    fi: 'Aika',
    sk: 'Čas',
    bg: 'Време',
    hr: 'Vrijeme',
    lt: 'Laikas',
    lv: 'Laiks',
    et: 'Aeg',
    sl: 'Čas',
    ga: 'Am',
    mt: 'Ħin',
    cy: 'Amser',
    ro: 'Ora',
    it: 'Ora',
    zh_cn: '时间',
    hi: 'समय',
    ar: 'الوقت',
    bn: 'সময়',
    ru: 'Время',
    ja: '時間',
    tr: 'Zaman',
    ko: '시간',
    vi: 'Thời gian',
    id: 'Waktu',
    th: 'เวลา',
    ms: 'Masa',
    ar_eg: 'الوقت',
    uk: 'Час',
  },
  item_type: {
    en: 'Item Type',
    es: 'Tipo de Artículo',
    fr: "Type d'Article",
    de: 'Artikeltyp',
    pt: 'Tipo de Item',
    pl: 'Rodzaj Przedmiotu',
    nl: 'Artikel Type',
    el: 'Τύπος Αντικειμένου',
    cs: 'Typ Položky',
    sv: 'Artikeltyp',
    hu: 'Tétel Típusa',
    da: 'Varetype',
    fi: 'Tyyppiluokka',
    sk: 'Typ Položky',
    bg: 'Тип Артикул',
    hr: 'Vrsta Predmeta',
    lt: 'Prekės Tipas',
    lv: 'Preces Veids',
    et: 'Toote Tüüp',
    sl: 'Vrsta Artikla',
    ga: 'Cineál Míre',
    mt: "Tip ta' Oġġett",
    cy: 'Math o Eitem',
    ro: 'Tip Articol',
    it: 'Tipo di Articolo',
    zh_cn: '物品类型',
    hi: 'आइटम प्रकार',
    ar: 'نوع العنصر',
    bn: 'আইটেমের ধরন',
    ru: 'Тип Элемента',
    ja: 'アイテムの種類',
    tr: 'Öğe Türü',
    ko: '항목 유형',
    vi: 'Loại Mặt Hàng',
    id: 'Jenis Barang',
    th: 'ประเภทสินค้า',
    ms: 'Jenis Item',
    ar_eg: 'نوع العنصر',
    uk: 'Тип Предмета',
  },
  item_types: {
    en: 'Item Types',
    es: 'Tipos de Artículos',
    fr: "Types d'Articles",
    de: 'Artikeltypen',
    pt: 'Tipos de Itens',
    pl: 'Rodzaje Przedmiotów',
    nl: 'Itemtypen',
    el: 'Τύποι Αντικειμένων',
    cs: 'Typy Položek',
    sv: 'Objekt Typer',
    hu: 'Tétel Típusok',
    da: 'Varetyper',
    fi: 'Tuotetyypit',
    sk: 'Typy Položiek',
    bg: 'Типове Артикули',
    hr: 'Vrste Stavki',
    lt: 'Prekių Tipai',
    lv: 'Vienumu Veidi',
    et: 'Kaubatüübid',
    sl: 'Vrste Artiklov',
    ga: 'Cineálacha Míreanna',
    mt: "Tipi ta' Oġġetti",
    cy: 'Mathau Eitem',
    ro: 'Tipuri de Articole',
    it: 'Tipi di Articoli',
    zh_cn: '项目类型',
    hi: 'आइटम प्रकार',
    ar: 'أنواع البنود',
    bn: 'আইটেম প্রকার',
    ru: 'Типы товаров',
    ja: 'アイテムタイプ',
    tr: 'Ürün Türleri',
    ko: '항목 유형',
    vi: 'Loại mặt hàng',
    id: 'Jenis Barang',
    th: 'ประเภทสินค้า',
    ms: 'Jenis Barang',
    ar_eg: 'أنواع العناصر',
    uk: 'Типи Елементів',
  },
  variant: {
    en: 'Variant',
    es: 'Variante',
    fr: 'Variante',
    de: 'Variante',
    pt: 'Variante',
    pl: 'Wariant',
    nl: 'Variant',
    el: 'Παραλλαγή',
    cs: 'Varianta',
    sv: 'Variant',
    hu: 'Változat',
    da: 'Variant',
    fi: 'Variantti',
    sk: 'Varianta',
    bg: 'Вариант',
    hr: 'Varijanta',
    lt: 'Variantas',
    lv: 'Variants',
    et: 'Variant',
    sl: 'Različica',
    ga: 'Athraitheach',
    mt: 'Varjant',
    cy: 'Amrywiad',
    ro: 'Variantă',
    it: 'Variante',
    zh_cn: '变种',
    hi: 'प्रकार',
    ar: 'البديل',
    bn: 'প্রকরণ',
    ru: 'Вариант',
    ja: 'バリアント',
    tr: 'Varyant',
    ko: '변형',
    vi: 'Biến Thể',
    id: 'Varian',
    th: 'ตัวแปร',
    ms: 'Varian',
    ar_eg: 'المتغير',
    uk: 'Варіант',
  },
  edit_item: {
    en: 'Edit Item',
    es: 'Editar Artículo',
    fr: "Modifier l'Article",
    de: 'Artikel Bearbeiten',
    pt: 'Editar Item',
    pl: 'Edytuj Przedmiot',
    nl: 'Item Bewerken',
    el: 'Επεξεργασία Στοιχείου',
    cs: 'Upravit Položku',
    sv: 'Redigera Artikel',
    hu: 'Elem Szerkesztése',
    da: 'Rediger Vare',
    fi: 'Muokkaa Kohdetta',
    sk: 'Upraviť Položku',
    bg: 'Редактиране на Артикул',
    hr: 'Uredi Stavku',
    lt: 'Redaguoti Prekę',
    lv: 'Rediģēt Vienumu',
    et: 'Muuda Üksust',
    sl: 'Uredi Element',
    ga: 'Cuir in Eagar Mír',
    mt: 'Editja l-Oġġett',
    cy: 'Golygu Eitem',
    ro: 'Editează Articolul',
    it: "Modifica l'Articolo",
    zh_cn: '编辑项目',
    hi: 'आइटम संपादित करें',
    ar: 'تحرير العنصر',
    bn: 'আইটেম সম্পাদনা করুন',
    ru: 'Редактировать Элемент',
    ja: 'アイテムを編集',
    tr: 'Öğeyi Düzenle',
    ko: '항목 편집',
    vi: 'Chỉnh Sửa Mặt Hàng',
    id: 'Edit Barang',
    th: 'แก้ไขสินค้า',
    ms: 'Edit Item',
    ar_eg: 'تحرير العنصر',
    uk: 'Редагувати Предмет',
  },
  move_item: {
    en: 'Move Item',
    es: 'Mover Artículo',
    fr: "Déplacer l'Article",
    de: 'Artikel Verschieben',
    pt: 'Mover Item',
    pl: 'Przenieś Przedmiot',
    nl: 'Item Verplaatsen',
    el: 'Μετακίνηση Στοιχείου',
    cs: 'Přesunout Položku',
    sv: 'Flytta Artikel',
    hu: 'Elem Áthelyezése',
    da: 'Flyt Vare',
    fi: 'Siirrä Kohde',
    sk: 'Presunúť Položku',
    bg: 'Преместване на Артикул',
    hr: 'Premjesti Stavku',
    lt: 'Perkelti Prekę',
    lv: 'Pārvietot Vienumu',
    et: 'Liiguta Üksust',
    sl: 'Premakni Element',
    ga: 'Bog Mír',
    mt: 'Mexxi l-Oġġett',
    cy: 'Symud Eitem',
    ro: 'Mută Articolul',
    it: "Sposta l'Articolo",
    zh_cn: '移动项目',
    hi: 'आइटम स्थानांतरित करें',
    ar: 'نقل العنصر',
    bn: 'আইটেম সরান',
    ru: 'Переместить Элемент',
    ja: 'アイテムを移動',
    tr: 'Öğeyi Taşı',
    ko: '항목 이동',
    vi: 'Di Chuyển Mặt Hàng',
    id: 'Pindahkan Barang',
    th: 'ย้ายสินค้า',
    ms: 'Pindah Item',
    ar_eg: 'نقل العنصر',
    uk: 'Перемістити Предмет',
  },
  categories: {
    en: 'Categories',
    es: 'Categorías',
    fr: 'Catégories',
    de: 'Kategorien',
    pt: 'Categorias',
    pl: 'Kategorie',
    nl: 'Categorieën',
    el: 'Κατηγορίες',
    cs: 'Kategorie',
    sv: 'Kategorier',
    hu: 'Kategóriák',
    da: 'Kategorier',
    fi: 'Kategoriat',
    sk: 'Kategórie',
    bg: 'Категории',
    hr: 'Kategorije',
    lt: 'Kategorijos',
    lv: 'Kategorijas',
    et: 'Kategooriad',
    sl: 'Kategorije',
    ga: 'Catagóirí',
    mt: 'Kategoriji',
    cy: 'Categorïau',
    ro: 'Categorii',
    it: 'Categorie',
    zh_cn: '分类',
    hi: 'श्रेणियाँ',
    ar: 'التصنيفات',
    bn: 'বিভাগসমূহ',
    ru: 'Категории',
    ja: 'カテゴリー',
    tr: 'Kategoriler',
    ko: '카테고리',
    vi: 'Danh Mục',
    id: 'Kategori',
    th: 'หมวดหมู่',
    ms: 'Kategori',
    ar_eg: 'الفئات',
    uk: 'Категорії',
  },
  create_new_item: {
    en: 'Create New Item',
    es: 'Crear Nuevo Artículo',
    fr: 'Créer un Nouvel Article',
    de: 'Neuen Artikel Erstellen',
    pt: 'Criar Novo Item',
    pl: 'Utwórz Nowy Przedmiot',
    nl: 'Nieuw Item Aanmaken',
    el: 'Δημιουργία Νέου Στοιχείου',
    cs: 'Vytvořit Novou Položku',
    sv: 'Skapa Ny Artikel',
    hu: 'Új Elem Létrehozása',
    da: 'Opret Ny Vare',
    fi: 'Luo Uusi Kohde',
    sk: 'Vytvoriť Novú Položku',
    bg: 'Създаване на Нов Артикул',
    hr: 'Kreiraj Novu Stavku',
    lt: 'Sukurti Naują Prekę',
    lv: 'Izveidot Jaunu Vienumu',
    et: 'Loo Uus Üksus',
    sl: 'Ustvari Novo Postavko',
    ga: 'Cruthaigh Mír Nua',
    mt: 'Oħloq Oġġett Ġdid',
    cy: 'Creu Eitem Newydd',
    ro: 'Creează Articol Nou',
    it: 'Crea Nuovo Articolo',
    zh_cn: '创建新项目',
    hi: 'नया आइटम बनाएं',
    ar: 'إنشاء عنصر جديد',
    bn: 'নতুন আইটেম তৈরি করুন',
    ru: 'Создать Новый Элемент',
    ja: '新しいアイテムを作成',
    tr: 'Yeni Öğe Oluştur',
    ko: '새 항목 만들기',
    vi: 'Tạo Mặt Hàng Mới',
    id: 'Buat Barang Baru',
    th: 'สร้างรายการใหม่',
    ms: 'Buat Item Baru',
    ar_eg: 'إنشاء عنصر جديد',
    uk: 'Створити Новий Елемент',
  },
  all_items: {
    en: 'All Items',
    es: 'Todos los Artículos',
    fr: 'Tous les Articles',
    de: 'Alle Artikel',
    pt: 'Todos os Itens',
    pl: 'Wszystkie Przedmioty',
    nl: 'Alle Items',
    el: 'Όλα τα Αντικείμενα',
    cs: 'Všechny Položky',
    sv: 'Alla Artiklar',
    hu: 'Minden Elem',
    da: 'Alle Vare',
    fi: 'Kaikki Kohteet',
    sk: 'Všetky Položky',
    bg: 'Всички Артикули',
    hr: 'Svi Predmeti',
    lt: 'Visi Daiktai',
    lv: 'Visi Vienumi',
    et: 'Kõik Üksused',
    sl: 'Vse Postavke',
    ga: 'Gach Mír',
    mt: 'Kollha Oġġetti',
    cy: 'Pob Eitem',
    ro: 'Toate Articolele',
    it: 'Tutti gli Articoli',
    zh_cn: '所有项目',
    hi: 'सभी आइटम',
    ar: 'جميع العناصر',
    bn: 'সকল আইটেম',
    ru: 'Все Элементы',
    ja: 'すべてのアイテム',
    tr: 'Tüm Öğeler',
    ko: '모든 항목',
    vi: 'Tất Cả Các Mặt Hàng',
    id: 'Semua Barang',
    th: 'สินค้าทั้งหมด',
    ms: 'Semua Item',
    ar_eg: 'كل العناصر',
    uk: 'Усі Предмети',
  },
  item_kinds: {
    goods_for_sale: {
      en: 'Goods for Sale',
      es: 'Bienes para la Venta',
      fr: 'Biens à Vendre',
      de: 'Waren zum Verkauf',
      pt: 'Bens à Venda',
      pl: 'Towary na Sprzedaż',
      nl: 'Goederen te Koop',
      el: 'Προϊόντα προς Πώληση',
      cs: 'Zboží na Prodej',
      sv: 'Varor till Salu',
      hu: 'Eladó Árucikkek',
      da: 'Varer til Salg',
      fi: 'Myytävät Tavarat',
      sk: 'Tovar na Predaj',
      bg: 'Стоки за Продажба',
      hr: 'Roba za Prodaju',
      lt: 'Pardavimui Prekės',
      lv: 'Pārdodamas Preces',
      et: 'Müügil Kaubad',
      sl: 'Blago za Prodajo',
      ga: 'Earraí le Díol',
      mt: 'Oġġetti għall-Bejgħ',
      cy: 'Nwyddau ar Werth',
      ro: 'Bunuri de Vânzare',
      it: 'Beni in Vendita',
      zh_cn: '待售商品',
      hi: 'बिक्री के लिए सामान',
      ar: 'سلع للبيع',
      bn: 'বিক্রয়ের জন্য পণ্য',
      ru: 'Товары на Продажу',
      ja: '販売商品',
      tr: 'Satışa Sunulan Mallar',
      ko: '판매용 상품',
      vi: 'Hàng hóa để Bán',
      id: 'Barang Dijual',
      th: 'สินค้าเพื่อขาย',
      ms: 'Barang untuk Dijual',
      ar_eg: 'بضائع للبيع',
      uk: 'Товари на Продаж',
    },
    services: {
      en: 'Services',
      es: 'Servicios',
      fr: 'Services',
      de: 'Dienstleistungen',
      pt: 'Serviços',
      pl: 'Usługi',
      nl: 'Diensten',
      el: 'Υπηρεσίες',
      cs: 'Služby',
      sv: 'Tjänster',
      hu: 'Szolgáltatások',
      da: 'Tjenester',
      fi: 'Palvelut',
      sk: 'Služby',
      bg: 'Услуги',
      hr: 'Usluge',
      lt: 'Paslaugos',
      lv: 'Pakalpojumi',
      et: 'Teenused',
      sl: 'Storitve',
      ga: 'Seirbhísí',
      mt: 'Servizzi',
      cy: 'Gwasanaethau',
      ro: 'Servicii',
      it: 'Servizi',
      zh_cn: '服务',
      hi: 'सेवाएँ',
      ar: 'الخدمات',
      bn: 'পরিষেবা',
      ru: 'Услуги',
      ja: 'サービス',
      tr: 'Hizmetler',
      ko: '서비스',
      vi: 'Dịch Vụ',
      id: 'Layanan',
      th: 'บริการ',
      ms: 'Perkhidmatan',
      ar_eg: 'الخدمات',
      uk: 'Послуги',
    },
    service: {
      en: 'Service',
      es: 'Servicio',
      fr: 'Service',
      de: 'Service',
      pt: 'Serviço',
      pl: 'Usługa',
      nl: 'Service',
      el: 'Υπηρεσία',
      cs: 'Služba',
      sv: 'Tjänst',
      hu: 'Szolgáltatás',
      da: 'Service',
      fi: 'Palvelu',
      sk: 'Služba',
      bg: 'Услуга',
      hr: 'Usluga',
      lt: 'Paslauga',
      lv: 'Pakalpojums',
      et: 'Teenindus',
      sl: 'Storitev',
      ga: 'Seirbhís',
      mt: 'Servizz',
      cy: 'Gwasanaeth',
      ro: 'Serviciu',
      it: 'Servizio',
      zh_cn: '服务',
      hi: 'सेवा',
      ar: 'خدمة',
      bn: 'পরিসেবা',
      ru: 'Сервис',
      ja: 'サービス',
      tr: 'Hizmet',
      ko: '서비스',
      vi: 'Dịch vụ',
      id: 'Layanan',
      th: 'บริการ',
      ms: 'Perkhidmatan',
      ar_eg: 'خدمة',
      uk: 'Послуга',
    },
    menu_item: {
      en: 'Menu Item',
      es: 'Elemento del Menú',
      fr: 'Élément de Menu',
      de: 'Menüpunkt',
      pt: 'Item do Menu',
      pl: 'Pozycja w Menu',
      nl: 'Menu-item',
      el: 'Στοιχείο Μενού',
      cs: 'Položka Menu',
      sv: 'Menyalternativ',
      hu: 'Menüpont',
      da: 'Menupunkt',
      fi: 'Valikon Kohta',
      sk: 'Položka Menu',
      bg: 'Елемент от Менюто',
      hr: 'Stavka Izbornika',
      lt: 'Meniu Punktas',
      lv: 'Izvēlnes Vienība',
      et: 'Menüü Element',
      sl: 'Element Menija',
      ga: 'Mír Roghchláir',
      mt: 'Element tal-Menu',
      cy: 'Eitem Dewislen',
      ro: 'Element de Meniu',
      it: 'Voce di Menu',
      zh_cn: '菜单项',
      hi: 'मेनू आइटम',
      ar: 'عنصر القائمة',
      bn: 'মেনু আইটেম',
      ru: 'Пункт Меню',
      ja: 'メニュー項目',
      tr: 'Menü Öğesi',
      ko: '메뉴 항목',
      vi: 'Mục Trên Thực Đơn',
      id: 'Item Menu',
      th: 'รายการเมนู',
      ms: 'Item Menu',
      ar_eg: 'عنصر القائمة',
      uk: 'Пункт Меню',
    },
    supplies: {
      en: 'Supplies',
      es: 'Suministros',
      fr: 'Fournitures',
      de: 'Vorräte',
      pt: 'Suprimentos',
      pl: 'Zasoby',
      nl: 'Benodigdheden',
      el: 'Εφόδια',
      cs: 'Potřeby',
      sv: 'Förnödenheter',
      hu: 'Kellékek',
      da: 'Forsyninger',
      fi: 'Tarvikkeet',
      sk: 'Zásoby',
      bg: 'Принадлежности',
      hr: 'Zalihe',
      lt: 'Atsargos',
      lv: 'Piederumi',
      et: 'Tarvikud',
      sl: 'Potrošni Material',
      ga: 'Soláthairtí',
      mt: 'Provvisti',
      cy: 'Cyflenwadau',
      ro: 'Provizii',
      it: 'Forniture',
      zh_cn: '供应品',
      hi: 'सामान',
      ar: 'مستلزمات',
      bn: 'সরবরাহ',
      ru: 'Припасы',
      ja: '備品',
      tr: 'Malzemeler',
      ko: '공급품',
      vi: 'Vật Tư',
      id: 'Perlengkapan',
      th: 'วัสดุสิ้นเปลือง',
      ms: 'Bekalan',
      ar_eg: 'مستلزمات',
      uk: 'Постачання',
    },
    bundle_deals: {
      en: 'Bundle Deals',
      es: 'Ofertas en Paquete',
      fr: 'Offres Groupées',
      de: 'Paketangebote',
      pt: 'Ofertas em Pacote',
      pl: 'Pakietowe Oferty',
      nl: 'Bundelaanbiedingen',
      el: 'Προσφορές Πακέτων',
      cs: 'Balíčkové Nabídky',
      sv: 'Paketdeals',
      hu: 'Csomagajánlatok',
      da: 'Pakkeaftaler',
      fi: 'Pakettiltarjoukset',
      sk: 'Balíkové Ponuky',
      bg: 'Пакетни Оферти',
      hr: 'Paketne Ponude',
      lt: 'Paketiniai Pasiūlymai',
      lv: 'Komplektēti Piedāvājumi',
      et: 'Pakettpakkumised',
      sl: 'Paketne Ponudbe',
      ga: 'Margaí Beartáin',
      mt: 'Ftehim tal-Pakketti',
      cy: 'Bargeinion Pecyn',
      ro: 'Oferte Pachet',
      it: 'Offerte a Pacchetto',
      zh_cn: '套餐优惠',
      hi: 'बंडल डील्स',
      ar: 'عروض الباقات',
      bn: 'বান্ডেল ডিল',
      ru: 'Пакетные Предложения',
      ja: 'バンドル取引',
      tr: 'Paket Fırsatları',
      ko: '번들 거래',
      vi: 'Ưu Đãi Gói',
      id: 'Paket Penawaran',
      th: 'ดีลแบบแพ็คเกจ',
      ms: 'Tawaran Berbundle',
      ar_eg: 'عروض الباقات',
      uk: 'Пакетні Пропозиції',
    },
  },
  daily_available_quantity: {
    en: 'Daily Available Quantity',
    es: 'Cantidad Disponible Diaria',
    fr: 'Quantité Disponible Quotidienne',
    de: 'Täglich Verfügbare Menge',
    pt: 'Quantidade Disponível Diária',
    pl: 'Dostępna Dzienna Ilość',
    nl: 'Dagelijks Beschikbare Hoeveelheid',
    el: 'Ημερήσια Διαθέσιμη Ποσότητα',
    cs: 'Denní Dostupné Množství',
    sv: 'Dagligt Tillgänglig Kvantitet',
    hu: 'Napi Elérhető Mennyiség',
    da: 'Dagligt Tilgængeligt Kvantitet',
    fi: 'Päivittäin Saatavilla Olevat Määrä',
    sk: 'Denná Dostupná Množstvo',
    bg: 'Ежедневно Налично Количество',
    hr: 'Dnevno Dostupna Količina',
    lt: 'Dienos Turimas Kiekis',
    lv: 'Dienas Pieejamais Daudzums',
    et: 'Päevas Saadaval Kogus',
    sl: 'Dnevno Razpoložljiva Količina',
    ga: 'Cainníocht Inrochtana Laethúil',
    mt: "Kwantità Disponibbli ta' Kuljum",
    cy: 'Nifer ar Gael Bob Dydd',
    ro: 'Cantitate Disponibilă Zilnic',
    it: 'Quantità Disponibile Giornaliera',
    zh_cn: '每日可用数量',
    hi: 'दैनिक उपलब्ध मात्रा',
    ar: 'الكمية المتاحة يوميا',
    bn: 'প্রতিদিনের উপলভ্য পরিমাণ',
    ru: 'Ежедневное Доступное Количество',
    ja: '一日の利用可能量',
    tr: 'Günlük Mevcut Miktar',
    ko: '일일 사용 가능 수량',
    vi: 'Số Lượng Có Sẵn Hàng Ngày',
    id: 'Kuantitas Tersedia Harian',
    th: 'ปริมาณที่มีอยู่ในแต่ละวัน',
    ms: 'Kuantiti Tersedia Harian',
    ar_eg: 'الكمية المتاحة يوميًا',
    uk: 'Щоденна Доступна Кількість',
  },
  from: {
    en: 'from',
    es: 'de',
    fr: 'de',
    de: 'von',
    pt: 'de',
    pl: 'od',
    nl: 'van',
    el: 'από',
    cs: 'z',
    sv: 'från',
    hu: 'tól',
    da: 'fra',
    fi: 'alkaen',
    sk: 'od',
    bg: 'от',
    hr: 'od',
    lt: 'nuo',
    lv: 'no',
    et: 'alates',
    sl: 'iz',
    ga: 'ó',
    mt: 'minn',
    cy: 'o',
    ro: 'de la',
    it: 'da',
    zh_cn: '从',
    hi: 'से',
    ar: 'من',
    bn: 'থেকে',
    ru: 'из',
    ja: 'から',
    tr: 'itibaren',
    ko: '에서',
    vi: 'từ',
    id: 'dari',
    th: 'จาก',
    ms: 'daripada',
    ar_eg: 'من',
    uk: 'від',
  },
  to: {
    en: 'to',
    es: 'hasta',
    fr: 'à',
    de: 'bis',
    pt: 'até',
    pl: 'do',
    nl: 'tot',
    el: 'έως',
    cs: 'do',
    sv: 'till',
    hu: 'ig',
    da: 'til',
    fi: 'asti',
    sk: 'do',
    bg: 'до',
    hr: 'do',
    lt: 'iki',
    lv: 'līdz',
    et: 'kuni',
    sl: 'do',
    ga: 'go dtí',
    mt: 'sa',
    cy: 'i',
    ro: 'până la',
    it: 'a',
    zh_cn: '至',
    hi: 'तक',
    ar: 'إلى',
    bn: 'পর্যন্ত',
    ru: 'до',
    ja: 'まで',
    tr: 'kadar',
    ko: '까지',
    vi: 'đến',
    id: 'sampai',
    th: 'ถึง',
    ms: 'hingga',
    ar_eg: 'لحد',
    uk: 'до',
  },
  per: {
    en: 'Per',
    es: 'Por',
    fr: 'Par',
    de: 'Pro',
    pt: 'Por',
    pl: 'Na',
    nl: 'Per',
    el: 'Ανά',
    cs: 'Za',
    sv: 'Per',
    hu: 'Per',
    da: 'Per',
    fi: 'Per',
    sk: 'Za',
    bg: 'На',
    hr: 'Po',
    lt: 'Per',
    lv: 'Par',
    et: 'Per',
    sl: 'Na',
    ga: 'In aghaidh',
    mt: 'Kull',
    cy: 'Y Peth',
    ro: 'Pe',
    it: 'Per',
    zh_cn: '每',
    hi: 'प्रति',
    ar: 'لكل',
    bn: 'প্রতি',
    ru: 'За',
    ja: '毎',
    tr: 'Başına',
    ko: '당',
    vi: 'Trên',
    id: 'Per',
    th: 'ต่อ',
    ms: 'Setiap',
    ar_eg: 'لكل',
    uk: 'За',
  },
  pricing: {
    en: 'Pricing',
    es: 'Precios',
    fr: 'Tarification',
    de: 'Preisgestaltung',
    pt: 'Preços',
    pl: 'Cennik',
    nl: 'Prijzen',
    el: 'Τιμολόγηση',
    cs: 'Cenotvorba',
    sv: 'Prissättning',
    hu: 'Árazás',
    da: 'Prisfastsættelse',
    fi: 'Hinnoittelu',
    sk: 'Cenotvorba',
    bg: 'Ценообразуване',
    hr: 'Cijene',
    lt: 'Kainodara',
    lv: 'Cenu Noteikšana',
    et: 'Hinnakujundus',
    sl: 'Cenitev',
    ga: 'Praghsáil',
    mt: 'Prezzijiet',
    cy: 'Prisio',
    ro: 'Stabilirea Prețurilor',
    it: 'Prezzi',
    zh_cn: '定价',
    hi: 'मूल्य निर्धारण',
    ar: 'التسعير',
    bn: 'মূল্য নির্ধারণ',
    ru: 'Ценообразование',
    ja: '価格設定',
    tr: 'Fiyatlandırma',
    ko: '가격 책정',
    vi: 'Định giá',
    id: 'Penetapan Harga',
    th: 'การตั้งราคา',
    ms: 'Harga',
    ar_eg: 'التسعير',
    uk: 'Ціноутворення',
  },
  units: {
    en: 'Units',
    es: 'Unidades',
    fr: 'Unités',
    de: 'Einheiten',
    pt: 'Unidades',
    pl: 'Jednostki',
    nl: 'Eenheden',
    el: 'Μονάδες',
    cs: 'Jednotky',
    sv: 'Enheter',
    hu: 'Egységek',
    da: 'Enheder',
    fi: 'Yksiköt',
    sk: 'Jednotky',
    bg: 'Единици',
    hr: 'Jedinice',
    lt: 'Vienetai',
    lv: 'Vienības',
    et: 'Üksused',
    sl: 'Enote',
    ga: 'Aonaid',
    mt: 'Unitajiet',
    cy: 'Unedau',
    ro: 'Unități',
    it: 'Unità',
    zh_cn: '单位',
    hi: 'इकाइयां',
    ar: 'الوحدات',
    bn: 'ইউনিট',
    ru: 'Единицы',
    ja: '単位',
    tr: 'Birimler',
    ko: '단위',
    vi: 'Đơn Vị',
    id: 'Satuan',
    th: 'หน่วย',
    ms: 'Unit',
    ar_eg: 'الوحدات',
    uk: 'Одиниці',
  },
  inventory: {
    en: 'Inventory',
    es: 'Inventario',
    fr: 'Inventaire',
    de: 'Inventar',
    pt: 'Inventário',
    pl: 'Inwentarz',
    nl: 'Voorraad',
    el: 'Απόθεμα',
    cs: 'Inventář',
    sv: 'Lager',
    hu: 'Készlet',
    da: 'Lager',
    fi: 'Varasto',
    sk: 'Inventár',
    bg: 'Инвентар',
    hr: 'Inventar',
    lt: 'Inventorius',
    lv: 'Krājumi',
    et: 'Inventar',
    sl: 'Inventar',
    ga: 'Fardal',
    mt: 'Inventarju',
    cy: 'Stoc',
    ro: 'Inventar',
    it: 'Inventario',
    zh_cn: '库存',
    hi: 'इन्वेंटरी',
    ar: 'المخزون',
    bn: 'ইনভেন্টরি',
    ru: 'Инвентарь',
    ja: '在庫',
    tr: 'Envanter',
    ko: '재고',
    vi: 'Hàng Tồn Kho',
    id: 'Inventaris',
    th: 'สินค้าคงคลัง',
    ms: 'Inventori',
    ar_eg: 'الجرد',
    uk: 'Інвентар',
  },
  purchase: {
    en: 'Purchase',
    es: 'Compra',
    fr: 'Achat',
    de: 'Einkauf',
    pt: 'Compra',
    pl: 'Zakup',
    nl: 'Aankoop',
    el: 'Αγορά',
    cs: 'Nákup',
    sv: 'Inköp',
    hu: 'Vásárlás',
    da: 'Køb',
    fi: 'Osto',
    sk: 'Nákup',
    bg: 'Покупка',
    hr: 'Kupnja',
    lt: 'Pirkimas',
    lv: 'Pirkums',
    et: 'Ost',
    sl: 'Nakup',
    ga: 'Ceannach',
    mt: 'Xiri',
    cy: 'Prynu',
    ro: 'Achiziție',
    it: 'Acquisto',
    zh_cn: '购买',
    hi: 'खरीद',
    ar: 'شراء',
    bn: 'ক্রয়',
    ru: 'Покупка',
    ja: '購入',
    tr: 'Satın Alma',
    ko: '구매',
    vi: 'Mua Hàng',
    id: 'Pembelian',
    th: 'ซื้อ',
    ms: 'Pembelian',
    ar_eg: 'شراء',
    uk: 'Закупівля',
  },
  sales: {
    en: 'Sales',
    es: 'Ventas',
    fr: 'Ventes',
    de: 'Verkäufe',
    pt: 'Vendas',
    pl: 'Sprzedaż',
    nl: 'Verkoop',
    el: 'Πωλήσεις',
    cs: 'Prodej',
    sv: 'Försäljning',
    hu: 'Értékesítés',
    da: 'Salg',
    fi: 'Myynti',
    sk: 'Predaj',
    bg: 'Продажби',
    hr: 'Prodaja',
    lt: 'Pardavimai',
    lv: 'Pārdošana',
    et: 'Müük',
    sl: 'Prodaja',
    ga: 'Díolacháin',
    mt: 'Bejgħ',
    cy: 'Gwerthiannau',
    ro: 'Vânzări',
    it: 'Vendite',
    zh_cn: '销售',
    hi: 'बिक्री',
    ar: 'مبيعات',
    bn: 'বিক্রয়',
    ru: 'Продажи',
    ja: '販売',
    tr: 'Satış',
    ko: '판매',
    vi: 'Bán Hàng',
    id: 'Penjualan',
    th: 'การขาย',
    ms: 'Jualan',
    ar_eg: 'مبيعات',
    uk: 'Продаж',
  },
  cost: {
    en: 'Cost',
    es: 'Coste',
    fr: 'Coût',
    de: 'Kosten',
    pt: 'Custo',
    pl: 'Koszt',
    nl: 'Kosten',
    el: 'Κόστος',
    cs: 'Náklady',
    sv: 'Kostnad',
    hu: 'Költség',
    da: 'Omkostninger',
    fi: 'Kustannus',
    sk: 'Náklady',
    bg: 'Цена',
    hr: 'Trošak',
    lt: 'Kaina',
    lv: 'Izmaksas',
    et: 'Kulu',
    sl: 'Strošek',
    ga: 'Costas',
    mt: 'Spiża',
    cy: 'Cost',
    ro: 'Cost',
    it: 'Costo',
    zh_cn: '成本',
    hi: 'लागत',
    ar: 'التكلفة',
    bn: 'খরচ',
    ru: 'Стоимость',
    ja: 'コスト',
    tr: 'Maliyet',
    ko: '비용',
    vi: 'Chi phí',
    id: 'Biaya',
    th: 'ต้นทุน',
    ms: 'Kos',
    ar_eg: 'التكلفة',
    uk: 'Вартість',
  },
  all_sales_type: {
    en: 'All Sales Types',
    es: 'Todos los Tipos de Venta',
    fr: 'Tous les Types de Vente',
    de: 'Alle Verkaufsarten',
    pt: 'Todos os Tipos de Venda',
    pl: 'Wszystkie Rodzaje Sprzedaży',
    nl: 'Alle Verkooptypen',
    el: 'Όλοι οι Τύποι Πωλήσεων',
    cs: 'Všechny Typy Prodeje',
    sv: 'Alla Försäljningstyper',
    hu: 'Minden Értékesítési Típus',
    da: 'Alle Salgstyper',
    fi: 'Kaikki Myyntityypit',
    sk: 'Všetky Typy Predaja',
    bg: 'Всички Видове Продажби',
    hr: 'Sve Vrste Prodaje',
    lt: 'Visų Tipų Pardavimai',
    lv: 'Visi Pārdošanas Veidi',
    et: 'Kõik Müügiliigid',
    sl: 'Vse Vrste Prodaje',
    ga: 'Gach Cineál Díolacháin',
    mt: "Kull Tip ta' Bejgħ",
    cy: 'Pob Math o Werthiannau',
    ro: 'Toate Tipurile de Vânzare',
    it: 'Tutti i Tipi di Vendita',
    zh_cn: '所有销售类型',
    hi: 'सभी बिक्री प्रकार',
    ar: 'جميع أنواع المبيعات',
    bn: 'সব বিক্রয় প্রকার',
    ru: 'Все Типы Продаж',
    ja: 'すべての販売タイプ',
    tr: 'Tüm Satış Türleri',
    ko: '모든 판매 유형',
    vi: 'Tất Cả Các Loại Bán Hàng',
    id: 'Semua Jenis Penjualan',
    th: 'ประเภทการขายทั้งหมด',
    ms: 'Semua Jenis Jualan',
    ar_eg: 'جميع أنواع المبيعات',
    uk: 'Усі Типи Продажів',
  },
  barcode: {
    en: 'Barcode',
    es: 'Código de Barras',
    fr: 'Code-barres',
    de: 'Barcode',
    pt: 'Código de Barras',
    pl: 'Kod Kreskowy',
    nl: 'Streepjescode',
    el: 'Γραμμωτός Κώδικας',
    cs: 'Čárový Kód',
    sv: 'Streckkod',
    hu: 'Vonalkód',
    da: 'Stregkode',
    fi: 'Viivakoodi',
    sk: 'Čiarový Kód',
    bg: 'Баркод',
    hr: 'Barkod',
    lt: 'Brūkšninis Kodu',
    lv: 'Svītrkods',
    et: 'Vöötkood',
    sl: 'Črtna Koda',
    ga: 'Cód Barra',
    mt: 'Kodiċi tal-Barra',
    cy: 'Cod Bar',
    ro: 'Cod de Bare',
    it: 'Codice a Barre',
    zh_cn: '条形码',
    hi: 'बारकोड',
    ar: 'الباركود',
    bn: 'বারকোড',
    ru: 'Штрихкод',
    ja: 'バーコード',
    tr: 'Barkod',
    ko: '바코드',
    vi: 'Mã Vạch',
    id: 'Kode Batang',
    th: 'บาร์โค้ด',
    ms: 'Kod Bar',
    ar_eg: 'الباركود',
    uk: 'Штрихкод',
  },
  discountable: {
    en: 'Discountable',
    es: 'Descontable',
    fr: 'Réductible',
    de: 'Rabattfähig',
    pt: 'Descontável',
    pl: 'Podlegający Rabatowi',
    nl: 'Kortingsgerechtigd',
    el: 'Εκπτώσιμο',
    cs: 'Zlevnitelné',
    sv: 'Rabatterbar',
    hu: 'Kedvezményes',
    da: 'Rabatberettiget',
    fi: 'Alennettava',
    sk: 'Zľaviteľné',
    bg: 'С Подлежи На Отстъпка',
    hr: 'Popustljivo',
    lt: 'Diskontuotinas',
    lv: 'Atlaide',
    et: 'Allahinnatav',
    sl: 'Znižljivo',
    ga: 'Lasctha',
    mt: 'Skont',
    cy: 'Gostyngedig',
    ro: 'Reducibil',
    it: 'Scontabile',
    zh_cn: '可折扣',
    hi: 'छूट योग्य',
    ar: 'قابل للخصم',
    bn: 'ছাড়যোগ্য',
    ru: 'Скидочный',
    ja: '値引き可能',
    tr: 'İndirimli',
    ko: '할인 가능',
    vi: 'Giảm Giá',
    id: 'Diskon',
    th: 'ส่วนลด',
    ms: 'Diskaun',
    ar_eg: 'قابل للخصم',
    uk: 'Знижка',
  },
  refundable: {
    en: 'Refundable',
    es: 'Reembolsable',
    fr: 'Remboursable',
    de: 'Rückerstattungsfähig',
    pt: 'Reembolsável',
    pl: 'Zwracalny',
    nl: 'Restitueerbaar',
    el: 'Επιστρέψιμο',
    cs: 'Vratitelné',
    sv: 'Återbetalningsbar',
    hu: 'Visszatéríthető',
    da: 'Refunderbar',
    fi: 'Hyvitettävä',
    sk: 'Refundovateľné',
    bg: 'Възстановими',
    hr: 'Povratni',
    lt: 'Grąžinamas',
    lv: 'Atmaksājams',
    et: 'Tagastatav',
    sl: 'Vračljivo',
    ga: 'Inaisíoctha',
    mt: 'Rimborsabbli',
    cy: 'Arianadwy',
    ro: 'Rambursabil',
    it: 'Rimborsabile',
    zh_cn: '可退款',
    hi: 'वापसी योग्य',
    ar: 'قابل للاسترداد',
    bn: 'ফেরতযোগ্য',
    ru: 'Возвратный',
    ja: '払い戻し可能',
    tr: 'İade Edilebilir',
    ko: '환불 가능',
    vi: 'Hoàn Lại',
    id: 'Dapat Dikembalikan',
    th: 'คืนเงินได้',
    ms: 'Boleh Dikembalikan',
    ar_eg: 'قابل للاسترداد',
    uk: 'Відшкодовується',
  },
  sku: { en: 'SKU' },
  name_price: {
    en: 'Name/Price',
    es: 'Nombre/Precio',
    fr: 'Nom/Prix',
    de: 'Name/Preis',
    pt: 'Nome/Preço',
    pl: 'Nazwa/Cena',
    nl: 'Naam/Prijs',
    el: 'Όνομα/Τιμή',
    cs: 'Název/Cena',
    sv: 'Namn/Pris',
    hu: 'Név/Ár',
    da: 'Navn/Pris',
    fi: 'Nimi/Hinta',
    sk: 'Názov/Cena',
    bg: 'Име/Цена',
    hr: 'Naziv/Cijena',
    lt: 'Pavadinimas/Kaina',
    lv: 'Nosaukums/Cena',
    et: 'Nimi/Hind',
    sl: 'Ime/Cena',
    ga: 'Ainm/Praghas',
    mt: 'Isem/Prezz',
    cy: 'Enw/Pris',
    ro: 'Nume/Preț',
    it: 'Nome/Prezzo',
    zh_cn: '名称/价格',
    hi: 'नाम/मूल्य',
    ar: 'الاسم/السعر',
    bn: 'নাম/দাম',
    ru: 'Название/Цена',
    ja: '名前/価格',
    tr: 'Ad/Fiyat',
    ko: '이름/가격',
    vi: 'Tên/Giá',
    id: 'Nama/Harga',
    th: 'ชื่อ/ราคา',
    ms: 'Nama/Harga',
    ar_eg: 'الاسم/السعر',
    uk: 'Назва/Ціна',
  },
  availability_callout: {
    title: {
      en: 'What "Item Availability" means in Item Setting?',
      es: '¿Qué significa "Disponibilidad del Artículo" en la Configuración del Artículo?',
      fr: 'Que signifie "Disponibilité de l’Article" dans les Paramètres de l’Article ?',
      de: 'Was bedeutet "Artikelverfügbarkeit" in den Artikeleinstellungen?',
      pt: 'O que "Disponibilidade do Item" significa na Configuração do Item?',
      pl: 'Co oznacza "Dostępność Produktu" w Ustawieniach Produktu?',
      nl: 'Wat betekent "Artikelbeschikbaarheid" in de Artikelinstellingen?',
      el: 'Τι σημαίνει "Διαθεσιμότητα Είδους" στις Ρυθμίσεις Είδους;',
      cs: 'Co znamená "Dostupnost Položky" v Nastavení Položky?',
      sv: 'Vad innebär "Artikelns Tillgänglighet" i Artikelinställningen?',
      hu: 'Mit jelent az "Árucikk Elérhetősége" az Árucikk Beállításoknál?',
      da: 'Hvad betyder "Varetilgængelighed" i Vareindstillinger?',
      fi: 'Mitä "Tuotteen Saatavuus" tarkoittaa Tuoteasetuksissa?',
      sk: 'Čo znamená "Dostupnosť Položky" v Nastavení Položky?',
      bg: 'Какво означава "Наличност на Артикула" в Настройките на Артикула?',
      hr: 'Što znači "Dostupnost Artikla" u Postavkama Artikla?',
      lt: 'Ką reiškia "Prekės Prieinamumas" Prekės Nustatymuose?',
      lv: 'Ko nozīmē "Preces Pieejamība" Preces Iestatījumos?',
      et: 'Mida tähendab "Kauba Saadavus" Kauba Seadistuses?',
      sl: 'Kaj pomeni "Razpoložljivost Izdelka" v Nastavitvah Izdelka?',
      ga: 'Cad a chiallaíonn "Infhaighteacht Míre" i Socruithe Míre?',
      mt: 'X’inhi t-tifsira ta’ "Disponibbiltà tal-Oġġett" fl-Issettjar tal-Oġġett?',
      cy: 'Beth mae "Argaeledd Eitem" yn ei olygu yn Gosodiad yr Eitem?',
      ro: 'Ce înseamnă "Disponibilitatea Articolului" în Setările Articolului?',
      it: 'Cosa significa "Disponibilità dell’Articolo" nelle Impostazioni dell’Articolo?',
      zh_cn: '在项目设置中"项目可用性"是什么意思？',
      hi: 'आइटम सेटिंग में "आइटम उपलब्धता" का क्या अर्थ है?',
      ar: 'ماذا تعني "توفر العنصر" في إعدادات العنصر؟',
      bn: 'আইটেম সেটিংসে "আইটেম উপলব্ধতা" কি?',
      ru: 'Что означает "Наличие Товара" в настройках товара?',
      ja: 'アイテム設定での"アイテムの利用可能性"とは何ですか？',
      tr: 'Ürün Ayarlarında "Ürün Mevcudiyeti" ne anlama gelir?',
      ko: '항목 설정에서 "항목 가용성"이란 무엇입니까?',
      vi: '"Tình trạng Sẵn có của Sản phẩm" có nghĩa là gì trong Cài đặt Sản phẩm?',
      id: 'Apa yang dimaksud dengan "Ketersediaan Item" dalam Pengaturan Item?',
      th: 'การตั้งค่ารายการหมายถึงอะไร?',
      ms: 'Apa maksud "Ketersediaan Item" dalam Tetapan Item?',
      ar_eg: 'ما معنى "توفر العنصر" في إعدادات العنصر؟',
      uk: 'Що означає "Наявність Товару" в налаштуваннях товару?',
    },
    description: {
      en: 'This refers to the specific periods when your products or services are on sale. It could align with a season, holiday, or any time-frame you set. You can create numerous sales availability periods, offering flexibility for managing your sales strategy. Apply these availability sets while adding items to your inventory, ensuring your products are available when your customers want them. To create or edit your sales availability sets tap the ‘Manage Availability’ button.',
      es: 'Esto se refiere a los períodos específicos cuando sus productos o servicios están en oferta. Puede coincidir con una temporada, un feriado o cualquier intervalo de tiempo que establezca. Puede crear numerosos períodos de disponibilidad de venta, ofreciendo flexibilidad para gestionar su estrategia de ventas. Aplique estos conjuntos de disponibilidad mientras agrega artículos a su inventario, asegurando que sus productos estén disponibles cuando sus clientes los deseen. Para crear o editar sus conjuntos de disponibilidad de venta, toque el botón ‘Gestionar Disponibilidad’.',
      fr: 'Cela fait référence aux périodes spécifiques pendant lesquelles vos produits ou services sont en vente. Cela peut correspondre à une saison, à un jour férié ou à toute période que vous définissez. Vous pouvez créer de nombreuses périodes de disponibilité des ventes, offrant de la flexibilité pour gérer votre stratégie de vente. Appliquez ces ensembles de disponibilité tout en ajoutant des articles à votre inventaire, en vous assurant que vos produits sont disponibles lorsque vos clients les souhaitent. Pour créer ou modifier vos ensembles de disponibilité de vente, appuyez sur le bouton ‘Gérer la Disponibilité’.',
      de: 'Dies bezieht sich auf die spezifischen Zeiträume, in denen Ihre Produkte oder Dienstleistungen zum Verkauf stehen. Es kann sich nach einer Saison, einem Feiertag oder jedem von Ihnen festgelegten Zeitrahmen richten. Sie können zahlreiche Verkaufsverfügbarkeitszeiträume erstellen, was Flexibilität bei der Verwaltung Ihrer Verkaufsstrategie bietet. Wenden Sie diese Verfügbarkeitssets an, während Sie Artikel zu Ihrem Inventar hinzufügen, um sicherzustellen, dass Ihre Produkte verfügbar sind, wenn Ihre Kunden sie wünschen. Um Ihre Verkaufsverfügbarkeitssets zu erstellen oder zu bearbeiten, tippen Sie auf die Schaltfläche ‘Verfügbarkeit Verwalten’.',
      pt: 'Isto refere-se aos períodos específicos em que seus produtos ou serviços estão à venda. Pode alinhar-se com uma estação, feriado ou qualquer período de tempo que você definir. Você pode criar vários períodos de disponibilidade de vendas, oferecendo flexibilidade para gerenciar sua estratégia de vendas. Aplique estes conjuntos de disponibilidade enquanto adiciona itens ao seu inventário, garantindo que seus produtos estejam disponíveis quando seus clientes os quiserem. Para criar ou editar seus conjuntos de disponibilidade de vendas toque no botão ‘Gerenciar Disponibilidade’.',
      pl: 'Odnosi się to do konkretnych okresów, kiedy Twoje produkty lub usługi są w sprzedaży. Może to być zgodne z sezonem, świętem lub dowolnym okresem czasu, który ustalisz. Możesz stworzyć liczne okresy dostępności sprzedaży, oferując elastyczność w zarządzaniu strategią sprzedaży. Zastosuj te zestawy dostępności podczas dodawania przedmiotów do swojego inwentarza, zapewniając dostępność produktów, gdy klienci ich potrzebują. Aby stworzyć lub edytować zestawy dostępności sprzedaży, dotknij przycisku ‘Zarządzaj dostępnością’.',
      nl: 'Dit verwijst naar de specifieke perioden waarin uw producten of diensten te koop zijn. Het kan overeenkomen met een seizoen, vakantie of welke tijdsperiode u ook instelt. U kunt talrijke verkoopbeschikbaarheidsperiodes creëren, wat flexibiliteit biedt voor het beheren van uw verkoopstrategie. Pas deze beschikbaarheidssets toe tijdens het toevoegen van items aan uw voorraad, om ervoor te zorgen dat uw producten beschikbaar zijn wanneer uw klanten ze willen. Om uw verkoopbeschikbaarheidssets te creëren of te bewerken, tik op de ‘Beheer Beschikbaarheid’ knop.',
      el: 'Αυτό αναφέρεται στις συγκεκριμένες περιόδους κατά τις οποίες τα προϊόντα ή οι υπηρεσίες σας είναι προς πώληση. Μπορεί να συμπίπτει με μια εποχή, μια αργία ή οποιαδήποτε χρονική περίοδο ορίσετε. Μπορείτε να δημιουργήσετε πολλές περιόδους διαθεσιμότητας πωλήσεων, προσφέροντας ευελιξία για τη διαχείριση της στρατηγικής πωλήσεων σας. Εφαρμόστε αυτά τα σετ διαθεσιμότητας κατά την προσθήκη αντικειμένων στο απόθεμά σας, διασφαλίζοντας ότι τα προϊόντα σας θα είναι διαθέσιμα όταν οι πελάτες σας τα θέλουν. Για να δημιουργήσετε ή να επεξεργαστείτε τα σετ διαθεσιμότητας πωλήσεων σας, πατήστε το κουμπί ‘Διαχείριση Διαθεσιμότητας’.',
      cs: "Toto se týká konkrétních období, kdy jsou vaše produkty nebo služby na prodej. Mohlo by to korespondovat s ročním obdobím, svátkem nebo jakýmkoliv časovým obdobím, které nastavíte. \nMůžete vytvořit několik období dostupnosti prodeje, což poskytuje flexibilitu při řízení vaší prodejní strategie. Tyto sady dostupnosti aplikujte při přidávání položek do vaší zásoby, čímž zajistíte, že vaše produkty budou k dispozici, když si je vaši zákazníci budou přát. \nPro vytvoření nebo úpravu vašich sad dostupnosti prodeje klepněte na tlačítko 'Spravovat dostupnost'.",
      sv: "Detta hänvisar till de specifika perioderna då dina produkter eller tjänster är till salu. Det kan sammanfalla med en säsong, högtid eller vilken tidsram du än ställer in. \nDu kan skapa många försäljningstillgänglighetsperioder, vilket erbjuder flexibilitet för att hantera din försäljningsstrategi. Tillämpa dessa tillgänglighetsset när du lägger till artiklar i ditt lager, för att säkerställa att dina produkter är tillgängliga när dina kunder vill ha dem. \nFör att skapa eller redigera dina försäljningstillgänglighetsset, tryck på 'Hantera tillgänglighet'-knappen.",
      hu: "Ez a konkrét időszakokra vonatkozik, amikor termékei vagy szolgáltatásai eladásra állnak. Ez összhangban lehet egy évszakkal, ünnepnapokkal vagy bármilyen általad beállított időkerettel. \nLétrehozhatsz számos értékesítési rendelkezésre állási időszakot, rugalmasságot nyújtva értékesítési stratégiád kezeléséhez. Ezeket a rendelkezésre állási készleteket alkalmazd az árukészletedbe történő cikkek hozzáadásakor, így biztosítva, hogy termékeid akkor álljanak rendelkezésre, amikor az ügyfeleid szeretnék őket. \nAz értékesítési rendelkezésre állási készletek létrehozásához vagy szerkesztéséhez érintsd meg a 'Rendelkezésre állás kezelése' gombot.",
      da: "Dette henviser til de specifikke perioder, hvor dine produkter eller tjenester er til salg. Det kunne være i tråd med en sæson, helligdag eller enhver tidsramme, du sætter. \nDu kan oprette adskillige salgs tilgængelighedsperioder, der tilbyder fleksibilitet for at håndtere din salgsstrategi. Anvend disse tilgængelighedssæt, mens du tilføjer varer til dit lager, hvilket sikrer, at dine produkter er tilgængelige, når dine kunder ønsker dem. \nFor at oprette eller redigere dine salgs tilgængelighedssæt, tryk på 'Håndter tilgængelighed'-knappen.",
      fi: "Tämä viittaa tiettyihin ajanjaksoihin, jolloin tuotteesi tai palvelusi ovat myynnissä. Se voi olla linjassa jonkin tietyn vuodenajan, juhlapyhän tai asettamasi aikavälin kanssa. \nVoit luoda useita myynnin saatavuusaikoja, mikä tarjoaa joustavuutta myyntistrategiasi hallintaan. Sovella näitä saatavuussettejä lisätessäsi tuotteita varastoon, varmistaen että tuotteesi ovat saatavilla, kun asiakkaasi niitä haluavat. \nLuodaksesi tai muokataksesi myynnin saatavuussettejä, napauta 'Hallitse saatavuutta'-painiketta.",
      sk: "Týka sa to konkrétnych období, kedy sú vaše produkty alebo služby na predaj. Mohlo by to zodpovedať sezóne, sviatku alebo akémukoľvek časovému obdobiu, ktoré nastavíte. \nMôžete vytvoriť viacero období dostupnosti predaja, čo ponúka flexibilitu pri riadení vašej predajnej stratégie. Tieto sady dostupnosti aplikujte pri pridávaní položiek do vášho inventára, čím zabezpečíte, že vaše produkty sú dostupné, keď si ich vaši zákazníci želajú. \nPre vytvorenie alebo úpravu vašich sád dostupnosti predaja, klepnite na tlačidlo 'Spravovať dostupnosť'.",
      bg: "Това се отнася до конкретните периоди, когато вашите продукти или услуги се продават. Може да съвпада със сезон, празник или който и да е времеви интервал, който сте задали. \nМожете да създадете множество периоди на наличност за продажба, което предлага гъвкавост при управлението на вашата стратегия за продажби. Прилагайте тези набори от наличности, докато добавяте артикули към вашия инвентар, осигурявайки, че вашите продукти са налични, когато клиентите ви ги искат. \nЗа да създадете или редактирате вашите набори от наличност за продажба, докоснете бутона 'Управление на наличността'.",
      hr: "To se odnosi na specifična razdoblja kada su vaši proizvodi ili usluge na prodaju. To bi se moglo uskladiti sa sezonom, blagdanom ili bilo kojim vremenskim okvirom koji postavite. \nMožete stvoriti brojna razdoblja dostupnosti za prodaju, nudeći fleksibilnost za upravljanje vašom strategijom prodaje. Primijenite ove setove dostupnosti prilikom dodavanja artikala u svoj inventar, osiguravajući da su vaši proizvodi dostupni kada ih vaši klijenti žele. \nDa biste stvorili ili uredili svoje setove dostupnosti za prodaju, dodirnite gumb 'Upravljanje dostupnošću'.",
      lt: 'Tai nurodo konkrečius laikotarpius, kai jūsų produktai ar paslaugos yra parduodami. Tai gali sutapti su sezonu, švente ar bet kokiu nustatytu laiko intervalu. <br>Jūs galite sukurti daugybę pardavimų prieinamumo laikotarpių, suteikdami lankstumą valdyti savo pardavimų strategiją. Taikykite šiuos prieinamumo rinkinius, pridedant prekes į savo atsargas, užtikrindami, kad jūsų produktai bus prieinami, kai jūsų klientai norės juos įsigyti. <br>Kad sukurtumėte ar redaguotumėte savo pardavimų prieinamumo rinkinius, palieskite mygtuką <strong>‘Valdyti Prieinamumą’</strong>.',
      lv: 'Tas attiecas uz konkrētiem laika posmiem, kad jūsu produkti vai pakalpojumi ir pārdošanā. Tas var sakrist ar sezonu, svētkiem vai jebkuru citu jūsu izvēlētu laika ietvaru. <br>Jūs varat izveidot vairākus pārdošanas pieejamības periodus, piedāvājot elastību jūsu pārdošanas stratēģijas pārvaldībā. Lietojiet šos pieejamības komplektus, pievienojot preces jūsu krājumam, nodrošinot, ka jūsu produkti ir pieejami, kad jūsu klienti tos vēlas iegādāties. <br>Lai izveidotu vai labotu jūsu pārdošanas pieejamības komplektus, pieskarieties pogai <strong>‘Pārvaldīt Pieejamību’</strong>.',
      et: 'See viitab kindlatele perioodidele, millal teie tooted või teenused on müügil. See võib kattuda hooajaga, pühadega või ükskõik millise teie määratud ajaraamiga. <br>Te võite luua mitmeid müügikättesaadavuse perioode, pakkudes paindlikkust teie müügistrateegia haldamiseks. Rakendage neid kättesaadavuse komplekte, lisades esemeid teie varudesse, tagades, et teie tooted on saadaval, kui teie kliendid neid soovivad. <br>Müügikättesaadavuse komplektide loomiseks või redigeerimiseks puudutage nuppu <strong>‘Halda Kättesaadavust’</strong>.',
      sl: 'To se nanaša na specifična obdobja, ko so vaši izdelki ali storitve naprodaj. Lahko se uskladi z letnim časom, praznikom ali katerim koli časovnim okvirom, ki ga nastavite. <br>Ustvarite lahko več obdobij razpoložljivosti prodaje, kar nudi fleksibilnost pri upravljanju vaše prodajne strategije. Uporabite te nabor razpoložljivosti, medtem ko dodajate artikle v vaš inventar, zagotavljajoč, da so vaši izdelki na voljo, ko si jih vaše stranke želijo. <br>Za ustvarjanje ali urejanje vaših naborov razpoložljivosti prodaje tapnite gumb <strong>‘Upravljanje z Razpoložljivostjo’</strong>.',
      ga: "Baineann sé seo le tréimhsí sonracha nuair a bhíonn do tháirgí nó seirbhísí ar díol. D'fhéadfadh sé a bheith ag teacht le séasúr, saoire, nó aon amharc ama a leagann tú síos. <br>Is féidir leat roinnt tréimhsí inrochtaineachta díolacháin a chruthú, ag soláthar solúbthacht chun do straitéis díolacháin a bhainistiú. Cuir i bhfeidhm na tacair inrochtaineachta seo agus tú ag cur míreanna le do stoc, ag cinntiú go mbeidh do tháirgí ar fáil nuair is mian le do chustaiméirí iad. <br>Chun tacair inrochtaineachta díolacháin a chruthú nó a chur in eagar, sconnaigh ar an gcnaipe <strong>‘Bainistigh Inrochtaineacht’</strong>.",
      mt: "Dan jirreferi għal perjodi speċifiċi meta l-prodotti jew is-servizzi tiegħek ikunu għall-bejgħ. Dan jista' jaqbel ma' staġun, vaganza, jew kwalunkwe ħin li tissettja int. <br>Tista' toħloq numru ta' perjodi ta' disponibbiltà tal-bejgħ, li joffru flessibbiltà fil-ġestjoni tal-istrateġija tal-bejgħ tiegħek. Applika dawn is-settijiet ta' disponibbiltà waqt li żżid oġġetti mal-inventarju tiegħek, biex tiżgura li l-prodotti tiegħek ikunu disponibbli meta l-klijenti tiegħek iriduhom. <br>Biex toħloq jew teditja s-settijiet ta' disponibbiltà tal-bejgħ tiegħek, agħfas il-buttuna <strong>‘Immaniġġja Disponibbiltà’</strong>.",
      cy: "Mae hyn yn cyfeirio at gyfnodau penodol pan fydd eich cynnyrch neu wasanaethau ar werth. Gallai gyd-fynd â thymor, gwyliau, neu unrhyw amserlen rydych chi'n ei gosod. <br>Gallwch greu nifer o gyfnodau argaeledd gwerthu, gan gynnig hyblygrwydd wrth reoli eich strategaeth werthu. Cymhwyswch y setiau argaeledd hyn wrth ychwanegu eitemau at eich rhestr eiddo, gan sicrhau bod eich cynhyrchion ar gael pan fydd eich cwsmeriaid eu heisiau. <br>I greu neu olygu eich setiau argaeledd gwerthu, tapiwch y botwm <strong>‘Rheoli Argaeledd’</strong>.",
      ro: 'Aceasta se referă la perioadele specifice când produsele sau serviciile dumneavoastră sunt de vânzare. Aceasta poate coincide cu un sezon, o sărbătoare sau orice interval de timp pe care îl setați. <br>Puteți crea numeroase perioade de disponibilitate pentru vânzări, oferind flexibilitate în gestionarea strategiei de vânzări. Aplicați aceste seturi de disponibilitate în timp ce adăugați articole în inventarul dumneavoastră, asigurându-vă că produsele dumneavoastră sunt disponibile atunci când clienții dumneavoastră le doresc. <br>Pentru a crea sau edita seturile dumneavoastră de disponibilitate pentru vânzări, apăsați butonul <strong>‘Gestionați Disponibilitatea’</strong>.',
      it: 'Questo si riferisce ai periodi specifici in cui i tuoi prodotti o servizi sono in vendita. Può coincidere con una stagione, una festività o qualsiasi intervallo di tempo che stabilisci. <br>Puoi creare numerosi periodi di disponibilità di vendita, offrendo flessibilità nella gestione della tua strategia di vendita. Applica questi set di disponibilità mentre aggiungi articoli al tuo inventario, assicurandoti che i tuoi prodotti siano disponibili quando i tuoi clienti li desiderano. <br>Per creare o modificare i tuoi set di disponibilità di vendita, tocca il pulsante <strong>‘Gestisci Disponibilità’</strong>.',
      zh_cn:
        '这指的是您的产品或服务进行销售的特定时期。它可以与季节、假日或您设定的任何时间框架相对应。<br>您可以创建多个销售可用时间段，为管理您的销售策略提供灵活性。在向您的库存添加物品时应用这些可用性设置，确保当您的客户需要时，您的产品可供购买。<br>要创建或编辑您的销售可用性设置，请点击<strong>‘管理可用性’</strong>按钮。',
      hi: "यह उन विशेष अवधियों को संदर्भित करता है जब आपके उत्पाद या सेवाएं बिक्री पर होती हैं। यह किसी मौसम, छुट्टी, या आपके द्वारा निर्धारित किसी भी समय-सीमा के अनुरूप हो सकता है। <br>आप कई बिक्री उपलब्धता अवधियां बना सकते हैं, जो आपकी बिक्री रणनीति को प्रबंधित करने के लिए लचीलापन प्रदान करती हैं। अपनी इन्वेंटरी में आइटम जोड़ते समय इन उपलब्धता सेटों को लागू करें, यह सुनिश्चित करते हुए कि जब आपके ग्राहक उन्हें चाहें तो आपके उत्पाद उपलब्ध हों। <br>अपने बिक्री उपलब्धता सेट बनाने या संपादित करने के लिए <strong>'उपलब्धता प्रबंधित करें'</strong> बटन पर टैप करें।",
      ar: "يشير هذا إلى الفترات المحددة التي تكون فيها منتجاتك أو خدماتك معروضة للبيع. يمكن أن يتماشى ذلك مع موسم معين، أو عطلة، أو أي إطار زمني تحدده. <br>يمكنك إنشاء عدة فترات توافر للمبيعات، مما يوفر المرونة في إدارة استراتيجية المبيعات الخاصة بك. طبّق هذه المجموعات من التوافر أثناء إضافة عناصر إلى جردك، لضمان توافر منتجاتك عندما يرغب عملاؤك في شرائها. <br>لإنشاء أو تحرير مجموعات توافر المبيعات الخاصة بك، انقر على زر <strong>'إدارة التوافر'</strong>.",
      bn: 'এটি উল্লেখ করে সেই নির্দিষ্ট সময়কালগুলিতে যখন আপনার পণ্য বা সেবাগুলি বিক্রি হয়। এটি মৌসুম, ছুটির দিন, বা আপনি যে কোন সময়সীমা নির্ধারণ করেন তার সাথে মিলিত হতে পারে। <br>আপনি বিক্রয়ের উপলব্ধির অনেকগুলি সময়কাল তৈরি করতে পারেন, যা আপনার বিক্রয় কৌশল পরিচালনা করার জন্য নমনীয়তা সরবরাহ করে। আপনার ইনভেন্টরিতে আইটেম যোগ করার সময় এই উপলব্ধি সেটগুলি প্রয়োগ করুন, নিশ্চিত করুন যে আপনার পণ্যগুলি গ্রাহকরা যখন চান তখন উপলব্ধ। <br>আপনার বিক্রয়ের উপলব্ধি সেট তৈরি বা সম্পাদনা করতে <strong>‘উপলব্ধি পরিচালনা’</strong> বোতামটি ট্যাপ করুন।',
      ru: 'Это относится к конкретным периодам времени, когда ваши товары или услуги продаются. Это может совпадать с сезоном, праздником или любым временным промежутком, который вы установите. <br>Вы можете создать несколько периодов доступности для продаж, что предоставляет гибкость в управлении вашей торговой стратегией. Применяйте эти наборы доступности при добавлении товаров в ваш инвентарь, чтобы ваши товары были доступны, когда это необходимо вашим клиентам. <br>Чтобы создать или отредактировать ваши наборы доступности для продаж, нажмите кнопку <strong>‘Управление доступностью’</strong>.',
      ja: 'これは、製品またはサービスが販売されている特定の期間を指します。季節、祝日、または設定した任意の期間に合わせることができます。<br>販売可能な期間を複数設定し、販売戦略を管理する柔軟性を提供できます。これらの利用可能セットを在庫にアイテムを追加する際に適用し、顧客が求める時に製品が利用可能であることを保証します。<br>販売利用可能セットを作成または編集するには、<strong>‘利用可能性の管理’</strong>ボタンをタップしてください。',
      tr: 'Bu, ürünlerinizin veya hizmetlerinizin satışta olduğu belirli dönemlere atıfta bulunur. Bir mevsime, tatile veya belirlediğiniz herhangi bir zaman dilimine uygun olabilir. <br>Satış stratejinizi yönetmek için esneklik sunarak, birçok satış uygunluk dönemi oluşturabilirsiniz. Envanterinize öğe eklerken bu uygunluk setlerini uygulayın, böylece ürünleriniz müşterileriniz istediğinde mevcut olur. <br>Satış uygunluk setlerinizi oluşturmak veya düzenlemek için <strong>‘Uygunluğu Yönet’</strong> butonuna dokunun.',
      ko: '이것은 귀하의 제품이나 서비스가 판매되고 있는 특정 기간을 나타냅니다. 계절, 휴일 또는 설정한 어떠한 시간 프레임과 일치할 수 있습니다. <br>여러분은 여러 판매 가능 시간을 생성하여 판매 전략을 관리할 유연성을 제공할 수 있습니다. 재고에 품목을 추가할 때 이러한 가능성 세트를 적용하여 고객이 원할 때 제품을 사용할 수 있도록 합니다. <br>판매 가능성 세트를 생성하거나 편집하려면 <strong>‘가능성 관리’</strong> 버튼을 탭하세요.',
      vi: 'Điều này ám chỉ các khoảng thời gian cụ thể khi sản phẩm hoặc dịch vụ của bạn được bán ra. Nó có thể phù hợp với một mùa, ngày lễ, hoặc bất kỳ khung thời gian nào bạn thiết lập. <br>Bạn có thể tạo ra nhiều khoảng thời gian khả dụng cho việc bán hàng, cung cấp tính linh hoạt trong quản lý chiến lược bán hàng của bạn. Áp dụng các bộ khả dụng này khi bạn thêm mặt hàng vào kho hàng của mình, đảm bảo sản phẩm của bạn sẵn có khi khách hàng của bạn muốn chúng. <br>Để tạo hoặc chỉnh sửa các bộ khả dụng bán hàng của bạn, hãy nhấn vào nút <strong>‘Quản lý Khả Dụng’</strong>.',
      id: 'Ini merujuk pada periode spesifik ketika produk atau layanan Anda sedang dijual. Ini bisa sesuai dengan musim, hari libur, atau kerangka waktu yang Anda tetapkan. <br>Anda dapat membuat beberapa periode ketersediaan penjualan, menawarkan fleksibilitas dalam mengelola strategi penjualan Anda. Terapkan set ketersediaan ini saat menambahkan item ke inventaris Anda, memastikan produk Anda tersedia saat pelanggan Anda menginginkannya. <br>Untuk membuat atau mengedit set ketersediaan penjualan Anda, ketuk tombol <strong>‘Kelola Ketersediaan’</strong>.',
      th: 'สิ่งนี้อ้างถึงช่วงเวลาเฉพาะเมื่อผลิตภัณฑ์หรือบริการของคุณอยู่ในการขาย มันสามารถสอดคล้องกับฤดูกาล วันหยุด หรือกรอบเวลาใด ๆ ที่คุณตั้งไว้ <br>คุณสามารถสร้างช่วงเวลาการขายที่มีให้เลือกหลายช่วงเวลา เพื่อเสนอความยืดหยุ่นในการจัดการกลยุทธ์การขายของคุณ ใช้ชุดความพร้อมใช้งานเหล่านี้ขณะเพิ่มสินค้าลงในสต็อกของคุณ เพื่อให้แน่ใจว่าผลิตภัณฑ์ของคุณพร้อมใช้งานเมื่อลูกค้าของคุณต้องการ <br>ในการสร้างหรือแก้ไขชุดความพร้อมใช้งานการขายของคุณ แตะที่ปุ่ม <strong>‘จัดการความพร้อมใช้งาน’</strong>',
      ms: 'Ini merujuk kepada tempoh tertentu apabila produk atau perkhidmatan anda sedang dijual. Ia boleh sejajar dengan musim, hari cuti, atau bingkai masa yang anda tetapkan. <br>Anda boleh mencipta beberapa tempoh ketersediaan jualan, menawarkan fleksibiliti dalam mengurus strategi jualan anda. Gunakan set ketersediaan ini semasa menambah item ke inventori anda, memastikan produk anda tersedia apabila pelanggan anda mahukannya. <br>Untuk membuat atau mengedit set ketersediaan jualan anda, ketik butang <strong>‘Urus Ketersediaan’</strong>.',
      ar_eg:
        'يشير هذا إلى الفترات المحددة التي تكون فيها منتجاتك أو خدماتك معروضة للبيع. قد تتماشى مع موسم، عطلة، أو أي إطار زمني تحدده. يمكنك إنشاء العديد من فترات توفر المبيعات، مما يوفر المرونة في إدارة استراتيجية المبيعات الخاصة بك. طبّق هذه المجموعات من الفترات أثناء إضافة العناصر إلى المخزون الخاص بك، لضمان توفر منتجاتك عندما يرغب عملاؤك فيها. لإنشاء أو تعديل مجموعات توفر المبيعات الخاصة بك، اضغط على زرإدارة التوفر.',
      uk: "Це стосується конкретних періодів, коли ваші товари або послуги продаються. Це може відповідати сезону, святу або будь-якому часовому проміжку, який ви встановите. Ви можете створити численні періоди доступності продажів, що надає гнучкість у керуванні вашою стратегією продажів. Застосовуйте ці набори доступності під час додавання товарів до вашого інвентарю, забезпечуючи наявність ваших товарів, коли вони потрібні вашим клієнтам. Щоб створити або редагувати набори доступності продажів, натисніть кнопку 'Керування доступністю'.",
    },
  },

  subcategory_name: {
    en: 'Subcategory Name',
    es: 'Nombre de Subcategoría',
    fr: 'Nom de la Sous-catégorie',
    de: 'Unterkategoriename',
    pt: 'Nome da Subcategoria',
    pl: 'Nazwa Podkategorii',
    nl: 'Naam Subcategorie',
    el: 'Όνομα Υποκατηγορίας',
    cs: 'Název Podkategorie',
    sv: 'Namn på Underkategori',
    hu: 'Alkategória Neve',
    da: 'Underkategorinavn',
    fi: 'Alakategorian Nimi',
    sk: 'Názov Podkategórie',
    bg: 'Име на Подкатегория',
    hr: 'Naziv Podkategorije',
    lt: 'Subkategorijos Pavadinimas',
    lv: 'Apakškategorijas Nosaukums',
    et: 'Alamkategooria Nimi',
    sl: 'Ime Podkategorije',
    ga: 'Ainm Fo-chatagóire',
    mt: "Isem ta' Sottokategorija",
    cy: 'Enw Is-gategori',
    ro: 'Nume Subcategorie',
    it: 'Nome della Sottocategoria',
    zh_cn: '子类别名称',
    hi: 'उप-श्रेणी नाम',
    ar: 'اسم الفئة الفرعية',
    bn: 'উপশ্রেণীর নাম',
    ru: 'Название Подкатегории',
    ja: 'サブカテゴリ名',
    tr: 'Alt Kategori Adı',
    ko: '하위 카테고리 이름',
    vi: 'Tên Danh Mục Con',
    id: 'Nama Subkategori',
    th: 'ชื่อหมวดหมู่ย่อย',
    ms: 'Nama Subkategori',
    ar_eg: 'اسم الفئة الفرعية',
    uk: 'Назва Підкатегорії',
  },
  item_types_no_data: {
    title: {
      en: 'No item has been created!',
      es: '¡No se ha creado ningún artículo!',
      fr: "Aucun article n'a été créé !",
      de: 'Kein Artikel wurde erstellt!',
      pt: 'Nenhum item foi criado!',
      pl: 'Nie utworzono żadnego elementu!',
      nl: 'Er is geen item aangemaakt!',
      el: 'Δεν έχει δημιουργηθεί κανένα αντικείμενο!',
      cs: 'Žádná položka nebyla vytvořena!',
      sv: 'Ingen artikel har skapats!',
      hu: 'Nem jött létre elem!',
      da: 'Ingen vare er blevet oprettet!',
      fi: 'Yhtään kohdetta ei ole luotu!',
      sk: 'Nebol vytvorený žiadny predmet!',
      bg: 'Не е създаден артикул!',
      hr: 'Nijedan predmet nije stvoren!',
      lt: 'Nėra sukurto elemento!',
      lv: 'Nav izveidots neviens priekšmets!',
      et: 'Ühtegi eset pole loodud!',
      sl: 'Ni bil ustvarjen noben predmet!',
      ga: 'Níor cruthaíodh aon mhír!',
      mt: 'L-ebda oġġett ma ġie maħluq!',
      cy: 'Ni chrewyd unrhyw eitem!',
      ro: 'Nu a fost creat niciun articol!',
      it: 'Nessun articolo è stato creato!',
      zh_cn: '尚未创建任何项目！',
      hi: 'कोई आइटम नहीं बनाया गया है!',
      ar: 'لم يتم إنشاء أي عنصر!',
      bn: 'কোনও আইটেম তৈরি করা হয়নি!',
      ru: 'Ни один элемент не был создан!',
      ja: 'アイテムが作成されていません！',
      tr: 'Hiçbir öğe oluşturulmadı!',
      ko: '항목이 생성되지 않았습니다!',
      vi: 'Không có mục nào được tạo!',
      id: 'Tidak ada item yang dibuat!',
      th: 'ยังไม่ได้สร้างรายการ!',
      ms: 'Tiada item telah dibuat!',
      ar_eg: 'لم يتم إنشاء أي عنصر!',
      uk: 'Жоден елемент не був створений!',
    },
    description: {
      en: 'You need to create items to be able to add them here.',
      es: 'Necesitas crear artículos para poder agregarlos aquí.',
      fr: 'Vous devez créer des articles pour pouvoir les ajouter ici.',
      de: 'Sie müssen Artikel erstellen, um sie hier hinzufügen zu können.',
      pt: 'Você precisa criar itens para poder adicioná-los aqui.',
      pl: 'Musisz utworzyć elementy, aby móc je tutaj dodać.',
      nl: 'U moet items aanmaken om ze hier te kunnen toevoegen.',
      el: 'Πρέπει να δημιουργήσετε αντικείμενα για να μπορέσετε να τα προσθέσετε εδώ.',
      cs: 'Musíte vytvořit položky, abyste je sem mohli přidat.',
      sv: 'Du måste skapa objekt för att kunna lägga till dem här.',
      hu: 'Létre kell hoznia elemeket, hogy hozzá tudja adni őket itt.',
      da: 'Du skal oprette varer for at kunne tilføje dem her.',
      fi: 'Sinun on luotava kohteita voidaksesi lisätä ne tänne.',
      sk: 'Musíte vytvoriť položky, aby ste ich sem mohli pridať.',
      bg: 'Трябва да създадете артикули, за да можете да ги добавите тук.',
      hr: 'Morate stvoriti stavke da biste ih mogli dodati ovdje.',
      lt: 'Turite sukurti elementus, kad galėtumėte juos pridėti čia.',
      lv: 'Jums ir jāizveido vienumi, lai varētu tos pievienot šeit.',
      et: 'Peate looma esemed, et saaksite neid siia lisada.',
      sl: 'Ustvariti morate elemente, da jih lahko tukaj dodate.',
      ga: 'Ní mór duit míreanna a chruthú chun iad a chur leis anseo.',
      mt: "Għandek bżonn toħloq oġġetti biex tkun tista' żżidhom hawn.",
      cy: 'Mae angen i chi greu eitemau i allu eu hychwanegu yma.',
      ro: 'Trebuie să creați articole pentru a le putea adăuga aici.',
      it: 'Devi creare elementi per poterli aggiungere qui.',
      zh_cn: '您需要创建项目才能将其添加到此处。',
      hi: 'आपको उन्हें यहाँ जोड़ने के लिए आइटम बनाने की आवश्यकता है।',
      ar: 'تحتاج إلى إنشاء عناصر لتتمكن من إضافتها هنا.',
      bn: 'আপনাকে এখানে যোগ করতে আইটেম তৈরি করতে হবে।',
      ru: 'Вам нужно создать элементы, чтобы иметь возможность добавить их здесь.',
      ja: 'ここに追加するにはアイテムを作成する必要があります。',
      tr: 'Buraya ekleyebilmek için öğeler oluşturmanız gerekir.',
      ko: '여기에 추가하려면 항목을 생성해야 합니다.',
      vi: 'Bạn cần tạo các mục để có thể thêm chúng vào đây.',
      id: 'Anda perlu membuat item agar dapat menambahkannya di sini.',
      th: 'คุณต้องสร้างรายการเพื่อเพิ่มในที่นี้',
      ms: 'Anda perlu mencipta item untuk menambahkannya di sini.',
      ar_eg: 'تحتاج إلى إنشاء عناصر لتتمكن من إضافتها هنا.',
      uk: 'Вам потрібно створити елементи, щоб мати можливість додати їх тут.',
    },
  },
  select_type: {
    en: 'Select type',
    es: 'Seleccionar tipo',
    fr: 'Sélectionner le type',
    de: 'Typ auswählen',
    pt: 'Selecionar tipo',
    pl: 'Wybierz typ',
    nl: 'Selecteer type',
    el: 'Επιλέξτε τύπο',
    cs: 'Vyberte typ',
    sv: 'Välj typ',
    hu: 'Típus kiválasztása',
    da: 'Vælg type',
    fi: 'Valitse tyyppi',
    sk: 'Vyberte typ',
    bg: 'Изберете тип',
    hr: 'Odaberite vrstu',
    lt: 'Pasirinkite tipą',
    lv: 'Izvēlieties veidu',
    et: 'Valige tüüp',
    sl: 'Izberite vrsto',
    ga: 'Roghnaigh cineál',
    mt: 'Agħżel it-tip',
    cy: 'Dewiswch fath',
    ro: 'Selectați tipul',
    it: 'Seleziona tipo',
    zh_cn: '选择类型',
    hi: 'प्रकार चुनें',
    ar: 'حدد النوع',
    bn: 'টাইপ নির্বাচন করুন',
    ru: 'Выберите тип',
    ja: 'タイプを選択',
    tr: 'Türü seçin',
    ko: '유형 선택',
    vi: 'Chọn loại',
    id: 'Pilih jenis',
    th: 'เลือกประเภท',
    ms: 'Pilih jenis',
    ar_eg: 'حدد النوع',
    uk: 'Виберіть тип',
  },
  amount: {
    en: 'Amount',
    es: 'Cantidad',
    fr: 'Montant',
    de: 'Betrag',
    pt: 'Quantia',
    pl: 'Kwota',
    nl: 'Bedrag',
    el: 'Ποσό',
    cs: 'Částka',
    sv: 'Belopp',
    hu: 'Összeg',
    da: 'Beløb',
    fi: 'Määrä',
    sk: 'Suma',
    bg: 'Сума',
    hr: 'Iznos',
    lt: 'Suma',
    lv: 'Summa',
    et: 'Summa',
    sl: 'Znesek',
    ga: 'Méid',
    mt: 'Ammont',
    cy: 'Swm',
    ro: 'Sumă',
    it: 'Importo',
    zh_cn: '金额',
    hi: 'राशि',
    ar: 'المبلغ',
    bn: 'পরিমাণ',
    ru: 'Сумма',
    ja: '金額',
    tr: 'Tutar',
    ko: '금액',
    vi: 'Số tiền',
    id: 'Jumlah',
    th: 'จำนวนเงิน',
    ms: 'Jumlah',
    ar_eg: 'المبلغ',
    uk: 'Сума',
  },
  quantity: {
    en: 'Quantity',
    es: 'Cantidad',
    fr: 'Quantité',
    de: 'Menge',
    pt: 'Quantidade',
    pl: 'Ilość',
    nl: 'Hoeveelheid',
    el: 'Ποσότητα',
    cs: 'Množství',
    sv: 'Kvantitet',
    hu: 'Mennyiség',
    da: 'Mængde',
    fi: 'Määrä',
    sk: 'Množstvo',
    bg: 'Количество',
    hr: 'Količina',
    lt: 'Kiekis',
    lv: 'Daudzums',
    et: 'Kogus',
    sl: 'Količina',
    ga: 'Cainníocht',
    mt: 'Kwantità',
    cy: 'Nifer',
    ro: 'Cantitate',
    it: 'Quantità',
    zh_cn: '数量',
    hi: 'मात्रा',
    ar: 'كمية',
    bn: 'পরিমাণ',
    ru: 'Количество',
    ja: '量',
    tr: 'Miktar',
    ko: '수량',
    vi: 'Số Lượng',
    id: 'Kuantitas',
    th: 'ปริมาณ',
    ms: 'Kuantiti',
    ar_eg: 'كمية',
    uk: 'Кількість',
  },
  inventory_unit: {
    en: 'Inventory Unit',
    es: 'Unidad de Inventario',
    fr: "Unité d'Inventaire",
    de: 'Bestandseinheit',
    pt: 'Unidade de Inventário',
    pl: 'Jednostka Magazynowa',
    nl: 'Inventaris Eenheid',
    el: 'Μονάδα Αποθέματος',
    cs: 'Inventární Jednotka',
    sv: 'Lagerenhet',
    hu: 'Készletegység',
    da: 'Lagerenhed',
    fi: 'Varastoyksikkö',
    sk: 'Inventúrna Jednotka',
    bg: 'Инвентарна Единица',
    hr: 'Inventarna Jedinica',
    lt: 'Inventoriaus Vienetas',
    lv: 'Inventāra Vienība',
    et: 'Varu Ühik',
    sl: 'Inventarna Enota',
    ga: 'Aonad Fardail',
    mt: "Unità ta' Inventarju",
    cy: 'Uned Stocrestr',
    ro: 'Unitate de Inventar',
    it: 'Unità di Inventario',
    zh_cn: '库存单位',
    hi: 'सूची इकाई',
    ar: 'وحدة المخزون',
    bn: 'ইনভেন্টরি ইউনিট',
    ru: 'Единица Учета',
    ja: '在庫単位',
    tr: 'Envanter Birimi',
    ko: '재고 단위',
    vi: 'Đơn Vị Hàng Tồn Kho',
    id: 'Unit Inventaris',
    th: 'หน่วยสินค้าคงคลัง',
    ms: 'Unit Inventori',
    ar_eg: 'وحدة المخزون',
    uk: 'Одиниця Інвентаризації',
  },
  sales_type: {
    en: 'Sales Type',
    es: 'Tipo de Venta',
    fr: 'Type de Vente',
    de: 'Verkaufstyp',
    pt: 'Tipo de Venda',
    pl: 'Typ Sprzedaży',
    nl: 'Verkooptype',
    el: 'Τύπος Πωλήσεων',
    cs: 'Typ Prodeje',
    sv: 'Försäljningstyp',
    hu: 'Értékesítés Típusa',
    da: 'Salgstype',
    fi: 'Myyntityyppi',
    sk: 'Typ Predaja',
    bg: 'Тип Продажба',
    hr: 'Tip Prodaje',
    lt: 'Pardavimo Tipas',
    lv: 'Pārdošanas Veids',
    et: 'Müügitüüp',
    sl: 'Vrsta Prodaje',
    ga: 'Cineál Díolacháin',
    mt: 'Tip ta’ Bejgħ',
    cy: 'Math o Werthiant',
    ro: 'Tip de Vânzare',
    it: 'Tipo di Vendita',
    zh_cn: '销售类型',
    hi: 'बिक्री का प्रकार',
    ar: 'نوع المبيعات',
    bn: 'বিক্রয়ের ধরন',
    ru: 'Тип Продажи',
    ja: '販売タイプ',
    tr: 'Satış Türü',
    ko: '판매 유형',
    vi: 'Loại Hình Bán Hàng',
    id: 'Tipe Penjualan',
    th: 'ประเภทการขาย',
    ms: 'Jenis Jualan',
    ar_eg: 'نوع المبيعات',
    uk: 'Тип Продажу',
  },
  default_price: {
    en: 'Default Price',
    es: 'Precio predeterminado',
    fr: 'Prix par défaut',
    de: 'Standardpreis',
    pt: 'Preço padrão',
    pl: 'Domyślna cena',
    nl: 'Standaardprijs',
    el: 'Προεπιλεγμένη τιμή',
    cs: 'Výchozí cena',
    sv: 'Standardpris',
    hu: 'Alapértelmezett ár',
    da: 'Standardpris',
    fi: 'Oletushinta',
    sk: 'Predvolená cena',
    bg: 'Основна цена',
    hr: 'Zadana cijena',
    lt: 'Numatytoji kaina',
    lv: 'Noklusējuma cena',
    et: 'Vaikehind',
    sl: 'Privzeta cena',
    ga: 'Praghas réamhshocraithe',
    mt: 'Prezz default',
    cy: 'Pris diofyn',
    ro: 'Preț implicit',
    it: 'Prezzo predefinito',
    zh_cn: '默认价格',
    hi: 'डिफ़ॉल्ट मूल्य',
    ar: 'السعر الافتراضي',
    bn: 'ডিফল্ট মূল্য',
    ru: 'Цена по умолчанию',
    ja: 'デフォルト価格',
    tr: 'Varsayılan Fiyat',
    ko: '기본 가격',
    vi: 'Giá mặc định',
    id: 'Harga default',
    th: 'ราคาปกติ',
    ms: 'Harga lalai',
    ar_eg: 'السعر الافتراضي',
    uk: 'Ціна за замовчуванням',
  },
  default_cost: {
    en: 'Default Cost',
    es: 'Costo predeterminado',
    fr: 'Coût par défaut',
    de: 'Standardkosten',
    pt: 'Custo padrão',
    pl: 'Domyślny koszt',
    nl: 'Standaardkosten',
    el: 'Προεπιλεγμένο κόστος',
    cs: 'Výchozí náklady',
    sv: 'Standardkostnad',
    hu: 'Alapértelmezett költség',
    da: 'Standardomkostning',
    fi: 'Oletuskustannus',
    sk: 'Predvolená cena',
    bg: 'Основна цена',
    hr: 'Zadani trošak',
    lt: 'Numatytoji kaina',
    lv: 'Noklusējuma izmaksas',
    et: 'Vaikimisi maksumus',
    sl: 'Privzeti stroški',
    ga: 'Costas réamhshocraithe',
    mt: 'Spiża default',
    cy: 'Cost diofyn',
    ro: 'Cost implicit',
    it: 'Costo predefinito',
    zh_cn: '默认成本',
    hi: 'डिफ़ॉल्ट लागत',
    ar: 'التكلفة الافتراضية',
    bn: 'ডিফল্ট খরচ',
    ru: 'Стоимость по умолчанию',
    ja: 'デフォルトコスト',
    tr: 'Varsayılan Maliyet',
    ko: '기본 비용',
    vi: 'Chi phí mặc định',
    id: 'Biaya default',
    th: 'ต้นทุนเริ่มต้น',
    ms: 'Kos lalai',
    ar_eg: 'التكلفة الافتراضية',
    uk: 'Вартість за замовчуванням',
  },
  maximum_discount_value: {
    en: 'Maximum Discount value',
    es: 'Valor máximo de descuento',
    fr: 'Valeur maximale de réduction',
    de: 'Maximaler Rabattwert',
    pt: 'Valor máximo de desconto',
    pl: 'Maksymalna wartość rabatu',
    nl: 'Maximale kortingswaarde',
    el: 'Μέγιστη αξία έκπτωσης',
    cs: 'Maximální hodnota slevy',
    sv: 'Maximalt rabattvärde',
    hu: 'Maximális kedvezmény értéke',
    da: 'Maksimal rabatværdi',
    fi: 'Suurin alennusarvo',
    sk: 'Maximálna hodnota zľavy',
    bg: 'Максимална стойност на отстъпката',
    hr: 'Maksimalna vrijednost popusta',
    lt: 'Maksimali nuolaidos vertė',
    lv: 'Maksimālā atlaides vērtība',
    et: 'Maksimaalne allahindluse väärtus',
    sl: 'Največja vrednost popusta',
    ga: 'Luach Uasmhéid Lascaine',
    mt: 'Valur massimu tal-iskont',
    cy: 'Gwerth mwyaf disgownt',
    ro: 'Valoarea maximă a reducerii',
    it: 'Valore massimo di sconto',
    zh_cn: '最大折扣价值',
    hi: 'अधिकतम छूट मूल्य',
    ar: 'قيمة الخصم القصوى',
    bn: 'সর্বাধিক ডিসকাউন্ট মান',
    ru: 'Максимальная сумма скидки',
    ja: '最大割引額',
    tr: 'Maksimum İndirim Değeri',
    ko: '최대 할인 가치',
    vi: 'Giá trị giảm giá tối đa',
    id: 'Nilai diskon maksimum',
    th: 'มูลค่าส่วนลดสูงสุด',
    ms: 'Nilai Diskaun Maksimum',
    ar_eg: 'قيمة الخصم القصوى',
    uk: 'Максимальна величина знижки',
  },
  default: {
    en: 'Default',
    es: 'Predeterminado',
    fr: 'Par défaut',
    de: 'Standard',
    pt: 'Padrão',
    pl: 'Domyślnie',
    nl: 'Standaard',
    el: 'Προεπιλογή',
    cs: 'Výchozí',
    sv: 'Standard',
    hu: 'Alapértelmezett',
    da: 'Standard',
    fi: 'Oletus',
    sk: 'Predvolený',
    bg: 'По подразбиране',
    hr: 'Zadano',
    lt: 'Numatytasis',
    lv: 'Noklusējums',
    et: 'Vaikimisi',
    sl: 'Privzeto',
    ga: 'Réamhshocrú',
    mt: 'Default',
    cy: 'Diofyn',
    ro: 'Implicit',
    it: 'Predefinito',
    zh_cn: '默认',
    hi: 'डिफ़ॉल्ट',
    ar: 'افتراضي',
    bn: 'ডিফল্ট',
    ru: 'По умолчанию',
    ja: 'デフォルト',
    tr: 'Varsayılan',
    ko: '기본',
    vi: 'Mặc định',
    id: 'Bawaan',
    th: 'ค่าเริ่มต้น',
    ms: 'Lalai',
    ar_eg: 'افتراضي',
    uk: 'Типовий',
  },
  modified: {
    en: 'Modified',
    es: 'Modificado',
    fr: 'Modifié',
    de: 'Geändert',
    pt: 'Modificado',
    pl: 'Zmodyfikowane',
    nl: 'Gewijzigd',
    el: 'Τροποποιημένο',
    cs: 'Upraveno',
    sv: 'Ändrad',
    hu: 'Módosított',
    da: 'Ændret',
    fi: 'Muokattu',
    sk: 'Upravený',
    bg: 'Променен',
    hr: 'Izmijenjeno',
    lt: 'Pakeistas',
    lv: 'Modificēts',
    et: 'Muudetud',
    sl: 'Spremenjeno',
    ga: 'Modhnaithe',
    mt: 'Modifikat',
    cy: "Wedi'i addasu",
    ro: 'Modificat',
    it: 'Modificato',
    zh_cn: '修改',
    hi: 'संशोधित',
    ar: 'معدل',
    bn: 'পরিবর্তিত',
    ru: 'Измененный',
    ja: '修正済み',
    tr: 'Değiştirilmiş',
    ko: '수정된',
    vi: 'Đã chỉnh sửa',
    id: 'Dimodifikasi',
    th: 'แก้ไข',
    ms: 'Diubah',
    ar_eg: 'معدل',
    uk: 'Змінений',
  },
  modifier_group_name: {
    en: 'Modifier Group Name',
    es: 'Nombre del grupo de modificadores',
    fr: 'Nom du groupe de modificateurs',
    de: 'Name der Modifikatorgruppe',
    pt: 'Nome do grupo de modificadores',
    pl: 'Nazwa grupy modyfikatorów',
    nl: 'Naam van de modificatiegroep',
    el: 'Όνομα ομάδας τροποποιητών',
    cs: 'Název skupiny modifikátorů',
    sv: 'Namn på modifierargrupp',
    hu: 'Modifikátorcsoport neve',
    da: 'Navn på modifikatorgruppe',
    fi: 'Muokkausryhmän nimi',
    sk: 'Názov skupiny modifikátorov',
    bg: 'Име на групата модификатори',
    hr: 'Naziv grupe modifikatora',
    lt: 'Modifikatorių grupės pavadinimas',
    lv: 'Modifikatoru grupas nosaukums',
    et: 'Modifikaatorite grupi nimi',
    sl: 'Ime skupine modifikatorjev',
    ga: 'Ainm Ghrúpa Modhnóirí',
    mt: 'Isem tal-Grupp tal-Modifikaturi',
    cy: 'Enw’r Grŵp Modiwlau',
    ro: 'Numele grupului de modificatori',
    it: 'Nome del gruppo di modificatori',
    zh_cn: '修饰符组名称',
    hi: 'मॉडिफायर समूह का नाम',
    ar: 'اسم مجموعة المعدلات',
    bn: 'মডিফায়ার গ্রুপের নাম',
    ru: 'Название группы модификаторов',
    ja: '修飾子グループ名',
    tr: 'Düzenleyici Grup Adı',
    ko: '수정자 그룹 이름',
    vi: 'Tên nhóm điều chỉnh',
    id: 'Nama Grup Pengubah',
    th: 'ชื่อกลุ่มตัวแก้ไข',
    ms: 'Nama Kumpulan Pengubah',
    ar_eg: 'اسم مجموعة المعدلات',
    uk: 'Назва групи модифікаторів',
  },
  connect_modifier_groups: {
    en: 'Connect Modifier Groups',
    es: 'Conectar grupos de modificadores',
    fr: 'Connecter des groupes de modificateurs',
    de: 'Modifikatorgruppen verbinden',
    pt: 'Conectar grupos de modificadores',
    pl: 'Połącz grupy modyfikatorów',
    nl: 'Koppel wijzigingsgroepen',
    el: 'Σύνδεση ομάδων τροποποιητών',
    cs: 'Propojit skupiny modifikátorů',
    sv: 'Anslut modifieringsgrupper',
    hu: 'Modifikátor csoportok összekapcsolása',
    da: 'Forbind modifikatorgrupper',
    fi: 'Yhdistä muokkausryhmät',
    sk: 'Prepojiť skupiny modifikátorov',
    bg: 'Свързване на групи модификатори',
    hr: 'Poveži grupe modifikatora',
    lt: 'Sujungti modifikatorių grupes',
    lv: 'Savienot modifikatoru grupas',
    et: 'Ühenda modifikaatorite grupid',
    sl: 'Poveži skupine modifikatorjev',
    ga: 'Nasc grúpaí modhnóirí',
    mt: 'Għaqqad gruppi ta’ modifikaturi',
    cy: 'Cysylltu Grwpiau Modifwr',
    ro: 'Conectează grupurile de modificatori',
    it: 'Collegare i gruppi di modificatori',
    zh_cn: '连接修改器组',
    hi: 'मोडिफायर समूहों को जोड़ें',
    ar: 'ربط مجموعات المعدّلات',
    bn: 'মডিফায়ার গ্রুপ সংযুক্ত করুন',
    ru: 'Соединить группы модификаторов',
    ja: '修正グループを接続する',
    tr: 'Modifikatör Gruplarını Bağla',
    ko: '수정자 그룹 연결',
    vi: 'Kết nối nhóm bộ điều chỉnh',
    id: 'Hubungkan Grup Modifier',
    th: 'เชื่อมต่อกลุ่มตัวปรับแต่ง',
    ms: 'Sambungkan Kumpulan Pengubah',
    ar_eg: 'ربط مجموعات المعدّلات',
    uk: 'Підключити групи модифікаторів',
  },
  select_modifier_group: {
    en: 'Select Modifier Groups',
    es: 'Seleccionar grupos de modificadores',
    fr: 'Sélectionner les groupes de modificateurs',
    de: 'Modifikatorgruppen auswählen',
    pt: 'Selecionar grupos de modificadores',
    pl: 'Wybierz grupy modyfikatorów',
    nl: 'Selecteer modificatiegroepen',
    el: 'Επιλέξτε ομάδες τροποποιητών',
    cs: 'Vyberte skupiny modifikátorů',
    sv: 'Välj modifikatorgrupper',
    hu: 'Módosító csoportok kiválasztása',
    da: 'Vælg modifikatorgrupper',
    fi: 'Valitse muokkausryhmät',
    sk: 'Vybrať skupiny modifikátorov',
    bg: 'Изберете групи модификатори',
    hr: 'Odaberite grupe modifikatora',
    lt: 'Pasirinkite modifikatorių grupes',
    lv: 'Izvēlieties modifikatoru grupas',
    et: 'Valige modifikaatorite grupid',
    sl: 'Izberite skupine modifikatorjev',
    ga: 'Roghnaigh Grúpaí Modhnóirí',
    mt: "Agħżel Gruppi ta' Modifikaturi",
    cy: 'Dewiswch Grwpiau Modiwlau',
    ro: 'Selectați grupurile de modificatori',
    it: 'Seleziona gruppi di modificatori',
    zh_cn: '选择修饰符组',
    hi: 'मॉडिफायर समूह चुनें',
    ar: 'اختر مجموعات المعدلات',
    bn: 'মডিফায়ার গ্রুপ নির্বাচন করুন',
    ru: 'Выберите группы модификаторов',
    ja: '修飾子グループを選択',
    tr: 'Düzenleyici Grupları Seçin',
    ko: '수정 그룹 선택',
    vi: 'Chọn nhóm điều chỉnh',
    id: 'Pilih Grup Pengubah',
    th: 'เลือกกลุ่มตัวปรับแต่ง',
    ms: 'Pilih Kumpulan Pengubah',
    ar_eg: 'اختار مجموعات المعدلات',
    uk: 'Виберіть групи модифікаторів',
  },
  modifier_no_data: {
    title: {
      en: 'No modifier has been created!',
      es: '¡No se ha creado ningún modificador!',
      fr: "Aucun modificateur n'a été créé !",
      de: 'Es wurde kein Modifikator erstellt!',
      pt: 'Nenhum modificador foi criado!',
      pl: 'Nie utworzono żadnego modyfikatora!',
      nl: 'Er is geen modificator aangemaakt!',
      el: 'Δεν έχει δημιουργηθεί τροποποιητής!',
      cs: 'Nebyl vytvořen žádný modifikátor!',
      sv: 'Ingen modifikator har skapats!',
      hu: 'Nem jött létre módosító!',
      da: 'Ingen modifikator er blevet oprettet!',
      fi: 'Yhtään modifioijaa ei ole luotu!',
      sk: 'Nebola vytvorená žiadna modifikácia!',
      bg: 'Не е създаден модификатор!',
      hr: 'Nije stvoren nijedan modifikator!',
      lt: 'Nepavyko sukurti jokio modifikatoriaus!',
      lv: 'Neviens modifikators nav izveidots!',
      et: 'Ühtegi modifikaatorit pole loodud!',
      sl: 'Nobenega modifikatorja ni bilo ustvarjenega!',
      ga: 'Níor cruthaíodh aon mhodhnóir!',
      mt: 'Maħluq l-ebda modifikatur!',
      cy: 'Nid yw unrhyw addasydd wedi cael ei greu!',
      ro: 'Nu a fost creat niciun modificator!',
      it: 'Non è stato creato nessun modificatore!',
      zh_cn: '没有创建任何修饰符！',
      hi: 'कोई संशोधक नहीं बनाया गया है!',
      ar: 'لم يتم إنشاء أي معدل!',
      bn: 'কোনও মডিফায়ার তৈরি করা হয়নি!',
      ru: 'Ни один модификатор не был создан!',
      ja: '修飾子が作成されていません！',
      tr: 'Hiçbir değiştirici oluşturulmadı!',
      ko: '수정자가 생성되지 않았습니다!',
      vi: 'Chưa tạo bộ điều chỉnh nào!',
      id: 'Tidak ada modifikator yang dibuat!',
      th: 'ไม่มีการสร้างตัวปรับแต่ง!',
      ms: 'Tiada pengubah yang telah dicipta!',
      ar_eg: 'لم يتم إنشاء أي معدل!',
      uk: 'Жоден модифікатор не був створений!',
    },
    description: {
      en: 'To connect modifiers to this item, go to <strong>‘Modifier page > Create New Modifier’</strong> and create a new modifier group!',
      es: 'Para conectar modificadores a este artículo, vaya a <strong>‘Página de modificadores > Crear nuevo modificador’</strong> y cree un nuevo grupo de modificadores.',
      fr: 'Pour connecter des modificateurs à cet article, allez à <strong>‘Page des modificateurs > Créer un nouveau modificateur’</strong> et créez un nouveau groupe de modificateurs.',
      de: 'Um Modifikatoren mit diesem Artikel zu verbinden, gehen Sie zu <strong>‘Modifikatorseite > Neuen Modifikator erstellen’</strong> und erstellen Sie eine neue Modifikatorgruppe.',
      pt: 'Para conectar modificadores a este item, vá para <strong>‘Página de modificadores > Criar novo modificador’</strong> e crie um novo grupo de modificadores.',
      pl: 'Aby połączyć modyfikatory z tym przedmiotem, przejdź do <strong>‘Strona modyfikatora > Utwórz nowy modyfikator’</strong> i utwórz nową grupę modyfikatorów.',
      nl: 'Om modifiers aan dit item te koppelen, ga naar <strong>‘Modificatorpagina > Nieuwe Modificator maken’</strong> en maak een nieuwe modificatorgroep.',
      el: 'Για να συνδέσετε τροποποιητές σε αυτό το αντικείμενο, μεταβείτε στη <strong>‘Σελίδα τροποποιητή > Δημιουργία νέου τροποποιητή’</strong> και δημιουργήστε μια νέα ομάδα τροποποιητών.',
      cs: 'Chcete-li připojit modifikátory k této položce, přejděte na <strong>‘Stránka modifikátoru > Vytvořit nový modifikátor’</strong> a vytvořte novou skupinu modifikátorů.',
      sv: 'För att ansluta modifierare till det här objektet, gå till <strong>‘Modifieringssida > Skapa ny modifierare’</strong> och skapa en ny modifierargrupp.',
      hu: 'A módosítók elemhez való csatlakoztatásához menjen a <strong>‘Módosító oldal > Új módosító létrehozása’</strong> oldalra, és hozzon létre egy új módosító csoportot!',
      da: 'For at tilslutte modifikatorer til dette element, gå til <strong>‘Modifikatorside > Opret ny modifikator’</strong> og opret en ny modifikatorgruppe.',
      fi: 'Yhdistääksesi muokkaajat tähän kohteeseen, siirry <strong>‘Muokkaajasivu > Luo uusi muokkaaja’</strong> ja luo uusi muokkaajaryhmä.',
      sk: 'Ak chcete pripojiť modifikátory k tejto položke, prejdite na <strong>‘Stránka modifikátora > Vytvoriť nový modifikátor’</strong> a vytvorte novú skupinu modifikátorov.',
      bg: 'За да свържете модификатори с този елемент, отидете на <strong>‘Страница на модификатора > Създаване на нов модификатор’</strong> и създайте нова група модификатори.',
      hr: 'Da biste povezali modifikatore s ovom stavkom, idite na <strong>‘Stranica modifikatora > Kreiraj novi modifikator’</strong> i kreirajte novu grupu modifikatora.',
      lt: 'Norėdami prijungti modifikatorius prie šio elemento, eikite į <strong>‘Modifikatoriaus puslapis > Sukurti naują modifikatorių’</strong> ir sukurkite naują modifikatorių grupę.',
      lv: 'Lai savienotu modifikatorus ar šo vienību, dodieties uz <strong>‘Modifikatora lapa > Izveidot jaunu modifikatoru’</strong> un izveidojiet jaunu modifikatoru grupu.',
      et: 'Modifikaatorite ühendamiseks selle üksusega minge <strong>‘Modifikaatori leht > Loo uus modifikaator’</strong> ja looge uus modifikaatorite grupp.',
      sl: 'Če želite povezati modifikatorje s tem elementom, pojdite na <strong>‘Stran modifikatorja > Ustvari nov modifikator’</strong> in ustvarite novo skupino modifikatorjev.',
      ga: 'Chun na modhnóirí a nascadh leis an mír seo, téigh go <strong>‘Leathanach Modhnóra > Cruthaigh Modhnóir Nua’</strong> agus cruthaigh grúpa modhnóirí nua!',
      mt: "Biex tgħaqqad il-modifikaturi ma' dan l-oġġett, mur fuq <strong>‘Paġna tal-Modifikatur > Oħloq Modifikatur Ġdid’</strong> u oħloq grupp ta' modifikaturi ġdid!",
      cy: "I gysylltu addaswyr â'r eitem hon, ewch i <strong>‘Tudalen Addasydd > Creu Addasydd Newydd’</strong> a chreu grŵp addasydd newydd!",
      ro: 'Pentru a conecta modificatori la acest articol, accesați <strong>‘Pagina de modificatori > Creați un nou modificator’</strong> și creați un nou grup de modificatori!',
      it: 'Per collegare i modificatori a questo elemento, vai a <strong>‘Pagina dei modicatori > Crea nuovo modificatore’</strong> e crea un nuovo gruppo di modificatori!',
      zh_cn: '要将修饰符连接到此项目，请转到<strong>‘修饰符页面 > 创建新修饰符’</strong>并创建一个新的修饰符组！',
      hi: 'संशोधक को इस आइटम से जोड़ने के लिए, <strong>‘संशोधक पृष्ठ > नया संशोधक बनाएँ’</strong> पर जाएं और एक नया संशोधक समूह बनाएं!',
      ar: 'لربط المُعدلات بهذا العنصر، انتقل إلى <strong>‘صفحة المُعدل > إنشاء مُعدل جديد’</strong> وأنشئ مجموعة مُعدلات جديدة!',
      bn: 'এই আইটেমের সাথে মডিফায়ার সংযোগ করতে, <strong>‘মডিফায়ার পৃষ্ঠা > নতুন মডিফায়ার তৈরি করুন’</strong> এ যান এবং একটি নতুন মডিফায়ার গ্রুপ তৈরি করুন!',
      ru: 'Чтобы подключить модификаторы к этому элементу, перейдите на <strong>‘Страница модификаторов > Создать новый модификатор’</strong> и создайте новую группу модификаторов!',
      ja: 'このアイテムに修飾子を接続するには、<strong>‘修飾子ページ > 新しい修飾子を作成’</strong>に移動して、新しい修飾子グループを作成してください！',
      tr: 'Bu öğeye değiştiricileri bağlamak için <strong>‘Değiştirici sayfası > Yeni Değiştirici Oluştur’</strong> sayfasına gidin ve yeni bir değiştirici grubu oluşturun!',
      ko: '이 항목에 수정자를 연결하려면 <strong>‘수정자 페이지 > 새 수정자 만들기’</strong>로 이동하여 새 수정자 그룹을 만드세요!',
      vi: 'Để kết nối các trình điều chỉnh với mục này, hãy chuyển đến <strong>‘Trang điều chỉnh > Tạo Trình điều chỉnh Mới’</strong> và tạo một nhóm trình điều chỉnh mới!',
      id: 'Untuk menghubungkan pengubah ke item ini, buka <strong>‘halaman Pengubah > Buat Pengubah Baru’</strong> dan buat grup pengubah baru!',
      th: 'หากต้องการเชื่อมต่อการดัดแปลงกับรายการนี้ ให้ไปที่ <strong>‘หน้าตัวปรับแต่ง > สร้างตัวปรับแต่งใหม่’</strong> และสร้างกลุ่มตัวปรับแต่งใหม่!',
      ms: 'Untuk menyambungkan pengubah kepada item ini, pergi ke <strong>‘halaman Pengubah > Buat Pengubah Baru’</strong> dan buat kumpulan pengubah baru!',
      ar_eg:
        'لربط المُعدلات بهذا العنصر، انتقل إلى <strong>‘صفحة المُعدل > إنشاء مُعدل جديد’</strong> وأنشئ مجموعة مُعدلات جديدة!',
      uk: 'Щоб підключити модифікатори до цього елемента, перейдіть на <strong>‘Сторінка модифікатора > Створити новий модифікатор’</strong> і створіть нову групу модифікаторів!',
    },
    search: {
      en: 'Search',
      es: 'Buscar',
      fr: 'Rechercher',
      de: 'Suchen',
      pt: 'Pesquisar',
      pl: 'Szukaj',
      nl: 'Zoeken',
      el: 'Αναζήτηση',
      cs: 'Hledat',
      sv: 'Sök',
      hu: 'Keresés',
      da: 'Søg',
      fi: 'Hae',
      sk: 'Hľadať',
      bg: 'Търсене',
      hr: 'Traži',
      lt: 'Ieškoti',
      lv: 'Meklēt',
      et: 'Otsing',
      sl: 'Išči',
      ga: 'Cuardach',
      mt: 'Fittex',
      cy: 'Chwilio',
      ro: 'Căutare',
      it: 'Cerca',
      zh_cn: '搜索',
      hi: 'खोज',
      ar: 'بحث',
      bn: 'অনুসন্ধান',
      ru: 'Поиск',
      ja: '検索',
      tr: 'Arama',
      ko: '검색',
      vi: 'Tìm kiếm',
      id: 'Cari',
      th: 'ค้นหา',
      ms: 'Cari',
      ar_eg: 'بحث',
      uk: 'Пошук',
    },
  },
  tax_no_data: {
    title: {
      en: 'No tax has been added to your system!',
      es: '¡No se ha añadido ningún impuesto a tu sistema!',
      fr: "Aucune taxe n'a été ajoutée à votre système!",
      de: 'Es wurde keine Steuer zu Ihrem System hinzugefügt!',
      pt: 'Nenhum imposto foi adicionado ao seu sistema!',
      pl: 'Żaden podatek nie został dodany do twojego systemu!',
      nl: 'Er is geen belasting aan uw systeem toegevoegd!',
      el: 'Δεν έχει προστεθεί κανένας φόρος στο σύστημά σας!',
      cs: 'Do vašeho systému nebyla přidána žádná daň!',
      sv: 'Ingen skatt har lagts till i ditt system!',
      hu: 'A rendszeréhez nem adtak hozzá adót!',
      da: 'Ingen skat er blevet tilføjet til dit system!',
      fi: 'Järjestelmääsi ei ole lisätty veroa!',
      sk: 'Do vášho systému nebola pridaná žiadna daň!',
      bg: 'Няма добавени данъци в системата ви!',
      hr: 'Nijedan porez nije dodan u vaš sustav!',
      lt: 'Jūsų sistemoje nepridėtas joks mokestis!',
      lv: 'Jūsu sistēmai nav pievienots neviens nodoklis!',
      et: 'Teie süsteemile ei ole lisatud ühtegi maksu!',
      sl: 'V vaš sistem ni bila dodana nobena davka!',
      ga: 'Níor cuireadh aon cháin le do chóras!',
      mt: 'Ebda taxxa ma ġiet miżjuda mas-sistema tiegħek!',
      cy: 'Nid yw treth wedi cael ei hychwanegu at eich system!',
      ro: 'Nu a fost adăugat niciun impozit în sistemul tău!',
      it: 'Nessuna tassa è stata aggiunta al tuo sistema!',
      zh_cn: '您的系统尚未添加税!',
      hi: 'आपकी प्रणाली में कोई कर नहीं जोड़ा गया है!',
      ar: 'لم تتم إضافة أي ضرائب إلى نظامك!',
      bn: 'আপনার সিস্টেমে কোনো কর যোগ করা হয়নি!',
      ru: 'В вашу систему не добавлен налог!',
      ja: 'システムに税金が追加されていません!',
      tr: 'Sisteminizde vergi eklenmedi!',
      ko: '시스템에 세금이 추가되지 않았습니다!',
      vi: 'Không có thuế nào được thêm vào hệ thống của bạn!',
      id: 'Tidak ada pajak yang ditambahkan ke sistem Anda!',
      th: 'ไม่มีการเพิ่มภาษีในระบบของคุณ!',
      ms: 'Tiada cukai telah ditambah ke sistem anda!',
      ar_eg: 'لم تتم إضافة أي ضرائب إلى نظامك!',
      uk: 'Жодного податку не було додано до вашої системи!',
    },
    description: {
      en: "To accurately calculate sales tax, you'll need to add a tax rate. To create or edit tax go to <strong>Setting > Accounting Setting > Sales Tax</strong>.",
      es: 'Para calcular con precisión el impuesto sobre las ventas, necesitarás agregar una tasa de impuesto. Para crear o editar impuestos, ve a <strong>Configuración > Configuración de contabilidad > Impuesto sobre las ventas</strong>.',
      fr: 'Pour calculer précisément la taxe de vente, vous devez ajouter un taux de taxe. Pour créer ou modifier une taxe, allez à <strong>Paramètre > Paramètre de comptabilité > Taxe de vente</strong>.',
      de: 'Um die Umsatzsteuer genau zu berechnen, müssen Sie einen Steuersatz hinzufügen. Um Steuern zu erstellen oder zu bearbeiten, gehen Sie zu <strong>Einstellung > Buchhaltungseinstellung > Umsatzsteuer</strong>.',
      pt: 'Para calcular com precisão o imposto sobre vendas, você precisará adicionar uma taxa de imposto. Para criar ou editar impostos, vá para <strong>Configuração > Configuração de contabilidade > Imposto sobre vendas</strong>.',
      pl: 'Aby dokładnie obliczyć podatek od sprzedaży, musisz dodać stawkę podatku. Aby utworzyć lub edytować podatek, przejdź do <strong>Ustawienie > Ustawienie księgowe > Podatek od sprzedaży</strong>.',
      nl: 'Om de verkoopbelasting nauwkeurig te berekenen, moet u een belastingtarief toevoegen. Om belasting te creëren of te bewerken, gaat u naar <strong>Instelling > Boekhoudinstelling > Verkoopbelasting</strong>.',
      el: 'Για να υπολογίσετε με ακρίβεια τον φόρο πωλήσεων, θα πρέπει να προσθέσετε έναν φορολογικό συντελεστή. Για να δημιουργήσετε ή να επεξεργαστείτε φόρο, μεταβείτε στο <strong>Ρύθμιση > Ρύθμιση Λογιστικής > Φόρος Πωλήσεων</strong>.',
      cs: 'Chcete-li přesně vypočítat daň z prodeje, budete muset přidat daňovou sazbu. Chcete-li vytvořit nebo upravit daň, přejděte na <strong>Nastavení > Nastavení účetnictví > Daň z prodeje</strong>.',
      sv: 'För att noggrant beräkna försäljningsskatt måste du lägga till en skattesats. För att skapa eller redigera skatt, gå till <strong>Inställning > Redovisningsinställning > Försäljningsskatt</strong>.',
      hu: 'Az értékesítési adó pontos kiszámításához adókulcsot kell hozzáadnia. Adó létrehozásához vagy szerkesztéséhez lépjen a <strong>Beállítás > Számviteli beállítás > Értékesítési adó</strong> menüpontra.',
      da: 'For nøjagtigt at beregne moms skal du tilføje en skattesats. For at oprette eller redigere skat, gå til <strong>Indstilling > Regnskabsindstilling > Moms</strong>.',
      fi: 'Myyntiveron tarkkaan laskemiseen sinun täytyy lisätä verokanta. Luo tai muokkaa veroa siirtymällä kohtaan <strong>Asetus > Kirjanpitoasetus > Myyntivero</strong>.',
      sk: 'Na presný výpočet dane z predaja musíte pridať daňovú sadzbu. Ak chcete vytvoriť alebo upraviť daň, prejdite na <strong>Nastavenie > Nastavenie účtovníctva > Daň z predaja</strong>.',
      bg: 'За да изчислите точно данъка върху продажбите, ще трябва да добавите данъчна ставка. За да създадете или редактирате данък, отидете на <strong>Настройка > Настройка на счетоводството > Данък върху продажбите</strong>.',
      hr: 'Da biste točno izračunali porez na prodaju, trebate dodati poreznu stopu. Za kreiranje ili uređivanje poreza idite na <strong>Postavke > Postavke računovodstva > Porez na prodaju</strong>.',
      lt: 'Norėdami tiksliai apskaičiuoti pardavimo mokestį, turėsite pridėti mokesčio tarifą. Norėdami sukurti ar redaguoti mokestį, eikite į <strong>Nustatymas > Apskaitos nustatymas > Pardavimo mokestis</strong>.',
      lv: 'Lai precīzi aprēķinātu pārdošanas nodokli, jums būs jāpievieno nodokļa likme. Lai izveidotu vai rediģētu nodokli, dodieties uz <strong>Iestatījumi > Grāmatvedības iestatījumi > Pārdošanas nodoklis</strong>.',
      et: 'Müügi maksu täpseks arvutamiseks peate lisama maksumäära. Maksu loomiseks või muutmiseks minge <strong>Seade > Raamatupidamise seaded > Müügimaks</strong>.',
      sl: 'Če želite natančno izračunati davek na prodajo, morate dodati davčno stopnjo. Če želite ustvariti ali urediti davek, pojdite na <strong>Nastavitve > Nastavitev računovodstva > Davek na prodajo</strong>.',
      ga: 'Chun cáin díolacháin a ríomh go cruinn, beidh ort ráta cánach a chur leis. Chun cáin a chruthú nó a chur in eagar téigh go <strong>Socruithe > Socrúchán Cuntasaíochta > Cáin Díolacháin</strong>.',
      mt: "Biex tikkalkula b'mod preċiż it-taxxa fuq il-bejgħ, ikollok bżonn iżżid rata ta' taxxa. Biex toħloq jew teditja taxxa mur fuq <strong>Setting > Accounting Setting > Sales Tax</strong>.",
      cy: "I gyfrifo treth gwerthu'n gywir, bydd angen i chi ychwanegu cyfradd dreth. I greu neu olygu treth ewch i <strong>Setting > Accounting Setting > Sales Tax</strong>.",
      ro: 'Pentru a calcula cu exactitate taxa pe vânzări, va trebui să adăugați o rată a taxei. Pentru a crea sau edita taxa, accesați <strong>Setare > Setare contabilitate > Taxă pe vânzări</strong>.',
      it: "Per calcolare con precisione l'imposta sulle vendite, è necessario aggiungere un'aliquota fiscale. Per creare o modificare l'imposta, vai su <strong>Impostazioni > Impostazioni contabili > Imposta sulle vendite</strong>.",
      zh_cn:
        '为了准确计算销售税，您需要添加税率。 要创建或编辑税金，请转到 <strong>设置 > 会计设置 > 销售税</strong>。',
      hi: 'बिक्री कर को सही ढंग से गणना करने के लिए, आपको एक कर दर जोड़नी होगी। कर बनाने या संपादित करने के लिए <strong>सेटिंग > लेखा सेटिंग > बिक्री कर</strong> पर जाएं।',
      ar: 'لحساب ضريبة المبيعات بدقة، ستحتاج إلى إضافة معدل ضريبي. لإنشاء أو تعديل الضريبة، انتقل إلى <strong>الإعداد > إعدادات المحاسبة > ضريبة المبيعات</strong>.',
      bn: 'বিক্রয় কর সঠিকভাবে গণনা করতে, আপনাকে একটি করের হার যোগ করতে হবে। কর তৈরি বা সম্পাদনা করতে <strong>সেটিং > অ্যাকাউন্টিং সেটিং > বিক্রয় কর</strong> এ যান।',
      ru: 'Чтобы точно рассчитать налог с продаж, вам нужно добавить налоговую ставку. Чтобы создать или изменить налог, перейдите в <strong>Настройка > Настройка бухгалтерии > Налог с продаж</strong>.',
      ja: '売上税を正確に計算するには、税率を追加する必要があります。税を作成または編集するには、<strong>設定 > 会計設定 > 売上税</strong>に移動します。',
      tr: 'Satış vergisini doğru hesaplamak için bir vergi oranı eklemeniz gerekecek. Vergi oluşturmak veya düzenlemek için <strong>Ayar > Muhasebe Ayarı > Satış Vergisi</strong> bölümüne gidin.',
      ko: '판매세를 정확하게 계산하려면 세율을 추가해야 합니다. 세금을 생성하거나 수정하려면 <strong>설정 > 회계 설정 > 판매세</strong>로 이동하세요.',
      vi: 'Để tính chính xác thuế bán hàng, bạn sẽ cần thêm thuế suất. Để tạo hoặc chỉnh sửa thuế, hãy chuyển đến <strong>Cài đặt > Cài đặt kế toán > Thuế bán hàng</strong>.',
      id: 'Untuk menghitung pajak penjualan secara akurat, Anda perlu menambahkan tarif pajak. Untuk membuat atau mengedit pajak, buka <strong>Pengaturan > Pengaturan Akuntansi > Pajak Penjualan</strong>.',
      th: 'หากต้องการคำนวณภาษีการขายอย่างถูกต้อง คุณจะต้องเพิ่มอัตราภาษี หากต้องการสร้างหรือแก้ไขภาษี ให้ไปที่ <strong>การตั้งค่า > การตั้งค่าการบัญชี > ภาษีการขาย</strong>',
      ms: 'Untuk mengira cukai jualan dengan tepat, anda perlu menambah kadar cukai. Untuk mencipta atau mengedit cukai pergi ke <strong>Tetapan > Tetapan Perakaunan > Cukai Jualan</strong>.',
      ar_eg:
        'لحساب ضريبة المبيعات بدقة، ستحتاج إلى إضافة معدل ضريبي. لإنشاء أو تعديل الضريبة، انتقل إلى <strong>الإعداد > إعدادات المحاسبة > ضريبة المبيعات</strong>.',
      uk: 'Щоб точно розрахувати податок з продажів, вам потрібно додати ставку податку. Щоб створити або відредагувати податок, перейдіть у <strong>Налаштування > Налаштування бухгалтерії > Податок з продажів</strong>.',
    },
  },
  qty: {
    en: 'QTY',
    es: 'CANT',
    fr: 'QTÉ',
    de: 'MENGE',
    pt: 'QTD',
    pl: 'ILOŚĆ',
    nl: 'AANTAL',
    el: 'ΠΟΣΟΤΗΤΑ',
    cs: 'MNOŽSTVÍ',
    sv: 'ANTAL',
    hu: 'MÉNY',
    da: 'ANTAL',
    fi: 'MÄÄRÄ',
    sk: 'MNOŽSTVO',
    bg: 'КОЛ',
    hr: 'KOL',
    lt: 'KIEKIS',
    lv: 'DAUDZUMS',
    et: 'KOGUS',
    sl: 'KOL',
    ga: 'CANT',
    mt: 'KWANTITÀ',
    cy: 'MAINT',
    ro: 'CANT',
    it: 'QTÀ',
    zh_cn: '数量',
    hi: 'मात्रा',
    ar: 'الكمية',
    bn: 'পরিমাণ',
    ru: 'КОЛ-ВО',
    ja: '数量',
    tr: 'MİKTAR',
    ko: '수량',
    vi: 'SỐ LƯỢNG',
    id: 'JML',
    th: 'จำนวน',
    ms: 'KUANTITI',
    ar_eg: 'كمية',
    uk: 'КІЛЬКІСТЬ',
  },
  sales_unit: {
    en: 'Sales Unit',
    es: 'Unidad de Venta',
    fr: 'Unité de Vente',
    de: 'Verkaufseinheit',
    pt: 'Unidade de Venda',
    pl: 'Jednostka Sprzedaży',
    nl: 'Verkoopeenheid',
    el: 'Μονάδα Πώλησης',
    cs: 'Prodejní Jednotka',
    sv: 'Försäljningsenhet',
    hu: 'Értékesítési Egység',
    da: 'Salgs Enhed',
    fi: 'Myyntiyksikkö',
    sk: 'Predajná Jednotka',
    bg: 'Продажна Единица',
    hr: 'Prodajna Jedinica',
    lt: 'Pardavimo Vienetas',
    lv: 'Pārdošanas Vienība',
    et: 'Müügiyksus',
    sl: 'Prodajna Enota',
    ga: 'Aonad Díolacháin',
    mt: 'Unità tal-Bejgħ',
    cy: 'Uned Werthu',
    ro: 'Unitate de Vânzare',
    it: 'Unità di Vendita',
    zh_cn: '销售单位',
    hi: 'बिक्री इकाई',
    ar: 'وحدة البيع',
    bn: 'বিক্রয় ইউনিট',
    ru: 'Единица Продажи',
    ja: '販売単位',
    tr: 'Satış Birimi',
    ko: '판매 단위',
    vi: 'Đơn vị Bán hàng',
    id: 'Unit Penjualan',
    th: 'หน่วยขาย',
    ms: 'Unit Jualan',
    ar_eg: 'وحدة البيع',
    uk: 'Одиниця Продажу',
  },
  print: {
    en: 'Print',
    es: 'Imprimir',
    fr: 'Imprimer',
    de: 'Drucken',
    pt: 'Imprimir',
    pl: 'Drukuj',
    nl: 'Afdrukken',
    el: 'Εκτύπωση',
    cs: 'Tisknout',
    sv: 'Skriv ut',
    hu: 'Nyomtatás',
    da: 'Udskriv',
    fi: 'Tulosta',
    sk: 'Tlačiť',
    bg: 'Печат',
    hr: 'Ispis',
    lt: 'Spausdinti',
    lv: 'Drukāt',
    et: 'Prindi',
    sl: 'Natisni',
    ga: 'Priontáil',
    mt: 'Stampa',
    cy: 'Argraffu',
    ro: 'Imprimare',
    it: 'Stampa',
    zh_cn: '打印',
    hi: 'प्रिंट',
    ar: 'طباعة',
    bn: 'প্রিন্ট',
    ru: 'Печать',
    ja: '印刷',
    tr: 'Yazdır',
    ko: '인쇄',
    vi: 'In',
    id: 'Cetak',
    th: 'พิมพ์',
    ms: 'Cetak',
    ar_eg: 'طباعة',
    uk: 'Друк',
  },
  item_tags: {
    en: 'Item Tags',
    es: 'Etiquetas de Artículos',
    fr: "Tags d'Articles",
    de: 'Artikel-Tags',
    pt: 'Tags de Itens',
    pl: 'Tagi Przedmiotów',
    nl: 'Item Tags',
    el: 'Ετικέτες Αντικειμένων',
    cs: 'Tagy Položek',
    sv: 'Artikeletiketter',
    hu: 'Címkek',
    da: 'Varemærker',
    fi: 'Tuotetunnisteet',
    sk: 'Tagy Položiek',
    bg: 'Етикети на Артикули',
    hr: 'Oznake Artikala',
    lt: 'Prekių Žymos',
    lv: 'Preču Tagi',
    et: 'Kauba Sildid',
    sl: 'Oznake Izdelkov',
    ga: 'Clibeanna Míreanna',
    mt: 'Tags tal-Oġġetti',
    cy: 'Tagiau Eitemau',
    ro: 'Etichete Articole',
    it: 'Tag degli Articoli',
    zh_cn: '项目标签',
    hi: 'वस्तु टैग',
    ar: 'علامات العناصر',
    bn: 'আইটেম ট্যাগ',
    ru: 'Теги Товаров',
    ja: 'アイテムタグ',
    tr: 'Ürün Etiketleri',
    ko: '항목 태그',
    vi: 'Thẻ Mặt Hàng',
    id: 'Tag Item',
    th: 'แท็กไอเท็ม',
    ms: 'Tag Item',
    ar_eg: 'علامات العناصر',
    uk: 'Теги Предметів',
  },
  auto_play: {
    en: 'Auto Apply',
    es: 'Aplicar automáticamente',
    fr: 'Application automatique',
    de: 'Automatisch anwenden',
    pt: 'Aplicar automaticamente',
    pl: 'Automatyczne stosowanie',
    nl: 'Automatisch toepassen',
    el: 'Αυτόματη εφαρμογή',
    cs: 'Automaticky použít',
    sv: 'Automatisk tillämpning',
    hu: 'Automatikus alkalmazás',
    da: 'Automatisk anvendelse',
    fi: 'Automaattinen sovellus',
    sk: 'Automatické použitie',
    bg: 'Автоматично прилагане',
    hr: 'Automatska primjena',
    lt: 'Automatinis taikymas',
    lv: 'Automātiska lietošana',
    et: 'Automaatne rakendamine',
    sl: 'Samodejno uporabi',
    ga: 'Cuir i bhFeidhm go hUathoibríoch',
    mt: 'Applika Awtomatika',
    cy: "Cymhwyso'n Awtomatig",
    ro: 'Aplicare automată',
    it: 'Applica automaticamente',
    zh_cn: '自动应用',
    hi: 'स्वचालित लागू',
    ar: 'التطبيق التلقائي',
    bn: 'স্বয়ংক্রিয়ভাবে প্রয়োগ',
    ru: 'Автоматическое применение',
    ja: '自動適用',
    tr: 'Otomatik Uygula',
    ko: '자동 적용',
    vi: 'Tự động áp dụng',
    id: 'Terapkan Otomatis',
    th: 'ใช้โดยอัตโนมัติ',
    ms: 'Guna Auto',
    ar_eg: 'التطبيق التلقائي',
    uk: 'Автоматично застосовувати',
  },
  rules: {
    en: 'Rules',
    es: 'Reglas',
    fr: 'Règles',
    de: 'Regeln',
    pt: 'Regras',
    pl: 'Zasady',
    nl: 'Regels',
    el: 'Κανόνες',
    cs: 'Pravidla',
    sv: 'Regler',
    hu: 'Szabályok',
    da: 'Regler',
    fi: 'Säännöt',
    sk: 'Pravidlá',
    bg: 'Правила',
    hr: 'Pravila',
    lt: 'Taisyklės',
    lv: 'Noteikumi',
    et: 'Reeglid',
    sl: 'Pravila',
    ga: 'Rialacha',
    mt: 'Regoli',
    cy: 'Rheolau',
    ro: 'Reguli',
    it: 'Regole',
    zh_cn: '规则',
    hi: 'नियम',
    ar: 'القواعد',
    bn: 'নিয়মাবলী',
    ru: 'Правила',
    ja: 'ルール',
    tr: 'Kurallar',
    ko: '규칙',
    vi: 'Quy tắc',
    id: 'Aturan',
    th: 'กฎ',
    ms: 'Peraturan',
    ar_eg: 'القواعد',
    uk: 'Правила',
  },
  availability: {
    en: 'Availability',
    es: 'Disponibilidad',
    fr: 'Disponibilité',
    de: 'Verfügbarkeit',
    pt: 'Disponibilidade',
    pl: 'Dostępność',
    nl: 'Beschikbaarheid',
    el: 'Διαθεσιμότητα',
    cs: 'Dostupnost',
    sv: 'Tillgänglighet',
    hu: 'Elérhetőség',
    da: 'Tilgængelighed',
    fi: 'Saatavuus',
    sk: 'Dostupnosť',
    bg: 'Наличност',
    hr: 'Dostupnost',
    lt: 'Prieinamumas',
    lv: 'Pieejamība',
    et: 'Saadavus',
    sl: 'Razpoložljivost',
    ga: 'Infhaighteacht',
    mt: 'Disponibbiltà',
    cy: 'Argaeledd',
    ro: 'Disponibilitate',
    it: 'Disponibilità',
    zh_cn: '可用性',
    hi: 'उपलब्धता',
    ar: 'التوافر',
    bn: 'প্রাপ্যতা',
    ru: 'Доступность',
    ja: '可用性',
    tr: 'Kullanılabilirlik',
    ko: '가용성',
    vi: 'Khả dụng',
    id: 'Ketersediaan',
    th: 'ความพร้อมใช้งาน',
    ms: 'Ketersediaan',
    ar_eg: 'التوافر',
    uk: 'Доступність',
  },
  terms_and_condition: {
    en: 'Terms & Conditions',
    es: 'Términos y Condiciones',
    fr: 'Termes et Conditions',
    de: 'Allgemeine Geschäftsbedingungen',
    pt: 'Termos e Condições',
    pl: 'Warunki i Zasady',
    nl: 'Voorwaarden',
    el: 'Όροι και Προϋποθέσεις',
    cs: 'Podmínky',
    sv: 'Villkor',
    hu: 'Felhasználási feltételek',
    da: 'Vilkår og Betingelser',
    fi: 'Ehdot ja säännöt',
    sk: 'Podmienky',
    bg: 'Условия',
    hr: 'Uvjeti',
    lt: 'Sąlygos',
    lv: 'Noteikumi',
    et: 'Tingimused',
    sl: 'Pogoji',
    ga: 'Téarmaí agus Coinníollacha',
    mt: 'Termini u Kundizzjonijiet',
    cy: 'Telerau ac Amodau',
    ro: 'Termeni și Condiții',
    it: 'Termini e Condizioni',
    zh_cn: '条款和条件',
    hi: 'नियम और शर्तें',
    ar: 'الشروط والأحكام',
    bn: 'শর্তাবলী',
    ru: 'Условия',
    ja: '利用規約',
    tr: 'Şartlar ve Koşullar',
    ko: '이용 약관',
    vi: 'Điều khoản và Điều kiện',
    id: 'Syarat & Ketentuan',
    th: 'ข้อกำหนดและเงื่อนไข',
    ms: 'Terma & Syarat',
    ar_eg: 'الشروط والأحكام',
    uk: 'Умови та положення',
  },
  add_text: {
    en: 'Add Text',
    es: 'Añadir texto',
    fr: 'Ajouter du texte',
    de: 'Text hinzufügen',
    pt: 'Adicionar texto',
    pl: 'Dodaj tekst',
    nl: 'Tekst toevoegen',
    el: 'Προσθήκη κειμένου',
    cs: 'Přidat text',
    sv: 'Lägg till text',
    hu: 'Szöveg hozzáadása',
    da: 'Tilføj tekst',
    fi: 'Lisää teksti',
    sk: 'Pridať text',
    bg: 'Добавяне на текст',
    hr: 'Dodaj tekst',
    lt: 'Pridėti tekstą',
    lv: 'Pievienot tekstu',
    et: 'Lisa tekst',
    sl: 'Dodaj besedilo',
    ga: 'Cuir téacs leis',
    mt: 'Żid test',
    cy: 'Ychwanegu testun',
    ro: 'Adaugă text',
    it: 'Aggiungi testo',
    zh_cn: '添加文本',
    hi: 'पाठ जोड़ें',
    ar: 'أضف نص',
    bn: 'পাঠ যোগ কর',
    ru: 'Добавить текст',
    ja: 'テキストを追加',
    tr: 'Metin Ekle',
    ko: '텍스트 추가',
    vi: 'Thêm văn bản',
    id: 'Tambahkan teks',
    th: 'เพิ่มข้อความ',
    ms: 'Tambah Teks',
    ar_eg: 'أضف نص',
    uk: 'Додати текст',
  },
  buy: {
    en: 'Buy',
    es: 'Comprar',
    fr: 'Acheter',
    de: 'Kaufen',
    pt: 'Comprar',
    pl: 'Kup',
    nl: 'Kopen',
    el: 'Αγορά',
    cs: 'Koupit',
    sv: 'Köpa',
    hu: 'Vásárolni',
    da: 'Køb',
    fi: 'Ostaa',
    sk: 'Kúpiť',
    bg: 'Купи',
    hr: 'Kupi',
    lt: 'Pirkti',
    lv: 'Pirkt',
    et: 'Osta',
    sl: 'Kupiti',
    ga: 'Ceannaigh',
    mt: 'Ixtri',
    cy: 'Prynu',
    ro: 'Cumpăra',
    it: 'Acquistare',
    zh_cn: '买',
    hi: 'खरीदें',
    ar: 'شراء',
    bn: 'কিনুন',
    ru: 'Купить',
    ja: '購入',
    tr: 'Satın almak',
    ko: '구매',
    vi: 'Mua',
    id: 'Beli',
    th: 'ซื้อ',
    ms: 'Beli',
    ar_eg: 'شراء',
    uk: 'Купити',
  },
  add_qty: {
    en: 'Add Qty',
    es: 'Añadir Cantidad',
    fr: 'Ajouter Qté',
    de: 'Menge hinzufügen',
    pt: 'Adicionar Quantidade',
    pl: 'Dodaj ilość',
    nl: 'Hoeveelheid toevoegen',
    el: 'Προσθήκη Ποσότητας',
    cs: 'Přidat množství',
    sv: 'Lägg till Antal',
    hu: 'Mennyiség hozzáadása',
    da: 'Tilføj antal',
    fi: 'Lisää Määrä',
    sk: 'Pridať množstvo',
    bg: 'Добавяне на количество',
    hr: 'Dodaj količinu',
    lt: 'Pridėti kiekį',
    lv: 'Pievienot Daudzumu',
    et: 'Lisa Kogus',
    sl: 'Dodaj količino',
    ga: 'Cuir Cainníocht leis',
    mt: 'Żid Kwantità',
    cy: 'Ychwanegu Meintiau',
    ro: 'Adăugați cantitate',
    it: 'Aggiungi Quantità',
    zh_cn: '添加数量',
    hi: 'मात्रा जोड़ें',
    ar: 'أضف الكمية',
    bn: 'পরিমাণ যোগ করুন',
    ru: 'Добавить количество',
    ja: '数量を追加',
    tr: 'Miktar Ekle',
    ko: '수량 추가',
    vi: 'Thêm số lượng',
    id: 'Tambah Jumlah',
    th: 'เพิ่มจำนวน',
    ms: 'Tambah Kuantiti',
    ar_eg: 'أضف الكمية',
    uk: 'Додати кількість',
  },
  get: {
    en: 'Get',
    es: 'Obtener',
    fr: 'Obtenir',
    de: 'Erhalten',
    pt: 'Obter',
    pl: 'Zdobądź',
    nl: 'Krijg',
    el: 'Πάρε',
    cs: 'Získat',
    sv: 'Få',
    hu: 'Kap',
    da: 'Få',
    fi: 'Hanki',
    sk: 'Dostať',
    bg: 'Вземи',
    hr: 'Dobiti',
    lt: 'Gauti',
    lv: 'Saņemt',
    et: 'Saa',
    sl: 'Pridobiti',
    ga: 'Faigh',
    mt: 'Ikseb',
    cy: 'Cael',
    ro: 'Obține',
    it: 'Ottieni',
    zh_cn: '获得',
    hi: 'प्राप्त करें',
    ar: 'احصل',
    bn: 'প্রাপ্ত করা',
    ru: 'Получить',
    ja: '取得',
    tr: 'Al',
    ko: '얻다',
    vi: 'Nhận',
    id: 'Dapatkan',
    th: 'รับ',
    ms: 'Dapatkan',
    ar_eg: 'احصل على',
    uk: 'Отримати',
  },
  free: {
    en: 'Free',
    es: 'Gratis',
    fr: 'Gratuit',
    de: 'Kostenlos',
    pt: 'Grátis',
    pl: 'Darmowy',
    nl: 'Gratis',
    el: 'Δωρεάν',
    cs: 'Zdarma',
    sv: 'Gratis',
    hu: 'Ingyenes',
    da: 'Gratis',
    fi: 'Ilmainen',
    sk: 'Voľný',
    bg: 'Безплатно',
    hr: 'Besplatno',
    lt: 'Nemokamai',
    lv: 'Bezmaksas',
    et: 'Tasuta',
    sl: 'Brezplačno',
    ga: 'Saor in aisce',
    mt: "B'xejn",
    cy: 'Am ddim',
    ro: 'Gratuit',
    it: 'Gratis',
    zh_cn: '免费',
    hi: 'मुक्त',
    ar: 'مجاني',
    bn: 'বিনামূল্যে',
    ru: 'Бесплатно',
    ja: '無料',
    tr: 'Bedava',
    ko: '무료',
    vi: 'Miễn phí',
    id: 'Gratis',
    th: 'ฟรี',
    ms: 'Percuma',
    ar_eg: 'مجانا',
    uk: 'Безкоштовно',
  },
  with: {
    en: 'With',
    es: 'Con',
    fr: 'Avec',
    de: 'Mit',
    pt: 'Com',
    pl: 'Z',
    nl: 'Met',
    el: 'Με',
    cs: 'S',
    sv: 'Med',
    hu: 'Val',
    da: 'Med',
    fi: 'Kanssa',
    sk: 'S',
    bg: 'Със',
    hr: 'Sa',
    lt: 'Su',
    lv: 'Ar',
    et: 'Koos',
    sl: 'Z',
    ga: 'Le',
    mt: 'Ma',
    cy: 'Gyda',
    ro: 'Cu',
    it: 'Con',
    zh_cn: '与',
    hi: 'साथ',
    ar: 'مع',
    bn: 'সঙ্গে',
    ru: 'С',
    ja: 'と',
    tr: 'ile',
    ko: '와',
    vi: 'Với',
    id: 'Dengan',
    th: 'ด้วย',
    ms: 'Dengan',
    ar_eg: 'مع',
    uk: 'З',
  },
  off: {
    en: 'Off',
    es: 'Desactivado',
    fr: 'Désactivé',
    de: 'Aus',
    pt: 'Desligado',
    pl: 'Wyłączony',
    nl: 'Uit',
    el: 'Απενεργοποιημένο',
    cs: 'Vypnuto',
    sv: 'Av',
    hu: 'Ki',
    da: 'Slukket',
    fi: 'Pois päältä',
    sk: 'Vypnuté',
    bg: 'Изключено',
    hr: 'Isključeno',
    lt: 'Išjungta',
    lv: 'Izslēgts',
    et: 'Väljas',
    sl: 'Izklopljeno',
    ga: 'As',
    mt: 'Mitfi',
    cy: 'I ffwrdd',
    ro: 'Oprit',
    it: 'Spento',
    zh_cn: '关闭',
    hi: 'बंद',
    ar: 'إيقاف',
    bn: 'বন্ধ',
    ru: 'Выкл',
    ja: 'オフ',
    tr: 'Kapalı',
    ko: '끄기',
    vi: 'Tắt',
    id: 'Mati',
    th: 'ปิด',
    ms: 'Mati',
    ar_eg: 'إيقاف',
    uk: 'Вимкнено',
  },
  category: {
    en: 'Category',
    es: 'Categoría',
    fr: 'Catégorie',
    de: 'Kategorie',
    pt: 'Categoria',
    pl: 'Kategoria',
    nl: 'Categorie',
    el: 'Κατηγορία',
    cs: 'Kategorie',
    sv: 'Kategori',
    hu: 'Kategória',
    da: 'Kategori',
    fi: 'Kategoria',
    sk: 'Kategória',
    bg: 'Категория',
    hr: 'Kategorija',
    lt: 'Kategorija',
    lv: 'Kategorija',
    et: 'Kategooria',
    sl: 'Kategorija',
    ga: 'Catagóir',
    mt: 'Kategorija',
    cy: 'Categori',
    ro: 'Categorie',
    it: 'Categoria',
    zh_cn: '类别',
    hi: 'श्रेणी',
    ar: 'فئة',
    bn: 'শ্রেণী',
    ru: 'Категория',
    ja: 'カテゴリ',
    tr: 'Kategori',
    ko: '카테고리',
    vi: 'Danh mục',
    id: 'Kategori',
    th: 'หมวดหมู่',
    ms: 'Kategori',
    ar_eg: 'فئة',
    uk: 'Категорія',
  },
  inventory_location: {
    en: 'Inventory Location',
    es: 'Ubicación del Inventario',
    fr: "Emplacement de l'Inventaire",
    de: 'Lagerort',
    pt: 'Localização do Inventário',
    pl: 'Lokalizacja Magazynu',
    nl: 'Voorraadlocatie',
    el: 'Τοποθεσία Αποθέματος',
    cs: 'Umístění Skladu',
    sv: 'Lagerplats',
    hu: 'Készlet Helye',
    da: 'Lagerplacering',
    fi: 'Varaston Sijainti',
    sk: 'Poloha Skladu',
    bg: 'Местоположение на Склад',
    hr: 'Lokacija Zaliha',
    lt: 'Atsargų Vieta',
    lv: 'Krājumu Atrašanās Vieta',
    et: 'Ladu Asukoht',
    sl: 'Lokacija Inventarja',
    ga: 'Suíomh Fardail',
    mt: 'Post tal-Inventarju',
    cy: 'Lleoliad Stocrestr',
    ro: 'Locație Inventar',
    it: 'Posizione Inventario',
    zh_cn: '库存位置',
    hi: 'इन्वेंटरी स्थान',
    ar: 'موقع المخزون',
    bn: 'ইনভেন্টরি অবস্থান',
    ru: 'Расположение Запасов',
    ja: '在庫場所',
    tr: 'Envanter Konumu',
    ko: '재고 위치',
    vi: 'Vị trí Hàng tồn kho',
    id: 'Lokasi Inventaris',
    th: 'ตำแหน่งสินค้าคงคลัง',
    ms: 'Lokasi Inventori',
    ar_eg: 'موقع المخزون',
    uk: 'Розташування Запасів',
  },
  all_locations: {
    en: 'All Locations',
    es: 'Todas las Ubicaciones',
    fr: 'Tous les Emplacements',
    de: 'Alle Standorte',
    pt: 'Todas as Localizações',
    pl: 'Wszystkie Lokalizacje',
    nl: 'Alle Locaties',
    el: 'Όλες οι Τοποθεσίες',
    cs: 'Všechny Lokality',
    sv: 'Alla Platser',
    hu: 'Minden Helyszín',
    da: 'Alle Lokationer',
    fi: 'Kaikki Sijainnit',
    sk: 'Všetky Lokality',
    bg: 'Всички Локации',
    hr: 'Sve Lokacije',
    lt: 'Visos Vietos',
    lv: 'Visas Atrašanās Vietas',
    et: 'Kõik Asukohad',
    sl: 'Vse Lokacije',
    ga: 'Gach Suíomh',
    mt: 'Il-Lokalitajiet Kollha',
    cy: 'Pob Lleoliad',
    ro: 'Toate Locațiile',
    it: 'Tutte le Località',
    zh_cn: '所有位置',
    hi: 'सभी स्थान',
    ar: 'كل المواقع',
    bn: 'সব অবস্থান',
    ru: 'Все Места',
    ja: 'すべての場所',
    tr: 'Tüm Konumlar',
    ko: '모든 위치',
    vi: 'Tất cả các Vị trí',
    id: 'Semua Lokasi',
    th: 'ทุกสถานที่',
    ms: 'Semua Lokasi',
    ar_eg: 'كل المواقع',
    uk: 'Всі Локації',
  },
  all_categories: {
    en: 'All Categories',
    es: 'Todas las Categorías',
    fr: 'Toutes les Catégories',
    de: 'Alle Kategorien',
    pt: 'Todas as Categorias',
    pl: 'Wszystkie Kategorie',
    nl: 'Alle Categorieën',
    el: 'Όλες οι Κατηγορίες',
    cs: 'Všechny Kategorie',
    sv: 'Alla Kategorier',
    hu: 'Minden Kategória',
    da: 'Alle Kategorier',
    fi: 'Kaikki Kategoriat',
    sk: 'Všetky Kategórie',
    bg: 'Всички Категории',
    hr: 'Sve Kategorije',
    lt: 'Visos Kategorijos',
    lv: 'Visas Kategorijas',
    et: 'Kõik Kategooriad',
    sl: 'Vse Kategorije',
    ga: 'Gach Catagóir',
    mt: 'Il-Kategoriji Kollha',
    cy: 'Pob Categori',
    ro: 'Toate Categoriile',
    it: 'Tutte le Categorie',
    zh_cn: '所有类别',
    hi: 'सभी श्रेणियाँ',
    ar: 'جميع الفئات',
    bn: 'সমস্ত বিভাগ',
    ru: 'Все Категории',
    ja: 'すべてのカテゴリ',
    tr: 'Tüm Kategoriler',
    ko: '모든 카테고리',
    vi: 'Tất cả các Danh mục',
    id: 'Semua Kategori',
    th: 'ทุกหมวดหมู่',
    ms: 'Semua Kategori',
    ar_eg: 'جميع الفئات',
    uk: 'Всі Категорії',
  },
  all_branches: {
    en: 'All Branches',
    es: 'Todas las Sucursales',
    fr: 'Toutes les Branches',
    de: 'Alle Filialen',
    pt: 'Todas as Filiais',
    pl: 'Wszystkie Oddziały',
    nl: 'Alle Vestigingen',
    el: 'Όλα τα Υποκαταστήματα',
    cs: 'Všechny Pobočky',
    sv: 'Alla Filialer',
    hu: 'Összes Fiók',
    da: 'Alle Afdelinger',
    fi: 'Kaikki Toimipisteet',
    sk: 'Všetky Pobočky',
    bg: 'Всички Клонове',
    hr: 'Sve Podružnice',
    lt: 'Visi Padaliniai',
    lv: 'Visas Filiāles',
    et: 'Kõik Harud',
    sl: 'Vse Podružnice',
    ga: 'Gach Brainse',
    mt: 'Il-Fergħat Kollha',
    cy: 'Pob Cangen',
    ro: 'Toate Filialele',
    it: 'Tutte le Filiali',
    zh_cn: '所有分支机构',
    hi: 'सभी शाखाएँ',
    ar: 'جميع الفروع',
    bn: 'সব শাখা',
    ru: 'Все Отделения',
    ja: 'すべての支店',
    tr: 'Tüm Şubeler',
    ko: '모든 지점',
    vi: 'Tất cả các Chi nhánh',
    id: 'Semua Cabang',
    th: 'ทุกสาขา',
    ms: 'Semua Cawangan',
    ar_eg: 'جميع الفروع',
    uk: 'Усі Філії',
  },
  all_channels: {
    en: 'All Channels',
    es: 'Todos los canales',
    fr: 'Tous les canaux',
    de: 'Alle Kanäle',
    pt: 'Todos os canais',
    pl: 'Wszystkie kanały',
    nl: 'Alle kanalen',
    el: 'Όλα τα κανάλια',
    cs: 'Všechny kanály',
    sv: 'Alla kanaler',
    hu: 'Minden csatorna',
    da: 'Alle kanaler',
    fi: 'Kaikki kanavat',
    sk: 'Všetky kanály',
    bg: 'Всички канали',
    hr: 'Svi kanali',
    lt: 'Visi kanalai',
    lv: 'Visi kanāli',
    et: 'Kõik kanalid',
    sl: 'Vsi kanali',
    ga: 'Gach Cainéal',
    mt: 'Il-Kanali Kollha',
    cy: 'Pob sianel',
    ro: 'Toate canalele',
    it: 'Tutti i canali',
    zh_cn: '所有频道',
    hi: 'सभी चैनल',
    ar: 'جميع القنوات',
    bn: 'সমস্ত চ্যানেল',
    ru: 'Все каналы',
    ja: 'すべてのチャンネル',
    tr: 'Tüm kanallar',
    ko: '모든 채널',
    vi: 'Tất cả các kênh',
    id: 'Semua saluran',
    th: 'ทุกช่องทาง',
    ms: 'Semua saluran',
    ar_eg: 'كل القنوات',
    uk: 'Усі канали',
  },
  change: {
    en: 'Change',
    es: 'Cambiar',
    fr: 'Modifier',
    de: 'Ändern',
    pt: 'Alterar',
    pl: 'Zmień',
    nl: 'Wijzigen',
    el: 'Αλλαγή',
    cs: 'Změnit',
    sv: 'Ändra',
    hu: 'Módosítás',
    da: 'Ændr',
    fi: 'Muuta',
    sk: 'Zmeniť',
    bg: 'Промени',
    hr: 'Promijeni',
    lt: 'Keisti',
    lv: 'Mainīt',
    et: 'Muuda',
    sl: 'Spremeni',
    ga: 'Athraigh',
    mt: 'Ibdel',
    cy: 'Newid',
    ro: 'Schimbă',
    it: 'Modifica',
    zh_cn: '更改',
    hi: 'बदलें',
    ar: 'تغيير',
    bn: 'পরিবর্তন করুন',
    ru: 'Изменить',
    ja: '変更',
    tr: 'Değiştir',
    ko: '변경',
    vi: 'Thay đổi',
    id: 'Ubah',
    th: 'เปลี่ยน',
    ms: 'Tukar',
    ar_eg: 'تغيير',
    uk: 'Змінити',
  },
  now: {
    en: 'Now',
    es: 'Ahora',
    fr: 'Maintenant',
    de: 'Jetzt',
    pt: 'Agora',
    pl: 'Teraz',
    nl: 'Nu',
    el: 'Τώρα',
    cs: 'Nyní',
    sv: 'Nu',
    hu: 'Most',
    da: 'Nu',
    fi: 'Nyt',
    sk: 'Teraz',
    bg: 'Сега',
    hr: 'Sada',
    lt: 'Dabar',
    lv: 'Tagad',
    et: 'Nüüd',
    sl: 'Zdaj',
    ga: 'Anois',
    mt: 'Issa',
    cy: 'Nawr',
    ro: 'Acum',
    it: 'Adesso',
    zh_cn: '现在',
    hi: 'अभी',
    ar: 'الآن',
    bn: 'এখন',
    ru: 'Сейчас',
    ja: '今',
    tr: 'Şimdi',
    ko: '지금',
    vi: 'Bây giờ',
    id: 'Sekarang',
    th: 'ตอนนี้',
    ms: 'Sekarang',
    ar_eg: 'الآن',
    uk: 'Зараз',
  },
  unit_value: {
    en: 'Unit Value',
    es: 'Valor Unitario',
    fr: 'Valeur Unitaire',
    de: 'Stückwert',
    pt: 'Valor Unitário',
    pl: 'Wartość Jednostkowa',
    nl: 'Eenheidswaarde',
    el: 'Τιμή Μονάδας',
    cs: 'Jednotková Hodnota',
    sv: 'Enhetsvärde',
    hu: 'Egységérték',
    da: 'Enhedsværdi',
    fi: 'Yksikköarvo',
    sk: 'Jednotková Hodnota',
    bg: 'Единична Стойност',
    hr: 'Jedinična Vrijednost',
    lt: 'Vieneto Vertė',
    lv: 'Vienības Vērtība',
    et: 'Ühikuväärtus',
    sl: 'Enotna Vrednost',
    ga: 'Luach Aonaid',
    mt: 'Valur tal-Unità',
    cy: 'Gwerth Uned',
    ro: 'Valoare Unitară',
    it: 'Valore Unitario',
    zh_cn: '单位价值',
    hi: 'इकाई मूल्य',
    ar: 'قيمة الوحدة',
    bn: 'একক মূল্য',
    ru: 'Единичная Стоимость',
    ja: '単価',
    tr: 'Birim Değeri',
    ko: '단가',
    vi: 'Giá trị Đơn vị',
    id: 'Nilai Unit',
    th: 'มูลค่าต่อหน่วย',
    ms: 'Nilai Unit',
    ar_eg: 'قيمة الوحدة',
    uk: 'Вартість Одиниці',
  },
  per_item: {
    en: 'Per Item',
    es: 'Por Artículo',
    fr: 'Par Article',
    de: 'Pro Artikel',
    pt: 'Por Item',
    pl: 'Na Sztukę',
    nl: 'Per Item',
    el: 'Ανά Αντικείμενο',
    cs: 'Za Položku',
    sv: 'Per Artikel',
    hu: 'Tételenként',
    da: 'Pr. Vare',
    fi: 'Per Tuote',
    sk: 'Za Položku',
    bg: 'На Артикул',
    hr: 'Po Stvarci',
    lt: 'Už Prekę',
    lv: 'Par Vienumu',
    et: 'Ühe Esmendi Kohta',
    sl: 'Na Izdelek',
    ga: 'In aghaidh an Míre',
    mt: 'Per Oġġett',
    cy: 'Fesul Eitem',
    ro: 'Per Articol',
    it: 'Per Articolo',
    zh_cn: '每件',
    hi: 'प्रति वस्तु',
    ar: 'لكل عنصر',
    bn: 'প্রতি আইটেম',
    ru: 'За Единицу',
    ja: 'アイテムごと',
    tr: 'Ürün Başına',
    ko: '항목당',
    vi: 'Mỗi Mục',
    id: 'Per Item',
    th: 'ต่อรายการ',
    ms: 'Per Item',
    ar_eg: 'لكل عنصر',
    uk: 'За Одиницю',
  },
  new_unit_value: {
    en: 'New Unit Value',
    es: 'Nuevo Valor Unitario',
    fr: 'Nouvelle Valeur Unitaire',
    de: 'Neuer Stückwert',
    pt: 'Novo Valor Unitário',
    pl: 'Nowa Wartość Jednostkowa',
    nl: 'Nieuwe Eenheidswaarde',
    el: 'Νέα Τιμή Μονάδας',
    cs: 'Nová Jednotková Hodnota',
    sv: 'Nytt Enhetsvärde',
    hu: 'Új Egységérték',
    da: 'Ny Enhedsværdi',
    fi: 'Uusi Yksikköarvo',
    sk: 'Nová Jednotková Hodnota',
    bg: 'Нова Единична Стойност',
    hr: 'Nova Jedinična Vrijednost',
    lt: 'Nauja Vieneto Vertė',
    lv: 'Jauna Vienības Vērtība',
    et: 'Uus Ühikuväärtus',
    sl: 'Nova Enotna Vrednost',
    ga: 'Luach Nua Aonaid',
    mt: 'Valur Ġdid tal-Unità',
    cy: 'Gwerth Uned Newydd',
    ro: 'Nouă Valoare Unitară',
    it: 'Nuovo Valore Unitario',
    zh_cn: '新单位价值',
    hi: 'नई इकाई मूल्य',
    ar: 'قيمة الوحدة الجديدة',
    bn: 'নতুন একক মূল্য',
    ru: 'Новая Единичная Стоимость',
    ja: '新しい単価',
    tr: 'Yeni Birim Değeri',
    ko: '새로운 단가',
    vi: 'Giá trị Đơn vị Mới',
    id: 'Nilai Unit Baru',
    th: 'มูลค่าต่อหน่วยใหม่',
    ms: 'Nilai Unit Baru',
    ar_eg: 'قيمة الوحدة الجديدة',
    uk: 'Нова Вартість Одиниці',
  },
  category_image: {
    en: 'Category Image',
    es: 'Imagen de la Categoría',
    fr: 'Image de la Catégorie',
    de: 'Kategoriebild',
    pt: 'Imagem da Categoria',
    pl: 'Obraz Kategorii',
    nl: 'Categorie Afbeelding',
    el: 'Εικόνα Κατηγορίας',
    cs: 'Obrázek Kategorie',
    sv: 'Kategoribild',
    hu: 'Kategória Kép',
    da: 'Kategori Billede',
    fi: 'Kategorian Kuva',
    sk: 'Obrázok Kategórie',
    bg: 'Изображение на Категорията',
    hr: 'Slika Kategorije',
    lt: 'Kategorijos Paveikslėlis',
    lv: 'Kategorijas Attēls',
    et: 'Kategooria Pilt',
    sl: 'Slika Kategorije',
    ga: 'Íomhá an Chataigh',
    mt: 'Immaġni tal-Kategorija',
    cy: 'Delwedd y Categori',
    ro: 'Imagine Categorie',
    it: 'Immagine della Categoria',
    zh_cn: '类别图片',
    hi: 'श्रेणी की छवि',
    ar: 'صورة التصنيف',
    bn: 'বিভাগের ছবি',
    ru: 'Изображение Категории',
    ja: 'カテゴリ画像',
    tr: 'Kategori Resmi',
    ko: '카테고리 이미지',
    vi: 'Hình Ảnh Danh Mục',
    id: 'Gambar Kategori',
    th: 'ภาพหมวดหมู่',
    ms: 'Imej Kategori',
    ar_eg: 'صورة الفئة',
    uk: 'Зображення Категорії',
  },
  create_category: {
    en: 'Create Category',
    es: 'Crear Categoría',
    fr: 'Créer une catégorie',
    de: 'Kategorie erstellen',
    pt: 'Criar Categoria',
    pl: 'Utwórz Kategorię',
    nl: 'Categorie Aanmaken',
    el: 'Δημιουργία Κατηγορίας',
    cs: 'Vytvořit kategorii',
    sv: 'Skapa kategori',
    hu: 'Kategória létrehozása',
    da: 'Opret kategori',
    fi: 'Luo kategoria',
    sk: 'Vytvoriť kategóriu',
    bg: 'Създаване на категория',
    hr: 'Kreiraj kategoriju',
    lt: 'Sukurti kategoriją',
    lv: 'Izveidot kategoriju',
    et: 'Loo kategooria',
    sl: 'Ustvari kategorijo',
    ga: 'Cruthaigh Catagóir',
    mt: 'Oħloq Kategorija',
    cy: 'Creu Categori',
    ro: 'Creează categorie',
    it: 'Crea categoria',
    zh_cn: '创建类别',
    hi: 'श्रेणी बनाएं',
    ar: 'إنشاء فئة',
    bn: 'বিভাগ তৈরি করুন',
    ru: 'Создать категорию',
    ja: 'カテゴリーを作成',
    tr: 'Kategori Oluştur',
    ko: '카테고리 생성',
    vi: 'Tạo danh mục',
    id: 'Buat Kategori',
    th: 'สร้างหมวดหมู่',
    ms: 'Buat Kategori',
    ar_eg: 'إنشاء فئة',
    uk: 'Створити категорію',
  },
  edit_category: {
    en: 'Edit Category',
    es: 'Editar Categoría',
    fr: 'Modifier la catégorie',
    de: 'Kategorie bearbeiten',
    pt: 'Editar Categoria',
    pl: 'Edytuj Kategorię',
    nl: 'Categorie Bewerken',
    el: 'Επεξεργασία Κατηγορίας',
    cs: 'Upravit kategorii',
    sv: 'Redigera kategori',
    hu: 'Kategória szerkesztése',
    da: 'Rediger kategori',
    fi: 'Muokkaa kategoriaa',
    sk: 'Upraviť kategóriu',
    bg: 'Редактиране на категория',
    hr: 'Uredi kategoriju',
    lt: 'Redaguoti kategoriją',
    lv: 'Rediģēt kategoriju',
    et: 'Redigeeri kategooriat',
    sl: 'Uredi kategorijo',
    ga: 'Cuir Catagóir in Eagar',
    mt: 'Editja Kategorija',
    cy: 'Golygu Categori',
    ro: 'Editare categorie',
    it: 'Modifica categoria',
    zh_cn: '编辑类别',
    hi: 'श्रेणी संपादित करें',
    ar: 'تحرير الفئة',
    bn: 'বিভাগ সম্পাদনা করুন',
    ru: 'Редактировать категорию',
    ja: 'カテゴリーを編集',
    tr: 'Kategori Düzenle',
    ko: '카테고리 편집',
    vi: 'Chỉnh sửa danh mục',
    id: 'Edit Kategori',
    th: 'แก้ไขหมวดหมู่',
    ms: 'Edit Kategori',
    ar_eg: 'تحرير الفئة',
    uk: 'Редагувати категорію',
  },
  category_info: {
    en: 'Category Info',
    es: 'Información de Categoría',
    fr: 'Informations sur la catégorie',
    de: 'Kategorie-Info',
    pt: 'Informações da Categoria',
    pl: 'Informacje o Kategorii',
    nl: 'Categorie-informatie',
    el: 'Πληροφορίες κατηγορίας',
    cs: 'Informace o kategorii',
    sv: 'Kategorinformation',
    hu: 'Kategória információk',
    da: 'Kategoriinformation',
    fi: 'Kategoria Info',
    sk: 'Informácie o kategórii',
    bg: 'Информация за категорията',
    hr: 'Informacije o kategoriji',
    lt: 'Kategorijos informacija',
    lv: 'Kategorijas informācija',
    et: 'Kategooria info',
    sl: 'Informacije o kategoriji',
    ga: 'Eolas Catagóir',
    mt: 'Informazzjoni tal-Kategorija',
    cy: 'Gwybodaeth Categori',
    ro: 'Informații despre categorie',
    it: 'Informazioni sulla categoria',
    zh_cn: '类别信息',
    hi: 'श्रेणी की जानकारी',
    ar: 'معلومات الفئة',
    bn: 'বিভাগ তথ্য',
    ru: 'Информация о категории',
    ja: 'カテゴリ情報',
    tr: 'Kategori Bilgisi',
    ko: '카테고리 정보',
    vi: 'Thông tin danh mục',
    id: 'Informasi Kategori',
    th: 'ข้อมูลหมวดหมู่',
    ms: 'Maklumat Kategori',
    ar_eg: 'معلومات الفئة',
    uk: 'Інформація про категорію',
  },
  upload_image_description: {
    en: 'Upload an image for your category or select one of the available icons.',
    es: 'Sube una imagen para tu categoría o selecciona uno de los iconos disponibles.',
    fr: 'Téléchargez une image pour votre catégorie ou sélectionnez une des icônes disponibles.',
    de: 'Laden Sie ein Bild für Ihre Kategorie hoch oder wählen Sie eines der verfügbaren Symbole aus.',
    pt: 'Faça o upload de uma imagem para a sua categoria ou selecione um dos ícones disponíveis.',
    pl: 'Prześlij obraz dla swojej kategorii lub wybierz jedną z dostępnych ikon.',
    nl: 'Upload een afbeelding voor uw categorie of kies een van de beschikbare pictogrammen.',
    el: 'Ανεβάστε μια εικόνα για την κατηγορία σας ή επιλέξτε ένα από τα διαθέσιμα εικονίδια.',
    cs: 'Nahrajte obrázek pro vaši kategorii nebo vyberte jednu z dostupných ikon.',
    sv: 'Ladda upp en bild för din kategori eller välj en av de tillgängliga ikonerna.',
    hu: 'Töltsön fel egy képet a kategóriájához vagy válasszon az elérhető ikonok közül.',
    da: 'Upload et billede til din kategori eller vælg et af de tilgængelige ikoner.',
    fi: 'Lataa kuva kategoriallesi tai valitse yksi saatavilla olevista ikoneista.',
    sk: 'Nahrajte obrázok pre vašu kategóriu alebo vyberte jednu z dostupných ikon.',
    bg: 'Качете изображение за вашата категория или изберете един от наличните икони.',
    hr: 'Prenesite sliku za svoju kategoriju ili odaberite jednu od dostupnih ikona.',
    lt: 'Įkelkite kategorijos atvaizdą arba pasirinkite vieną iš prieinamų piktogramų.',
    lv: 'Augšupielādējiet attēlu savai kategorijai vai izvēlieties kādu no pieejamajām ikonām.',
    et: 'Laadige üles pilt oma kategooria jaoks või valige üks saadaolevatest ikoonidest.',
    sl: 'Naložite sliko za svojo kategorijo ali izberite eno od razpoložljivih ikon.',
    ga: 'Uaslódáil íomhá do do chatagóir nó roghnaigh ceann de na deilbhíní atá ar fáil.',
    mt: 'Ittella’ immaġni għall-kategorija tiegħek jew agħżel waħda mill-ikoni disponibbli.',
    cy: "Llwythwch lun ar gyfer eich categori neu dewiswch un o'r eiconau sydd ar gael.",
    ro: 'Încărcați o imagine pentru categoria dvs. sau selectați una dintre icoanele disponibile.',
    it: "Carica un'immagine per la tua categoria o seleziona una delle icone disponibili.",
    zh_cn: '为您的类别上传图像或选择一个可用的图标。',
    hi: 'अपनी श्रेणी के लिए एक छवि अपलोड करें या उपलब्ध आइकनों में से एक का चयन करें।',
    ar: 'حمّل صورة لتصنيفك أو اختر واحدًا من الأيقونات المتاحة.',
    bn: 'আপনার বিভাগের জন্য একটি চিত্র আপলোড করুন অথবা উপলব্ধ আইকনগুলির একটি নির্বাচন করুন।',
    ru: 'Загрузите изображение для вашей категории или выберите один из доступных значков.',
    ja: 'カテゴリ用の画像をアップロードするか、利用可能なアイコンのうちの一つを選択してください。',
    tr: 'Kategoriniz için bir resim yükleyin veya mevcut simgelerden birini seçin.',
    ko: '카테고리 이미지를 업로드하거나 사용 가능한 아이콘 중 하나를 선택하세요.',
    vi: 'Tải lên hình ảnh cho danh mục của bạn hoặc chọn một trong những biểu tượng có sẵn.',
    id: 'Unggah gambar untuk kategori Anda atau pilih salah satu ikon yang tersedia.',
    th: 'อัปโหลดภาพสำหรับหมวดหมู่ของคุณหรือเลือกหนึ่งในไอคอนที่มีอยู่',
    ms: 'Muat naik imej untuk kategori anda atau pilih salah satu ikon yang tersedia.',
    ar_eg: 'قم بتحميل صورة لفئتك أو اختر أحد الأيقونات المتاحة.',
    uk: 'Завантажте зображення для вашої категорії або виберіть один із доступних значків.',
  },
  store_id: {
    en: 'Store ID',
    es: 'ID de tienda',
    fr: 'ID de magasin',
    de: 'Geschäfts-ID',
    pt: 'ID da loja',
    pl: 'ID sklepu',
    nl: 'Winkel-ID',
    el: 'Αναγνωριστικό καταστήματος',
    cs: 'ID obchodu',
    sv: 'Butiks-ID',
    hu: 'Bolt azonosító',
    da: 'Butiks-ID',
    fi: 'Myymälän ID',
    sk: 'ID obchodu',
    bg: 'ID на магазина',
    hr: 'ID trgovine',
    lt: 'Parduotuvės ID',
    lv: 'Veikala ID',
    et: 'Poekood',
    sl: 'ID trgovine',
    ga: 'Aitheantas an tSiopa',
    mt: 'ID tal-ħanut',
    cy: 'ID y siop',
    ro: 'ID magazin',
    it: 'ID del negozio',
    zh_cn: '店铺ID',
    hi: 'स्टोर आईडी',
    ar: 'معرف المتجر',
    bn: 'দোকানের আইডি',
    ru: 'ID магазина',
    ja: '店舗ID',
    tr: 'Mağaza Kimliği',
    ko: '매장 ID',
    vi: 'ID cửa hàng',
    id: 'ID Toko',
    th: 'รหัสร้านค้า',
    ms: 'ID Kedai',
    ar_eg: 'معرف المتجر',
    uk: 'ID магазину',
  },
  store_name: {
    en: 'Store Name',
    es: 'Nombre de la tienda',
    fr: 'Nom du magasin',
    de: 'Geschäftsname',
    pt: 'Nome da loja',
    pl: 'Nazwa sklepu',
    nl: 'Winkelnaam',
    el: 'Όνομα καταστήματος',
    cs: 'Název obchodu',
    sv: 'Butiksnamn',
    hu: 'Bolt neve',
    da: 'Butiksnavn',
    fi: 'Myymälän nimi',
    sk: 'Názov obchodu',
    bg: 'Име на магазина',
    hr: 'Naziv trgovine',
    lt: 'Parduotuvės pavadinimas',
    lv: 'Veikala nosaukums',
    et: 'Poenimi',
    sl: 'Ime trgovine',
    ga: 'Ainm an tSiopa',
    mt: 'Isem tal-ħanut',
    cy: 'Enw’r siop',
    ro: 'Nume magazin',
    it: 'Nome del negozio',
    zh_cn: '店名',
    hi: 'स्टोर का नाम',
    ar: 'اسم المتجر',
    bn: 'দোকানের নাম',
    ru: 'Название магазина',
    ja: '店舗名',
    tr: 'Mağaza Adı',
    ko: '매장 이름',
    vi: 'Tên cửa hàng',
    id: 'Nama Toko',
    th: 'ชื่อร้านค้า',
    ms: 'Nama Kedai',
    ar_eg: 'اسم المتجر',
    uk: 'Назва магазину',
  },
  location_id: {
    en: 'Location ID',
    es: 'ID de ubicación',
    fr: 'ID de localisation',
    de: 'Standort-ID',
    pt: 'ID de localização',
    pl: 'ID lokalizacji',
    nl: 'Locatie-ID',
    el: 'Αναγνωριστικό τοποθεσίας',
    cs: 'ID umístění',
    sv: 'Plats-ID',
    hu: 'Helyazonosító',
    da: 'Lokalitets-ID',
    fi: 'Sijaintitunnus',
    sk: 'ID lokality',
    bg: 'Идентификатор на местоположението',
    hr: 'ID lokacije',
    lt: 'Vietos ID',
    lv: 'Atrašanās vietas ID',
    et: 'Asukoha ID',
    sl: 'ID lokacije',
    ga: 'Aitheantas Suíomh',
    mt: 'ID tal-Lokazzjoni',
    cy: 'ID Lleoliad',
    ro: 'ID locație',
    it: 'ID posizione',
    zh_cn: '位置ID',
    hi: 'स्थान आईडी',
    ar: 'معرف الموقع',
    bn: 'অবস্থান আইডি',
    ru: 'ID местоположения',
    ja: '場所ID',
    tr: 'Konum Kimliği',
    ko: '위치 ID',
    vi: 'ID vị trí',
    id: 'ID Lokasi',
    th: 'รหัสตำแหน่ง',
    ms: 'ID Lokasi',
    ar_eg: 'معرف الموقع',
    uk: 'Ідентифікатор місця',
  },
  yes_delete: {
    en: 'Yes, Delete',
    es: 'Sí, Eliminar',
    fr: 'Oui, Supprimer',
    de: 'Ja, Löschen',
    pt: 'Sim, Excluir',
    pl: 'Tak, Usuń',
    nl: 'Ja, Verwijderen',
    el: 'Ναι, Διαγραφή',
    cs: 'Ano, Smazat',
    sv: 'Ja, Ta Bort',
    hu: 'Igen, Törlés',
    da: 'Ja, Slet',
    fi: 'Kyllä, Poista',
    sk: 'Áno, Odstrániť',
    bg: 'Да, Изтрий',
    hr: 'Da, Izbriši',
    lt: 'Taip, Ištrinti',
    lv: 'Jā, Dzēst',
    et: 'Jah, Kustuta',
    sl: 'Da, Izbriši',
    ga: 'Tá, Scrios',
    mt: 'Iva, Ħassar',
    cy: 'Ie, Dileu',
    ro: 'Da, Șterge',
    it: 'Sì, Elimina',
    zh_cn: '是的，删除',
    hi: 'हां, हटाएं',
    ar: 'نعم، احذف',
    bn: 'হ্যাঁ, মুছে ফেলুন',
    ru: 'Да, Удалить',
    ja: 'はい、削除',
    tr: 'Evet, Sil',
    ko: '예, 삭제',
    vi: 'Có, Xóa',
    id: 'Ya, Hapus',
    th: 'ใช่, ลบ',
    ms: 'Ya, Padam',
    ar_eg: 'نعم، احذف',
    uk: 'Так, Видалити',
  },
  auto_accept: {
    en: 'Auto Accept',
    es: 'Aceptación Automática',
    fr: 'Acceptation Automatique',
    de: 'Automatische Annahme',
    pt: 'Aceitação Automática',
    pl: 'Automatyczne Akceptowanie',
    nl: 'Automatisch Accepteren',
    el: 'Αυτόματη Αποδοχή',
    cs: 'Automatické Přijetí',
    sv: 'Automatisk Godkännande',
    hu: 'Automatikus Elfogadás',
    da: 'Automatisk Accept',
    fi: 'Automaattinen Hyväksyntä',
    sk: 'Automatické Prijatie',
    bg: 'Автоматично Приемане',
    hr: 'Automatsko Prihvaćanje',
    lt: 'Automatinis Priėmimas',
    lv: 'Automātiska Pieņemšana',
    et: 'Automaatne Kinnitamine',
    sl: 'Samodejno Sprejemanje',
    ga: 'Glacadh Uathoibríoch',
    mt: 'Aċċettazzjoni Awtomatika',
    cy: 'Derbyn yn Awtomatig',
    ro: 'Acceptare Automată',
    it: 'Accettazione Automatica',
    zh_cn: '自动接受',
    hi: 'स्वतः स्वीकार',
    ar: 'القبول التلقائي',
    bn: 'স্বয়ংক্রিয় গ্রহণ',
    ru: 'Автоматическое Принятие',
    ja: '自動承認',
    tr: 'Otomatik Kabul',
    ko: '자동 수락',
    vi: 'Chấp Nhận Tự Động',
    id: 'Terima Otomatis',
    th: 'การยอมรับอัตโนมัติ',
    ms: 'Terima Otomatik',
    ar_eg: 'القبول التلقائي',
    uk: 'Автоматичне Прийняття',
  },
  min: {
    en: 'min',
    es: 'min',
    fr: 'min',
    de: 'Min',
    pt: 'min',
    pl: 'min',
    nl: 'min',
    el: 'λεπτό',
    cs: 'min',
    sv: 'min',
    hu: 'perc',
    da: 'min',
    fi: 'min',
    sk: 'min',
    bg: 'мин',
    hr: 'min',
    lt: 'min',
    lv: 'min',
    et: 'min',
    sl: 'min',
    ga: 'nóim',
    mt: 'min',
    cy: 'mun',
    ro: 'min',
    it: 'min',
    zh_cn: '分钟',
    hi: 'मिनट',
    ar: 'دقيقة',
    bn: 'মিনিট',
    ru: 'мин',
    ja: '分',
    tr: 'dak',
    ko: '분',
    vi: 'phút',
    id: 'mnt',
    th: 'นาที',
    ms: 'min',
    ar_eg: 'د',
    uk: 'хв',
  },
  mins: {
    en: 'mins',
    es: 'mins',
    fr: 'mins',
    de: 'Min',
    pt: 'mins',
    pl: 'min',
    nl: 'mins',
    el: 'λεπτά',
    cs: 'min',
    sv: 'min',
    hu: 'perc',
    da: 'min',
    fi: 'min',
    sk: 'min',
    bg: 'мин',
    hr: 'min',
    lt: 'min',
    lv: 'min',
    et: 'min',
    sl: 'min',
    ga: 'nóim',
    mt: 'min',
    cy: 'mun',
    ro: 'min',
    it: 'min',
    zh_cn: '分钟',
    hi: 'मिनट',
    ar: 'دقائق',
    bn: 'মিনিট',
    ru: 'мин',
    ja: '分',
    tr: 'dak',
    ko: '분',
    vi: 'phút',
    id: 'mnt',
    th: 'นาที',
    ms: 'min',
    ar_eg: 'دقائق',
    uk: 'хв',
  },
  sales_by_type: {
    en: 'Sales by Type',
    es: 'Ventas por Tipo',
    fr: 'Ventes par Type',
    de: 'Verkäufe nach Typ',
    pt: 'Vendas por Tipo',
    pl: 'Sprzedaż według Typu',
    nl: 'Verkoop per Type',
    el: 'Πωλήσεις ανά Τύπο',
    cs: 'Prodej podle Typu',
    sv: 'Försäljning efter Typ',
    hu: 'Értékesítés Típus szerint',
    da: 'Salg efter Type',
    fi: 'Myynti Tyypin mukaan',
    sk: 'Predaj podľa Typu',
    bg: 'Продажби по Вид',
    hr: 'Prodaja prema Vrsti',
    lt: 'Pardavimai pagal Tipą',
    lv: 'Pārdošana pēc Veida',
    et: 'Müük Tüübi järgi',
    sl: 'Prodaja po Vrsti',
    ga: 'Díolacháin de réir Cineáil',
    mt: 'Bejgħ skont Tip',
    cy: 'Gwerthiannau yn ôl Math',
    ro: 'Vânzări pe Tip',
    it: 'Vendite per Tipo',
    zh_cn: '按类型销售',
    hi: 'प्रकार के अनुसार बिक्री',
    ar: 'المبيعات حسب النوع',
    bn: 'প্রকার অনুযায়ী বিক্রয়',
    ru: 'Продажи по Типу',
    ja: 'タイプ別販売',
    tr: 'Türe Göre Satışlar',
    ko: '유형별 판매',
    vi: 'Doanh Số Theo Loại',
    id: 'Penjualan berdasarkan Tipe',
    th: 'ยอดขายตามประเภท',
    ms: 'Jualan mengikut Jenis',
    ar_eg: 'المبيعات حسب النوع',
    uk: 'Продажі за Типом',
  },
  sales_types: {
    en: 'Sales Types',
    es: 'Tipos de Ventas',
    fr: 'Types de Ventes',
    de: 'Verkaufstypen',
    pt: 'Tipos de Vendas',
    pl: 'Typy Sprzedaży',
    nl: 'Verkooptypen',
    el: 'Τύποι Πωλήσεων',
    cs: 'Typy Prodeje',
    sv: 'Försäljningstyper',
    hu: 'Értékesítési Típusok',
    da: 'Salgstyper',
    fi: 'Myyntityypit',
    sk: 'Typy Predaja',
    bg: 'Видове Продажби',
    hr: 'Vrste Prodaje',
    lt: 'Pardavimų Tipai',
    lv: 'Pārdošanas Veidi',
    et: 'Müügitüübid',
    sl: 'Vrste Prodaje',
    ga: 'Cineálacha Díolacháin',
    mt: 'Tipi ta’ Bejgħ',
    cy: 'Mathau Gwerthu',
    ro: 'Tipuri de Vânzări',
    it: 'Tipi di Vendite',
    zh_cn: '销售类型',
    hi: 'बिक्री प्रकार',
    ar: 'أنواع المبيعات',
    bn: 'বিক্রয় প্রকার',
    ru: 'Типы Продаж',
    ja: '販売タイプ',
    tr: 'Satış Türleri',
    ko: '판매 유형',
    vi: 'Loại Hình Bán Hàng',
    id: 'Jenis Penjualan',
    th: 'ประเภทการขาย',
    ms: 'Jenis Jualan',
    ar_eg: 'أنواع المبيعات',
    uk: 'Типи Продажів',
  },
  channels: {
    en: 'channels',
    es: 'canales',
    fr: 'canaux',
    de: 'Kanäle',
    pt: 'canais',
    pl: 'kanały',
    nl: 'kanalen',
    el: 'κανάλια',
    cs: 'kanály',
    sv: 'kanaler',
    hu: 'csatornák',
    da: 'kanaler',
    fi: 'kanavat',
    sk: 'kanály',
    bg: 'канали',
    hr: 'kanali',
    lt: 'kanalai',
    lv: 'kanāli',
    et: 'kanalid',
    sl: 'kanali',
    ga: 'cainéil',
    mt: 'kanali',
    cy: 'sianeli',
    ro: 'canale',
    it: 'canali',
    zh_cn: '渠道',
    hi: 'चैनल',
    ar: 'قنوات',
    bn: 'চ্যানেল',
    ru: 'каналы',
    ja: 'チャネル',
    tr: 'kanallar',
    ko: '채널',
    vi: 'kênh',
    id: 'saluran',
    th: 'ช่องทาง',
    ms: 'saluran',
    ar_eg: 'قنوات',
    uk: 'канали',
  },
  total_sales: {
    en: 'Total Sales',
    es: 'Ventas Totales',
    fr: 'Ventes Totales',
    de: 'Gesamtumsatz',
    pt: 'Vendas Totais',
    pl: 'Łączna sprzedaż',
    nl: 'Totale Verkoop',
    el: 'Συνολικές Πωλήσεις',
    cs: 'Celkový Prodej',
    sv: 'Total Försäljning',
    hu: 'Összes Eladás',
    da: 'Samlede Salg',
    fi: 'Kokonaishinnat',
    sk: 'Celkový Predaj',
    bg: 'Общи Продажби',
    hr: 'Ukupna Prodaja',
    lt: 'Bendras Pardavimas',
    lv: 'Kopējie Pārdošanas Apjomi',
    et: 'Kogumüük',
    sl: 'Skupna Prodaja',
    ga: 'Díolacháin Iomlána',
    mt: 'Bejgħ Totali',
    cy: 'Cyfanswm y Gwerthiant',
    ro: 'Vânzări Totale',
    it: 'Vendite Totali',
    zh_cn: '总销售额',
    hi: 'कुल बिक्री',
    ar: 'إجمالي المبيعات',
    bn: 'মোট বিক্রয়',
    ru: 'Общий Объем Продаж',
    ja: '総売上',
    tr: 'Toplam Satış',
    ko: '총 매출',
    vi: 'Tổng Doanh Thu',
    id: 'Penjualan Total',
    th: 'ยอดขายรวม',
    ms: 'Jumlah Jualan',
    ar_eg: 'إجمالي المبيعات',
    uk: 'Загальний Обсяг Продажів',
  },
  total_branches: {
    en: 'Total Branches',
    es: 'Sucursales Totales',
    fr: 'Branches Totales',
    de: 'Gesamtfilialen',
    pt: 'Total de Filiais',
    pl: 'Łączna Liczba Oddziałów',
    nl: 'Totale Vestigingen',
    el: 'Συνολικά Καταστήματα',
    cs: 'Celkový Počet Poboček',
    sv: 'Totalt Antal Filialer',
    hu: 'Összes Fiók',
    da: 'Samlede Filialer',
    fi: 'Kokonaismäärä Toimipaikkoja',
    sk: 'Celkový Počet Pobočiek',
    bg: 'Общ Брой Клонове',
    hr: 'Ukupno Podružnica',
    lt: 'Bendras Filialų Skaičius',
    lv: 'Kopējais Filiāļu Skaits',
    et: 'Koguarv Harukontoreid',
    sl: 'Skupno Število Podružnic',
    ga: 'Brainse Iomlán',
    mt: 'Fergħat Totali',
    cy: 'Cyfanswm y Canghennau',
    ro: 'Numărul Total de Filiale',
    it: 'Filiali Totali',
    zh_cn: '总分支机构',
    hi: 'कुल शाखाएँ',
    ar: 'إجمالي الفروع',
    bn: 'মোট শাখা',
    ru: 'Общее Количество Филиалов',
    ja: '総支店数',
    tr: 'Toplam Şube',
    ko: '총 지점',
    vi: 'Tổng Số Chi Nhánh',
    id: 'Total Cabang',
    th: 'สาขาทั้งหมด',
    ms: 'Jumlah Cawangan',
    ar_eg: 'إجمالي الفروع',
    uk: 'Загальна Кількість Відділень',
  },
  total_orders: {
    en: 'Total Orders',
    es: 'Órdenes Totales',
    fr: 'Commandes Totales',
    de: 'Gesamtbestellungen',
    pt: 'Total de Pedidos',
    pl: 'Łączna Liczba Zamówień',
    nl: 'Totale Bestellingen',
    el: 'Συνολικές Παραγγελίες',
    cs: 'Celkový Počet Objednávek',
    sv: 'Totala Beställningar',
    hu: 'Összes Rendelés',
    da: 'Samlede Ordrer',
    fi: 'Kokonaistilaukset',
    sk: 'Celkový Počet Objednávok',
    bg: 'Общ Брой Поръчки',
    hr: 'Ukupno Narudžbi',
    lt: 'Bendras Užsakymų Skaičius',
    lv: 'Kopējais Pasūtījumu Skaits',
    et: 'Koguarv Tellimusi',
    sl: 'Skupno Število Naročil',
    ga: 'Iomlán Orduithe',
    mt: 'Total Ordni',
    cy: 'Cyfanswm y Gorchmynion',
    ro: 'Total Comenzi',
    it: 'Ordini Totali',
    zh_cn: '总订单',
    hi: 'कुल आदेश',
    ar: 'إجمالي الطلبات',
    bn: 'মোট আদেশ',
    ru: 'Общее Количество Заказов',
    ja: '総注文',
    tr: 'Toplam Sipariş',
    ko: '총 주문',
    vi: 'Tổng Số Đơn Hàng',
    id: 'Total Pesanan',
    th: 'คำสั่งซื้อทั้งหมด',
    ms: 'Jumlah Pesanan',
    ar_eg: 'إجمالي الطلبات',
    uk: 'Загальна Кількість Замовлень',
  },
  order: {
    en: 'Order',
    es: 'Pedido',
    fr: 'Commande',
    de: 'Bestellung',
    pt: 'Pedido',
    pl: 'Zamówienie',
    nl: 'Bestelling',
    el: 'Παραγγελία',
    cs: 'Objednávka',
    sv: 'Beställning',
    hu: 'Rendelés',
    da: 'Bestilling',
    fi: 'Tilaus',
    sk: 'Objednávka',
    bg: 'Поръчка',
    hr: 'Narudžba',
    lt: 'Užsakymas',
    lv: 'Pasūtījums',
    et: 'Tellimus',
    sl: 'Naročilo',
    ga: 'Ordú',
    mt: 'Ordni',
    cy: 'Archeb',
    ro: 'Comandă',
    it: 'Ordine',
    zh_cn: '订单',
    hi: 'ऑर्डर',
    ar: 'طلب',
    bn: 'অর্ডার',
    ru: 'Заказ',
    ja: '注文',
    tr: 'Sipariş',
    ko: '주문',
    vi: 'Đơn hàng',
    id: 'Pesanan',
    th: 'คำสั่งซื้อ',
    ms: 'Pesanan',
    ar_eg: 'طلب',
    uk: 'Замовлення',
  },
  orders: {
    en: 'Orders',
    es: 'Pedidos',
    fr: 'Commandes',
    de: 'Bestellungen',
    pt: 'Pedidos',
    pl: 'Zamówienia',
    nl: 'Bestellingen',
    el: 'Παραγγελίες',
    cs: 'Objednávky',
    sv: 'Beställningar',
    hu: 'Rendelések',
    da: 'Bestillinger',
    fi: 'Tilaukset',
    sk: 'Objednávky',
    bg: 'Поръчки',
    hr: 'Narudžbe',
    lt: 'Užsakymai',
    lv: 'Pasūtījumi',
    et: 'Tellimused',
    sl: 'Naročila',
    ga: 'Orduithe',
    mt: 'Ordijiet',
    cy: 'Archebion',
    ro: 'Comenzi',
    it: 'Ordini',
    zh_cn: '订单',
    hi: 'ऑर्डर',
    ar: 'الطلبات',
    bn: 'অর্ডার',
    ru: 'Заказы',
    ja: '注文',
    tr: 'Siparişler',
    ko: '주문',
    vi: 'Đơn hàng',
    id: 'Pesanan',
    th: 'คำสั่งซื้อ',
    ms: 'Pesanan',
    ar_eg: 'الطلبات',
    uk: 'Замовлення',
  },
  code: {
    en: 'Code',
    es: 'Código',
    fr: 'Code',
    de: 'Code',
    pt: 'Código',
    pl: 'Kod',
    nl: 'Code',
    el: 'Κωδικός',
    cs: 'Kód',
    sv: 'Kod',
    hu: 'Kód',
    da: 'Kode',
    fi: 'Koodi',
    sk: 'Kód',
    bg: 'Код',
    hr: 'Kod',
    lt: 'Kodas',
    lv: 'Kods',
    et: 'Kood',
    sl: 'Koda',
    ga: 'Cód',
    mt: 'Kodiċi',
    cy: 'Cod',
    ro: 'Cod',
    it: 'Codice',
    zh_cn: '代码',
    hi: 'कोड',
    ar: 'رمز',
    bn: 'কোড',
    ru: 'Код',
    ja: 'コード',
    tr: 'Kod',
    ko: '코드',
    vi: 'Mã',
    id: 'Kode',
    th: 'รหัส',
    ms: 'Kod',
    ar_eg: 'كود',
    uk: 'Код',
  },
  order_playing_type: {
    until_order_accept: {
      en: 'Until the order is accepted',
      es: 'Hasta aceptar el pedido',
      fr: "Jusqu'à acceptation de la commande",
      de: 'Bis zur Annahme der Bestellung',
      pt: 'Até aceitar o pedido',
      pl: 'Do momentu przyjęcia zamówienia',
      nl: 'Tot bestelling geaccepteerd',
      el: 'Μέχρι την αποδοχή της παραγγελίας',
      cs: 'Dokud není objednávka přijata',
      sv: 'Tills ordern accepteras',
      hu: 'A rendelés elfogadásáig',
      da: 'Indtil ordren accepteres',
      fi: 'Kunnes tilaus hyväksytään',
      sk: 'Až do prijatia objednávky',
      bg: 'До приемане на поръчката',
      hr: 'Dok se narudžba ne prihvati',
      lt: 'Kol priimamas užsakymas',
      lv: 'Līdz pasūtījuma apstiprināšanai',
      et: 'Kuni tellimus on vastu võetud',
      sl: 'Dokler ne sprejmete naročila',
      ga: 'Go dtí go nglactar leis an ordú',
      mt: 'Sakemm tiġi aċċettata l-ordni',
      cy: 'Nes bod yr archeb yn cael ei dderbyn',
      ro: 'Până la acceptarea comenzii',
      it: "Fino all'accettazione dell'ordine",
      zh_cn: '直到订单接受',
      hi: 'आदेश स्वीकार होने तक',
      ar: 'حتى قبول الطلب',
      bn: 'অর্ডার গ্রহণ না করা পর্যন্ত',
      ru: 'До принятия заказа',
      ja: '注文を受け入れるまで',
      tr: 'Sipariş kabul edilene kadar',
      ko: '주문이 수락될 때까지',
      vi: 'Cho đến khi nhận đơn hàng',
      id: 'Hingga pesanan diterima',
      th: 'จนกว่าจะรับคำสั่งซื้อ',
      ms: 'Sehingga pesanan diterima',
      ar_eg: 'حتى قبول الطلب',
      uk: 'До прийняття замовлення',
    },
    only_once: {
      en: 'Only once',
      es: 'Solo una vez',
      fr: 'Une seule fois',
      de: 'Nur einmal',
      pt: 'Apenas uma vez',
      pl: 'Tylko raz',
      nl: 'Slechts één keer',
      el: 'Μόνο μία φορά',
      cs: 'Pouze jednou',
      sv: 'Endast en gång',
      hu: 'Csak egyszer',
      da: 'Kun én gang',
      fi: 'Vain kerran',
      sk: 'Iba raz',
      bg: 'Само веднъж',
      hr: 'Samo jednom',
      lt: 'Tik vieną kartą',
      lv: 'Tikai vienreiz',
      et: 'Ainult üks kord',
      sl: 'Samo enkrat',
      ga: 'Ach uair amháin',
      mt: 'Darba waħda biss',
      cy: 'Dim ond unwaith',
      ro: 'O singură dată',
      it: 'Solo una volta',
      zh_cn: '仅一次',
      hi: 'केवल एक बार',
      ar: 'مرة واحدة فقط',
      bn: 'শুধু একবার',
      ru: 'Только один раз',
      ja: '一度だけ',
      tr: 'Sadece bir kez',
      ko: '단 한 번',
      vi: 'Chỉ một lần',
      id: 'Hanya sekali',
      th: 'เพียงครั้งเดียว',
      ms: 'Hanya sekali',
      ar_eg: 'مرة واحدة فقط',
      uk: 'Лише один раз',
    },
    no_sound: {
      en: 'No sound',
      es: 'Sin sonido',
      fr: 'Pas de son',
      de: 'Kein Ton',
      pt: 'Sem som',
      pl: 'Brak dźwięku',
      nl: 'Geen geluid',
      el: 'Χωρίς ήχο',
      cs: 'Žádný zvuk',
      sv: 'Inget ljud',
      hu: 'Nincs hang',
      da: 'Ingen lyd',
      fi: 'Ei ääntä',
      sk: 'Žiadny zvuk',
      bg: 'Без звук',
      hr: 'Nema zvuka',
      lt: 'Be garso',
      lv: 'Nav skaņas',
      et: 'Heli puudub',
      sl: 'Brez zvoka',
      ga: 'Gan aon fhuaim',
      mt: 'L-ebda ħoss',
      cy: 'Dim sain',
      ro: 'Fără sunet',
      it: 'Nessun suono',
      zh_cn: '无声音',
      hi: 'कोई ध्वनि नहीं',
      ar: 'بدون صوت',
      bn: 'কোনো শব্দ নেই',
      ru: 'Без звука',
      ja: 'サウンドなし',
      tr: 'Ses yok',
      ko: '소리 없음',
      vi: 'Không âm thanh',
      id: 'Tidak ada suara',
      th: 'ไม่มีเสียง',
      ms: 'Tiada bunyi',
      ar_eg: 'بدون صوت',
      uk: 'Без звуку',
    },
  },
  play: {
    en: 'Play',
    es: 'Reproducir',
    fr: 'Lire',
    de: 'Abspielen',
    pt: 'Reproduzir',
    pl: 'Odtwórz',
    nl: 'Afspelen',
    el: 'Αναπαραγωγή',
    cs: 'Přehrát',
    sv: 'Spela',
    hu: 'Lejátszás',
    da: 'Afspil',
    fi: 'Toista',
    sk: 'Prehrať',
    bg: 'Пусни',
    hr: 'Pusti',
    lt: 'Leisti',
    lv: 'Atskaņot',
    et: 'Esita',
    sl: 'Predvajaj',
    ga: 'Seinn',
    mt: 'Ilgħab',
    cy: 'Chwarae',
    ro: 'Redă',
    it: 'Riproduci',
    zh_cn: '播放',
    hi: 'चलाएं',
    ar: 'تشغيل',
    bn: 'বাজান',
    ru: 'Воспроизвести',
    ja: '再生',
    tr: 'Oynat',
    ko: '재생',
    vi: 'Phát',
    id: 'Putar',
    th: 'เล่น',
    ms: 'Main',
    ar_eg: 'تشغيل',
    uk: 'Відтворити',
  },
  back_to_default: {
    en: 'Back to Default',
    es: 'Volver a los valores predeterminados',
    fr: 'Revenir à la valeur par défaut',
    de: 'Zurück zur Standardansicht',
    pt: 'Voltar ao Padrão',
    pl: 'Powrót do ustawień domyślnych',
    nl: 'Terug naar standaardinstellingen',
    el: 'Επιστροφή στις προεπιλογές',
    cs: 'Zpět na výchozí',
    sv: 'Återställ till standard',
    hu: 'Vissza az alapértelmezett beállításhoz',
    da: 'Tilbage til standard',
    fi: 'Palauta oletusasetukset',
    sk: 'Späť na predvolené',
    bg: 'Връщане към стандартните настройки',
    hr: 'Povratak na zadano',
    lt: 'Grįžti į numatytąjį',
    lv: 'Atgriezties pie noklusējuma iestatījumiem',
    et: 'Tagasi vaikeväärtuse juurde',
    sl: 'Nazaj na privzeto',
    ga: 'Ar ais go réamhshocrú',
    mt: 'Lura għall-Default',
    cy: 'Yn ôl i Rhagosodiad',
    ro: 'Înapoi la setările implicite',
    it: 'Torna a Predefinito',
    zh_cn: '恢复默认',
    hi: 'डिफ़ॉल्ट पर वापस जाएं',
    ar: 'العودة إلى الافتراضي',
    bn: 'ডিফল্টে ফিরে যান',
    ru: 'Вернуться к настройкам по умолчанию',
    ja: 'デフォルトに戻す',
    tr: 'Varsayılana Geri Dön',
    ko: '기본값으로 되돌리기',
    vi: 'Quay lại mặc định',
    id: 'Kembali ke Default',
    th: 'กลับไปที่ค่าเริ่มต้น',
    ms: 'Kembali ke Lalai',
    ar_eg: 'الرجوع إلى الافتراضي',
    uk: 'Повернутися до стандартних',
  },
  column_layout: {
    en: 'Column Layout',
    es: 'Disposición de Columnas',
    fr: 'Disposition des Colonnes',
    de: 'Spaltenlayout',
    pt: 'Layout de Coluna',
    pl: 'Układ Kolumn',
    nl: 'Kolomindeling',
    el: 'Διάταξη Στήλης',
    cs: 'Rozvržení Sloupců',
    sv: 'Kolumnlayout',
    hu: 'Oszlopelrendezés',
    da: 'Kolonne Layout',
    fi: 'Sarakkeiden Asettelu',
    sk: 'Rozloženie Stĺpcov',
    bg: 'Оформление на Колони',
    hr: 'Izgled Stupca',
    lt: 'Stulpelių Išdėstymas',
    lv: 'Kolonnu Izkārtojums',
    et: 'Veeru Paigutus',
    sl: 'Postavitev Stolpcev',
    ga: 'Leagan Colúin',
    mt: 'Tqassim tal-Kolonna',
    cy: 'Gosodiad Colofnau',
    ro: 'Configurația Coloanelor',
    it: 'Layout Colonna',
    zh_cn: '列布局',
    hi: 'कॉलम लेआउट',
    ar: 'تخطيط الأعمدة',
    bn: 'কলাম বিন্যাস',
    ru: 'Макет Колонок',
    ja: '列のレイアウト',
    tr: 'Sütun Düzeni',
    ko: '열 레이아웃',
    vi: 'Bố Cục Cột',
    id: 'Tata Letak Kolom',
    th: 'เค้าโครงคอลัมน์',
    ms: 'Tata Letak Lajur',
    ar_eg: 'تخطيط الأعمدة',
    uk: 'Макет Стовпців',
  },
  unavailable: {
    en: 'Unavailable',
    es: 'No disponible',
    fr: 'Indisponible',
    de: 'Nicht verfügbar',
    pt: 'Indisponível',
    pl: 'Niedostępny',
    nl: 'Niet beschikbaar',
    el: 'Μη διαθέσιμο',
    cs: 'Nedostupné',
    sv: 'Otillgänglig',
    hu: 'Nem elérhető',
    da: 'Ikke tilgængelig',
    fi: 'Ei saatavilla',
    sk: 'Nedostupné',
    bg: 'Неналично',
    hr: 'Nedostupno',
    lt: 'Nepasiekiamas',
    lv: 'Nav pieejams',
    et: 'Pole saadaval',
    sl: 'Ni na voljo',
    ga: 'Níl ar fáil',
    mt: 'Mhux disponibbli',
    cy: 'Heb ei gael',
    ro: 'Indisponibil',
    it: 'Non disponibile',
    zh_cn: '不可用',
    hi: 'उपलब्ध नहीं है',
    ar: 'غير متاح',
    bn: 'অনুপলব্ধ',
    ru: 'Недоступно',
    ja: '利用できません',
    tr: 'Mevcut değil',
    ko: '사용할 수 없음',
    vi: 'Không có sẵn',
    id: 'Tidak tersedia',
    th: 'ไม่พร้อมใช้งาน',
    ms: 'Tidak tersedia',
    ar_eg: 'غير متاح',
    uk: 'Недоступно',
  },
  modifiers: {
    en: 'Modifiers',
    es: 'Modificadores',
    fr: 'Modificateurs',
    de: 'Modifikatoren',
    pt: 'Modificadores',
    pl: 'Modyfikatory',
    nl: 'Aanpassingen',
    el: 'Τροποποιητές',
    cs: 'Modifikátory',
    sv: 'Modifierare',
    hu: 'Módosítók',
    da: 'Modifikatorer',
    fi: 'Muuntimet',
    sk: 'Modifikátory',
    bg: 'Модификатори',
    hr: 'Modifikatori',
    lt: 'Modifikatoriai',
    lv: 'Modifikatori',
    et: 'Modifikaatorid',
    sl: 'Modifikatorji',
    ga: 'Modhnóirí',
    mt: 'Modifikaturi',
    cy: 'Addasyddion',
    ro: 'Modificatori',
    it: 'Modificatori',
    zh_cn: '修饰符',
    hi: 'परिवर्तक',
    ar: 'المُعدِّلات',
    bn: 'পরিবর্তক',
    ru: 'Модификаторы',
    ja: '修飾子',
    tr: 'Değiştiriciler',
    ko: '수정자들',
    vi: 'Bộ sửa đổi',
    id: 'Modifikator',
    th: 'ตัวดัดแปลง',
    ms: 'Pengubah',
    ar_eg: 'المُعدِّلات',
    uk: 'Модифікатори',
  },
  discounts: {
    en: 'Discounts',
    es: 'Descuentos',
    fr: 'Remises',
    de: 'Rabatte',
    pt: 'Descontos',
    pl: 'Zniżki',
    nl: 'Kortingen',
    el: 'Εκπτώσεις',
    cs: 'Slevy',
    sv: 'Rabatter',
    hu: 'Kedvezmények',
    da: 'Rabatter',
    fi: 'Alennukset',
    sk: 'Zľavy',
    bg: 'Отстъпки',
    hr: 'Popusti',
    lt: 'Nuolaidos',
    lv: 'Atlaides',
    et: 'Soodustused',
    sl: 'Popusti',
    ga: 'Lascainí',
    mt: 'Skontijiet',
    cy: 'Gostyngiadau',
    ro: 'Reduceri',
    it: 'Sconti',
    zh_cn: '折扣',
    hi: 'छूट',
    ar: 'الخصومات',
    bn: 'ছাড়',
    ru: 'Скидки',
    ja: '割引',
    tr: 'İndirimler',
    ko: '할인',
    vi: 'Giảm giá',
    id: 'Diskon',
    th: 'ส่วนลด',
    ms: 'Diskaun',
    ar_eg: 'الخصومات',
    uk: 'Знижки',
  },
  deductions: {
    en: 'Deductions',
    es: 'Deducciones',
    fr: 'Déductions',
    de: 'Abzüge',
    pt: 'Deduções',
    pl: 'Odliczenia',
    nl: 'Aftrekken',
    el: 'Εκπτώσεις',
    cs: 'Odpočty',
    sv: 'Avdrag',
    hu: 'Levonások',
    da: 'Fradrag',
    fi: 'Vähennykset',
    sk: 'Odpočty',
    bg: 'Приспадания',
    hr: 'Odbici',
    lt: 'Atskaitymai',
    lv: 'Atskaitījumi',
    et: 'Mahaarvamised',
    sl: 'Odbitki',
    ga: 'Asbhaintí',
    mt: 'Tnaqqisiet',
    cy: 'Didyniadau',
    ro: 'Deduceri',
    it: 'Detrazioni',
    zh_cn: '扣除项',
    hi: 'कटौतियाँ',
    ar: 'خصومات',
    bn: 'কর্তনসমূহ',
    ru: 'Вычеты',
    ja: '控除',
    tr: 'Kesintiler',
    ko: '공제',
    vi: 'Các khoản khấu trừ',
    id: 'Potongan',
    th: 'รายการหักลด',
    ms: 'Potongan',
    ar_eg: 'خصومات',
    uk: 'Відрахування',
  },
  stock_control: {
    en: 'Stock Control',
    es: 'Control de Inventario',
    fr: 'Gestion des Stocks',
    de: 'Bestandskontrolle',
    pt: 'Controle de Estoque',
    pl: 'Kontrola Zapasów',
    nl: 'Voorraadbeheer',
    el: 'Έλεγχος Αποθεμάτων',
    cs: 'Kontrola Zásob',
    sv: 'Lagerkontroll',
    hu: 'Készletkezelés',
    da: 'Lagerkontrol',
    fi: 'Varastonhallinta',
    sk: 'Kontrola Zásob',
    bg: 'Контрол на Складовите Наличности',
    hr: 'Kontrola Zaliha',
    lt: 'Atsargų Kontrolė',
    lv: 'Krājumu Kontrole',
    et: 'Varude Kontroll',
    sl: 'Nadzor Zaloge',
    ga: 'Rialú Stoc',
    mt: 'Kontroll tal-Istokk',
    cy: 'Rheoli Stoc',
    ro: 'Controlul Stocurilor',
    it: 'Controllo delle Scorte',
    zh_cn: '库存控制',
    hi: 'स्टॉक नियंत्रण',
    ar: 'التحكم في المخزون',
    bn: 'স্টক নিয়ন্ত্রণ',
    ru: 'Контроль Запасов',
    ja: '在庫管理',
    tr: 'Stok Kontrolü',
    ko: '재고 관리',
    vi: 'Kiểm Soát Hàng Tồn',
    id: 'Kontrol Stok',
    th: 'การควบคุมสต็อก',
    ms: 'Kawalan Stok',
    ar_eg: 'التحكم في المخزون',
    uk: 'Контроль Запасів',
  },
  journals: {
    en: 'Journals',
    es: 'Diarios',
    fr: 'Journaux',
    de: 'Journale',
    pt: 'Diários',
    pl: 'Dzienniki',
    nl: 'Journaals',
    el: 'Ημερολόγια',
    cs: 'Deníky',
    sv: 'Journaler',
    hu: 'Naplók',
    da: 'Journaler',
    fi: 'Päiväkirjat',
    sk: 'Denníky',
    bg: 'Дневници',
    hr: 'Dnevnici',
    lt: 'Žurnalai',
    lv: 'Žurnāli',
    et: 'Päevikud',
    sl: 'Dnevniki',
    ga: 'Irisí',
    mt: 'Ġurnali',
    cy: 'Cylchgronau',
    ro: 'Jurnale',
    it: 'Giornali',
    zh_cn: '日记',
    hi: 'पत्रिकाएँ',
    ar: 'المجلات',
    bn: 'জার্নাল',
    ru: 'Журналы',
    ja: 'ジャーナル',
    tr: 'Günlükler',
    ko: '저널',
    vi: 'Nhật ký',
    id: 'Jurnal',
    th: 'วารสาร',
    ms: 'Jurnal',
    ar_eg: 'السجلات',
    uk: 'Журнали',
  },
  accounting_charts: {
    en: 'Accounting Charts',
    es: 'Gráficos Contables',
    fr: 'Graphiques Comptables',
    de: 'Buchhaltungstabellen',
    pt: 'Gráficos Contábeis',
    pl: 'Wykresy Księgowe',
    nl: "Boekhoudschema's",
    el: 'Λογιστικά Διαγράμματα',
    cs: 'Účetní Grafy',
    sv: 'Redovisningsdiagram',
    hu: 'Könyvelési Diagramok',
    da: 'Regnskabsdiagrammer',
    fi: 'Kirjanpitokaaviot',
    sk: 'Účtovné Grafy',
    bg: 'Счетоводни Диаграми',
    hr: 'Računovodstveni Grafikoni',
    lt: 'Apskaitos Diagramos',
    lv: 'Grāmatvedības Diagrammas',
    et: 'Raamatupidamise Diagrammid',
    sl: 'Računovodski Diagrami',
    ga: 'Cairteacha Cuntasaíochta',
    mt: 'Ċarts tal-Kontabbiltà',
    cy: 'Siartiau Cyfrifeg',
    ro: 'Grafice Contabile',
    it: 'Grafici Contabili',
    zh_cn: '会计图表',
    hi: 'लेखा चार्ट्स',
    ar: 'الرسوم البيانية المحاسبية',
    bn: 'হিসাবের চার্ট',
    ru: 'Бухгалтерские Диаграммы',
    ja: '会計チャート',
    tr: 'Muhasebe Tabloları',
    ko: '회계 차트',
    vi: 'Biểu Đồ Kế Toán',
    id: 'Bagan Akuntansi',
    th: 'แผนภูมิการบัญชี',
    ms: 'Carta Perakaunan',
    ar_eg: 'الرسوم البيانية المحاسبية',
    uk: 'Бухгалтерські Графіки',
  },
  cash_flow: {
    en: 'Cash Flow Statement',
    es: 'Estado de Flujo de Efectivo',
    fr: 'Tableau des Flux de Trésorerie',
    de: 'Kapitalflussrechnung',
    pt: 'Demonstração do Fluxo de Caixa',
    pl: 'Rachunek Przepływów Pieniężnych',
    nl: 'Kasstroomoverzicht',
    el: 'Κατάσταση Ταμειακών Ροών',
    cs: 'Přehled Peněžních Toků',
    sv: 'Kassaflödesanalys',
    hu: 'Cash Flow Kimutatás',
    da: 'Pengestrømsopgørelse',
    fi: 'Kassavirtalaskelma',
    sk: 'Prehľad Peňažných Tokov',
    bg: 'Отчет за Паричните Потокове',
    hr: 'Izvještaj o Novčanom Toku',
    lt: 'Pinigų Srautų Ataskaita',
    lv: 'Naudas Plūsmas Pārskats',
    et: 'Rahahulude Aruanne',
    sl: 'Izkaz Denarnih Tokov',
    ga: 'Ráiteas Sreafa Airgid',
    mt: 'Dikjarazzjoni tal-Fluss tal-Flus',
    cy: 'Datganiad Llif Arian',
    ro: 'Situația Fluxurilor de Trezorerie',
    it: 'Rendiconto Finanziario',
    zh_cn: '现金流量表',
    hi: 'नकदी प्रवाह विवरण',
    ar: 'بيان التدفقات النقدية',
    bn: 'নগদ প্রবাহ বিবরণী',
    ru: 'Отчет о Движении Денежных Средств',
    ja: 'キャッシュフロー計算書',
    tr: 'Nakit Akış Tablosu',
    ko: '현금 흐름표',
    vi: 'Báo Cáo Lưu Chuyển Tiền Tệ',
    id: 'Laporan Arus Kas',
    th: 'งบกระแสเงินสด',
    ms: 'Penyata Aliran Tunai',
    ar_eg: 'بيان التدفقات النقدية',
    uk: 'Звіт про Рух Грошових Коштів',
  },
  profit_and_loss: {
    en: 'Profit & Loss',
    es: 'Pérdidas & Ganancias',
    fr: 'Résultat & Pertes',
    de: 'Gewinn & Verlust',
    pt: 'Lucros & Perdas',
    pl: 'Zysk & Strata',
    nl: 'Winst & Verlies',
    el: 'Κέρδη & Ζημίες',
    cs: 'Zisk & Ztráta',
    sv: 'Vinst & Förlust',
    hu: 'Nyereség & Veszteség',
    da: 'Overskud & Tab',
    fi: 'Voitto & Tappio',
    sk: 'Zisk & Strata',
    bg: 'Печалба & Загуба',
    hr: 'Dobit & Gubitak',
    lt: 'Pelnas & Nuostolis',
    lv: 'Peļņa & Zaudējumi',
    et: 'Kasum & Kahjum',
    sl: 'Dobiček & Izguba',
    ga: 'Brabús & Caillteanas',
    mt: 'Qligħ & Telf',
    cy: 'Elw & Colled',
    ro: 'Profit & Pierdere',
    it: 'Utile & Perdita',
    zh_cn: '利润 & 损失',
    hi: 'लाभ & हानि',
    ar: 'الربح & الخسارة',
    bn: 'লাভ & ক্ষতি',
    ru: 'Прибыль & Убыток',
    ja: '利益 & 損失',
    tr: 'Kar & Zarar',
    ko: '수익 & 손실',
    vi: 'Lãi & Lỗ',
    id: 'Laba & Rugi',
    th: 'กำไร & ขาดทุน',
    ms: 'Untung & Rugi',
    ar_eg: 'الربح & الخسارة',
    uk: 'Прибуток & Збиток',
  },
  customer_list: {
    en: 'Customer List',
    es: 'Lista de Clientes',
    fr: 'Liste des Clients',
    de: 'Kundenliste',
    pt: 'Lista de Clientes',
    pl: 'Lista Klientów',
    nl: 'Klantenlijst',
    el: 'Λίστα Πελατών',
    cs: 'Seznam Zákazníků',
    sv: 'Kundlista',
    hu: 'Vevőlista',
    da: 'Kundeliste',
    fi: 'Asiakaslista',
    sk: 'Zoznam Zákazníkov',
    bg: 'Списък с Клиенти',
    hr: 'Popis Kupaca',
    lt: 'Klientų Sąrašas',
    lv: 'Klientu Saraksts',
    et: 'Kliendinimekiri',
    sl: 'Seznam Strank',
    ga: 'Liosta Custaiméirí',
    mt: 'Lista tal-Klijenti',
    cy: 'Rhestr Cwsmeriaid',
    ro: 'Lista Clienților',
    it: 'Elenco Clienti',
    zh_cn: '客户名单',
    hi: 'ग्राहक सूची',
    ar: 'قائمة العملاء',
    bn: 'গ্রাহকের তালিকা',
    ru: 'Список Клиентов',
    ja: '顧客リスト',
    tr: 'Müşteri Listesi',
    ko: '고객 목록',
    vi: 'Danh Sách Khách Hàng',
    id: 'Daftar Pelanggan',
    th: 'รายชื่อลูกค้า',
    ms: 'Senarai Pelanggan',
    ar_eg: 'قائمة العملاء',
    uk: 'Список Клієнтів',
  },
  dashboard: {
    en: 'Dashboard',
    es: 'Panel de Control',
    fr: 'Tableau de Bord',
    de: 'Instrumententafel',
    pt: 'Painel de Controle',
    pl: 'Pulpit',
    nl: 'Dashboard',
    el: 'Πίνακας Ελέγχου',
    cs: 'Řídicí Panel',
    sv: 'Instrumentpanel',
    hu: 'Irányítópult',
    da: 'Instrumentbræt',
    fi: 'Hallintapaneeli',
    sk: 'Ovládací Panel',
    bg: 'Табло',
    hr: 'Nadzorna Ploča',
    lt: 'Prietaisų Skydelis',
    lv: 'Pārskata Panelis',
    et: 'Töölaud',
    sl: 'Nadzorna Plošča',
    ga: 'Painéal',
    mt: 'Pannell ta’ Kontroll',
    cy: 'Dangosfwrdd',
    ro: 'Tablou de Bord',
    it: 'Cruscotto',
    zh_cn: '仪表板',
    hi: 'डैशबोर्ड',
    ar: 'لوحة القيادة',
    bn: 'ড্যাশবোর্ড',
    ru: 'Панель Управления',
    ja: 'ダッシュボード',
    tr: 'Gösterge Paneli',
    ko: '대시보드',
    vi: 'Bảng Điều Khiển',
    id: 'Dasbor',
    th: 'แผงควบคุม',
    ms: 'Papan Pemuka',
    ar_eg: 'لوحة القيادة',
    uk: 'Панель Управління',
  },
  manage_availability: {
    en: 'Manage Availability',
    es: 'Gestionar Disponibilidad',
    fr: 'Gérer la Disponibilité',
    de: 'Verfügbarkeit Verwalten',
    pt: 'Gerenciar Disponibilidade',
    pl: 'Zarządzaj Dostępnością',
    nl: 'Beschikbaarheid Beheren',
    el: 'Διαχείριση Διαθεσιμότητας',
    cs: 'Spravovat Dostupnost',
    sv: 'Hantera Tillgänglighet',
    hu: 'Elérhetőség Kezelése',
    da: 'Administrer Tilgængelighed',
    fi: 'Hallinnoi Saatavuutta',
    sk: 'Spravovať Dostupnosť',
    bg: 'Управление на Наличността',
    hr: 'Upravljanje Dostupnošću',
    lt: 'Tvarkyti Prieinamumą',
    lv: 'Pārvaldīt Pieejamību',
    et: 'Haldage Saadavust',
    sl: 'Upravljanje Razpoložljivosti',
    ga: 'Bainistigh ar an Infhaighteacht',
    mt: 'Immaniġġja d-Disponibbiltà',
    cy: 'Rheoli Argaeledd',
    ro: 'Gestionați Disponibilitatea',
    it: 'Gestisci la Disponibilità',
    zh_cn: '管理可用性',
    hi: 'उपलब्धता प्रबंधित करें',
    ar: 'إدارة التوفر',
    bn: 'উপলব্ধতা পরিচালনা করুন',
    ru: 'Управление Доступностью',
    ja: '可用性を管理する',
    tr: 'Kullanılabilirliği Yönet',
    ko: '가용성 관리',
    vi: 'Quản Lý Tính Khả Dụng',
    id: 'Kelola Ketersediaan',
    th: 'จัดการความพร้อมใช้งาน',
    ms: 'Urus Ketersediaan',
    ar_eg: 'إدارة التوفر',
    uk: 'Керувати Доступністю',
  },
  menu_library: {
    en: 'Menu Library',
    es: 'Biblioteca de Menús',
    fr: 'Bibliothèque de Menus',
    de: 'Menübibliothek',
    pt: 'Biblioteca de Menus',
    pl: 'Biblioteka Menu',
    nl: 'Menubibliotheek',
    el: 'Βιβλιοθήκη Μενού',
    cs: 'Knihovna Nabídek',
    sv: 'Menybibliotek',
    hu: 'Menükönyvtár',
    da: 'Menubibliotek',
    fi: 'Valikkokirjasto',
    sk: 'Knižnica Menu',
    bg: 'Библиотека с Менюта',
    hr: 'Knjižnica Jelovnika',
    lt: 'Meniu Biblioteka',
    lv: 'Izvēlņu Bibliotēka',
    et: 'Menüüraamatukogu',
    sl: 'Knjižnica Menijev',
    ga: 'Leabharlann Roghchlár',
    mt: 'Librerija tal-Menù',
    cy: 'Llyfrgell Ddewislenni',
    ro: 'Biblioteca de Meniuri',
    it: 'Libreria del Menù',
    zh_cn: '菜单库',
    hi: 'मेनू पुस्तकालय',
    ar: 'مكتبة القوائم',
    bn: 'মেনু গ্রন্থাগার',
    ru: 'Библиотека Меню',
    ja: 'メニューライブラリ',
    tr: 'Menü Kütüphanesi',
    ko: '메뉴 라이브러리',
    vi: 'Thư Viện Thực Đơn',
    id: 'Perpustakaan Menu',
    th: 'ห้องสมุดเมนู',
    ms: 'Perpustakaan Menu',
    ar_eg: 'مكتبة القوائم',
    uk: 'Бібліотека Меню',
  },
  order_management: {
    en: 'Order Management',
    es: 'Gestión de Pedidos',
    fr: 'Gestion des Commandes',
    de: 'Bestellverwaltung',
    pt: 'Gestão de Pedidos',
    pl: 'Zarządzanie Zamówieniami',
    nl: 'Bestelbeheer',
    el: 'Διαχείριση Παραγγελιών',
    cs: 'Správa Objednávek',
    sv: 'Orderhantering',
    hu: 'Rendeléskezelés',
    da: 'Ordrestyring',
    fi: 'Tilausten Hallinta',
    sk: 'Správa Objednávok',
    bg: 'Управление на Поръчките',
    hr: 'Upravljanje Narudžbama',
    lt: 'Užsakymų Valdymas',
    lv: 'Pasūtījumu Pārvaldība',
    et: 'Tellimuste Haldus',
    sl: 'Upravljanje Naročil',
    ga: 'Bainistíocht Orduithe',
    mt: 'Ġestjoni tal-Ordni',
    cy: 'Rheoli Gorchmynion',
    ro: 'Gestionarea Comenzilor',
    it: 'Gestione degli Ordini',
    zh_cn: '订单管理',
    hi: 'ऑर्डर प्रबंधन',
    ar: 'إدارة الطلبات',
    bn: 'অর্ডার ব্যবস্থাপনা',
    ru: 'Управление Заказами',
    ja: '注文管理',
    tr: 'Sipariş Yönetimi',
    ko: '주문 관리',
    vi: 'Quản Lý Đơn Hàng',
    id: 'Manajemen Pesanan',
    th: 'การจัดการคำสั่งซื้อ',
    ms: 'Pengurusan Pesanan',
    ar_eg: 'إدارة الطلبات',
    uk: 'Управління Замовленнями',
  },
  table_management: {
    en: 'Table Management',
    es: 'Gestión de mesas',
    fr: 'Gestion des tables',
    de: 'Tischverwaltung',
    pt: 'Gestão de mesas',
    pl: 'Zarządzanie stolikami',
    nl: 'Tafelbeheer',
    el: 'Διαχείριση τραπεζιών',
    cs: 'Správa stolů',
    sv: 'Bordshantering',
    hu: 'Asztalkezelés',
    da: 'Bordadministration',
    fi: 'Pöytien hallinta',
    sk: 'Správa stolov',
    bg: 'Управление на маси',
    hr: 'Upravljanje stolovima',
    lt: 'Stalų valdymas',
    lv: 'Galdu pārvaldība',
    et: 'Laudade haldamine',
    sl: 'Upravljanje miz',
    ga: 'Bainistíocht táblaí',
    mt: 'Ġestjoni tal-imwejjed',
    cy: 'Rheoli byrddau',
    ro: 'Gestionarea meselor',
    it: 'Gestione dei tavoli',
    zh_cn: '桌位管理',
    hi: 'टेबल प्रबंधन',
    ar: 'إدارة الطاولات',
    bn: 'টেবিল ব্যবস্থাপনা',
    ru: 'Управление столами',
    ja: 'テーブル管理',
    tr: 'Masa Yönetimi',
    ko: '테이블 관리',
    vi: 'Quản lý bàn',
    id: 'Manajemen meja',
    th: 'การจัดการโต๊ะ',
    ms: 'Pengurusan meja',
    ar_eg: 'إدارة الطاولات',
    uk: 'Керування столами',
  },
  active_orders: {
    en: 'Active Orders',
    es: 'Pedidos Activos',
    fr: 'Commandes Actives',
    de: 'Aktive Bestellungen',
    pt: 'Pedidos Ativos',
    pl: 'Aktywne Zamówienia',
    nl: 'Actieve Bestellingen',
    el: 'Ενεργές Παραγγελίες',
    cs: 'Aktivní Objednávky',
    sv: 'Aktiva Beställningar',
    hu: 'Aktív Rendelések',
    da: 'Aktive Ordrer',
    fi: 'Aktiiviset Tilaukset',
    sk: 'Aktívne Objednávky',
    bg: 'Активни Поръчки',
    hr: 'Aktivne Narudžbe',
    lt: 'Aktyvūs Užsakymai',
    lv: 'Aktīvie Pasūtījumi',
    et: 'Aktiivsed Tellimused',
    sl: 'Aktivna Naročila',
    ga: 'Orduithe Gníomhacha',
    mt: 'Ordijiet Attivi',
    cy: 'Archebion Gweithredol',
    ro: 'Comenzi Active',
    it: 'Ordini Attivi',
    zh_cn: '活跃订单',
    hi: 'सक्रिय आदेश',
    ar: 'الطلبات النشطة',
    bn: 'সক্রিয় অর্ডার',
    ru: 'Активные Заказы',
    ja: 'アクティブ注文',
    tr: 'Aktif Siparişler',
    ko: '활성 주문',
    vi: 'Đơn Hàng Đang Hoạt Động',
    id: 'Pesanan Aktif',
    th: 'คำสั่งซื้อที่ใช้งานอยู่',
    ms: 'Pesanan Aktif',
    ar_eg: 'الطلبات النشطة',
    uk: 'Активні Замовлення',
  },
  order_history: {
    en: 'Order History',
    es: 'Historial de Pedidos',
    fr: 'Historique des Commandes',
    de: 'Bestellverlauf',
    pt: 'Histórico de Pedidos',
    pl: 'Historia Zamówień',
    nl: 'Bestelgeschiedenis',
    el: 'Ιστορικό Παραγγελιών',
    cs: 'Historie Objednávek',
    sv: 'Orderhistorik',
    hu: 'Rendelési Előzmények',
    da: 'Ordrehistorik',
    fi: 'Tilaushistoria',
    sk: 'História Objednávok',
    bg: 'История на Поръчките',
    hr: 'Povijest Narudžbi',
    lt: 'Užsakymų Istorija',
    lv: 'Pasūtījumu Vēsture',
    et: 'Tellimuste Ajalugu',
    sl: 'Zgodovina Naročil',
    ga: 'Stair na nOrduithe',
    mt: 'Storja tal-Ordni',
    cy: 'Hanes Archebion',
    ro: 'Istoricul Comenzilor',
    it: 'Storico Ordini',
    zh_cn: '订单历史',
    hi: 'ऑर्डर इतिहास',
    ar: 'تاريخ الطلبات',
    bn: 'অর্ডার ইতিহাস',
    ru: 'История Заказов',
    ja: '注文履歴',
    tr: 'Sipariş Geçmişi',
    ko: '주문 내역',
    vi: 'Lịch Sử Đơn Hàng',
    id: 'Riwayat Pesanan',
    th: 'ประวัติการสั่งซื้อ',
    ms: 'Sejarah Pesanan',
    ar_eg: 'سجل الطلبات',
    uk: 'Історія Замовлень',
  },
  hourly_sales: {
    en: 'Hourly Sales',
    es: 'Ventas por Hora',
    fr: 'Ventes Horaires',
    de: 'Stündliche Verkäufe',
    pt: 'Vendas por Hora',
    pl: 'Sprzedaż Godzinowa',
    nl: 'Uurverkopen',
    el: 'Ωριαίες Πωλήσεις',
    cs: 'Hodinové Prodeje',
    sv: 'Timförsäljning',
    hu: 'Óránkénti Eladások',
    da: 'Timebaseret Salg',
    fi: 'Tuntimyynti',
    sk: 'Hodinový Predaj',
    bg: 'Почасови Продажби',
    hr: 'Prodaja po Satu',
    lt: 'Valandiniai Pardavimai',
    lv: 'Stundas Pārdošana',
    et: 'Tunnimüük',
    sl: 'Urna Prodaja',
    ga: 'Díolacháin Uaireanta',
    mt: 'Bejgħ Kull Siegħa',
    cy: 'Gwerthiannau Fesul Awr',
    ro: 'Vânzări pe Oră',
    it: 'Vendite Orarie',
    zh_cn: '每小时销售',
    hi: 'प्रति घंटा बिक्री',
    ar: 'المبيعات بالساعة',
    bn: 'প্রতি ঘন্টায় বিক্রয়',
    ru: 'Почасовые Продажи',
    ja: '時間別売上',
    tr: 'Saatlik Satışlar',
    ko: '시간당 매출',
    vi: 'Doanh Số Theo Giờ',
    id: 'Penjualan per Jam',
    th: 'ยอดขายรายชั่วโมง',
    ms: 'Jualan Mengikut Jam',
    ar_eg: 'المبيعات بالساعة',
    uk: 'Щогодинні Продажі',
  },
  weekly_sales: {
    en: 'Weekly Sales',
    es: 'Ventas Semanales',
    fr: 'Ventes Hebdomadaires',
    de: 'Wöchentliche Verkäufe',
    pt: 'Vendas Semanais',
    pl: 'Sprzedaż Tygodniowa',
    nl: 'Wekelijkse Verkoop',
    el: 'Εβδομαδιαίες Πωλήσεις',
    cs: 'Týdenní Prodeje',
    sv: 'Veckoförsäljning',
    hu: 'Heti Értékesítés',
    da: 'Ugentligt Salg',
    fi: 'Viikoittainen Myynti',
    sk: 'Týždenný Predaj',
    bg: 'Седмични Продажби',
    hr: 'Tjedna Prodaja',
    lt: 'Savaitės Pardavimai',
    lv: 'Nedēļas Pārdošana',
    et: 'Nädalane Müük',
    sl: 'Tedenska Prodaja',
    ga: 'Díolacháin Sheachtainiúla',
    mt: 'Bejgħ ta’ Kull Ġimgħa',
    cy: 'Gwerthiannau Wythnosol',
    ro: 'Vânzări Săptămânale',
    it: 'Vendite Settimanali',
    zh_cn: '每周销售额',
    hi: 'साप्ताहिक बिक्री',
    ar: 'المبيعات الأسبوعية',
    bn: 'সাপ্তাহিক বিক্রয়',
    ru: 'Еженедельные Продажи',
    ja: '週間売上',
    tr: 'Haftalık Satışlar',
    ko: '주간 매출',
    vi: 'Doanh số Hàng tuần',
    id: 'Penjualan Mingguan',
    th: 'ยอดขายรายสัปดาห์',
    ms: 'Jualan Mingguan',
    ar_eg: 'المبيعات الأسبوعية',
    uk: 'Тижневі Продажі',
  },
  item_hourly_sales: {
    en: 'Item Hourly Sales',
    es: 'Ventas por Hora del Artículo',
    fr: 'Ventes Horaires par Article',
    de: 'Stündliche Verkäufe pro Artikel',
    pt: 'Vendas por Hora do Item',
    pl: 'Sprzedaż Godzinowa Produktu',
    nl: 'Uurlijkse Verkopen per Item',
    el: 'Ωριαίες Πωλήσεις Είδους',
    cs: 'Hodinové Prodeje Položky',
    sv: 'Timförsäljning per Artikel',
    hu: 'Termék Óránkénti Eladásai',
    da: 'Timebaseret Salg for Vare',
    fi: 'Tuotteen Tuntimyynti',
    sk: 'Hodinový Predaj Položky',
    bg: 'Почасови Продажби на Артикул',
    hr: 'Satna Prodaja Artikla',
    lt: 'Prekės Valandiniai Pardavimai',
    lv: 'Preces Stundas Pārdošana',
    et: 'Toote Tunnimüük',
    sl: 'Urna Prodaja Izdelka',
    ga: 'Díolacháin Uaireanta na Míre',
    mt: 'Bejgħ Kull Siegħa tal-Oġġett',
    cy: 'Gwerthiannau Fesul Awr Eitem',
    ro: 'Vânzări pe Oră ale Articolului',
    it: "Vendite Orarie dell'Articolo",
    zh_cn: '商品每小时销售',
    hi: 'आइटम प्रति घंटा बिक्री',
    ar: 'المبيعات الساعية للعنصر',
    bn: 'আইটেমের প্রতি ঘন্টায় বিক্রয়',
    ru: 'Почасовые Продажи Товара',
    ja: '商品別時間別売上',
    tr: 'Ürün Saatlik Satışları',
    ko: '항목별 시간당 매출',
    vi: 'Doanh Số Theo Giờ Của Mặt Hàng',
    id: 'Penjualan per Jam Item',
    th: 'ยอดขายรายชั่วโมงของรายการ',
    ms: 'Jualan Mengikut Jam Item',
    ar_eg: 'المبيعات بالساعة للعنصر',
    uk: 'Погодинні Продажі Товару',
  },
  daily_sales: {
    en: 'Daily Sales',
    es: 'Ventas diarias',
    fr: 'Ventes quotidiennes',
    de: 'Tägliche Verkäufe',
    pt: 'Vendas diárias',
    pl: 'Sprzedaż dzienna',
    nl: 'Dagelijkse verkoop',
    el: 'Ημερήσιες πωλήσεις',
    cs: 'Denní prodeje',
    sv: 'Daglig försäljning',
    hu: 'Napi értékesítés',
    da: 'Dagligt salg',
    fi: 'Päivittäiset myynnit',
    sk: 'Denný predaj',
    bg: 'Дневни продажби',
    hr: 'Dnevna prodaja',
    lt: 'Dienos pardavimai',
    lv: 'Dienas pārdošana',
    et: 'Igapäevane müük',
    sl: 'Dnevna prodaja',
    ga: 'Díolacháin Laethúla',
    mt: 'Bejgħ ta’ Kuljum',
    cy: 'Gwerthiant Dyddiol',
    ro: 'Vânzări zilnice',
    it: 'Vendite giornaliere',
    zh_cn: '每日销售',
    hi: 'दैनिक बिक्री',
    ar: 'المبيعات اليومية',
    bn: 'দৈনিক বিক্রয়',
    ru: 'Ежедневные продажи',
    ja: '日次売上',
    tr: 'Günlük Satışlar',
    ko: '일일 매출',
    vi: 'Doanh số hàng ngày',
    id: 'Penjualan Harian',
    th: 'ยอดขายรายวัน',
    ms: 'Jualan Harian',
    ar_eg: 'المبيعات اليومية',
    uk: 'Щоденні продажі',
  },

  monthly_sales: {
    en: 'Monthly Sales',
    es: 'Ventas mensuales',
    fr: 'Ventes mensuelles',
    de: 'Monatliche Verkäufe',
    pt: 'Vendas mensais',
    pl: 'Sprzedaż miesięczna',
    nl: 'Maandelijkse verkoop',
    el: 'Μηνιαίες πωλήσεις',
    cs: 'Měsíční prodeje',
    sv: 'Månatlig försäljning',
    hu: 'Havi értékesítés',
    da: 'Månedligt salg',
    fi: 'Kuukausittaiset myynnit',
    sk: 'Mesačný predaj',
    bg: 'Месечни продажби',
    hr: 'Mjesečna prodaja',
    lt: 'Mėnesio pardavimai',
    lv: 'Mēneša pārdošana',
    et: 'Igakuine müük',
    sl: 'Mesečna prodaja',
    ga: 'Díolacháin Mhíosúla',
    mt: 'Bejgħ ta’ Kull Xahar',
    cy: 'Gwerthiant Misol',
    ro: 'Vânzări lunare',
    it: 'Vendite mensili',
    zh_cn: '每月销售',
    hi: 'मासिक बिक्री',
    ar: 'المبيعات الشهرية',
    bn: 'মাসিক বিক্রয়',
    ru: 'Ежемесячные продажи',
    ja: '月次売上',
    tr: 'Aylık Satışlar',
    ko: '월간 매출',
    vi: 'Doanh số hàng tháng',
    id: 'Penjualan Bulanan',
    th: 'ยอดขายรายเดือน',
    ms: 'Jualan Bulanan',
    ar_eg: 'المبيعات الشهرية',
    uk: 'Щомісячні продажі',
  },
  embargopay_reports: {
    en: 'EmbargoPay Reports',
    es: 'Informes de EmbargoPay',
    fr: 'Rapports EmbargoPay',
    de: 'EmbargoPay-Berichte',
    pt: 'Relatórios EmbargoPay',
    pl: 'Raporty EmbargoPay',
    nl: 'EmbargoPay-rapporten',
    el: 'Αναφορές EmbargoPay',
    cs: 'Přehledy EmbargoPay',
    sv: 'EmbargoPay-rapporter',
    hu: 'EmbargoPay jelentések',
    da: 'EmbargoPay-rapporter',
    fi: 'EmbargoPay-raportit',
    sk: 'Prehľady EmbargoPay',
    bg: 'Отчети EmbargoPay',
    hr: 'EmbargoPay izvještaji',
    lt: 'EmbargoPay ataskaitos',
    lv: 'EmbargoPay pārskati',
    et: 'EmbargoPay aruanded',
    sl: 'EmbargoPay poročila',
    ga: 'Tuarascálacha EmbargoPay',
    mt: 'Rapporti EmbargoPay',
    cy: 'Adroddiadau EmbargoPay',
    ro: 'Rapoarte EmbargoPay',
    it: 'Report EmbargoPay',
    zh_cn: 'EmbargoPay 报告',
    hi: 'EmbargoPay रिपोर्ट',
    ar: 'تقارير EmbargoPay',
    bn: 'EmbargoPay প্রতিবেদন',
    ru: 'Отчёты EmbargoPay',
    ja: 'EmbargoPay レポート',
    tr: 'EmbargoPay Raporları',
    ko: 'EmbargoPay 보고서',
    vi: 'Báo cáo EmbargoPay',
    id: 'Laporan EmbargoPay',
    th: 'รายงาน EmbargoPay',
    ms: 'Laporan EmbargoPay',
    ar_eg: 'تقارير EmbargoPay',
    uk: 'Звіти EmbargoPay',
  },
  end_of_day: {
    en: 'End of Day',
    es: 'Fin del día',
    fr: 'Fin de journée',
    de: 'Tagesabschluss',
    pt: 'Fim do dia',
    pl: 'Koniec dnia',
    nl: 'Einde van de dag',
    el: 'Τέλος ημέρας',
    cs: 'Konec dne',
    sv: 'Dagens slut',
    hu: 'Nap vége',
    da: 'Dagens afslutning',
    fi: 'Päivän päättyessä',
    sk: 'Koniec dňa',
    bg: 'Край на деня',
    hr: 'Kraj dana',
    lt: 'Dienos pabaiga',
    lv: 'Dienas beigas',
    et: 'Päeva lõpp',
    sl: 'Konec dneva',
    ga: 'Deireadh an Lae',
    mt: 'Tmiem il-Jum',
    cy: 'Diwedd y Dydd',
    ro: 'Sfârșitul zilei',
    it: 'Fine della giornata',
    zh_cn: '日终',
    hi: 'दिन का अंत',
    ar: 'نهاية اليوم',
    bn: 'দিনের শেষ',
    ru: 'Конец дня',
    ja: '営業終了',
    tr: 'Günün Sonu',
    ko: '영업 마감',
    vi: 'Cuối ngày',
    id: 'Akhir Hari',
    th: 'สิ้นวัน',
    ms: 'Tamat Hari',
    ar_eg: 'نهاية اليوم',
    uk: 'Кінець дня',
  },
  kitchen_efficiency: {
    en: 'Kitchen Efficiency',
    es: 'Eficiencia de Cocina',
    fr: 'Efficacité de Cuisine',
    de: 'Kücheneffizienz',
    pt: 'Eficiência da Cozinha',
    pl: 'Wydajność Kuchni',
    nl: 'Keukenefficiëntie',
    el: 'Απόδοση Κουζίνας',
    cs: 'Efektivita Kuchyně',
    sv: 'Kökseffektivitet',
    hu: 'Konyhai Hatékonyság',
    da: 'Køkkeneffektivitet',
    fi: 'Keittiön Tehokkuus',
    sk: 'Efektivita Kuchyne',
    bg: 'Ефективност на Кухнята',
    hr: 'Učinkovitost Kuhinje',
    lt: 'Virtuvės Efektyvumas',
    lv: 'Virtuves Efektivitāte',
    et: 'Köögi Tõhusus',
    sl: 'Učinkovitost Kuhinje',
    ga: 'Éifeachtúlacht Cistine',
    mt: 'Effiċjenza tal-Kċina',
    cy: 'Effeithlonrwydd Cegin',
    ro: 'Eficiența Bucătăriei',
    it: 'Efficienza della Cucina',
    zh_cn: '厨房效率',
    hi: 'रसोई दक्षता',
    ar: 'كفاءة المطبخ',
    bn: 'রান্নাঘরের দক্ষতা',
    ru: 'Эффективность Кухни',
    ja: 'キッチン効率',
    tr: 'Mutfak Verimliliği',
    ko: '주방 효율성',
    vi: 'Hiệu Suất Nhà Bếp',
    id: 'Efisiensi Dapur',
    th: 'ประสิทธิภาพของครัว',
    ms: 'Kecekapan Dapur',
    ar_eg: 'كفاءة المطبخ',
    uk: 'Ефективність Кухні',
  },
  transactions: {
    en: 'Transactions',
    es: 'Transacciones',
    fr: 'Transactions',
    de: 'Transaktionen',
    pt: 'Transações',
    pl: 'Transakcje',
    nl: 'Transacties',
    el: 'Συναλλαγές',
    cs: 'Transakce',
    sv: 'Transaktioner',
    hu: 'Tranzakciók',
    da: 'Transaktioner',
    fi: 'Tapahtumat',
    sk: 'Transakcie',
    bg: 'Транзакции',
    hr: 'Transakcije',
    lt: 'Sandoriai',
    lv: 'Transakcijas',
    et: 'Tehingud',
    sl: 'Transakcije',
    ga: 'Idirbhearta',
    mt: 'Tranżazzjonijiet',
    cy: 'Trafodion',
    ro: 'Tranzacții',
    it: 'Transazioni',
    zh_cn: '交易',
    hi: 'लेनदेन',
    ar: 'المعاملات',
    bn: 'লেনদেন',
    ru: 'Транзакции',
    ja: '取引',
    tr: 'İşlemler',
    ko: '거래',
    vi: 'Giao Dịch',
    id: 'Transaksi',
    th: 'ธุรกรรม',
    ms: 'Transaksi',
    ar_eg: 'المعاملات',
    uk: 'Транзакції',
  },
  payment_reconciliation: {
    en: 'Card Reconciliation',
    es: 'Conciliación de Tarjetas',
    fr: 'Rapprochement des Cartes',
    de: 'Kartenabstimmung',
    pt: 'Reconciliação de Cartões',
    pl: 'Uzgadnianie Kart',
    nl: 'Kaartafstemming',
    el: 'Συμφωνία Καρτών',
    cs: 'Odsouhlasení Karet',
    sv: 'Kortavstämning',
    hu: 'Kártyaegyeztetés',
    da: 'Kortafstemning',
    fi: 'Korttien Täsmäytys',
    sk: 'Odsúhlasenie Kariet',
    bg: 'Съгласуване на Карти',
    hr: 'Usklađivanje Kartica',
    lt: 'Kortelių Suderinimas',
    lv: 'Karšu Saskaņošana',
    et: 'Kaartide Sobitamine',
    sl: 'Usklajevanje Kartic',
    ga: 'Athmhuintearas Cárta',
    mt: 'Rikonċiljazzjoni tal-Karta',
    cy: 'Cysoni Cardiau',
    ro: 'Reconcilierea Cardurilor',
    it: 'Riconciliazione Carte',
    zh_cn: '卡片对账',
    hi: 'कार्ड सुलह',
    ar: 'تسوية البطاقات',
    bn: 'কার্ড পুনর্মিলন',
    ru: 'Сверка Карт',
    ja: 'カード照合',
    tr: 'Kart Mutabakatı',
    ko: '카드 대사',
    vi: 'Đối Soát Thẻ',
    id: 'Rekonsiliasi Kartu',
    th: 'การกระทบยอดบัตร',
    ms: 'Penyesuaian Kad',
    ar_eg: 'تسوية الكروت',
    uk: 'Звірка Карток',
  },
  payment: {
    en: 'Payment',
    es: 'Pago',
    fr: 'Paiement',
    de: 'Zahlung',
    pt: 'Pagamento',
    pl: 'Płatność',
    nl: 'Betaling',
    el: 'Πληρωμή',
    cs: 'Platba',
    sv: 'Betalning',
    hu: 'Fizetés',
    da: 'Betaling',
    fi: 'Maksu',
    sk: 'Platba',
    bg: 'Плащане',
    hr: 'Plaćanje',
    lt: 'Mokėjimas',
    lv: 'Maksājums',
    et: 'Makse',
    sl: 'Plačilo',
    ga: 'Íocaíocht',
    mt: 'Ħlas',
    cy: 'Taliad',
    ro: 'Plată',
    it: 'Pagamento',
    zh_cn: '付款',
    hi: 'भुगतान',
    ar: 'الدفع',
    bn: 'পেমেন্ট',
    ru: 'Оплата',
    ja: '支払い',
    tr: 'Ödeme',
    ko: '결제',
    vi: 'Thanh Toán',
    id: 'Pembayaran',
    th: 'การชำระเงิน',
    ms: 'Pembayaran',
    ar_eg: 'الدفع',
    uk: 'Оплата',
  },
  payouts: {
    en: 'Payouts',
    es: 'Pagos',
    fr: 'Versements',
    de: 'Auszahlungen',
    pt: 'Pagamentos',
    pl: 'Wypłaty',
    nl: 'Uitbetalingen',
    el: 'Πληρωμές',
    cs: 'Výplaty',
    sv: 'Utbetalningar',
    hu: 'Kifizetések',
    da: 'Udbetalinger',
    fi: 'Maksut',
    sk: 'Výplaty',
    bg: 'Изплащания',
    hr: 'Isplate',
    lt: 'Išmokos',
    lv: 'Izmaksas',
    et: 'Väljamaksed',
    sl: 'Izplačila',
    ga: 'Íocaíochtaí',
    mt: 'Ħlasijiet',
    cy: 'Taliadau',
    ro: 'Plăți',
    it: 'Pagamenti',
    zh_cn: '打款',
    hi: 'भुगतान',
    ar: 'المدفوعات',
    bn: 'পেআউট',
    ru: 'Выплаты',
    ja: '入金',
    tr: 'Ödemeler',
    ko: '지급',
    vi: 'Khoản Chi Trả',
    id: 'Pencairan Dana',
    th: 'การจ่ายเงิน',
    ms: 'Pengeluaran Dana',
    ar_eg: 'المدفوعات',
    uk: 'Виплати',
  },
  payment_statements: {
    en: 'Payment Statements',
    es: 'Extractos de Pago',
    fr: 'Relevés de Paiement',
    de: 'Zahlungsabrechnungen',
    pt: 'Extratos de Pagamento',
    pl: 'Zestawienia Płatności',
    nl: 'Betalingsoverzichten',
    el: 'Καταστάσεις Πληρωμών',
    cs: 'Výpisy Plateb',
    sv: 'Betalningsrapporter',
    hu: 'Fizetési Kimutatások',
    da: 'Betalingsopgørelser',
    fi: 'Maksuraportit',
    sk: 'Výpisy Platieb',
    bg: 'Отчети за Плащания',
    hr: 'Izvještaji o Plaćanjima',
    lt: 'Mokėjimų Ataskaitos',
    lv: 'Maksājumu Izraksti',
    et: 'Maksearuanded',
    sl: 'Poročila o Plačilih',
    ga: 'Ráitis Íocaíochta',
    mt: 'Dikjarazzjonijiet tal-Ħlas',
    cy: 'Datganiadau Talu',
    ro: 'Situații de Plată',
    it: 'Estratti Conto dei Pagamenti',
    zh_cn: '付款结算单',
    hi: 'भुगतान विवरण',
    ar: 'كشوف الدفع',
    bn: 'পেমেন্ট স্টেটমেন্ট',
    ru: 'Отчеты об Оплате',
    ja: '支払い明細書',
    tr: 'Ödeme Ekstreleri',
    ko: '결제 명세서',
    vi: 'Sao Kê Thanh Toán',
    id: 'Laporan Pembayaran',
    th: 'ใบแจ้งยอดการชำระเงิน',
    ms: 'Penyata Pembayaran',
    ar_eg: 'كشوف الدفع',
    uk: 'Виписки з Оплати',
  },
  item_transactions: {
    en: 'Item Transactions',
    es: 'Transacciones de artículos',
    fr: 'Transactions d’articles',
    de: 'Artikeltransaktionen',
    pt: 'Transações de itens',
    pl: 'Transakcje przedmiotów',
    nl: 'Artikeltransacties',
    el: 'Συναλλαγές αντικειμένων',
    cs: 'Transakce položek',
    sv: 'Artikeltransaktioner',
    hu: 'Tételtranzakciók',
    da: 'Varetransaktioner',
    fi: 'Tuotetapahtumat',
    sk: 'Transakcie položiek',
    bg: 'Транзакции на артикули',
    hr: 'Transakcije artikala',
    lt: 'Prekių operacijos',
    lv: 'Preču darījumi',
    et: 'Tootetehingud',
    sl: 'Transakcije predmetov',
    ga: 'Idirbhearta Míreanna',
    mt: 'Transazzjonijiet tal-Oġġetti',
    cy: 'Trafodion Eitemau',
    ro: 'Tranzacții cu articole',
    it: 'Transazioni degli articoli',
    zh_cn: '物品交易',
    hi: 'आइटम लेनदेन',
    ar: 'معاملات العناصر',
    bn: 'আইটেম লেনদেন',
    ru: 'Операции с товарами',
    ja: 'アイテム取引',
    tr: 'Öğe İşlemleri',
    ko: '항목 거래',
    vi: 'Giao dịch mặt hàng',
    id: 'Transaksi Barang',
    th: 'ธุรกรรมรายการ',
    ms: 'Transaksi Item',
    ar_eg: 'معاملات الأصناف',
    uk: 'Операції з предметами',
  },
  sales_tax_report: {
    en: 'Sales Tax Report',
    es: 'Informe de Impuesto sobre las Ventas',
    fr: 'Rapport de Taxe sur les Ventes',
    de: 'Umsatzsteuerbericht',
    pt: 'Relatório de Imposto sobre Vendas',
    pl: 'Raport z Podatku od Sprzedaży',
    nl: 'Rapport over de Verkoopbelasting',
    el: 'Αναφορά Φόρου Πωλήσεων',
    cs: 'Zpráva o Daňi z Prodeje',
    sv: 'Rapport om Försäljningsskatt',
    hu: 'Forgalmi Adó Jelentés',
    da: 'Rapport om Moms',
    fi: 'Myyntiveroraportti',
    sk: 'Správa o Daniach z Predaja',
    bg: 'Доклад за Данък върху Продажбите',
    hr: 'Izvješće o Porezu na Prodaju',
    lt: 'Pardavimo Mokesčių Ataskaita',
    lv: 'Pārdošanas Nodokļa Pārskats',
    et: 'Käibemaksuaruanne',
    sl: 'Poročilo o Davek na Prodajo',
    ga: 'Tuarascáil Cáin Díolacháin',
    mt: 'Rapport tat-Taxxa fuq il-Bejgħ',
    cy: 'Adroddiad Treth Gwerthu',
    ro: 'Raport de Taxă pe Vânzări',
    it: 'Rapporto sull’Imposta sulle Vendite',
    zh_cn: '销售税报告',
    hi: 'बिक्री कर रिपोर्ट',
    ar: 'تقرير ضريبة المبيعات',
    bn: 'বিক্রয় কর প্রতিবেদন',
    ru: 'Отчет о Налоге с Продаж',
    ja: '売上税報告書',
    tr: 'Satış Vergisi Raporu',
    ko: '판매세 보고서',
    vi: 'Báo Cáo Thuế Bán Hàng',
    id: 'Laporan Pajak Penjualan',
    th: 'รายงานภาษีการขาย',
    ms: 'Laporan Cukai Jualan',
    ar_eg: 'تقرير ضريبة المبيعات',
    uk: 'Звіт про Податок з Продажів',
  },
  sales_tip_report: {
    en: 'Sales Tip Report',
    es: 'Informe de Propinas de Ventas',
    fr: 'Rapport des Pourboires de Vente',
    de: 'Trinkgeldbericht für Verkäufe',
    pt: 'Relatório de Gorjetas de Vendas',
    pl: 'Raport Napiwków ze Sprzedaży',
    nl: 'Fooienrapport Verkoop',
    el: 'Αναφορά Φιλοδωρημάτων Πωλήσεων',
    cs: 'Report Spropitného z Prodeje',
    sv: 'Dricksrapport för Försäljning',
    hu: 'Értékesítési Borravaló Jelentés',
    da: 'Drikkepengerapport for Salg',
    fi: 'Myyntijuomaraportti',
    sk: 'Prehľad Sprepitného z Predaja',
    bg: 'Отчет за Бакшиши от Продажби',
    hr: 'Izvještaj o Napojnicama od Prodaje',
    lt: 'Pardavimo Arbatpinigių Ataskaita',
    lv: 'Pārdošanas Dzeramnaudas Pārskats',
    et: 'Müügi Jootraha Aruanne',
    sl: 'Poročilo o Napitninah iz Prodaje',
    ga: 'Tuarascáil Leideanna Díolacháin',
    mt: 'Rapport dwar Tips tal-Bejgħ',
    cy: 'Adroddiad Tomenni Gwerthiant',
    ro: 'Raport Bacșișuri Vânzări',
    it: 'Report Mance delle Vendite',
    zh_cn: '销售小费报告',
    hi: 'बिक्री टिप रिपोर्ट',
    ar: 'تقرير إكراميات المبيعات',
    bn: 'বিক্রয় টিপ রিপোর্ট',
    ru: 'Отчет по Чаевым с Продаж',
    ja: '売上チップレポート',
    tr: 'Satış Bahşiş Raporu',
    ko: '판매 팁 보고서',
    vi: 'Báo Cáo Tiền Tip Bán Hàng',
    id: 'Laporan Tip Penjualan',
    th: 'รายงานทิปการขาย',
    ms: 'Laporan Tip Jualan',
    ar_eg: 'تقرير بقشيش المبيعات',
    uk: 'Звіт про Чайові з Продажів',
  },
  sales_refund_report: {
    en: 'Sales Refund Report',
    es: 'Informe de reembolsos de ventas',
    fr: 'Rapport des remboursements de ventes',
    de: 'Verkaufsrückerstattungsbericht',
    pt: 'Relatório de reembolsos de vendas',
    pl: 'Raport zwrotów sprzedaży',
    nl: 'Rapport verkoopterugbetalingen',
    el: 'Αναφορά επιστροφών πωλήσεων',
    cs: 'Přehled refundací prodeje',
    sv: 'Rapport över försäljningsåterbetalningar',
    hu: 'Értékesítési visszatérítési jelentés',
    da: 'Rapport over salgsrefusioner',
    fi: 'Myynnin hyvitysraportti',
    sk: 'Prehľad refundácií predaja',
    bg: 'Отчет за възстановявания от продажби',
    hr: 'Izvješće o povratima prodaje',
    lt: 'Pardavimų grąžinimų ataskaita',
    lv: 'Pārdošanas atmaksu pārskats',
    et: 'Müügi tagasimaksete aruanne',
    sl: 'Poročilo o vračilih prodaje',
    ga: 'Tuarascáil ar aisíocaíochtaí díolacháin',
    mt: 'Rapport tar-rifużjonijiet tal-bejgħ',
    cy: 'Adroddiad ad-daliadau gwerthiant',
    ro: 'Raport privind rambursările vânzărilor',
    it: 'Report sui rimborsi delle vendite',
    zh_cn: '销售退款报告',
    hi: 'बिक्री रिफंड रिपोर्ट',
    ar: 'تقرير استردادات المبيعات',
    bn: 'বিক্রয় ফেরত প্রতিবেদন',
    ru: 'Отчёт о возвратах по продажам',
    ja: '売上返金レポート',
    tr: 'Satış İadeleri Raporu',
    ko: '판매 환불 보고서',
    vi: 'Báo cáo hoàn tiền bán hàng',
    id: 'Laporan Pengembalian Dana Penjualan',
    th: 'รายงานการคืนเงินการขาย',
    ms: 'Laporan Bayaran Balik Jualan',
    ar_eg: 'تقرير مرتجعات المبيعات',
    uk: 'Звіт про повернення коштів за продажами',
  },
  total: {
    en: 'Total',
    es: 'Total',
    fr: 'Total',
    de: 'Gesamt',
    pt: 'Total',
    pl: 'Suma',
    nl: 'Totaal',
    el: 'Σύνολο',
    cs: 'Celkem',
    sv: 'Totalt',
    hu: 'Összesen',
    da: 'Total',
    fi: 'Yhteensä',
    sk: 'Celkom',
    bg: 'Общо',
    hr: 'Ukupno',
    lt: 'Iš viso',
    lv: 'Kopā',
    et: 'Kokku',
    sl: 'Skupaj',
    ga: 'Iomlán',
    mt: 'Total',
    cy: 'Cyfanswm',
    ro: 'Total',
    it: 'Totale',
    zh_cn: '总计',
    hi: 'कुल',
    ar: 'الإجمالي',
    bn: 'মোট',
    ru: 'Итого',
    ja: '合計',
    tr: 'Toplam',
    ko: '합계',
    vi: 'Tổng cộng',
    id: 'Total',
    th: 'รวม',
    ms: 'Jumlah',
    ar_eg: 'الإجمالي',
    uk: 'Всього',
  },
  channel: {
    en: 'Channel',
    es: 'Canal',
    fr: 'Canal',
    de: 'Kanal',
    pt: 'Canal',
    pl: 'Kanał',
    nl: 'Kanaal',
    el: 'Κανάλι',
    cs: 'Kanál',
    sv: 'Kanal',
    hu: 'Csatorna',
    da: 'Kanal',
    fi: 'Kanava',
    sk: 'Kanál',
    bg: 'Канал',
    hr: 'Kanal',
    lt: 'Kanalas',
    lv: 'Kanāls',
    et: 'Kanal',
    sl: 'Kanal',
    ga: 'Cainéal',
    mt: 'Kanal',
    cy: 'Sianel',
    ro: 'Canal',
    it: 'Canale',
    zh_cn: '渠道',
    hi: 'चैनल',
    ar: 'القناة',
    bn: 'চ্যানেল',
    ru: 'Канал',
    ja: 'チャネル',
    tr: 'Kanal',
    ko: '채널',
    vi: 'Kênh',
    id: 'Saluran',
    th: 'ช่องทาง',
    ms: 'Saluran',
    ar_eg: 'القناة',
    uk: 'Канал',
  },
  overview: {
    en: 'Overview',
    es: 'Resumen',
    fr: 'Aperçu',
    de: 'Übersicht',
    pt: 'Visão Geral',
    pl: 'Przegląd',
    nl: 'Overzicht',
    el: 'Επισκόπηση',
    cs: 'Přehled',
    sv: 'Översikt',
    hu: 'Áttekintés',
    da: 'Oversigt',
    fi: 'Yleiskatsaus',
    sk: 'Prehľad',
    bg: 'Преглед',
    hr: 'Pregled',
    lt: 'Apžvalga',
    lv: 'Pārskats',
    et: 'Ülevaade',
    sl: 'Pregled',
    ga: 'Forbhreathnú',
    mt: 'Ħarsa Ġenerali',
    cy: 'Trosolwg',
    ro: 'Prezentare Generală',
    it: 'Panoramica',
    zh_cn: '概览',
    hi: 'सारांश',
    ar: 'نظرة عامة',
    bn: 'সংক্ষিপ্ত বিবরণ',
    ru: 'Обзор',
    ja: '概要',
    tr: 'Genel Bakış',
    ko: '개요',
    vi: 'Tổng Quan',
    id: 'Ikhtisar',
    th: 'ภาพรวม',
    ms: 'Gambaran Keseluruhan',
    ar_eg: 'نظرة عامة',
    uk: 'Огляд',
  },
  sales_by_items: {
    en: 'Sales By Items',
    es: 'Ventas por Artículos',
    fr: 'Ventes par Articles',
    de: 'Verkäufe nach Artikeln',
    pt: 'Vendas por Itens',
    pl: 'Sprzedaż Według Przedmiotów',
    nl: 'Verkopen per Artikel',
    el: 'Πωλήσεις ανά Είδος',
    cs: 'Prodeje podle Položek',
    sv: 'Försäljning per Artikel',
    hu: 'Eladások Termékek Szerint',
    da: 'Salg Efter Varer',
    fi: 'Myynti Tuotteittain',
    sk: 'Predaj podľa Položiek',
    bg: 'Продажби по Артикули',
    hr: 'Prodaja po Artiklima',
    lt: 'Pardavimai pagal Prekes',
    lv: 'Pārdošana pēc Preces',
    et: 'Müük Kaupade Kaupa',
    sl: 'Prodaja po Artiklih',
    ga: 'Díolacháin de réir Míreanna',
    mt: 'Bejgħ Skont l-Oġġetti',
    cy: 'Gwerthiannau Yn ôl Eitemau',
    ro: 'Vânzări pe Articole',
    it: 'Vendite per Articolo',
    zh_cn: '按商品销售',
    hi: 'आइटम द्वारा बिक्री',
    ar: 'المبيعات حسب العناصر',
    bn: 'আইটেম দ্বারা বিক্রয়',
    ru: 'Продажи по Товарам',
    ja: '商品別売上',
    tr: 'Ürün Bazında Satışlar',
    ko: '항목별 판매',
    vi: 'Bán Hàng Theo Mặt Hàng',
    id: 'Penjualan Berdasarkan Item',
    th: 'ยอดขายตามสินค้า',
    ms: 'Jualan Mengikut Item',
    ar_eg: 'المبيعات حسب العناصر',
    uk: 'Продажі за Товарами',
  },
  sales_by_categories: {
    en: 'Sales By Categories',
    es: 'Ventas por categorías',
    fr: 'Ventes par catégories',
    de: 'Umsätze nach Kategorien',
    pt: 'Vendas por categorias',
    pl: 'Sprzedaż według kategorii',
    nl: 'Verkopen per categorie',
    el: 'Πωλήσεις ανά κατηγορία',
    cs: 'Prodeje podle kategorií',
    sv: 'Försäljning per kategori',
    hu: 'Eladások kategóriák szerint',
    da: 'Salg efter kategorier',
    fi: 'Myynti kategorioittain',
    sk: 'Predaj podľa kategórií',
    bg: 'Продажби по категории',
    hr: 'Prodaja po kategorijama',
    lt: 'Pardavimai pagal kategorijas',
    lv: 'Pārdošana pēc kategorijām',
    et: 'Müük kategooriate kaupa',
    sl: 'Prodaja po kategorijah',
    ga: 'Díolacháin de réir catagóirí',
    mt: 'Bejgħ skont il-kategoriji',
    cy: 'Gwerthiant yn ôl categorïau',
    ro: 'Vânzări pe categorii',
    it: 'Vendite per categoria',
    zh_cn: '按类别销售',
    hi: 'श्रेणियों के अनुसार बिक्री',
    ar: 'المبيعات حسب الفئات',
    bn: 'বিভাগ অনুযায়ী বিক্রয়',
    ru: 'Продажи по категориям',
    ja: 'カテゴリ別の売上',
    tr: 'Kategoriye Göre Satışlar',
    ko: '카테고리별 판매',
    vi: 'Doanh số theo danh mục',
    id: 'Penjualan Menurut Kategori',
    th: 'ยอดขายตามหมวดหมู่',
    ms: 'Jualan Mengikut Kategori',
    ar_eg: 'المبيعات حسب التصنيفات',
    uk: 'Продажі за категоріями',
  },
  sales_by_store: {
    en: 'Sales By Store',
    es: 'Ventas Por Tienda',
    fr: 'Ventes Par Magasin',
    de: 'Verkäufe Nach Geschäft',
    pt: 'Vendas Por Loja',
    pl: 'Sprzedaż Według Sklepu',
    nl: 'Verkopen Per Winkel',
    el: 'Πωλήσεις Ανά Κατάστημα',
    cs: 'Prodeje Podle Obchodu',
    sv: 'Försäljning Per Butik',
    hu: 'Eladások Bolt Szerint',
    da: 'Salg Efter Butik',
    fi: 'Myynti Myymälöittäin',
    sk: 'Predaje Podľa Obchodu',
    bg: 'Продажби По Магазин',
    hr: 'Prodaja Po Trgovini',
    lt: 'Pardavimai Pagal Parduotuvę',
    lv: 'Pārdošana Pēc Veikala',
    et: 'Müük Kaupluste Kaupa',
    sl: 'Prodaja Po Trgovinah',
    ga: 'Díolacháin De Réir Siopa',
    mt: 'Bejgħ Skont il-Ħanut',
    cy: 'Gwerthiannau Fesul Siop',
    ro: 'Vânzări Pe Magazin',
    it: 'Vendite Per Negozio',
    zh_cn: '按商店分类的销售额',
    hi: 'स्टोर के अनुसार बिक्री',
    ar: 'المبيعات حسب المتجر',
    bn: 'দোকান অনুযায়ী বিক্রয়',
    ru: 'Продажи По Магазинам',
    ja: '店舗別売上',
    tr: 'Mağaza Bazlı Satışlar',
    ko: '매장별 매출',
    vi: 'Doanh Số Theo Cửa Hàng',
    id: 'Penjualan Menurut Toko',
    th: 'ยอดขายตามร้านค้า',
    ms: 'Jualan Mengikut Kedai',
    ar_eg: 'المبيعات حسب المتجر',
    uk: 'Продажі За Магазинами',
  },
  sales_by_channel: {
    en: 'Sales By Channel',
    es: 'Ventas por Canal',
    fr: 'Ventes par Canal',
    de: 'Verkäufe nach Kanal',
    pt: 'Vendas por Canal',
    pl: 'Sprzedaż według Kanału',
    nl: 'Verkoop per Kanaal',
    el: 'Πωλήσεις ανά Κανάλι',
    cs: 'Prodeje podle Kanálu',
    sv: 'Försäljning per Kanal',
    hu: 'Értékesítés Csatornánként',
    da: 'Salg efter Kanal',
    fi: 'Myynti Kanavittain',
    sk: 'Predaj podľa Kanála',
    bg: 'Продажби по Канал',
    hr: 'Prodaja po Kanalu',
    lt: 'Pardavimai pagal Kanalą',
    lv: 'Pārdošana pēc Kanāla',
    et: 'Müük Kanali Kaupa',
    sl: 'Prodaja po Kanalu',
    ga: 'Díolacháin de Réir Cainéil',
    mt: 'Bejgħ Skont il-Kanal',
    cy: 'Gwerthiant fesul Sianel',
    ro: 'Vânzări pe Canal',
    it: 'Vendite per Canale',
    zh_cn: '按渠道销售',
    hi: 'चैनल के अनुसार बिक्री',
    ar: 'المبيعات حسب القناة',
    bn: 'চ্যানেল অনুসারে বিক্রয়',
    ru: 'Продажи по Каналам',
    ja: 'チャネル別売上',
    tr: 'Kanala Göre Satışlar',
    ko: '채널별 판매',
    vi: 'Doanh số theo Kênh',
    id: 'Penjualan per Saluran',
    th: 'ยอดขายตามช่องทาง',
    ms: 'Jualan Mengikut Saluran',
    ar_eg: 'المبيعات حسب القناة',
    uk: 'Продажі за Каналом',
  },
  sales_by_branch: {
    en: 'Sales By Branch',
    es: 'Ventas por Sucursal',
    fr: 'Ventes par Succursale',
    de: 'Verkäufe nach Filiale',
    pt: 'Vendas por Filial',
    pl: 'Sprzedaż według Oddziału',
    nl: 'Verkopen per Vestiging',
    el: 'Πωλήσεις ανά Υποκατάστημα',
    cs: 'Prodeje podle Pobočky',
    sv: 'Försäljning per Filial',
    hu: 'Eladások Fiók Szerint',
    da: 'Salg efter Afdeling',
    fi: 'Myynti Toimipisteittäin',
    sk: 'Predaje podľa Pobočky',
    bg: 'Продажби по Клонове',
    hr: 'Prodaja po Podružnici',
    lt: 'Pardavimai Pagal Filialą',
    lv: 'Pārdošana pa Filiālēm',
    et: 'Müük Haru Kaupa',
    sl: 'Prodaja po Podružnicah',
    ga: 'Díolacháin de réir Brainse',
    mt: 'Bejgħ Skont il-Filjal',
    cy: 'Gwerthiant yn ôl Cangen',
    ro: 'Vânzări pe Sucursală',
    it: 'Vendite per Filiale',
    zh_cn: '按分支机构销售',
    hi: 'शाखा के अनुसार बिक्री',
    ar: 'المبيعات حسب الفرع',
    bn: 'শাখা অনুযায়ী বিক্রয়',
    ru: 'Продажи по Филиалам',
    ja: '支店別売上',
    tr: 'Şubeye Göre Satışlar',
    ko: '지점별 판매',
    vi: 'Doanh Thu Theo Chi Nhánh',
    id: 'Penjualan per Cabang',
    th: 'ยอดขายตามสาขา',
    ms: 'Jualan Mengikut Cawangan',
    ar_eg: 'المبيعات حسب الفرع',
    uk: 'Продажі за Філіями',
  },
  sales_by_conditions: {
    en: 'Sales By Conditions',
    es: 'Ventas por condiciones',
    fr: 'Ventes par conditions',
    de: 'Verkäufe nach Bedingungen',
    pt: 'Vendas por condições',
    pl: 'Sprzedaż według warunków',
    nl: 'Verkoop op basis van voorwaarden',
    el: 'Πωλήσεις ανά συνθήκες',
    cs: 'Prodeje podle podmínek',
    sv: 'Försäljning efter villkor',
    hu: 'Értékesítés feltételek szerint',
    da: 'Salg efter betingelser',
    fi: 'Myynti ehtojen mukaan',
    sk: 'Predaje podľa podmienok',
    bg: 'Продажби по условия',
    hr: 'Prodaja prema uvjetima',
    lt: 'Pardavimai pagal sąlygas',
    lv: 'Pārdošana pēc nosacījumiem',
    et: 'Müük tingimuste alusel',
    sl: 'Prodaja po pogojih',
    ga: 'Díolacháin de réir coinníollacha',
    mt: 'Bejgħ skont il-kundizzjonijiet',
    cy: 'Gwerthiant yn ôl amodau',
    ro: 'Vânzări după condiții',
    it: 'Vendite per condizioni',
    zh_cn: '按条件分类的销售',
    hi: 'शर्तों के अनुसार बिक्री',
    ar: 'المبيعات حسب الشروط',
    bn: 'শর্ত অনুযায়ী বিক্রয়',
    ru: 'Продажи по условиям',
    ja: '条件別売上',
    tr: 'Koşullara Göre Satışlar',
    ko: '조건별 판매',
    vi: 'Bán hàng theo điều kiện',
    id: 'Penjualan Berdasarkan Ketentuan',
    th: 'ยอดขายตามเงื่อนไข',
    ms: 'Jualan Mengikut Syarat',
    ar_eg: 'المبيعات حسب الشروط',
    uk: 'Продажі за умовами',
  },
  sales_by_payments: {
    en: 'Sales By Payments',
    es: 'Ventas por métodos de pago',
    fr: 'Ventes par paiements',
    de: 'Verkäufe nach Zahlungen',
    pt: 'Vendas por pagamentos',
    pl: 'Sprzedaż według płatności',
    nl: 'Verkoop op basis van betalingen',
    el: 'Πωλήσεις ανά τρόπο πληρωμής',
    cs: 'Prodeje podle plateb',
    sv: 'Försäljning efter betalningar',
    hu: 'Értékesítés fizetések szerint',
    da: 'Salg efter betalinger',
    fi: 'Myynti maksutavoittain',
    sk: 'Predaje podľa platieb',
    bg: 'Продажби по плащания',
    hr: 'Prodaja prema načinima plaćanja',
    lt: 'Pardavimai pagal mokėjimus',
    lv: 'Pārdošana pēc maksājumiem',
    et: 'Müük maksete alusel',
    sl: 'Prodaja po plačilih',
    ga: 'Díolacháin de réir íocaíochtaí',
    mt: 'Bejgħ skont il-ħlasijiet',
    cy: 'Gwerthiant yn ôl taliadau',
    ro: 'Vânzări după plăți',
    it: 'Vendite per pagamenti',
    zh_cn: '按付款分类的销售',
    hi: 'भुगतान के अनुसार बिक्री',
    ar: 'المبيعات حسب طرق الدفع',
    bn: 'পেমেন্ট অনুযায়ী বিক্রয়',
    ru: 'Продажи по видам оплаты',
    ja: '支払い別売上',
    tr: 'Ödeme Türüne Göre Satışlar',
    ko: '결제별 판매',
    vi: 'Bán hàng theo phương thức thanh toán',
    id: 'Penjualan Berdasarkan Pembayaran',
    th: 'ยอดขายตามการชำระเงิน',
    ms: 'Jualan Mengikut Pembayaran',
    ar_eg: 'المبيعات حسب طرق الدفع',
    uk: 'Продажі за способами оплати',
  },
  sales_by_modifiers: {
    en: 'Sales By Modifiers',
    es: 'Ventas por modificadores',
    fr: 'Ventes par modificateurs',
    de: 'Verkäufe nach Modifikatoren',
    pt: 'Vendas por modificadores',
    pl: 'Sprzedaż według modyfikatorów',
    nl: 'Verkoop per modifiers',
    el: 'Πωλήσεις ανά τροποποιητές',
    cs: 'Prodeje podle modifikátorů',
    sv: 'Försäljning efter modifierare',
    hu: 'Értékesítés módosítók szerint',
    da: 'Salg efter modifikatorer',
    fi: 'Myynti muokkainten mukaan',
    sk: 'Predaj podľa modifikátorov',
    bg: 'Продажби по модификатори',
    hr: 'Prodaja po modifikatorima',
    lt: 'Pardavimai pagal modifikatorius',
    lv: 'Pārdošana pēc modifikatoriem',
    et: 'Müük modifikaatorite järgi',
    sl: 'Prodaja po modifikatorjih',
    ga: 'Díolacháin de réir modhnóirí',
    mt: 'Bejgħ skont il-modifikaturi',
    cy: 'Gwerthiannau yn ôl addaswyr',
    ro: 'Vânzări după modificatori',
    it: 'Vendite per modificatori',
    zh_cn: '按修饰项统计销售额',
    hi: 'मॉडिफ़ायर्स के अनुसार बिक्री',
    ar: 'المبيعات حسب المعدّلات',
    bn: 'মডিফায়ার অনুযায়ী বিক্রয়',
    ru: 'Продажи по модификаторам',
    ja: '修飾子別売上',
    tr: 'Değiştiricilere Göre Satışlar',
    ko: '수정자별 매출',
    vi: 'Doanh số theo bộ điều chỉnh',
    id: 'Penjualan Berdasarkan Modifier',
    th: 'ยอดขายตามตัวปรับแต่ง',
    ms: 'Jualan Mengikut Pengubah Suai',
    ar_eg: 'المبيعات حسب المُعدِّلات',
    uk: 'Продажі за модифікаторами',
  },
  applied_promotions: {
    en: 'Applied Promotions',
    es: 'Promociones Aplicadas',
    fr: 'Promotions Appliquées',
    de: 'Angewandte Aktionen',
    pt: 'Promoções Aplicadas',
    pl: 'Zastosowane Promocje',
    nl: 'Toegepaste Promoties',
    el: 'Εφαρμοσμένες Προσφορές',
    cs: 'Uplatněné Promoakce',
    sv: 'Tillämpade Kampanjer',
    hu: 'Alkalmazott Akciók',
    da: 'Anvendte Kampagner',
    fi: 'Sovelletut Kampanjat',
    sk: 'Použité Akcie',
    bg: 'Приложени Промоции',
    hr: 'Primijenjene Promocije',
    lt: 'Pritaikytos Akcijos',
    lv: 'Pielietotās Akcijas',
    et: 'Rakendatud Kampaaniad',
    sl: 'Uporabljene Promocije',
    ga: 'Cur Chun Cinn a Cuireadh i bhFeidhm',
    mt: 'Promozzjonijiet Applikati',
    cy: 'Hyrwyddiadau a Gymhwyswyd',
    ro: 'Promoții Aplicate',
    it: 'Promozioni Applicate',
    zh_cn: '已应用的促销',
    hi: 'लागू की गई प्रोमोशंस',
    ar: 'العروض الترويجية المطبقة',
    bn: 'প্রয়োগ করা প্রচারাভিযান',
    ru: 'Применённые Акции',
    ja: '適用されたプロモーション',
    tr: 'Uygulanan Promosyonlar',
    ko: '적용된 프로모션',
    vi: 'Khuyến Mãi Đã Áp Dụng',
    id: 'Promosi yang Diterapkan',
    th: 'โปรโมชั่นที่ใช้แล้ว',
    ms: 'Promosi yang Digunakan',
    ar_eg: 'العروض الترويجية المُطبقة',
    uk: 'Застосовані Промоакції',
  },
  settings: {
    en: 'Settings',
    es: 'Configuración',
    fr: 'Paramètres',
    de: 'Einstellungen',
    pt: 'Configurações',
    pl: 'Ustawienia',
    nl: 'Instellingen',
    el: 'Ρυθμίσεις',
    cs: 'Nastavení',
    sv: 'Inställningar',
    hu: 'Beállítások',
    da: 'Indstillinger',
    fi: 'Asetukset',
    sk: 'Nastavenia',
    bg: 'Настройки',
    hr: 'Postavke',
    lt: 'Nustatymai',
    lv: 'Iestatījumi',
    et: 'Seaded',
    sl: 'Nastavitve',
    ga: 'Socruithe',
    mt: 'Settings',
    cy: 'Gosodiadau',
    ro: 'Setări',
    it: 'Impostazioni',
    zh_cn: '设置',
    hi: 'सेटिंग्स',
    ar: 'الإعدادات',
    bn: 'সেটিংস',
    ru: 'Настройки',
    ja: '設定',
    tr: 'Ayarlar',
    ko: '설정',
    vi: 'Cài Đặt',
    id: 'Pengaturan',
    th: 'การตั้งค่า',
    ms: 'Tetapan',
    ar_eg: 'الإعدادات',
    uk: 'Налаштування',
  },
  staff_management: {
    en: 'Staff Management',
    es: 'Gestión de Personal',
    fr: 'Gestion du Personnel',
    de: 'Mitarbeiterverwaltung',
    pt: 'Gestão de Pessoal',
    pl: 'Zarządzanie Personelem',
    nl: 'Personeelsbeheer',
    el: 'Διαχείριση Προσωπικού',
    cs: 'Správa Zaměstnanců',
    sv: 'Personalhantering',
    hu: 'Személyzet Kezelése',
    da: 'Personaleadministration',
    fi: 'Henkilöstön Hallinta',
    sk: 'Správa Zamestnancov',
    bg: 'Управление на Персонала',
    hr: 'Upravljanje Osobljem',
    lt: 'Personalo Valdymas',
    lv: 'Personāla Pārvaldība',
    et: 'Töötajate Haldamine',
    sl: 'Upravljanje Osebja',
    ga: 'Bainistíocht Foirne',
    mt: 'Ġestjoni tal-Persunal',
    cy: 'Rheoli Staff',
    ro: 'Managementul Personalului',
    it: 'Gestione del Personale',
    zh_cn: '员工管理',
    hi: 'कर्मचारी प्रबंधन',
    ar: 'إدارة الموظفين',
    bn: 'স্টাফ ব্যবস্থাপনা',
    ru: 'Управление Персоналом',
    ja: 'スタッフ管理',
    tr: 'Personel Yönetimi',
    ko: '직원 관리',
    vi: 'Quản Lý Nhân Viên',
    id: 'Manajemen Staf',
    th: 'การจัดการพนักงาน',
    ms: 'Pengurusan Kakitangan',
    ar_eg: 'إدارة الموظفين',
    uk: 'Управління Персоналом',
  },
  staff_list: {
    en: 'Staff List',
    es: 'Lista de Personal',
    fr: 'Liste du Personnel',
    de: 'Mitarbeiterliste',
    pt: 'Lista de Pessoal',
    pl: 'Lista Pracowników',
    nl: 'Personeelslijst',
    el: 'Λίστα Προσωπικού',
    cs: 'Seznam Zaměstnanců',
    sv: 'Personallista',
    hu: 'Alkalmazottak Listája',
    da: 'Personaleoversigt',
    fi: 'Henkilöstöluettelo',
    sk: 'Zoznam Zamestnancov',
    bg: 'Списък на Персонала',
    hr: 'Popis Osoblja',
    lt: 'Darbuotojų Sąrašas',
    lv: 'Personāla Saraksts',
    et: 'Töötajate Nimekiri',
    sl: 'Seznam Osebja',
    ga: 'Liosta Foirne',
    mt: 'Lista tal-Persunal',
    cy: 'Rhestr Staff',
    ro: 'Lista de Personal',
    it: 'Elenco del Personale',
    zh_cn: '员工名单',
    hi: 'कर्मचारी सूची',
    ar: 'قائمة الموظفين',
    bn: 'স্টাফ তালিকা',
    ru: 'Список Сотрудников',
    ja: 'スタッフリスト',
    tr: 'Personel Listesi',
    ko: '직원 명단',
    vi: 'Danh Sách Nhân Viên',
    id: 'Daftar Staf',
    th: 'รายชื่อพนักงาน',
    ms: 'Senarai Kakitangan',
    ar_eg: 'قائمة الموظفين',
    uk: 'Список Персоналу',
  },
  staff_timesheets: {
    en: 'Staff Timesheets',
    es: 'Hojas de Tiempo del Personal',
    fr: 'Feuilles de Temps du Personnel',
    de: 'Mitarbeiter-Stundenzettel',
    pt: 'Folhas de Ponto da Equipe',
    pl: 'Karty Czasu Pracy Pracowników',
    nl: 'Urenstaten van Personeel',
    el: 'Φύλλα Χρόνου Προσωπικού',
    cs: 'Výkazy Práce Zaměstnanců',
    sv: 'Personalens Tidsrapporter',
    hu: 'Dolgozói Munkaidő-nyilvántartások',
    da: 'Personalets Tidsrapporter',
    fi: 'Henkilöstön Tuntikirjanpidot',
    sk: 'Výkazy Práce Zamestnancov',
    bg: 'Трудови Отчети на Персонала',
    hr: 'Evidencije Radnog Vremena Osoblja',
    lt: 'Darbuotojų Laiko Suvestinės',
    lv: 'Darbinieku Laika Uzskaites Lapas',
    et: 'Töötajate Tööaja Aruanded',
    sl: 'Časovnice Zaposlenih',
    ga: 'Bileoga Ama na Foirne',
    mt: 'Ħinijiet tax-Xogħol tal-Persunal',
    cy: 'Taflenni Amser Staff',
    ro: 'Foi de Pontaj ale Personalului',
    it: 'Fogli Ore del Personale',
    zh_cn: '员工工时表',
    hi: 'कर्मचारी समय पत्रक',
    ar: 'جداول أوقات الموظفين',
    bn: 'স্টাফ সময়পত্র',
    ru: 'Табели Учета Рабочего Времени Персонала',
    ja: 'スタッフのタイムシート',
    tr: 'Personel Zaman Çizelgeleri',
    ko: '직원 근무 시간표',
    vi: 'Bảng Chấm Công Nhân Viên',
    id: 'Lembar Waktu Staf',
    th: 'ตารางเวลาพนักงาน',
    ms: 'Lembaran Masa Kakitangan',
    ar_eg: 'جداول أوقات الموظفين',
    uk: 'Табелі Робочого Часу Персоналу',
  },
  staff_time_clock: {
    en: 'Staff Time Clock',
    es: 'Reloj de Tiempo del Personal',
    fr: 'Horloge du Temps du Personnel',
    de: 'Mitarbeiteruhr',
    pt: 'Relógio de Ponto da Equipa',
    pl: 'Zegar Czasu Pracowników',
    nl: 'Personeelsklok',
    el: 'Ρολόι Χρόνου Προσωπικού',
    cs: 'Docházkový Systém Zaměstnanců',
    sv: 'Personalens Tidsur',
    hu: 'Dolgozói Időóra',
    da: 'Personale Tidsur',
    fi: 'Henkilöstön Kellokortti',
    sk: 'Dochádzkové Hodiny Zamestnancov',
    bg: 'Часовник за Персонала',
    hr: 'Sat za Evidenciju Radnog Vremena',
    lt: 'Personalo Laikrodis',
    lv: 'Personāla Laika Pulkstenis',
    et: 'Töötajate Kell',
    sl: 'Ura za Zaposlene',
    ga: 'Cloch Ama Foirne',
    mt: 'Arloġġ tal-Ħin tal-Persunal',
    cy: 'Cloc Amser Staff',
    ro: 'Ceas de Pontaj pentru Personal',
    it: 'Orologio del Tempo del Personale',
    zh_cn: '员工打卡钟',
    hi: 'स्टाफ टाइम क्लॉक',
    ar: 'ساعة وقت الموظفين',
    bn: 'স্টাফ টাইম ক্লক',
    ru: 'Часы Учета Времени Персонала',
    ja: 'スタッフ用タイムクロック',
    tr: 'Personel Zaman Saati',
    ko: '직원 근무 시간 시계',
    vi: 'Đồng Hồ Thời Gian Nhân Viên',
    id: 'Jam Waktu Staf',
    th: 'นาฬิกาเวลาเจ้าหน้าที่',
    ms: 'Jam Masa Kakitangan',
    ar_eg: 'ساعة حضور الموظفين',
    uk: 'Табель Обліку Часу Персоналу',
  },
  customer_management: {
    en: 'Customer Management',
    es: 'Gestión de Clientes',
    fr: 'Gestion des Clients',
    de: 'Kundenverwaltung',
    pt: 'Gestão de Clientes',
    pl: 'Zarządzanie Klientami',
    nl: 'Klantenbeheer',
    el: 'Διαχείριση Πελατών',
    cs: 'Správa Zákazníků',
    sv: 'Kundhantering',
    hu: 'Ügyfélkezelés',
    da: 'Kundeadministration',
    fi: 'Asiakashallinta',
    sk: 'Správa Zákazníkov',
    bg: 'Управление на Клиенти',
    hr: 'Upravljanje Kupcima',
    lt: 'Klientų Valdymas',
    lv: 'Klientu Pārvaldība',
    et: 'Kliendihaldus',
    sl: 'Upravljanje Strank',
    ga: 'Bainistíocht Custaiméirí',
    mt: 'Ġestjoni tal-Klijenti',
    cy: 'Rheoli Cwsmeriaid',
    ro: 'Managementul Clienților',
    it: 'Gestione dei Clienti',
    zh_cn: '客户管理',
    hi: 'ग्राहक प्रबंधन',
    ar: 'إدارة العملاء',
    bn: 'গ্রাহক ব্যবস্থাপনা',
    ru: 'Управление Клиентами',
    ja: '顧客管理',
    tr: 'Müşteri Yönetimi',
    ko: '고객 관리',
    vi: 'Quản Lý Khách Hàng',
    id: 'Manajemen Pelanggan',
    th: 'การจัดการลูกค้า',
    ms: 'Pengurusan Pelanggan',
    ar_eg: 'إدارة العملاء',
    uk: 'Управління Клієнтами',
  },
  video: {
    en: 'Video',
    es: 'Video',
    fr: 'Vidéo',
    de: 'Video',
    pt: 'Vídeo',
    pl: 'Wideo',
    nl: 'Video',
    el: 'Βίντεο',
    cs: 'Video',
    sv: 'Video',
    hu: 'Videó',
    da: 'Video',
    fi: 'Video',
    sk: 'Video',
    bg: 'Видео',
    hr: 'Video',
    lt: 'Vaizdo Įrašas',
    lv: 'Video',
    et: 'Video',
    sl: 'Video',
    ga: 'Físeán',
    mt: 'Vidjo',
    cy: 'Fideo',
    ro: 'Video',
    it: 'Video',
    zh_cn: '视频',
    hi: 'वीडियो',
    ar: 'فيديو',
    bn: 'ভিডিও',
    ru: 'Видео',
    ja: 'ビデオ',
    tr: 'Video',
    ko: '비디오',
    vi: 'Video',
    id: 'Video',
    th: 'วิดีโอ',
    ms: 'Video',
    ar_eg: 'فيديو',
    uk: 'Відео',
  },
  copy_to_clipboard: {
    en: 'Copy To Clipboard',
    es: 'Copiar al portapapeles',
    fr: 'Copier dans le presse-papiers',
    de: 'In die Zwischenablage kopieren',
    pt: 'Copiar para a área de transferência',
    pl: 'Skopiuj do schowka',
    nl: 'Kopiëren naar klembord',
    el: 'Αντιγραφή στο πρόχειρο',
    cs: 'Kopírovat do schránky',
    sv: 'Kopiera till urklipp',
    hu: 'Másolás a vágólapra',
    da: 'Kopiér til udklipsholder',
    fi: 'Kopioi leikepöydälle',
    sk: 'Kopírovať do schránky',
    bg: 'Копиране в клипборда',
    hr: 'Kopiraj u međuspremnik',
    lt: 'Kopijuoti į iškarpinę',
    lv: 'Kopēt uz starpliktuvi',
    et: 'Kopeeri lõikelauale',
    sl: 'Kopiraj v odložišče',
    ga: 'Cóipeáil chuig an ghearrthaisce',
    mt: 'Kopja fil-clipboard',
    cy: "Copïo i'r clipfwrdd",
    ro: 'Copiază în clipboard',
    it: 'Copia negli appunti',
    zh_cn: '复制到剪贴板',
    hi: 'क्लिपबोर्ड पर कॉपी करें',
    ar: 'نسخ إلى الحافظة',
    bn: 'ক্লিপবোর্ডে অনুলিপি করুন',
    ru: 'Копировать в буфер обмена',
    ja: 'クリップボードにコピー',
    tr: 'Panoya Kopyala',
    ko: '클립보드에 복사',
    vi: 'Sao chép vào bảng tạm',
    id: 'Salin ke papan klip',
    th: 'คัดลอกไปยังคลิปบอร์ด',
    ms: 'Salin ke papan keratan',
    ar_eg: 'نسخ إلى الحافظة',
    uk: 'Скопіювати в буфер обміну',
  },
  powered_by: {
    en: 'Powered by',
    es: 'Desarrollado por',
    fr: 'Propulsé par',
    de: 'Angetrieben von',
    pt: 'Desenvolvido por',
    pl: 'Zasilany przez',
    nl: 'Aangedreven door',
    el: 'Τροφοδοτείται από',
    cs: 'Poháněno',
    sv: 'Drivs av',
    hu: 'Működteti',
    da: 'Drevet af',
    fi: 'Toimii',
    sk: 'Poháňané',
    bg: 'Задвижвано от',
    hr: 'Pokreće',
    lt: 'Varomas',
    lv: 'Darbina',
    et: 'Töötab',
    sl: 'Poganja',
    ga: 'Á thiomáint ag',
    mt: 'Immexxi minn',
    cy: "Wedi'i bweru gan",
    ro: 'Susținut de',
    it: 'Offerto da',
    zh_cn: '技术支持',
    hi: 'द्वारा संचालित',
    ar: 'مدعوم من',
    bn: 'দ্বারা চালিত',
    ru: 'Работает на',
    ja: '提供元',
    tr: 'Tarafından desteklenmektedir',
    ko: '구동:',
    vi: 'Cung cấp bởi',
    id: 'Didukung oleh',
    th: 'ขับเคลื่อนโดย',
    ms: 'Dikuasakan oleh',
    ar_eg: 'مدعوم من',
    uk: 'Працює на',
  },
  and: {
    en: 'and',
    es: 'y',
    fr: 'et',
    de: 'und',
    pt: 'e',
    pl: 'i',
    nl: 'en',
    el: 'και',
    cs: 'a',
    sv: 'och',
    hu: 'és',
    da: 'og',
    fi: 'ja',
    sk: 'a',
    bg: 'и',
    hr: 'i',
    lt: 'ir',
    lv: 'un',
    et: 'ja',
    sl: 'in',
    ga: 'agus',
    mt: 'u',
    cy: 'a',
    ro: 'și',
    it: 'e',
    zh_cn: '和',
    hi: 'और',
    ar: 'و',
    bn: 'এবং',
    ru: 'и',
    ja: 'と',
    tr: 've',
    ko: '그리고',
    vi: 'và',
    id: 'dan',
    th: 'และ',
    ms: 'dan',
    ar_eg: 'و',
    uk: 'і',
  },
  rate: {
    en: 'Rate',
    es: 'Tasa',
    fr: 'Taux',
    de: 'Satz',
    pt: 'Taxa',
    pl: 'Stawka',
    nl: 'Tarief',
    el: 'Συντελεστής',
    cs: 'Sazba',
    sv: 'Sats',
    hu: 'Arány',
    da: 'Sats',
    fi: 'Prosentti',
    sk: 'Sadzba',
    bg: 'Ставка',
    hr: 'Stopa',
    lt: 'Tarifas',
    lv: 'Likme',
    et: 'Määr',
    sl: 'Stopnja',
    ga: 'Ráta',
    mt: 'Rata',
    cy: 'Cyfradd',
    ro: 'Rată',
    it: 'Aliquota',
    zh_cn: '费率',
    hi: 'दर',
    ar: 'معدل',
    bn: 'হার',
    ru: 'Ставка',
    ja: '率',
    tr: 'Oran',
    ko: '비율',
    vi: 'Tỷ lệ',
    id: 'Tarif',
    th: 'อัตรา',
    ms: 'Kadar',
    ar_eg: 'معدل',
    uk: 'Ставка',
  },
  okay: {
    en: 'Okay',
    es: 'Aceptar',
    fr: 'D’accord',
    de: 'Okay',
    pt: 'Ok',
    pl: 'Zgoda',
    nl: 'Oké',
    el: 'Εντάξει',
    cs: 'Ok',
    sv: 'Okej',
    hu: 'Rendben',
    da: 'Okay',
    fi: 'Okei',
    sk: 'Ok',
    bg: 'Добре',
    hr: 'U redu',
    lt: 'Gerai',
    lv: 'Labi',
    et: 'Okei',
    sl: 'V redu',
    ga: 'Ceart go leor',
    mt: 'Okay',
    cy: 'Iawn',
    ro: 'Ok',
    it: 'Ok',
    zh_cn: '好的',
    hi: 'ठीक है',
    ar: 'حسنًا',
    bn: 'ঠিক আছে',
    ru: 'Окей',
    ja: 'オーケー',
    tr: 'Tamam',
    ko: '확인',
    vi: 'Đồng ý',
    id: 'Oke',
    th: 'ตกลง',
    ms: 'Okey',
    ar_eg: 'ماشي',
    uk: 'Гаразд',
  },
  unknown_error: {
    en: 'An unknown error occurred',
    es: 'Ocurrió un error desconocido',
    fr: "Une erreur inconnue s'est produite",
    de: 'Ein unbekannter Fehler ist aufgetreten',
    pt: 'Ocorreu um erro desconhecido',
    pl: 'Wystąpił nieznany błąd',
    nl: 'Er is een onbekende fout opgetreden',
    el: 'Παρουσιάστηκε άγνωστο σφάλμα',
    cs: 'Došlo k neznámé chybě',
    sv: 'Ett okänt fel inträffade',
    hu: 'Ismeretlen hiba történt',
    da: 'Der opstod en ukendt fejl',
    fi: 'Tuntematon virhe tapahtui',
    sk: 'Vyskytla sa neznáma chyba',
    bg: 'Възникна неизвестна грешка',
    hr: 'Došlo je do nepoznate greške',
    lt: 'Įvyko nežinoma klaida',
    lv: 'Radās nezināma kļūda',
    et: 'Tekkis tundmatu viga',
    sl: 'Prišlo je do neznane napake',
    ga: 'Tharla earráid anaithnid',
    mt: 'Seħħet żball mhux magħruf',
    cy: 'Digwyddodd gwall anhysbys',
    ro: 'A apărut o eroare necunoscută',
    it: 'Si è verificato un errore sconosciuto',
    zh_cn: '发生了未知错误',
    hi: 'अज्ञात त्रुटि हुई',
    ar: 'حدث خطأ غير معروف',
    bn: 'একটি অজানা ত্রুটি ঘটেছে',
    ru: 'Произошла неизвестная ошибка',
    ja: '不明なエラーが発生しました',
    tr: 'Bilinmeyen bir hata oluştu',
    ko: '알 수 없는 오류가 발생했습니다',
    vi: 'Đã xảy ra lỗi không xác định',
    id: 'Terjadi kesalahan yang tidak diketahui',
    th: 'เกิดข้อผิดพลาดที่ไม่รู้จัก',
    ms: 'Ralat yang tidak diketahui berlaku',
    ar_eg: 'حدث خطأ غير معروف',
    uk: 'Сталася невідома помилка',
  },
  more: {
    en: 'More',
    es: 'Más',
    fr: 'Plus',
    de: 'Mehr',
    pt: 'Mais',
    pl: 'Więcej',
    nl: 'Meer',
    el: 'Περισσότερα',
    cs: 'Více',
    sv: 'Mer',
    hu: 'Több',
    da: 'Mere',
    fi: 'Lisää',
    sk: 'Viac',
    bg: 'Още',
    hr: 'Više',
    lt: 'Daugiau',
    lv: 'Vairāk',
    et: 'Rohkem',
    sl: 'Več',
    ga: 'Níos mó',
    mt: 'Aktar',
    cy: 'Mwy',
    ro: 'Mai mult',
    it: 'Altro',
    zh_cn: '更多',
    hi: 'अधिक',
    ar: 'المزيد',
    bn: 'আরও',
    ru: 'Ещё',
    ja: 'もっと',
    tr: 'Daha fazla',
    ko: '더',
    vi: 'Thêm',
    id: 'Lebih',
    th: 'เพิ่มเติม',
    ms: 'Lagi',
    ar_eg: 'المزيد',
    uk: 'Більше',
  },
  unit_cost: {
    en: 'Unit Cost',
    es: 'Costo unitario',
    fr: 'Coût unitaire',
    de: 'Stückkosten',
    pt: 'Custo unitário',
    pl: 'Koszt jednostkowy',
    nl: 'Kostprijs per eenheid',
    el: 'Κόστος μονάδας',
    cs: 'Jednotkové náklady',
    sv: 'Enhetskostnad',
    hu: 'Egységköltség',
    da: 'Enhedsomkostning',
    fi: 'Yksikkökustannus',
    sk: 'Jednotkové náklady',
    bg: 'Единична цена',
    hr: 'Jedinični trošak',
    lt: 'Vieneto kaina',
    lv: 'Vienības izmaksas',
    et: 'Ühiku maksumus',
    sl: 'Enotni strošek',
    ga: 'Costas Aonaid',
    mt: 'Spiża unitarja',
    cy: 'Cost Uned',
    ro: 'Cost unitar',
    it: 'Costo unitario',
    zh_cn: '单位成本',
    hi: 'यूनिट लागत',
    ar: 'تكلفة الوحدة',
    bn: 'একক খরচ',
    ru: 'Себестоимость единицы',
    ja: '単価',
    tr: 'Birim Maliyet',
    ko: '단위 비용',
    vi: 'Chi phí đơn vị',
    id: 'Biaya per unit',
    th: 'ต้นทุนต่อหน่วย',
    ms: 'Kos seunit',
    ar_eg: 'تكلفة الوحدة',
    uk: 'Вартість одиниці',
  },
  line_total: {
    en: 'Line Total',
    es: 'Total de línea',
    fr: 'Total de la ligne',
    de: 'Zeilensumme',
    pt: 'Total da linha',
    pl: 'Suma pozycji',
    nl: 'Lijn totaal',
    el: 'Σύνολο γραμμής',
    cs: 'Řádkový součet',
    sv: 'Radsumma',
    hu: 'Sorösszeg',
    da: 'Linjetotal',
    fi: 'Rivin kokonaissumma',
    sk: 'Celkova suma riadku',
    bg: 'Обща сума за реда',
    hr: 'Ukupno za stavku',
    lt: 'Eilutės suma',
    lv: 'Rindas kopsumma',
    et: 'Rea kogusumma',
    sl: 'Skupni znesek vrstice',
    ga: 'Iomlán Líne',
    mt: 'Total tal-linja',
    cy: 'Cyfanswm llinell',
    ro: 'Total linie',
    it: 'Totale riga',
    zh_cn: '行总计',
    hi: 'लाइन कुल',
    ar: 'إجمالي السطر',
    bn: 'লাইন মোট',
    ru: 'Итог по строке',
    ja: '行合計',
    tr: 'Satır Toplamı',
    ko: '행 합계',
    vi: 'Tổng dòng',
    id: 'Total baris',
    th: 'ยอดรวมรายการ',
    ms: 'Jumlah baris',
    ar_eg: 'إجمالي السطر',
    uk: 'Підсумок рядка',
  },
  discount: {
    en: 'Discount',
    es: 'Descuento',
    fr: 'Remise',
    de: 'Rabatt',
    pt: 'Desconto',
    pl: 'Zniżka',
    nl: 'Korting',
    el: 'Έκπτωση',
    cs: 'Sleva',
    sv: 'Rabatt',
    hu: 'Kedvezmény',
    da: 'Rabat',
    fi: 'Alennus',
    sk: 'Zľava',
    bg: 'Отстъпка',
    hr: 'Popust',
    lt: 'Nuolaida',
    lv: 'Atlaide',
    et: 'Allahindlus',
    sl: 'Popust',
    ga: 'Lascaine',
    mt: 'Skont',
    cy: 'Disgownt',
    ro: 'Reducere',
    it: 'Sconto',
    zh_cn: '折扣',
    hi: 'छूट',
    ar: 'خصم',
    bn: 'ডিসকাউন্ট',
    ru: 'Скидка',
    ja: '割引',
    tr: 'İndirim',
    ko: '할인',
    vi: 'Giảm Giá',
    id: 'Diskon',
    th: 'ส่วนลด',
    ms: 'Diskaun',
    ar_eg: 'خصم',
    uk: 'Знижка',
  },
  deduction: {
    en: 'Deduction',
    es: 'Deducción',
    fr: 'Déduction',
    de: 'Abzug',
    pt: 'Dedução',
    pl: 'Odliczenie',
    nl: 'Aftrek',
    el: 'Έκπτωση',
    cs: 'Odpočet',
    sv: 'Avdrag',
    hu: 'Levonás',
    da: 'Fradrag',
    fi: 'Vähennys',
    sk: 'Odpočet',
    bg: 'Приспадане',
    hr: 'Odbitak',
    lt: 'Atskaitymas',
    lv: 'Atskaitījums',
    et: 'Mahaarvamine',
    sl: 'Odbitek',
    ga: 'Asbhaint',
    mt: 'Tnaqqis',
    cy: 'Didyniad',
    ro: 'Deducere',
    it: 'Detrazione',
    zh_cn: '扣除',
    hi: 'कटौती',
    ar: 'خصم',
    bn: 'কর্তন',
    ru: 'Вычет',
    ja: '控除',
    tr: 'Kesinti',
    ko: '공제',
    vi: 'Khấu trừ',
    id: 'Potongan',
    th: 'การหักลด',
    ms: 'Potongan',
    ar_eg: 'خصم',
    uk: 'Відрахування',
  },
  promotion: {
    en: 'Promotion',
    es: 'Promoción',
    fr: 'Promotion',
    de: 'Aktion',
    pt: 'Promoção',
    pl: 'Promocja',
    nl: 'Promotie',
    el: 'Προσφορά',
    cs: 'Promoce',
    sv: 'Kampanj',
    hu: 'Akció',
    da: 'Kampagne',
    fi: 'Kampanja',
    sk: 'Propagácia',
    bg: 'Промоция',
    hr: 'Promocija',
    lt: 'Akcija',
    lv: 'Akcija',
    et: 'Kampaania',
    sl: 'Promocija',
    ga: 'Cur Chun Cinn',
    mt: 'Promozzjoni',
    cy: 'Hyrwyddiad',
    ro: 'Promoție',
    it: 'Promozione',
    zh_cn: '促销',
    hi: 'प्रमोशन',
    ar: 'عرض ترويجي',
    bn: 'প্রচার',
    ru: 'Акция',
    ja: 'プロモーション',
    tr: 'Kampanya',
    ko: '프로모션',
    vi: 'Khuyến Mãi',
    id: 'Promosi',
    th: 'โปรโมชั่น',
    ms: 'Promosi',
    ar_eg: 'عرض ترويجي',
    uk: 'Промоція',
  },
  promotions: {
    en: 'Promotions',
    es: 'Promociones',
    fr: 'Promotions',
    de: 'Aktionen',
    pt: 'Promoções',
    pl: 'Promocje',
    nl: 'Promoties',
    el: 'Προσφορές',
    cs: 'Promoce',
    sv: 'Kampanjer',
    hu: 'Akciók',
    da: 'Kampagner',
    fi: 'Kampanjat',
    sk: 'Propagácie',
    bg: 'Промоции',
    hr: 'Promocije',
    lt: 'Akcijos',
    lv: 'Akcijas',
    et: 'Kampaaniad',
    sl: 'Promocije',
    ga: 'Cur Chun Cinn',
    mt: 'Promozzjonijiet',
    cy: 'Hyrwyddiadau',
    ro: 'Promoții',
    it: 'Promozioni',
    zh_cn: '促销活动',
    hi: 'प्रमोशन्स',
    ar: 'عروض ترويجية',
    bn: 'প্রচারণা',
    ru: 'Акции',
    ja: 'プロモーション',
    tr: 'Kampanyalar',
    ko: '프로모션',
    vi: 'Các Khuyến Mãi',
    id: 'Promosi-Promosi',
    th: 'โปรโมชั่นต่างๆ',
    ms: 'Promosi-Promosi',
    ar_eg: 'عروض ترويجية',
    uk: 'Промоції',
  },
  delivery: {
    en: 'Delivery',
    es: 'Entrega',
    fr: 'Livraison',
    de: 'Lieferung',
    pt: 'Entrega',
    pl: 'Dostawa',
    nl: 'Bezorging',
    el: 'Παράδοση',
    cs: 'Doručení',
    sv: 'Leverans',
    hu: 'Kiszállítás',
    da: 'Levering',
    fi: 'Toimitus',
    sk: 'Doručenie',
    bg: 'Доставка',
    hr: 'Dostava',
    lt: 'Pristatymas',
    lv: 'Piegāde',
    et: 'Kohaletoimetamine',
    sl: 'Dostava',
    ga: 'Seachadadh',
    mt: 'Kunsinna',
    cy: 'Dosbarthiad',
    ro: 'Livrare',
    it: 'Consegna',
    zh_cn: '配送',
    hi: 'डिलीवरी',
    ar: 'التوصيل',
    bn: 'ডেলিভারি',
    ru: 'Доставка',
    ja: '配達',
    tr: 'Teslimat',
    ko: '배달',
    vi: 'Giao Hàng',
    id: 'Pengiriman',
    th: 'การจัดส่ง',
    ms: 'Penghantaran',
    ar_eg: 'التوصيل',
    uk: 'Доставка',
  },
  tax: {
    en: 'Tax',
    es: 'Impuesto',
    fr: 'Taxe',
    de: 'Steuer',
    pt: 'Imposto',
    pl: 'Podatek',
    nl: 'Belasting',
    el: 'Φόρος',
    cs: 'Daň',
    sv: 'Skatt',
    hu: 'Adó',
    da: 'Skat',
    fi: 'Vero',
    sk: 'Daň',
    bg: 'Данък',
    hr: 'Porez',
    lt: 'Mokestis',
    lv: 'Nodoklis',
    et: 'Maks',
    sl: 'Davek',
    ga: 'Cáin',
    mt: 'Taxxa',
    cy: 'Treth',
    ro: 'Taxă',
    it: 'Tassa',
    zh_cn: '税',
    hi: 'कर',
    ar: 'ضريبة',
    bn: 'কর',
    ru: 'Налог',
    ja: '税金',
    tr: 'Vergi',
    ko: '세금',
    vi: 'Thuế',
    id: 'Pajak',
    th: 'ภาษี',
    ms: 'Cukai',
    ar_eg: 'ضريبة',
    uk: 'Податок',
  },
  service_charge: {
    en: 'Service Charge',
    es: 'Cargo por Servicio',
    fr: 'Frais de Service',
    de: 'Servicegebühr',
    pt: 'Taxa de Serviço',
    pl: 'Opłata za Usługę',
    nl: 'Servicekosten',
    el: 'Χρέωση Υπηρεσίας',
    cs: 'Poplatek za Služby',
    sv: 'Serviceavgift',
    hu: 'Szolgáltatási Díj',
    da: 'Servicegebyr',
    fi: 'Palvelumaksu',
    sk: 'Poplatok za Služby',
    bg: 'Такса за Обслужване',
    hr: 'Naknada za Uslugu',
    lt: 'Paslaugų Mokestis',
    lv: 'Pakalpojumu Maksa',
    et: 'Teenustasu',
    sl: 'Strošek Storitve',
    ga: 'Táille Seirbhíse',
    mt: 'Ħlas tas-Servizz',
    cy: 'Tâl Gwasanaeth',
    ro: 'Taxă de Serviciu',
    it: 'Costo del Servizio',
    zh_cn: '服务费',
    hi: 'सेवा शुल्क',
    ar: 'رسوم الخدمة',
    bn: 'পরিসেবা চার্জ',
    ru: 'Плата за Услуги',
    ja: 'サービス料',
    tr: 'Hizmet Bedeli',
    ko: '서비스 요금',
    vi: 'Phí Dịch Vụ',
    id: 'Biaya Layanan',
    th: 'ค่าบริการ',
    ms: 'Caj Perkhidmatan',
    ar_eg: 'رسوم الخدمة',
    uk: 'Плата за Послуги',
  },
  tip: {
    en: 'Tip',
    es: 'Propina',
    fr: 'Pourboire',
    de: 'Trinkgeld',
    pt: 'Gorjeta',
    pl: 'Napiwek',
    nl: 'Fooi',
    el: 'Φιλοδώρημα',
    cs: 'Spropitné',
    sv: 'Dricks',
    hu: 'Borravaló',
    da: 'Drikkepenge',
    fi: 'Tippi',
    sk: 'Sprepitné',
    bg: 'Бакшиш',
    hr: 'Napojnica',
    lt: 'Arbatpinigiai',
    lv: 'Dzeramnauda',
    et: 'Jootraha',
    sl: 'Napojnina',
    ga: 'Leide',
    mt: 'Mgħax',
    cy: 'Tocyn',
    ro: 'Bacșiș',
    it: 'Mancia',
    zh_cn: '小费',
    hi: 'बख्शीश',
    ar: 'إكرامية',
    bn: 'টিপ',
    ru: 'Чаевые',
    ja: 'チップ',
    tr: 'Bahşiş',
    ko: '팁',
    vi: 'Tiền Boa',
    id: 'Tip',
    th: 'ทิป',
    ms: 'Tip',
    ar_eg: 'إكرامية',
    uk: 'Чайові',
  },
  required_qty: {
    en: 'Required Qty',
    es: 'Cantidad Requerida',
    fr: 'Quantité Requise',
    de: 'Erforderliche Menge',
    pt: 'Quantidade Necessária',
    pl: 'Wymagana Ilość',
    nl: 'Vereiste Hoeveelheid',
    el: 'Απαιτούμενη Ποσότητα',
    cs: 'Požadované Množství',
    sv: 'Krävd Kvantitet',
    hu: 'Szükséges Mennyiség',
    da: 'Påkrævet Mængde',
    fi: 'Vaadittu Määrä',
    sk: 'Požadované Množstvo',
    bg: 'Необходимо Количество',
    hr: 'Potrebna Količina',
    lt: 'Reikalingas Kiekis',
    lv: 'Nepieciešamais Daudzums',
    et: 'Nõutav Kogus',
    sl: 'Zahtevana Količina',
    ga: 'Cainníocht Riachtanach',
    mt: 'Kwantità Meħtieġa',
    cy: 'Qty Angenrheidiol',
    ro: 'Cantitate Necesară',
    it: 'Quantità Richiesta',
    zh_cn: '所需数量',
    hi: 'आवश्यक मात्रा',
    ar: 'الكمية المطلوبة',
    bn: 'প্রয়োজনীয় পরিমাণ',
    ru: 'Требуемое Количество',
    ja: '必要な数量',
    tr: 'Gerekli Miktar',
    ko: '필요 수량',
    vi: 'Số Lượng Yêu Cầu',
    id: 'Kuantitas yang Diperlukan',
    th: 'ปริมาณที่ต้องการ',
    ms: 'Kuantiti Diperlukan',
    ar_eg: 'الكمية المطلوبة',
    uk: 'Необхідна Кількість',
  },
  allowed_qty: {
    en: 'Allowed Qty',
    es: 'Cantidad Permitida',
    fr: 'Quantité Autorisée',
    de: 'Erlaubte Menge',
    pt: 'Quantidade Permitida',
    pl: 'Dozwolona Ilość',
    nl: 'Toegestane Hoeveelheid',
    el: 'Επιτρεπόμενη Ποσότητα',
    cs: 'Povolené Množství',
    sv: 'Tillåten Kvantitet',
    hu: 'Engedélyezett Mennyiség',
    da: 'Tilladt Mængde',
    fi: 'Sallittu Määrä',
    sk: 'Povolené Množstvo',
    bg: 'Разрешено Количество',
    hr: 'Dozvoljena Količina',
    lt: 'Leistinas Kiekis',
    lv: 'Atļautais Daudzums',
    et: 'Lubatud Kogus',
    sl: 'Dovoljena Količina',
    ga: 'Cainníocht Ceadaithe',
    mt: 'Kwantità Permessa',
    cy: 'Qty a Ganiateir',
    ro: 'Cantitate Permisă',
    it: 'Quantità Consentita',
    zh_cn: '允许数量',
    hi: 'अनुमत मात्रा',
    ar: 'الكمية المسموح بها',
    bn: 'অনুমোদিত পরিমাণ',
    ru: 'Разрешенное Количество',
    ja: '許可された数量',
    tr: 'İzin Verilen Miktar',
    ko: '허용 수량',
    vi: 'Số Lượng Được Phép',
    id: 'Kuantitas yang Diizinkan',
    th: 'ปริมาณที่อนุญาต',
    ms: 'Kuantiti Dibenarkan',
    ar_eg: 'الكمية المسموح بها',
    uk: 'Дозволена Кількість',
  },
  select_item: {
    en: 'Select Item',
    es: 'Seleccionar elemento',
    fr: 'Sélectionner un élément',
    de: 'Element auswählen',
    pt: 'Selecionar item',
    pl: 'Wybierz element',
    nl: 'Selecteer item',
    el: 'Επιλογή στοιχείου',
    cs: 'Vybrat položku',
    sv: 'Välj objekt',
    hu: 'Elem kiválasztása',
    da: 'Vælg element',
    fi: 'Valitse kohde',
    sk: 'Vyberte položku',
    bg: 'Изберете елемент',
    hr: 'Odaberite stavku',
    lt: 'Pasirinkti elementą',
    lv: 'Izvēlēties vienumu',
    et: 'Vali üksus',
    sl: 'Izberite element',
    ga: 'Roghnaigh Mír',
    mt: 'Agħżel oġġett',
    cy: 'Dewiswch Eitem',
    ro: 'Selectați elementul',
    it: 'Seleziona elemento',
    zh_cn: '选择项目',
    hi: 'आइटम चुनें',
    ar: 'اختر العنصر',
    bn: 'আইটেম নির্বাচন করুন',
    ru: 'Выбрать элемент',
    ja: 'アイテムを選択',
    tr: 'Öğe Seç',
    ko: '항목 선택',
    vi: 'Chọn mục',
    id: 'Pilih item',
    th: 'เลือกไอเท็ม',
    ms: 'Pilih item',
    ar_eg: 'اختر العنصر',
    uk: 'Виберіть елемент',
  },
  phone_number: {
    en: 'Phone Number',
    es: 'Número de teléfono',
    fr: 'Numéro de téléphone',
    de: 'Telefonnummer',
    pt: 'Número de telefone',
    pl: 'Numer telefonu',
    nl: 'Telefoonnummer',
    el: 'Αριθμός τηλεφώνου',
    cs: 'Telefonní číslo',
    sv: 'Telefonnummer',
    hu: 'Telefonszám',
    da: 'Telefonnummer',
    fi: 'Puhelinnumero',
    sk: 'Telefónne číslo',
    bg: 'Телефонен номер',
    hr: 'Broj telefona',
    lt: 'Telefono numeris',
    lv: 'Telefona numurs',
    et: 'Telefoninumber',
    sl: 'Telefonska številka',
    ga: 'Uimhir Theileafóin',
    mt: 'Numru tat-Telefon',
    cy: 'Rhif Ffôn',
    ro: 'Număr de telefon',
    it: 'Numero di telefono',
    zh_cn: '电话号码',
    hi: 'फोन नंबर',
    ar: 'رقم الهاتف',
    bn: 'ফোন নম্বর',
    ru: 'Номер телефона',
    ja: '電話番号',
    tr: 'Telefon Numarası',
    ko: '전화번호',
    vi: 'Số điện thoại',
    id: 'Nomor Telepon',
    th: 'หมายเลขโทรศัพท์',
    ms: 'Nombor Telefon',
    ar_eg: 'رقم التليفون',
    uk: 'Номер телефону',
  },
  integrations: {
    en: 'Integrations',
    es: 'Integraciones',
    fr: 'Intégrations',
    de: 'Integrationen',
    pt: 'Integrações',
    pl: 'Integracje',
    nl: 'Integraties',
    el: 'Ενσωματώσεις',
    cs: 'Integrace',
    sv: 'Integrationer',
    hu: 'Integrációk',
    da: 'Integrationer',
    fi: 'Integraatiot',
    sk: 'Integrácie',
    bg: 'Интеграции',
    hr: 'Integracije',
    lt: 'Integracijos',
    lv: 'Integrācijas',
    et: 'Integratsioonid',
    sl: 'Integracije',
    ga: 'Comhtháthaithe',
    mt: 'Integrazzjonijiet',
    cy: 'Integreiddiadau',
    ro: 'Integrare',
    it: 'Integrazioni',
    zh_cn: '集成',
    hi: 'एकीकरण',
    ar: 'التكاملات',
    bn: 'ইন্টিগ্রেশন',
    ru: 'Интеграции',
    ja: '統合',
    tr: 'Entegrasyonlar',
    ko: '통합',
    vi: 'Tích Hợp',
    id: 'Integrasi',
    th: 'การรวม',
    ms: 'Integrasi',
    ar_eg: 'التكاملات',
    uk: 'Інтеграції',
  },
  staff: {
    en: 'Staff',
    es: 'Personal',
    fr: 'Personnel',
    de: 'Mitarbeiter',
    pt: 'Equipe',
    pl: 'Personel',
    nl: 'Personeel',
    el: 'Προσωπικό',
    cs: 'Personál',
    sv: 'Personal',
    hu: 'Személyzet',
    da: 'Personale',
    fi: 'Henkilöstö',
    sk: 'Personál',
    bg: 'Персонал',
    hr: 'Osoblje',
    lt: 'Personalas',
    lv: 'Personāls',
    et: 'Töötajad',
    sl: 'Osebje',
    ga: 'Foireann',
    mt: 'Persunal',
    cy: 'Staff',
    ro: 'Personal',
    it: 'Personale',
    zh_cn: '员工',
    hi: 'कर्मचारी',
    ar: 'الموظفون',
    bn: 'কর্মী',
    ru: 'Персонал',
    ja: 'スタッフ',
    tr: 'Personel',
    ko: '직원',
    vi: 'Nhân Viên',
    id: 'Staf',
    th: 'พนักงาน',
    ms: 'Kakitangan',
    ar_eg: 'الموظفون',
    uk: 'Персонал',
  },
  manage_account: {
    en: 'Manage Account',
    es: 'Gestionar Cuenta',
    fr: 'Gérer le Compte',
    de: 'Konto Verwalten',
    pt: 'Gerir Conta',
    pl: 'Zarządzaj Kontem',
    nl: 'Account Beheren',
    el: 'Διαχείριση Λογαριασμού',
    cs: 'Správa Účtu',
    sv: 'Hantera Konto',
    hu: 'Fiók Kezelése',
    da: 'Administrer Konto',
    fi: 'Hallitse Tiliä',
    sk: 'Spravovať Účet',
    bg: 'Управление на Акаунт',
    hr: 'Upravljanje Računom',
    lt: 'Tvarkyti Paskyrą',
    lv: 'Pārvaldīt Kontu',
    et: 'Halda Kontot',
    sl: 'Upravljanje Računa',
    ga: 'Bainistigh an Cuntas',
    mt: 'Immaniġġja l-Kont',
    cy: 'Rheoli Cyfrif',
    ro: 'Gestionează Contul',
    it: 'Gestisci Account',
    zh_cn: '管理账户',
    hi: 'खाता प्रबंधित करें',
    ar: 'إدارة الحساب',
    bn: 'অ্যাকাউন্ট পরিচালনা করুন',
    ru: 'Управление Аккаунтом',
    ja: 'アカウントを管理する',
    tr: 'Hesabı Yönet',
    ko: '계정 관리',
    vi: 'Quản Lý Tài Khoản',
    id: 'Kelola Akun',
    th: 'จัดการบัญชี',
    ms: 'Urus Akaun',
    ar_eg: 'إدارة الحساب',
    uk: 'Керувати Обліковим Записом',
  },
  subscription_and_plans: {
    en: 'Subscription & Plans',
    es: 'Suscripción y Planes',
    fr: 'Abonnement et Plans',
    de: 'Abonnement und Pläne',
    pt: 'Assinatura e Planos',
    pl: 'Subskrypcja i Plany',
    nl: 'Abonnementen en Plannen',
    el: 'Συνδρομή και Σχέδια',
    cs: 'Předplatné a Plány',
    sv: 'Prenumeration och Planer',
    hu: 'Előfizetés és Tervek',
    da: 'Abonnement og Planer',
    fi: 'Tilaukset ja Suunnitelmat',
    sk: 'Predplatné a Plány',
    bg: 'Абонамент и Планове',
    hr: 'Pretplata i Planovi',
    lt: 'Prenumerata ir Planai',
    lv: 'Abonements un Plāni',
    et: 'Tellimus ja Plaanid',
    sl: 'Naročnina in Načrti',
    ga: 'Síntiús agus Pleananna',
    mt: 'Abbonament u Pjanijiet',
    cy: 'Tanysgrifio a Chynlluniau',
    ro: 'Abonament și Planuri',
    it: 'Abbonamenti e Piani',
    zh_cn: '订阅和计划',
    hi: 'सदस्यता और योजनाएँ',
    ar: 'الاشتراكات والخطط',
    bn: 'সাবস্ক্রিপশন এবং পরিকল্পনা',
    ru: 'Подписка и Планы',
    ja: 'サブスクリプションとプラン',
    tr: 'Abonelik ve Planlar',
    ko: '구독 및 계획',
    vi: 'Gói Đăng Ký & Kế Hoạch',
    id: 'Langganan & Paket',
    th: 'การสมัครสมาชิกและแผน',
    ms: 'Langganan & Pelan',
    ar_eg: 'الاشتراكات والخطط',
    uk: 'Підписка та Плани',
  },
  system_settings: {
    en: 'System Settings',
    es: 'Configuración del Sistema',
    fr: 'Paramètres du Système',
    de: 'Systemeinstellungen',
    pt: 'Configurações do Sistema',
    pl: 'Ustawienia Systemu',
    nl: 'Systeeminstellingen',
    el: 'Ρυθμίσεις Συστήματος',
    cs: 'Systémová Nastavení',
    sv: 'Systeminställningar',
    hu: 'Rendszerbeállítások',
    da: 'Systemindstillinger',
    fi: 'Järjestelmäasetukset',
    sk: 'Nastavenia Systému',
    bg: 'Настройки на Системата',
    hr: 'Postavke Sustava',
    lt: 'Sistemos Nustatymai',
    lv: 'Sistēmas Iestatījumi',
    et: 'Süsteemi Seaded',
    sl: 'Nastavitve Sistema',
    ga: 'Socruithe Córa',
    mt: 'Settings tas-Sistema',
    cy: 'Gosodiadau System',
    ro: 'Setări de Sistem',
    it: 'Impostazioni di Sistema',
    zh_cn: '系统设置',
    hi: 'सिस्टम सेटिंग्स',
    ar: 'إعدادات النظام',
    bn: 'সিস্টেম সেটিংস',
    ru: 'Настройки Системы',
    ja: 'システム設定',
    tr: 'Sistem Ayarları',
    ko: '시스템 설정',
    vi: 'Cài Đặt Hệ Thống',
    id: 'Pengaturan Sistem',
    th: 'การตั้งค่าระบบ',
    ms: 'Tetapan Sistem',
    ar_eg: 'إعدادات النظام',
    uk: 'Налаштування Системи',
  },
  receipt_templates: {
    en: 'Receipt Templates',
    es: 'Plantillas de Recibos',
    fr: 'Modèles de Reçus',
    de: 'Vorlagen für Belege',
    pt: 'Modelos de Recibos',
    pl: 'Szablony Paragonów',
    nl: 'Bon Sjablonen',
    el: 'Πρότυπα Αποδείξεων',
    cs: 'Šablony Účtenek',
    sv: 'Kvitto Mallar',
    hu: 'Nyugtasablonok',
    da: 'Kvitteringsskabeloner',
    fi: 'Kuittimallit',
    sk: 'Šablóny Pokladničných Dokladov',
    bg: 'Шаблони за Касови Бележки',
    hr: 'Predlošci Računa',
    lt: 'Kvito Šablonai',
    lv: 'Kvīšu Veidnes',
    et: 'Kviitungi Mallid',
    sl: 'Predloge Računov',
    ga: 'Teimpléid Admhálacha',
    mt: 'Mudelli ta’ Riċevuti',
    cy: 'Templedi Derbynneb',
    ro: 'Șabloane de Chitanțe',
    it: 'Modelli di Ricevute',
    zh_cn: '收据模板',
    hi: 'रसीद टेम्पलेट्स',
    ar: 'قوالب الإيصالات',
    bn: 'রসিদের টেম্পলেট',
    ru: 'Шаблоны Квитанций',
    ja: '領収書テンプレート',
    tr: 'Fiş Şablonları',
    ko: '영수증 템플릿',
    vi: 'Mẫu Biên Nhận',
    id: 'Template Tanda Terima',
    th: 'แม่แบบใบเสร็จ',
    ms: 'Templat Resit',
    ar_eg: 'قوالب الإيصالات',
    uk: 'Шаблони Квитанцій',
  },
  print_receipt: {
    en: 'Print Receipt',
    es: 'Imprimir recibo',
    fr: 'Imprimer le reçu',
    de: 'Beleg drucken',
    pt: 'Imprimir recibo',
    pl: 'Drukuj paragon',
    nl: 'Bon afdrukken',
    el: 'Εκτύπωση απόδειξης',
    cs: 'Tisk účtenky',
    sv: 'Skriv ut kvitto',
    hu: 'Nyugta nyomtatása',
    da: 'Udskriv kvittering',
    fi: 'Tulosta kuitti',
    sk: 'Tlačiť účtenku',
    bg: 'Печат на касова бележка',
    hr: 'Ispis računa',
    lt: 'Spausdinti kvitą',
    lv: 'Drukāt čeku',
    et: 'Prindi kviitung',
    sl: 'Natisni račun',
    ga: 'Priontáil admháil',
    mt: 'Ipprintja rċevuta',
    cy: 'Argraffu derbynneb',
    ro: 'Tipărește bonul',
    it: 'Stampa ricevuta',
    zh_cn: '打印收据',
    hi: 'रसीद प्रिंट करें',
    ar: 'طباعة الإيصال',
    bn: 'রসিদ প্রিন্ট করুন',
    ru: 'Печать чека',
    ja: 'レシートを印刷',
    tr: 'Fiş yazdır',
    ko: '영수증 인쇄',
    vi: 'In biên lai',
    id: 'Cetak struk',
    th: 'พิมพ์ใบเสร็จ',
    ms: 'Cetak resit',
    ar_eg: 'طباعة الإيصال',
    uk: 'Друк чека',
  },
  digital_menu: {
    en: 'Digital Menu',
    es: 'Menú Digital',
    fr: 'Menu Numérique',
    de: 'Digitales Menü',
    pt: 'Menu Digital',
    pl: 'Menu Cyfrowe',
    nl: 'Digitaal Menu',
    el: 'Ψηφιακό Μενού',
    cs: 'Digitální Menu',
    sv: 'Digital Meny',
    hu: 'Digitális Menü',
    da: 'Digital Menu',
    fi: 'Digitaalinen Menu',
    sk: 'Digitálne Menu',
    bg: 'Дигитално Меню',
    hr: 'Digitalni Meni',
    lt: 'Skaitmeninis Meniu',
    lv: 'Digitālā Ēdienkarte',
    et: 'Digitaalne Menüü',
    sl: 'Digitalni Meni',
    ga: 'Biachlár Digiteach',
    mt: 'Menu Diġitali',
    cy: 'Dewislen Ddigidol',
    ro: 'Meniu Digital',
    it: 'Menu Digitale',
    zh_cn: '数字菜单',
    hi: 'डिजिटल मेनू',
    ar: 'القائمة الرقمية',
    bn: 'ডিজিটাল মেনু',
    ru: 'Цифровое Меню',
    ja: 'デジタルメニュー',
    tr: 'Dijital Menü',
    ko: '디지털 메뉴',
    vi: 'Thực Đơn Kỹ Thuật Số',
    id: 'Menu Digital',
    th: 'เมนูดิจิทัล',
    ms: 'Menu Digital',
    ar_eg: 'القائمة الرقمية',
    uk: 'Цифрове Меню',
  },
  archives: {
    en: 'Archives',
    es: 'Archivos',
    fr: 'Archives',
    de: 'Archive',
    pt: 'Arquivos',
    pl: 'Archiwa',
    nl: 'Archieven',
    el: 'Αρχεία',
    cs: 'Archivy',
    sv: 'Arkiv',
    hu: 'Archívumok',
    da: 'Arkiver',
    fi: 'Arkistot',
    sk: 'Archívy',
    bg: 'Архиви',
    hr: 'Arhive',
    lt: 'Archyvai',
    lv: 'Arhīvi',
    et: 'Arhiivid',
    sl: 'Arhivi',
    ga: 'Cartlanna',
    mt: 'Arkivji',
    cy: 'Archifau',
    ro: 'Arhive',
    it: 'Archivi',
    zh_cn: '档案',
    hi: 'अभिलेखागार',
    ar: 'الأرشيفات',
    bn: 'আর্কাইভ',
    ru: 'Архивы',
    ja: 'アーカイブ',
    tr: 'Arşivler',
    ko: '아카이브',
    vi: 'Lưu Trữ',
    id: 'Arsip',
    th: 'คลังข้อมูล',
    ms: 'Arkib',
    ar_eg: 'الأرشيفات',
    uk: 'Архіви',
  },
  pos_profiles: {
    en: 'POS Profiles',
    es: 'Perfiles de Punto de Venta',
    fr: 'Profils de Point de Vente',
    de: 'POS-Profile',
    pt: 'Perfis de Ponto de Venda',
    pl: 'Profile POS',
    nl: 'POS-profielen',
    el: 'Προφίλ Σημείων Πώλησης',
    cs: 'Profily POS',
    sv: 'POS-profiler',
    hu: 'POS-profilok',
    da: 'POS-profiler',
    fi: 'POS-profiilit',
    sk: 'Profily POS',
    bg: 'Профили на POS',
    hr: 'POS profili',
    lt: 'POS profiliai',
    lv: 'POS profili',
    et: 'POS-profiilid',
    sl: 'POS profili',
    ga: 'Próifílí POS',
    mt: 'Profili tal-POS',
    cy: 'Proffiliau POS',
    ro: 'Profiluri POS',
    it: 'Profili POS',
    zh_cn: 'POS配置文件',
    hi: 'पीओएस प्रोफाइल',
    ar: 'ملفات تعريف نقاط البيع',
    bn: 'পিওএস প্রোফাইল',
    ru: 'Профили POS',
    ja: 'POSプロファイル',
    tr: 'POS Profilleri',
    ko: 'POS 프로필',
    vi: 'Hồ sơ POS',
    id: 'Profil POS',
    th: 'โปรไฟล์ POS',
    ms: 'Profil POS',
    ar_eg: 'ملفات تعريف نقاط البيع',
    uk: 'Профілі POS',
  },
  device_licences: {
    en: 'Device Licences',
    es: 'Licencias de Dispositivos',
    fr: "Licences d'Appareils",
    de: 'Gerätelizenzen',
    pt: 'Licenças de Dispositivos',
    pl: 'Licencje Urządzeń',
    nl: 'Apparaatlicenties',
    el: 'Άδειες Συσκευών',
    cs: 'Licence Zařízení',
    sv: 'Enhetslicenser',
    hu: 'Eszközlicencek',
    da: 'Enhedslicenser',
    fi: 'Laitteiden Lisenssit',
    sk: 'Licencie Zariadení',
    bg: 'Лицензи за Устройства',
    hr: 'Licencije za Uređaje',
    lt: 'Įrenginių Licencijos',
    lv: 'Ierīču Licences',
    et: 'Seadme Litsentsid',
    sl: 'Licence za Naprave',
    ga: 'Ceadúnais Gléasanna',
    mt: "Liċenzji ta' Tagħmir",
    cy: 'Trwyddedau Dyfais',
    ro: 'Licențe Dispozitive',
    it: 'Licenze Dispositivi',
    zh_cn: '设备许可证',
    hi: 'डिवाइस लाइसेंस',
    ar: 'تراخيص الأجهزة',
    bn: 'ডিভাইস লাইসেন্স',
    ru: 'Лицензии на Устройства',
    ja: 'デバイスライセンス',
    tr: 'Cihaz Lisansları',
    ko: '장치 라이선스',
    vi: 'Giấy Phép Thiết Bị',
    id: 'Lisensi Perangkat',
    th: 'ใบอนุญาตอุปกรณ์',
    ms: 'Lesen Peranti',
    ar_eg: 'تراخيص الأجهزة',
    uk: 'Ліцензії на Пристрої',
  },
  printing_setups: {
    en: 'Printing Setups',
    es: 'Configuraciones de Impresión',
    fr: "Configurations d'Impression",
    de: 'Druckeinstellungen',
    pt: 'Configurações de Impressão',
    pl: 'Ustawienia Druku',
    nl: 'Afdrukinstellingen',
    el: 'Ρυθμίσεις Εκτύπωσης',
    cs: 'Nastavení Tisku',
    sv: 'Utskriftsinställningar',
    hu: 'Nyomtatási Beállítások',
    da: 'Udskrivningsopsætninger',
    fi: 'Tulostusasetukset',
    sk: 'Nastavenia Tlače',
    bg: 'Настройки за Печат',
    hr: 'Postavke Ispisa',
    lt: 'Spausdinimo Nustatymai',
    lv: 'Drukāšanas Iestatījumi',
    et: 'Trükkimise Seaded',
    sl: 'Nastavitve Tiskanja',
    ga: 'Socruithe Clódála',
    mt: 'Setup tal-Istampar',
    cy: 'Gosodiadau Argraffu',
    ro: 'Setări de Tipărire',
    it: 'Impostazioni di Stampa',
    zh_cn: '打印设置',
    hi: 'प्रिंटिंग सेटअप्स',
    ar: 'إعدادات الطباعة',
    bn: 'প্রিন্টিং সেটআপ',
    ru: 'Настройки Печати',
    ja: '印刷設定',
    tr: 'Baskı Ayarları',
    ko: '인쇄 설정',
    vi: 'Cài Đặt In Ấn',
    id: 'Pengaturan Pencetakan',
    th: 'การตั้งค่าการพิมพ์',
    ms: 'Persediaan Pencetakan',
    ar_eg: 'إعدادات الطباعة',
    uk: 'Налаштування Друку',
  },
  printers: {
    en: 'Printers',
    es: 'Impresoras',
    fr: 'Imprimantes',
    de: 'Drucker',
    pt: 'Impressoras',
    pl: 'Drukarki',
    nl: 'Printers',
    el: 'Εκτυπωτές',
    cs: 'Tiskárny',
    sv: 'Skrivare',
    hu: 'Nyomtatók',
    da: 'Printere',
    fi: 'Tulostimet',
    sk: 'Tlačiarne',
    bg: 'Принтери',
    hr: 'Pisači',
    lt: 'Spausdintuvai',
    lv: 'Printeri',
    et: 'Printerid',
    sl: 'Tiskalniki',
    ga: 'Clódóirí',
    mt: 'Printers',
    cy: 'Argraffwyr',
    ro: 'Imprimante',
    it: 'Stampanti',
    zh_cn: '打印机',
    hi: 'प्रिंटर',
    ar: 'طابعات',
    bn: 'প্রিন্টার',
    ru: 'Принтеры',
    ja: 'プリンター',
    tr: 'Yazıcılar',
    ko: '프린터',
    vi: 'Máy In',
    id: 'Printer',
    th: 'เครื่องพิมพ์',
    ms: 'Pencetak',
    ar_eg: 'طابعات',
    uk: 'Принтери',
  },
  location: {
    en: 'Location',
    es: 'Ubicación',
    fr: 'Emplacement',
    de: 'Standort',
    pt: 'Localização',
    pl: 'Lokalizacja',
    nl: 'Locatie',
    el: 'Τοποθεσία',
    cs: 'Umístění',
    sv: 'Plats',
    hu: 'Helyszín',
    da: 'Placering',
    fi: 'Sijainti',
    sk: 'Poloha',
    bg: 'Местоположение',
    hr: 'Lokacija',
    lt: 'Vieta',
    lv: 'Atrašanās Vieta',
    et: 'Asukoht',
    sl: 'Lokacija',
    ga: 'Suíomh',
    mt: 'Post',
    cy: 'Lleoliad',
    ro: 'Locație',
    it: 'Posizione',
    zh_cn: '位置',
    hi: 'स्थान',
    ar: 'الموقع',
    bn: 'অবস্থান',
    ru: 'Местоположение',
    ja: '場所',
    tr: 'Konum',
    ko: '위치',
    vi: 'Vị Trí',
    id: 'Lokasi',
    th: 'ตำแหน่งที่ตั้ง',
    ms: 'Lokasi',
    ar_eg: 'الموقع',
    uk: 'Місцезнаходження',
  },
  print_profiles: {
    en: 'Print Profiles',
    es: 'Perfiles de Impresión',
    fr: 'Profils d’Impression',
    de: 'Druckprofile',
    pt: 'Perfis de Impressão',
    pl: 'Profile Druku',
    nl: 'Printprofielen',
    el: 'Προφίλ Εκτύπωσης',
    cs: 'Profily Tisku',
    sv: 'Utskriftsprofiler',
    hu: 'Nyomtatási Profilok',
    da: 'Udskriftsprofiler',
    fi: 'Tulostusprofiilit',
    sk: 'Profily Tlače',
    bg: 'Профили за Печат',
    hr: 'Profili Ispisa',
    lt: 'Spausdinimo Profiliai',
    lv: 'Drukas Profili',
    et: 'Prindiprofiilid',
    sl: 'Profili Tiskanja',
    ga: 'Próifílí Cló',
    mt: 'Profili tal-Istampar',
    cy: 'Proffiliau Argraffu',
    ro: 'Profile de Tipărire',
    it: 'Profili di Stampa',
    zh_cn: '打印档案',
    hi: 'प्रिंट प्रोफाइल',
    ar: 'ملفات تعريف الطباعة',
    bn: 'প্রিন্ট প্রোফাইল',
    ru: 'Профили Печати',
    ja: '印刷プロファイル',
    tr: 'Baskı Profilleri',
    ko: '인쇄 프로필',
    vi: 'Hồ sơ In',
    id: 'Profil Cetak',
    th: 'โปรไฟล์การพิมพ์',
    ms: 'Profil Cetakan',
    ar_eg: 'ملفات تعريف الطباعة',
    uk: 'Профілі Друку',
  },
  print_templates: {
    en: 'Print Templates',
    es: 'Plantillas de Impresión',
    fr: 'Modèles d’Impression',
    de: 'Druckvorlagen',
    pt: 'Modelos de Impressão',
    pl: 'Szablony Druku',
    nl: 'Printsjablonen',
    el: 'Πρότυπα Εκτύπωσης',
    cs: 'Šablony Tisku',
    sv: 'Utskriftsmallar',
    hu: 'Nyomtatási Sablonok',
    da: 'Udskriftskabeloner',
    fi: 'Tulostusmallit',
    sk: 'Šablóny Tlače',
    bg: 'Шаблони за Печат',
    hr: 'Predlošci Ispisa',
    lt: 'Spausdinimo Šablonai',
    lv: 'Drukas Šabloni',
    et: 'Prindimallid',
    sl: 'Predloge Tiskanja',
    ga: 'Teimpléid Chló',
    mt: 'Mudelli tal-Istampar',
    cy: 'Templedi Argraffu',
    ro: 'Șabloane de Tipărire',
    it: 'Modelli di Stampa',
    zh_cn: '打印模板',
    hi: 'प्रिंट टेम्पलेट्स',
    ar: 'قوالب الطباعة',
    bn: 'প্রিন্ট টেমপ্লেট',
    ru: 'Шаблоны Печати',
    ja: '印刷テンプレート',
    tr: 'Baskı Şablonları',
    ko: '인쇄 템플릿',
    vi: 'Mẫu In',
    id: 'Template Cetak',
    th: 'เทมเพลตการพิมพ์',
    ms: 'Templat Cetakan',
    ar_eg: 'قوالب الطباعة',
    uk: 'Шаблони Друку',
  },
  devices_and_profiles: {
    en: 'Devices & Profiles',
    es: 'Dispositivos y Perfiles',
    fr: 'Appareils et Profils',
    de: 'Geräte und Profile',
    pt: 'Dispositivos e Perfis',
    pl: 'Urządzenia i Profile',
    nl: 'Apparaten en Profielen',
    el: 'Συσκευές και Προφίλ',
    cs: 'Zařízení a Profily',
    sv: 'Enheter och Profiler',
    hu: 'Eszközök és Profilok',
    da: 'Enheder og Profiler',
    fi: 'Laitteet ja Profiilit',
    sk: 'Zariadenia a Profily',
    bg: 'Устройства и Профили',
    hr: 'Uređaji i Profili',
    lt: 'Įrenginiai ir Profiliai',
    lv: 'Ierīces un Profili',
    et: 'Seadmed ja Profiilid',
    sl: 'Naprave in Profili',
    ga: 'Gléasanna agus Próifílí',
    mt: 'Apparati u Profili',
    cy: 'Dyfeisiau a Phroffiliau',
    ro: 'Dispozitive și Profiluri',
    it: 'Dispositivi e Profili',
    zh_cn: '设备和配置文件',
    hi: 'उपकरण और प्रोफाइल',
    ar: 'الأجهزة والملفات الشخصية',
    bn: 'ডিভাইস এবং প্রোফাইল',
    ru: 'Устройства и Профили',
    ja: 'デバイスとプロファイル',
    tr: 'Cihazlar ve Profiller',
    ko: '기기 및 프로필',
    vi: 'Thiết Bị và Hồ Sơ',
    id: 'Perangkat & Profil',
    th: 'อุปกรณ์และโปรไฟล์',
    ms: 'Peranti & Profil',
    ar_eg: 'الأجهزة والملفات الشخصية',
    uk: 'Пристрої та Профілі',
  },
  kds_profiles: {
    en: 'KDS Profiles',
    es: 'Perfiles de KDS',
    fr: 'Profils KDS',
    de: 'KDS-Profile',
    pt: 'Perfis de KDS',
    pl: 'Profile KDS',
    nl: 'KDS-profielen',
    el: 'Προφίλ KDS',
    cs: 'Profily KDS',
    sv: 'KDS-profiler',
    hu: 'KDS-profilok',
    da: 'KDS-profiler',
    fi: 'KDS-profiilit',
    sk: 'Profily KDS',
    bg: 'Профили на KDS',
    hr: 'KDS profili',
    lt: 'KDS Profiliai',
    lv: 'KDS Profili',
    et: 'KDS Profiilid',
    sl: 'Profili KDS',
    ga: 'Próifílí KDS',
    mt: 'Profili tal-KDS',
    cy: 'Proffiliau KDS',
    ro: 'Profile KDS',
    it: 'Profili KDS',
    zh_cn: 'KDS 档案',
    hi: 'केडीएस प्रोफाइल',
    ar: 'ملفات تعريف KDS',
    bn: 'কেডিএস প্রোফাইল',
    ru: 'Профили KDS',
    ja: 'KDSプロファイル',
    tr: 'KDS Profilleri',
    ko: 'KDS 프로필',
    vi: 'Hồ sơ KDS',
    id: 'Profil KDS',
    th: 'โปรไฟล์ KDS',
    ms: 'Profil KDS',
    ar_eg: 'ملفات تعريف KDS',
    uk: 'Профілі KDS',
  },
  digital_menu_profiles: {
    en: 'Digital Menu Profiles',
    es: 'Perfiles de Menú Digital',
    fr: 'Profils de Menu Numérique',
    de: 'Digitale Menüprofile',
    pt: 'Perfis de Menu Digital',
    pl: 'Profile Menu Cyfrowego',
    nl: 'Digitale Menuprofielen',
    el: 'Προφίλ Ψηφιακού Μενού',
    cs: 'Profily Digitálního Jídelníčku',
    sv: 'Digitala Menyprofiler',
    hu: 'Digitális Menüprofilok',
    da: 'Digitale Menuprofiler',
    fi: 'Digitaaliset Ruokalistaprofiilit',
    sk: 'Profily Digitálneho Menu',
    bg: 'Цифрови Профили на Менюто',
    hr: 'Profili Digitalnog Izbornika',
    lt: 'Skaitmeniniai Meniu Profiliai',
    lv: 'Digitālo Ēdienkartes Profili',
    et: 'Digitaalse Menüü Profiilid',
    sl: 'Digitalni Profili Jedilnikov',
    ga: 'Próifílí Roghchlár Digiteach',
    mt: 'Profili tal-Menù Diġitali',
    cy: 'Proffiliau Dewislen Digidol',
    ro: 'Profiluri de Meniu Digital',
    it: 'Profili Menu Digitali',
    zh_cn: '数字菜单配置文件',
    hi: 'डिजिटल मेनू प्रोफाइल्स',
    ar: 'ملفات تعريف القائمة الرقمية',
    bn: 'ডিজিটাল মেনু প্রোফাইল',
    ru: 'Профили Цифрового Меню',
    ja: 'デジタルメニュープロファイル',
    tr: 'Dijital Menü Profilleri',
    ko: '디지털 메뉴 프로필',
    vi: 'Hồ sơ Thực đơn Kỹ thuật số',
    id: 'Profil Menu Digital',
    th: 'โปรไฟล์เมนูดิจิทัล',
    ms: 'Profil Menu Digital',
    ar_eg: 'ملفات تعريف القائمة الرقمية',
    uk: 'Цифрові Профілі Меню',
  },
  digital_menu_templates: {
    en: 'Menu Display Templates',
    es: 'Plantillas de Visualización de Menú',
    fr: 'Modèles d’Affichage du Menu',
    de: 'Menüanzeige-Vorlagen',
    pt: 'Modelos de Exibição de Menu',
    pl: 'Szablony Wyświetlania Menu',
    nl: 'Menuweergavesjablonen',
    el: 'Πρότυπα Εμφάνισης Μενού',
    cs: 'Šablony Zobrazení Nabídky',
    sv: 'Mallar för Menyvisning',
    hu: 'Menükijelző Sablonok',
    da: 'Skabeloner til Menuvisning',
    fi: 'Valikon Näyttöpohjat',
    sk: 'Šablóny Zobrazenia Menu',
    bg: 'Шаблони за Показване на Меню',
    hr: 'Predlošci za Prikaz Izbornika',
    lt: 'Meniu Rodymo Šablonai',
    lv: 'Izvēlnes Displeja Veidnes',
    et: 'Menüü Kuvamise Mallid',
    sl: 'Predloge za Prikaz Menija',
    ga: 'Teimpléid Taispeána Roghchláir',
    mt: 'Mudelli tal-Wiri tal-Menù',
    cy: 'Templedi Arddangos Dewislen',
    ro: 'Șabloane de Afișare Meniu',
    it: 'Modelli di Visualizzazione Menu',
    zh_cn: '菜单显示模板',
    hi: 'मेनू डिस्प्ले टेम्पलेट्स',
    ar: 'قوالب عرض القائمة',
    bn: 'মেনু প্রদর্শন টেমপ্লেট',
    ru: 'Шаблоны Отображения Меню',
    ja: 'メニュー表示テンプレート',
    tr: 'Menü Görüntüleme Şablonları',
    ko: '메뉴 표시 템플릿',
    vi: 'Mẫu Hiển Thị Thực Đơn',
    id: 'Templat Tampilan Menu',
    th: 'แม่แบบการแสดงเมนู',
    ms: 'Templat Paparan Menu',
    ar_eg: 'قوالب عرض القائمة',
    uk: 'Шаблони Відображення Меню',
  },
  kiosk_profiles: {
    en: 'Kiosk Profiles',
    es: 'Perfiles de Kiosco',
    fr: 'Profils de Kiosque',
    de: 'Kiosk-Profile',
    pt: 'Perfis de Quiosque',
    pl: 'Profile Kiosku',
    nl: 'Kiosk-profielen',
    el: 'Προφίλ Κιοσκ',
    cs: 'Profily Kiosku',
    sv: 'Kioskprofiler',
    hu: 'Kioszk-profilok',
    da: 'Kiosk-profiler',
    fi: 'Kioskiprofiilit',
    sk: 'Profily Kiosku',
    bg: 'Профили на Киоск',
    hr: 'Kiosk profili',
    lt: 'Kiosko Profiliai',
    lv: 'Kioska Profili',
    et: 'Kioski Profiilid',
    sl: 'Profili Kioska',
    ga: 'Próifílí Kiosca',
    mt: 'Profili tal-Kjosk',
    cy: 'Proffiliau Kiosg',
    ro: 'Profile de Chioșc',
    it: 'Profili Chiosco',
    zh_cn: '自助终端档案',
    hi: 'कियोस्क प्रोफाइल',
    ar: 'ملفات تعريف الكشك',
    bn: 'কিয়স্ক প্রোফাইল',
    ru: 'Профили Киоска',
    ja: 'キオスクプロファイル',
    tr: 'Kiosk Profilleri',
    ko: '키오스크 프로필',
    vi: 'Hồ sơ Ki-ốt',
    id: 'Profil Kios',
    th: 'โปรไฟล์คีออสก์',
    ms: 'Profil Kiosk',
    ar_eg: 'ملفات تعريف الكشك',
    uk: 'Профілі Кіоску',
  },
  custom_reasons: {
    en: 'Custom Reasons',
    es: 'Razones Personalizadas',
    fr: 'Raisons Personnalisées',
    de: 'Benutzerdefinierte Gründe',
    pt: 'Razões Personalizadas',
    pl: 'Niestandardowe Powody',
    nl: 'Aangepaste Redenen',
    el: 'Προσαρμοσμένοι Λόγοι',
    cs: 'Vlastní Důvody',
    sv: 'Anpassade Skäl',
    hu: 'Egyéni Okok',
    da: 'Tilpassede Årsager',
    fi: 'Mukautetut Syyt',
    sk: 'Vlastné Dôvody',
    bg: 'Персонализирани Причини',
    hr: 'Prilagođeni Razlozi',
    lt: 'Tinkintos Priežastys',
    lv: 'Pielāgoti Iemesli',
    et: 'Kohandatud Põhjused',
    sl: 'Prilagojeni Razlogi',
    ga: 'Cúiseanna Saincheaptha',
    mt: 'Raġunijiet Personalizzati',
    cy: 'Rhesymau Personol',
    ro: 'Motive Personalizate',
    it: 'Motivi Personalizzati',
    zh_cn: '自定义原因',
    hi: 'कस्टम कारण',
    ar: 'أسباب مخصصة',
    bn: 'কাস্টম কারণ',
    ru: 'Пользовательские Причины',
    ja: 'カスタム理由',
    tr: 'Özel Nedenler',
    ko: '사용자 지정 이유',
    vi: 'Lý Do Tùy Chỉnh',
    id: 'Alasan Khusus',
    th: 'เหตุผลที่กำหนดเอง',
    ms: 'Sebab Tersuai',
    ar_eg: 'أسباب مخصصة',
    uk: 'Користувацькі Причини',
  },
  partner_id: {
    en: 'Partner ID',
    es: 'ID de Socio',
    fr: 'ID de Partenaire',
    de: 'Partner-ID',
    pt: 'ID do Parceiro',
    pl: 'ID Partnera',
    nl: 'Partner-ID',
    el: 'ID Συνεργάτη',
    cs: 'ID Partnera',
    sv: 'Partner-ID',
    hu: 'Partnerazonosító',
    da: 'Partner-ID',
    fi: 'Kumppanin tunnus',
    sk: 'ID Partnera',
    bg: 'ID на партньора',
    hr: 'ID partnera',
    lt: 'Partnerio ID',
    lv: 'Partnera ID',
    et: 'Partneri ID',
    sl: 'ID partnerja',
    ga: 'Aitheantas Comhpháirtí',
    mt: 'ID tas-Sieħeb',
    cy: 'ID Partner',
    ro: 'ID Partener',
    it: 'ID Partner',
    zh_cn: '合作伙伴 ID',
    hi: 'साझेदार आईडी',
    ar: 'معرّف الشريك',
    bn: 'অংশীদার আইডি',
    ru: 'ID Партнёра',
    ja: 'パートナーID',
    tr: 'Ortak Kimliği',
    ko: '파트너 ID',
    vi: 'ID Đối tác',
    id: 'ID Mitra',
    th: 'รหัสพาร์ทเนอร์',
    ms: 'ID Rakan Kongsi',
    ar_eg: 'معرّف الشريك',
    uk: 'ID Партнера',
  },
  partner_name: {
    en: 'Partner Name',
    es: 'Nombre del Socio',
    fr: 'Nom du Partenaire',
    de: 'Partnername',
    pt: 'Nome do Parceiro',
    pl: 'Nazwa Partnera',
    nl: 'Partnernaam',
    el: 'Όνομα Συνεργάτη',
    cs: 'Název Partnera',
    sv: 'Partnernamn',
    hu: 'Partner neve',
    da: 'Partnernavn',
    fi: 'Kumppanin nimi',
    sk: 'Názov Partnera',
    bg: 'Име на партньора',
    hr: 'Naziv partnera',
    lt: 'Partnerio vardas',
    lv: 'Partnera nosaukums',
    et: 'Partneri nimi',
    sl: 'Ime partnerja',
    ga: 'Ainm an Chomhpháirtí',
    mt: 'Isem is-Sieħeb',
    cy: 'Enw Partner',
    ro: 'Nume Partener',
    it: 'Nome Partner',
    zh_cn: '合作伙伴名称',
    hi: 'साझेदार का नाम',
    ar: 'اسم الشريك',
    bn: 'অংশীদারের নাম',
    ru: 'Имя партнёра',
    ja: 'パートナー名',
    tr: 'Ortak Adı',
    ko: '파트너 이름',
    vi: 'Tên Đối tác',
    id: 'Nama Mitra',
    th: 'ชื่อพาร์ทเนอร์',
    ms: 'Nama Rakan Kongsi',
    ar_eg: 'اسم الشريك',
    uk: 'Ім’я партнера',
  },
  stock_level: {
    en: 'Stock Level',
    es: 'Nivel de stock',
    fr: 'Niveau de stock',
    de: 'Lagerbestand',
    pt: 'Nível de estoque',
    pl: 'Poziom zapasów',
    nl: 'Voorraadniveau',
    el: 'Επίπεδο αποθέματος',
    cs: 'Úroveň zásob',
    sv: 'Lagernivå',
    hu: 'Készletszint',
    da: 'Lagerbeholdning',
    fi: 'Varastotaso',
    sk: 'Úroveň zásob',
    bg: 'Ниво на складова наличност',
    hr: 'Stanje zaliha',
    lt: 'Atsargų lygis',
    lv: 'Krājumu līmenis',
    et: 'Laoseis',
    sl: 'Nivo zalog',
    ga: 'Leibhéal Stoc',
    mt: 'Livell tal-Istokk',
    cy: 'Lefel Stoc',
    ro: 'Nivelul stocului',
    it: 'Livello delle scorte',
    zh_cn: '库存水平',
    hi: 'स्टॉक स्तर',
    ar: 'مستوى المخزون',
    bn: 'স্টক স্তর',
    ru: 'Уровень запасов',
    ja: '在庫レベル',
    tr: 'Stok Seviyesi',
    ko: '재고 수준',
    vi: 'Mức tồn kho',
    id: 'Tingkat Stok',
    th: 'ระดับสต๊อก',
    ms: 'Paras Stok',
    ar_eg: 'مستوى المخزون',
    uk: 'Рівень запасів',
  },
  select_branch: {
    en: 'Select Branch',
    es: 'Seleccionar Sucursal',
    fr: 'Sélectionner une Agence',
    de: 'Filiale Auswählen',
    pt: 'Selecionar Filial',
    pl: 'Wybierz Oddział',
    nl: 'Kies Vestiging',
    el: 'Επιλέξτε Υποκατάστημα',
    cs: 'Vyberte Pobočku',
    sv: 'Välj Filial',
    hu: 'Fiók Kiválasztása',
    da: 'Vælg Filial',
    fi: 'Valitse Toimipiste',
    sk: 'Vyberte Pobočku',
    bg: 'Изберете Клон',
    hr: 'Odaberite Podružnicu',
    lt: 'Pasirinkite Padalinį',
    lv: 'Izvēlieties Filiāli',
    et: 'Vali Harukontor',
    sl: 'Izberi Podružnico',
    ga: 'Roghnaigh Brainse',
    mt: 'Agħżel Fergħa',
    cy: 'Dewiswch Gangen',
    ro: 'Selectați Sucursala',
    it: 'Seleziona Filiale',
    zh_cn: '选择分支机构',
    hi: 'शाखा चुनें',
    ar: 'اختر الفرع',
    bn: 'শাখা নির্বাচন করুন',
    ru: 'Выберите Филиал',
    ja: '支店を選択',
    tr: 'Şube Seç',
    ko: '지점 선택',
    vi: 'Chọn Chi Nhánh',
    id: 'Pilih Cabang',
    th: 'เลือกสาขา',
    ms: 'Pilih Cawangan',
    ar_eg: 'اختر الفرع',
    uk: 'Виберіть Філію',
  },
  item_margin: {
    en: 'Item Margin',
    es: 'Margen del artículo',
    fr: 'Marge de l’article',
    de: 'Artikelmarge',
    pt: 'Margem do item',
    pl: 'Marża pozycji',
    nl: 'Artikelmarge',
    el: 'Περιθώριο είδους',
    cs: 'Marže položky',
    sv: 'Artikelförtjänst',
    hu: 'Tétel haszonkulcsa',
    da: 'Varemargin',
    fi: 'Tuotteen kate',
    sk: 'Marža položky',
    bg: 'Марж на артикула',
    hr: 'Marža artikla',
    lt: 'Prekės marža',
    lv: 'Preces peļņa',
    et: 'Kauba marginaal',
    sl: 'Marža izdelka',
    ga: 'Imchlúd Míre',
    mt: 'Margini tal-Oġġett',
    cy: 'Ymyl Eitem',
    ro: 'Marja articolului',
    it: 'Margine dell’articolo',
    zh_cn: '商品利润率',
    hi: 'आइटम मार्जिन',
    ar: 'هامش العنصر',
    bn: 'আইটেম মার্জিন',
    ru: 'Маржа товара',
    ja: '商品のマージン',
    tr: 'Ürün Marjı',
    ko: '항목 마진',
    vi: 'Biên lợi nhuận mặt hàng',
    id: 'Margin Item',
    th: 'กำไรต่อรายการ',
    ms: 'Margin Item',
    ar_eg: 'هامش البند',
    uk: 'Маржа товару',
  },
  balance_sheet: {
    en: 'Balance Sheet',
    es: 'Balance General',
    fr: 'Bilan Comptable',
    de: 'Bilanz',
    pt: 'Balanço Patrimonial',
    pl: 'Bilans',
    nl: 'Balans',
    el: 'Ισολογισμός',
    cs: 'Rozvaha',
    sv: 'Balansräkning',
    hu: 'Mérleg',
    da: 'Balanceopgørelse',
    fi: 'Tase',
    sk: 'Súvaha',
    bg: 'Счетоводен Баланс',
    hr: 'Bilanca Stanja',
    lt: 'Balansas',
    lv: 'Bilance',
    et: 'Bilanss',
    sl: 'Bilanca Stanja',
    ga: 'Bileog Chothromaíochta',
    mt: 'Bilanċ',
    cy: 'Dalen Gydbwysedd',
    ro: 'Bilanț',
    it: 'Stato Patrimoniale',
    zh_cn: '资产负债表',
    hi: 'बैलेंस शीट',
    ar: 'الميزانية العمومية',
    bn: 'ব্যালান্স শীট',
    ru: 'Бухгалтерский Баланс',
    ja: '貸借対照表',
    tr: 'Bilanço',
    ko: '대차대조표',
    vi: 'Bảng Cân Đối Kế Toán',
    id: 'Neraca',
    th: 'งบดุล',
    ms: 'Lembaran Imbangan',
    ar_eg: 'الميزانية العمومية',
    uk: 'Баланс',
  },
  import_csv: {
    en: 'Import CSV',
    es: 'Importar CSV',
    fr: 'Importer CSV',
    de: 'CSV importieren',
    pt: 'Importar CSV',
    pl: 'Importuj CSV',
    nl: 'CSV importeren',
    el: 'Εισαγωγή CSV',
    cs: 'Importovat CSV',
    sv: 'Importera CSV',
    hu: 'CSV Importálása',
    da: 'Importer CSV',
    fi: 'Tuo CSV',
    sk: 'Importovať CSV',
    bg: 'Импортиране на CSV',
    hr: 'Uvoz CSV',
    lt: 'Importuoti CSV',
    lv: 'Importēt CSV',
    et: 'Impordi CSV',
    sl: 'Uvozi CSV',
    ga: 'Iompórtáil CSV',
    mt: 'Importa CSV',
    cy: 'Mewnforio CSV',
    ro: 'Importă CSV',
    it: 'Importa CSV',
    zh_cn: '导入 CSV',
    hi: 'CSV आयात करें',
    ar: 'استيراد CSV',
    bn: 'CSV আমদানি করুন',
    ru: 'Импорт CSV',
    ja: 'CSV をインポート',
    tr: 'CSV İçeri Aktar',
    ko: 'CSV 가져오기',
    vi: 'Nhập CSV',
    id: 'Impor CSV',
    th: 'นำเข้า CSV',
    ms: 'Import CSV',
    ar_eg: 'استيراد CSV',
    uk: 'Імпортувати CSV',
  },
  restricted_access: {
    en: 'Restricted Access',
    es: 'Acceso Restringido',
    fr: 'Accès Restreint',
    de: 'Eingeschränkter Zugriff',
    pt: 'Acesso Restrito',
    pl: 'Dostęp Ograniczony',
    nl: 'Beperkte Toegang',
    el: 'Περιορισμένη Πρόσβαση',
    cs: 'Omezený Přístup',
    sv: 'Begränsad Åtkomst',
    hu: 'Korlátozott Hozzáférés',
    da: 'Begrænset Adgang',
    fi: 'Rajoitettu Pääsy',
    sk: 'Obmedzený Prístup',
    bg: 'Ограничен Достъп',
    hr: 'Ograničen Pristup',
    lt: 'Ribota Prieiga',
    lv: 'Ierobežota Piekļuve',
    et: 'Piiratud Juurdepääs',
    sl: 'Omejen Dostop',
    ga: 'Rochtain Teoranta',
    mt: 'Aċċess Ristrett',
    cy: 'Mynediad Cyfyngedig',
    ro: 'Acces Restricționat',
    it: 'Accesso Limitato',
    zh_cn: '受限访问',
    hi: 'प्रतिबंधित प्रवेश',
    ar: 'وصول مقيد',
    bn: 'নিয়ন্ত্রিত প্রবেশাধিকার',
    ru: 'Ограниченный Доступ',
    ja: '制限付きアクセス',
    tr: 'Kısıtlı Erişim',
    ko: '제한된 액세스',
    vi: 'Truy Cập Bị Hạn Chế',
    id: 'Akses Terbatas',
    th: 'การเข้าถึงที่จำกัด',
    ms: 'Akses Terhad',
    ar_eg: 'وصول محدود',
    uk: 'Обмежений Доступ',
  },
  access_denied: {
    en: 'Access Denied',
    es: 'Acceso Denegado',
    fr: 'Accès Refusé',
    de: 'Zugriff Verweigert',
    pt: 'Acesso Negado',
    pl: 'Odmowa Dostępu',
    nl: 'Toegang Geweigerd',
    el: 'Άρνηση Πρόσβασης',
    cs: 'Přístup Odepřen',
    sv: 'Åtkomst Nekad',
    hu: 'Hozzáférés Megtagadva',
    da: 'Adgang Nægtet',
    fi: 'Pääsy Estetty',
    sk: 'Prístup Zamietnutý',
    bg: 'Достъп Отказан',
    hr: 'Pristup Odbijen',
    lt: 'Prieiga Atmesta',
    lv: 'Pieeja Liegt',
    et: 'Juurdepääs Keelatud',
    sl: 'Dostop Zavrnjen',
    ga: 'Rochtain Diúltaithe',
    mt: 'Aċċess Miċħud',
    cy: 'Mynediad Gwrthodwyd',
    ro: 'Acces Refuzat',
    it: 'Accesso Negato',
    zh_cn: '拒绝访问',
    hi: 'प्रवेश अस्वीकृत',
    ar: 'تم رفض الوصول',
    bn: 'অ্যাক্সেস অস্বীকৃত',
    ru: 'Доступ Запрещён',
    ja: 'アクセス拒否',
    tr: 'Erişim Reddedildi',
    ko: '접근 거부됨',
    vi: 'Từ Chối Truy Cập',
    id: 'Akses Ditolak',
    th: 'ปฏิเสธการเข้าถึง',
    ms: 'Akses Dinafikan',
    ar_eg: 'تم رفض الدخول',
    uk: 'Доступ Заборонено',
  },
  instant: {
    en: 'Instant',
    es: 'Instantáneo',
    fr: 'Instantané',
    de: 'Sofort',
    pt: 'Instantâneo',
    pl: 'Natychmiastowy',
    nl: 'Onmiddellijk',
    el: 'Άμεσο',
    cs: 'Okamžitý',
    sv: 'Omedelbar',
    hu: 'Azonnali',
    da: 'Øjeblikkelig',
    fi: 'Välitön',
    sk: 'Okamžitý',
    bg: 'Мигновен',
    hr: 'Trenutni',
    lt: 'Momentinis',
    lv: 'Tūlītējs',
    et: 'Vahetu',
    sl: 'Takojšnji',
    ga: 'Láithreach',
    mt: 'Istantanju',
    cy: 'Ar unwaith',
    ro: 'Instantaneu',
    it: 'Istantaneo',
    zh_cn: '即时',
    hi: 'तत्काल',
    ar: 'فوري',
    bn: 'তাৎক্ষণিক',
    ru: 'Мгновенный',
    ja: '即時',
    tr: 'Anında',
    ko: '즉시',
    vi: 'Tức thì',
    id: 'Instan',
    th: 'ทันที',
    ms: 'Segera',
    ar_eg: 'فوري',
    uk: 'Миттєвий',
  },
  pre_order: {
    en: 'Pre-order',
    es: 'Preordenar',
    fr: 'Précommander',
    de: 'Vorbestellen',
    pt: 'Pré-encomenda',
    pl: 'Przedsprzedaż',
    nl: 'Voorbestellen',
    el: 'Προπαραγγελία',
    cs: 'Předobjednávka',
    sv: 'Förbeställ',
    hu: 'Előrendelés',
    da: 'Forudbestil',
    fi: 'Ennakkotilaus',
    sk: 'Predobjednávka',
    bg: 'Предварителна поръчка',
    hr: 'Prednarudžba',
    lt: 'Išankstinis užsakymas',
    lv: 'Iepriekš pasūtīt',
    et: 'Eeltellimus',
    sl: 'Prednaročilo',
    ga: 'Réordú',
    mt: 'Pre-ordni',
    cy: 'Rhag-archebu',
    ro: 'Precomandă',
    it: 'Pre-ordine',
    zh_cn: '预购',
    hi: 'प्री-ऑर्डर',
    ar: 'طلب مسبق',
    bn: 'পূর্ব-অর্ডার',
    ru: 'Предзаказ',
    ja: '予約注文',
    tr: 'Ön sipariş',
    ko: '사전 주문',
    vi: 'Đặt trước',
    id: 'Pre-order',
    th: 'สั่งจองล่วงหน้า',
    ms: 'Pra-pesanan',
    ar_eg: 'طلب مسبق',
    uk: 'Попереднє замовлення',
  },
  kiosk: {
    en: 'Kiosk',
    es: 'Quiosco',
    fr: 'Kiosque',
    de: 'Kiosk',
    pt: 'Quiosque',
    pl: 'Kiosk',
    nl: 'Kiosk',
    el: 'Περίπτερο',
    cs: 'Kiosek',
    sv: 'Kiosk',
    hu: 'Kioszk',
    da: 'Kiosk',
    fi: 'Kioski',
    sk: 'Kiosk',
    bg: 'Киоск',
    hr: 'Kiosk',
    lt: 'Kioskas',
    lv: 'Kiosks',
    et: 'Kiosk',
    sl: 'Kiosk',
    ga: 'Cíosc',
    mt: 'Kiosk',
    cy: 'Ciosg',
    ro: 'Chioșc',
    it: 'Chiosco',
    zh_cn: '自助服务终端',
    hi: 'किओस्क',
    ar: 'كشك',
    bn: 'কিওস্ক',
    ru: 'Киоск',
    ja: 'キオスク',
    tr: 'Kiosk',
    ko: '키오스크',
    vi: 'Ki-ốt',
    id: 'Kios',
    th: 'คีออสก์',
    ms: 'Kios',
    ar_eg: 'كشك',
    uk: 'Кіоск',
  },
  items_translation: {
    en: 'Items Translation',
    es: 'Traducción de artículos',
    fr: 'Traduction des éléments',
    de: 'Übersetzung der Elemente',
    pt: 'Tradução de itens',
    pl: 'Tłumaczenie elementów',
    nl: 'Vertaling van items',
    el: 'Μετάφραση αντικειμένων',
    cs: 'Překlad položek',
    sv: 'Översättning av objekt',
    hu: 'Elemek fordítása',
    da: 'Oversættelse af elementer',
    fi: 'Kohteiden käännös',
    sk: 'Preklad položiek',
    bg: 'Превод на елементи',
    hr: 'Prijevod stavki',
    lt: 'Elementų vertimas',
    lv: 'Vienumu tulkojums',
    et: 'Üksuste tõlge',
    sl: 'Prevajanje elementov',
    ga: 'Aistriúchán míreanna',
    mt: 'Traduzzjoni tal-oġġetti',
    cy: 'Cyfieithiad eitemau',
    ro: 'Traducerea articolelor',
    it: 'Traduzione degli articoli',
    zh_cn: '项目翻译',
    hi: 'आइटम्स का अनुवाद',
    ar: 'ترجمة العناصر',
    bn: 'আইটেম অনুবাদ',
    ru: 'Перевод элементов',
    ja: 'アイテムの翻訳',
    tr: 'Öğe Çevirisi',
    ko: '항목 번역',
    vi: 'Dịch mục',
    id: 'Terjemahan item',
    th: 'การแปลรายการ',
    ms: 'Terjemahan item',
    ar_eg: 'ترجمة العناصر',
    uk: 'Переклад елементів',
  },
  staff_shifts: {
    en: 'Staff Shifts',
    es: 'Turnos del Personal',
    fr: 'Postes du Personnel',
    de: 'Mitarbeiterschichten',
    pt: 'Turnos da Equipa',
    pl: 'Zmiany Pracowników',
    nl: 'Personeelsdiensten',
    el: 'Βάρδιες Προσωπικού',
    cs: 'Směny Personálu',
    sv: 'Personalens Skift',
    hu: 'Dolgozói Műszakok',
    da: 'Personalets Vagter',
    fi: 'Henkilökunnan Vuorot',
    sk: 'Zmeny Personálu',
    bg: 'Смени на Персонала',
    hr: 'Smjene Osoblja',
    lt: 'Darbuotojų Pamainos',
    lv: 'Darbinieku Maiņas',
    et: 'Töötajate Vahetused',
    sl: 'Izmene Osebja',
    ga: 'Seifteanna Foirne',
    mt: 'Xiftijiet tal-Persunal',
    cy: 'Shifftiau Staff',
    ro: 'Schimburi de Personal',
    it: 'Turni del Personale',
    zh_cn: '员工班次',
    hi: 'स्टाफ की शिफ्टें',
    ar: 'ورديات الموظفين',
    bn: 'কর্মীদের শিফট',
    ru: 'Смены Персонала',
    ja: 'スタッフのシフト',
    tr: 'Personel Vardiyaları',
    ko: '직원 교대근무',
    vi: 'Ca Làm Việc của Nhân Viên',
    id: 'Shift Staf',
    th: 'กะทำงานของพนักงาน',
    ms: 'Syif Kakitangan',
    ar_eg: 'ورديات العاملين',
    uk: 'Зміни Персоналу',
  },
  job_titles: {
    en: 'Job Titles',
    es: 'Puestos de Trabajo',
    fr: 'Intitulés de Poste',
    de: 'Berufsbezeichnungen',
    pt: 'Cargos',
    pl: 'Stanowiska Pracy',
    nl: 'Functietitels',
    el: 'Τίτλοι Εργασίας',
    cs: 'Pracovní Pozice',
    sv: 'Befattningar',
    hu: 'Munkaköri Címek',
    da: 'Jobtitler',
    fi: 'Työnimikkeet',
    sk: 'Pracovné Pozície',
    bg: 'Длъжности',
    hr: 'Nazivi Poslova',
    lt: 'Pareigų Pavadinimai',
    lv: 'Amatu Nosaukumi',
    et: 'Ametinimetused',
    sl: 'Nazivi Delovnih Mest',
    ga: 'Teidilí Poist',
    mt: 'Titli tax-Xogħol',
    cy: 'Teitlau Swyddi',
    ro: 'Titluri de Post',
    it: 'Titoli di Lavoro',
    zh_cn: '职位名称',
    hi: 'नौकरी के शीर्षक',
    ar: 'المسميات الوظيفية',
    bn: 'চাকরির শিরোনাম',
    ru: 'Должности',
    ja: '職種名',
    tr: 'İş Unvanları',
    ko: '직책',
    vi: 'Chức Danh Công Việc',
    id: 'Judul Pekerjaan',
    th: 'ชื่อตำแหน่งงาน',
    ms: 'Jawatan Kerja',
    ar_eg: 'المسميات الوظيفية',
    uk: 'Посади',
  },
  item_condition: {
    en: 'Item Condition',
    es: 'Condición del artículo',
    fr: 'État de l’article',
    de: 'Artikelzustand',
    pt: 'Condição do item',
    pl: 'Stan przedmiotu',
    nl: 'Staat van het item',
    el: 'Κατάσταση είδους',
    cs: 'Stav položky',
    sv: 'Artikelns skick',
    hu: 'Tétel állapota',
    da: 'Varens tilstand',
    fi: 'Tuotteen kunto',
    sk: 'Stav položky',
    bg: 'Състояние на артикула',
    hr: 'Stanje artikla',
    lt: 'Prekės būklė',
    lv: 'Preces stāvoklis',
    et: 'Kauba seisukord',
    sl: 'Stanje artikla',
    ga: 'Staid na míre',
    mt: 'Kundizzjoni tal-oġġett',
    cy: 'Cyflwr eitem',
    ro: 'Starea articolului',
    it: 'Condizione dell’articolo',
    zh_cn: '物品状况',
    hi: 'वस्तु की स्थिति',
    ar: 'حالة العنصر',
    bn: 'আইটেমের অবস্থা',
    ru: 'Состояние товара',
    ja: '商品の状態',
    tr: 'Ürün durumu',
    ko: '상품 상태',
    vi: 'Tình trạng hàng hóa',
    id: 'Kondisi Barang',
    th: 'สภาพสินค้า',
    ms: 'Keadaan Item',
    ar_eg: 'حالة المنتج',
    uk: 'Стан товару',
  },
  username: {
    en: 'Username',
    es: 'Nombre de usuario',
    fr: "Nom d'utilisateur",
    de: 'Benutzername',
    pt: 'Nome de usuário',
    pl: 'Nazwa użytkownika',
    nl: 'Gebruikersnaam',
    el: 'Όνομα χρήστη',
    cs: 'Uživatelské jméno',
    sv: 'Användarnamn',
    hu: 'Felhasználónév',
    da: 'Brugernavn',
    fi: 'Käyttäjätunnus',
    sk: 'Používateľské meno',
    bg: 'Потребителско име',
    hr: 'Korisničko ime',
    lt: 'Naudotojo vardas',
    lv: 'Lietotājvārds',
    et: 'Kasutajanimi',
    sl: 'Uporabniško ime',
    ga: 'Ainm Úsáideora',
    mt: 'Isem tal-utent',
    cy: 'Enw Defnyddiwr',
    ro: 'Nume de utilizator',
    it: 'Nome utente',
    zh_cn: '用户名',
    hi: 'उपयोगकर्ता नाम',
    ar: 'اسم المستخدم',
    bn: 'ব্যবহারকারীর নাম',
    ru: 'Имя пользователя',
    ja: 'ユーザー名',
    tr: 'Kullanıcı adı',
    ko: '사용자 이름',
    vi: 'Tên người dùng',
    id: 'Nama pengguna',
    th: 'ชื่อผู้ใช้',
    ms: 'Nama pengguna',
    ar_eg: 'اسم المستخدم',
    uk: 'Ім’я користувача',
  },
  password: {
    en: 'Password',
    es: 'Contraseña',
    fr: 'Mot de passe',
    de: 'Passwort',
    pt: 'Senha',
    pl: 'Hasło',
    nl: 'Wachtwoord',
    el: 'Κωδικός πρόσβασης',
    cs: 'Heslo',
    sv: 'Lösenord',
    hu: 'Jelszó',
    da: 'Adgangskode',
    fi: 'Salasana',
    sk: 'Heslo',
    bg: 'Парола',
    hr: 'Lozinka',
    lt: 'Slaptažodis',
    lv: 'Parole',
    et: 'Parool',
    sl: 'Geslo',
    ga: 'Focal faire',
    mt: 'Password',
    cy: 'Cyfrinair',
    ro: 'Parolă',
    it: 'Password',
    zh_cn: '密码',
    hi: 'पासवर्ड',
    ar: 'كلمة المرور',
    bn: 'পাসওয়ার্ড',
    ru: 'Пароль',
    ja: 'パスワード',
    tr: 'Parola',
    ko: '비밀번호',
    vi: 'Mật khẩu',
    id: 'Kata sandi',
    th: 'รหัสผ่าน',
    ms: 'Kata laluan',
    ar_eg: 'كلمة السر',
    uk: 'Пароль',
  },
  alias: {
    en: 'Alias',
    es: 'Alias',
    fr: 'Alias',
    de: 'Alias',
    pt: 'Alias',
    pl: 'Alias',
    nl: 'Alias',
    el: 'Ψευδώνυμο',
    cs: 'Alias',
    sv: 'Alias',
    hu: 'Alias',
    da: 'Alias',
    fi: 'Alias',
    sk: 'Alias',
    bg: 'Псевдоним',
    hr: 'Alias',
    lt: 'Alias',
    lv: 'Alias',
    et: 'Alias',
    sl: 'Alias',
    ga: 'Alias',
    mt: 'Alias',
    cy: 'Alias',
    ro: 'Alias',
    it: 'Alias',
    zh_cn: '别名',
    hi: 'उपनाम',
    ar: 'الاسم المستعار',
    bn: 'ছদ্মনাম',
    ru: 'Псевдоним',
    ja: 'エイリアス',
    tr: 'Takma ad',
    ko: '별칭',
    vi: 'Bí danh',
    id: 'Alias',
    th: 'นามแฝง',
    ms: 'Alias',
    ar_eg: 'الاسم المستعار',
    uk: 'Псевдонім',
  },
  all: {
    en: 'All',
    es: 'Todos',
    fr: 'Tous',
    de: 'Alle',
    pt: 'Todos',
    pl: 'Wszystkie',
    nl: 'Alle',
    el: 'Όλα',
    cs: 'Vše',
    sv: 'Alla',
    hu: 'Összes',
    da: 'Alle',
    fi: 'Kaikki',
    sk: 'Všetko',
    bg: 'Всички',
    hr: 'Sve',
    lt: 'Visi',
    lv: 'Visi',
    et: 'Kõik',
    sl: 'Vse',
    ga: 'Uile',
    mt: 'Kollha',
    cy: 'Pob un',
    ro: 'Toate',
    it: 'Tutti',
    zh_cn: '全部',
    hi: 'सभी',
    ar: 'الكل',
    bn: 'সব',
    ru: 'Все',
    ja: 'すべて',
    tr: 'Hepsi',
    ko: '전체',
    vi: 'Tất cả',
    id: 'Semua',
    th: 'ทั้งหมด',
    ms: 'Semua',
    ar_eg: 'الكل',
    uk: 'Усі',
  },
  translations: {
    en: 'Translations',
    es: 'Traducciones',
    fr: 'Traductions',
    de: 'Übersetzungen',
    pt: 'Traduções',
    pl: 'Tłumaczenia',
    nl: 'Vertalingen',
    el: 'Μεταφράσεις',
    cs: 'Překlady',
    sv: 'Översättningar',
    hu: 'Fordítások',
    da: 'Oversættelser',
    fi: 'Käännökset',
    sk: 'Preklady',
    bg: 'Преводи',
    hr: 'Prijevodi',
    lt: 'Vertimai',
    lv: 'Tulkojumi',
    et: 'Tõlked',
    sl: 'Prevodi',
    ga: 'Aistriúcháin',
    mt: 'Traduzzjonijiet',
    cy: 'Cyfieithiadau',
    ro: 'Traduceri',
    it: 'Traduzioni',
    zh_cn: '翻译',
    hi: 'अनुवाद',
    ar: 'ترجمات',
    bn: 'অনুবাদসমূহ',
    ru: 'Переводы',
    ja: '翻訳',
    tr: 'Çeviriler',
    ko: '번역',
    vi: 'Bản dịch',
    id: 'Terjemahan',
    th: 'คำแปล',
    ms: 'Terjemahan',
    ar_eg: 'ترجمات',
    uk: 'Переклади',
  },
  sales_compare: {
    en: 'Sales Compare',
    es: 'Comparación de ventas',
    fr: 'Comparaison des ventes',
    de: 'Verkaufsvergleich',
    pt: 'Comparação de vendas',
    pl: 'Porównanie sprzedaży',
    nl: 'Verkoopvergelijking',
    el: 'Σύγκριση πωλήσεων',
    cs: 'Porovnání prodeje',
    sv: 'Försäljningsjämförelse',
    hu: 'Értékesítések összehasonlítása',
    da: 'Salgssammenligning',
    fi: 'Myynnin vertailu',
    sk: 'Porovnanie predaja',
    bg: 'Сравнение на продажбите',
    hr: 'Usporedba prodaje',
    lt: 'Pardavimų palyginimas',
    lv: 'Pārdošanas salīdzinājums',
    et: 'Müügi võrdlus',
    sl: 'Primerjava prodaje',
    ga: 'Comórtas Díolacháin',
    mt: 'Qabbel il-Bejgħ',
    cy: 'Cymhariaeth Gwerthiant',
    ro: 'Comparație vânzări',
    it: 'Confronto vendite',
    zh_cn: '销售对比',
    hi: 'बिक्री तुलना',
    ar: 'مقارنة المبيعات',
    bn: 'বিক্রয় তুলনা',
    ru: 'Сравнение продаж',
    ja: '売上比較',
    tr: 'Satış Karşılaştırması',
    ko: '매출 비교',
    vi: 'So sánh doanh số',
    id: 'Perbandingan penjualan',
    th: 'เปรียบเทียบยอดขาย',
    ms: 'Perbandingan Jualan',
    ar_eg: 'مقارنة المبيعات',
    uk: 'Порівняння продажів',
  },
  marketing: {
    en: 'Marketing',
    es: 'Marketing',
    fr: 'Marketing',
    de: 'Marketing',
    pt: 'Marketing',
    pl: 'Marketing',
    nl: 'Marketing',
    el: 'Μάρκετινγκ',
    cs: 'Marketing',
    sv: 'Marknadsföring',
    hu: 'Marketing',
    da: 'Markedsføring',
    fi: 'Markkinointi',
    sk: 'Marketing',
    bg: 'Маркетинг',
    hr: 'Marketing',
    lt: 'Rinkodara',
    lv: 'Mārketings',
    et: 'Turundus',
    ga: 'Margaíocht',
    mt: 'Marketing',
    cy: 'Marchnata',
    ro: 'Marketing',
    it: 'Marketing',
    zh_cn: '市场营销',
    hi: 'विपणन',
    ar: 'التسويق',
    bn: 'বিপণন',
    ru: 'Маркетинг',
    ja: 'マーケティング',
    tr: 'Pazarlama',
    ko: '마케팅',
    vi: 'Tiếp thị',
    id: 'Pemasaran',
    th: 'การตลาด',
    ms: 'Pemasaran',
    ar_eg: 'التسويق',
    uk: 'Маркетинг',
  },
  gift_card: {
    en: 'Gift Card',
    es: 'Tarjeta de regalo',
    fr: 'Carte-cadeau',
    de: 'Geschenkkarte',
    pt: 'Cartão-presente',
    pl: 'Karta podarunkowa',
    nl: 'Cadeaubon',
    el: 'Κάρτα δώρου',
    cs: 'Dárková karta',
    sv: 'Presentkort',
    hu: 'Ajándékkártya',
    da: 'Gavekort',
    fi: 'Lahjakortti',
    sk: 'Darčeková karta',
    bg: 'Подаръчна карта',
    hr: 'Poklon kartica',
    lt: 'Dovanų kortelė',
    lv: 'Dāvanu karte',
    et: 'Kinkekaart',
    ga: 'Cárta Bronntanais',
    mt: 'Karta Rigal',
    cy: 'Cerdyn Rhodd',
    ro: 'Card cadou',
    it: 'Carta regalo',
    zh_cn: '礼品卡',
    hi: 'उपहार कार्ड',
    ar: 'بطاقة هدايا',
    bn: 'উপহার কার্ড',
    ru: 'Подарочная карта',
    ja: 'ギフトカード',
    tr: 'Hediye Kartı',
    ko: '기프트 카드',
    vi: 'Thẻ quà tặng',
    id: 'Kartu hadiah',
    th: 'บัตรของขวัญ',
    ms: 'Kad hadiah',
    ar_eg: 'كارت هدايا',
    uk: 'Подарункова картка',
  },
  issued_gift_cards: {
    en: 'Issued Gift Cards',
    es: 'Tarjetas regalo emitidas',
    fr: 'Cartes cadeaux émises',
    de: 'Ausgestellte Geschenkkarten',
    pt: 'Cartões-presente emitidos',
    pl: 'Wydane karty podarunkowe',
    nl: 'Uitgegeven cadeaubonnen',
    el: 'Εκδοθείσες δωροκάρτες',
    cs: 'Vydané dárkové karty',
    sv: 'Utfärdade presentkort',
    hu: 'Kibocsátott ajándékkártyák',
    da: 'Udstedte gavekort',
    fi: 'Myönnetyt lahjakortit',
    sk: 'Vydané darčekové karty',
    bg: 'Издадени подаръчни карти',
    hr: 'Izdane poklon kartice',
    lt: 'Išduotos dovanų kortelės',
    lv: 'Izsniegtās dāvanu kartes',
    et: 'Väljastatud kinkekaardid',
    sl: 'Izdane darilne kartice',
    ga: 'Cártaí bronntanais eisithe',
    mt: 'Karti rigal maħruġa',
    cy: 'Cardiau rhodd a gyhoeddwyd',
    ro: 'Carduri cadou emise',
    it: 'Carte regalo emesse',
    zh_cn: '已发行礼品卡',
    hi: 'जारी किए गए गिफ्ट कार्ड',
    ar: 'بطاقات الهدايا الصادرة',
    bn: 'ইস্যুকৃত গিফট কার্ড',
    ru: 'Выпущенные подарочные карты',
    ja: '発行済みギフトカード',
    tr: 'Düzenlenen hediye kartları',
    ko: '발행된 기프트 카드',
    vi: 'Thẻ quà tặng đã phát hành',
    id: 'Kartu hadiah yang diterbitkan',
    th: 'บัตรของขวัญที่ออกแล้ว',
    ms: 'Kad hadiah yang dikeluarkan',
    ar_eg: 'كروت الهدية المُصدرة',
    uk: 'Випущені подарункові картки',
  },
  suppliers: {
    en: 'Suppliers',
    es: 'Proveedores',
    fr: 'Fournisseurs',
    de: 'Lieferanten',
    pt: 'Fornecedores',
    pl: 'Dostawcy',
    nl: 'Leveranciers',
    el: 'Προμηθευτές',
    cs: 'Dodavatelé',
    sv: 'Leverantörer',
    hu: 'Beszállítók',
    da: 'Leverandører',
    fi: 'Toimittajat',
    sk: 'Dodávatelia',
    bg: 'Доставчици',
    hr: 'Dobavljači',
    lt: 'Tiekėjai',
    lv: 'Piegādātāji',
    et: 'Tarnijad',
    sl: 'Dobavitelji',
    ga: 'Soláthróirí',
    mt: 'Fornituri',
    cy: 'Cyflenwyr',
    ro: 'Furnizori',
    it: 'Fornitori',
    zh_cn: '供应商',
    hi: 'आपूर्तिकर्ता',
    ar: 'الموردون',
    bn: 'সরবরাহকারী',
    ru: 'Поставщики',
    ja: '仕入先',
    tr: 'Tedarikçiler',
    ko: '공급업체',
    vi: 'Nhà Cung Cấp',
    id: 'Pemasok',
    th: 'ผู้จัดหา',
    ms: 'Pembekal',
    ar_eg: 'الموردين',
    uk: 'Постачальники',
  },
  purchase_orders: {
    en: 'Purchase Orders',
    es: 'Órdenes de compra',
    fr: "Ordres d'achat",
    de: 'Bestellungen',
    pt: 'Ordens de compra',
    pl: 'Zamówienia zakupu',
    nl: 'Inkooporders',
    el: 'Παραγγελίες αγοράς',
    cs: 'Objednávky nákupu',
    sv: 'Inköpsorder',
    hu: 'Beszerzési rendelések',
    da: 'Indkøbsordrer',
    fi: 'Ostotilaukset',
    sk: 'Objednávky nákupu',
    bg: 'Поръчки за покупка',
    hr: 'Narudžbenice',
    lt: 'Pirkimo užsakymai',
    lv: 'Pirkuma pasūtījumi',
    et: 'Ostutellimused',
    sl: 'Naročila za nakup',
    ga: 'Orduithe Ceannaigh',
    mt: 'Ordnijiet tax-xiri',
    cy: 'Archebion prynu',
    ro: 'Comenzi de achiziție',
    it: 'Ordini di acquisto',
    zh_cn: '采购订单',
    hi: 'खरीद आदेश',
    ar: 'أوامر الشراء',
    bn: 'ক্রয় আদেশসমূহ',
    ru: 'Заказы на покупку',
    ja: '購買注文',
    tr: 'Satın Alma Siparişleri',
    ko: '구매 주문서',
    vi: 'Đơn đặt hàng mua',
    id: 'Pesanan pembelian',
    th: 'ใบสั่งซื้อ',
    ms: 'Pesanan belian',
    ar_eg: 'أوامر الشراء',
    uk: 'Замовлення на покупку',
  },

  ai_insights_stock: {
    en: 'AI Insights-Stock',
    es: 'Perspectivas de IA - Stock',
    fr: 'Aperçus IA - Stock',
    de: 'KI-Einblicke – Bestand',
    pt: 'Insights de IA - Stock',
    pl: 'Wglądy AI – Zapas',
    nl: 'AI-inzichten - Voorraad',
    el: 'Συμβουλές ΤΝ - Απόθεμα',
    cs: 'AI poznatky – Sklad',
    sv: 'AI-insikter – Lager',
    hu: 'MI-elemzések – Készlet',
    da: 'AI-indsigter – Lager',
    fi: 'AI-oivallukset – Varasto',
    sk: 'AI poznatky – Sklad',
    bg: 'AI анализи – Наличности',
    hr: 'AI uvidi – Zaliha',
    lt: 'AI įžvalgos – Atsargos',
    lv: 'AI ieskati – Krājumi',
    et: 'AI teadmised – Laoseis',
    sl: 'AI vpogledi – Zaloga',
    ga: 'Léargais AI – Stoc',
    mt: 'Għarfien AI – Stock',
    cy: 'Mewnwelediadau AI – Stoc',
    ro: 'Informații AI – Stoc',
    it: 'Approfondimenti IA – Stock',
    zh_cn: 'AI 洞察 - 库存',
    hi: 'एआई इनसाइट्स - स्टॉक',
    ar: 'تحليلات الذكاء الاصطناعي - المخزون',
    bn: 'এআই ইনসাইটস - স্টক',
    ru: 'AI-аналитика – Запасы',
    ja: 'AI インサイト - 在庫',
    tr: 'Yapay Zekâ İçgörüleri - Stok',
    ko: 'AI 인사이트 - 재고',
    vi: 'AI Thấu hiểu – Tồn kho',
    id: 'Wawasan AI – Stok',
    th: 'ข้อมูลเชิงลึกจาก AI - สต็อก',
    ms: 'Wawasan AI – Stok',
    ar_eg: 'تحليلات الذكاء الاصطناعي - المخزون',
    uk: 'AI Аналітика – Запаси',
  },
  ai_insights_staff: {
    en: 'AI Insights-Staff',
    es: 'Perspectivas de IA - Personal',
    fr: 'Aperçus IA - Personnel',
    de: 'KI-Einblicke – Personal',
    pt: 'Insights de IA - Equipa',
    pl: 'Wglądy AI – Personel',
    nl: 'AI-inzichten - Personeel',
    el: 'Συμβουλές ΤΝ - Προσωπικό',
    cs: 'AI poznatky – Personál',
    sv: 'AI-insikter – Personal',
    hu: 'MI-elemzések – Személyzet',
    da: 'AI-indsigter – Personale',
    fi: 'AI-oivallukset – Henkilöstö',
    sk: 'AI poznatky – Personál',
    bg: 'AI анализи – Персонал',
    hr: 'AI uvidi – Osoblje',
    lt: 'AI įžvalgos – Personalas',
    lv: 'AI ieskati – Personāls',
    et: 'AI teadmised – Personal',
    sl: 'AI vpogledi – Osebje',
    ga: 'Léargais AI – Foireann',
    mt: 'Għarfien AI – Staff',
    cy: 'Mewnwelediadau AI – Staff',
    ro: 'Informații AI – Personal',
    it: 'Approfondimenti IA – Personale',
    zh_cn: 'AI 洞察 - 员工',
    hi: 'एआई इनसाइट्स - स्टाफ',
    ar: 'تحليلات الذكاء الاصطناعي - الموظفين',
    bn: 'এআই ইনসাইটস - স্টাফ',
    ru: 'AI-аналитика – Персонал',
    ja: 'AI インサイト - スタッフ',
    tr: 'Yapay Zekâ İçgörüleri - Personel',
    ko: 'AI 인사이트 - 직원',
    vi: 'AI Thấu hiểu – Nhân sự',
    id: 'Wawasan AI – Staf',
    th: 'ข้อมูลเชิงลึกจาก AI - พนักงาน',
    ms: 'Wawasan AI – Kakitangan',
    ar_eg: 'تحليلات الذكاء الاصطناعي - الموظفين',
    uk: 'AI Аналітика – Персонал',
  },
  payment_methods: {
    en: 'Payment Methods',
    es: 'Métodos de Pago',
    fr: 'Méthodes de Paiement',
    de: 'Zahlungsmethoden',
    pt: 'Métodos de Pagamento',
    pl: 'Metody Płatności',
    nl: 'Betaalmethoden',
    el: 'Μέθοδοι Πληρωμής',
    cs: 'Platební Metody',
    sv: 'Betalningsmetoder',
    hu: 'Fizetési Módok',
    da: 'Betalingsmetoder',
    fi: 'Maksutavat',
    sk: 'Spôsoby Platby',
    bg: 'Методи на Плащане',
    hr: 'Načini Plaćanja',
    lt: 'Mokėjimo Būdai',
    lv: 'Maksājumu Metodes',
    et: 'Makseviisid',
    sl: 'Načini Plačila',
    ga: 'Modhanna Íocaíochta',
    mt: 'Metodi ta’ Ħlas',
    cy: 'Dulliau Talu',
    ro: 'Metode de Plată',
    it: 'Metodi di Pagamento',
    zh_cn: '付款方式',
    hi: 'भुगतान विधियाँ',
    ar: 'طرق الدفع',
    bn: 'পরিশোধের পদ্ধতি',
    ru: 'Способы оплаты',
    ja: '支払い方法',
    tr: 'Ödeme Yöntemleri',
    ko: '결제 방법',
    vi: 'Phương Thức Thanh Toán',
    id: 'Metode Pembayaran',
    th: 'วิธีการชำระเงิน',
    ms: 'Kaedah Pembayaran',
    ar_eg: 'طرق الدفع',
    uk: 'Способи оплати',
  },
  stock_take: {
    en: 'Stock Take',
    es: 'Inventario',
    fr: 'Inventaire',
    de: 'Bestandsaufnahme',
    pt: 'Contagem de estoque',
    pl: 'Inwentaryzacja',
    nl: 'Voorraadopname',
    el: 'Απογραφή αποθεμάτων',
    cs: 'Inventura',
    sv: 'Lagerinventering',
    hu: 'Leltár',
    da: 'Lageroptælling',
    fi: 'Varastoselvitys',
    sk: 'Inventúra zásob',
    bg: 'Инвентаризация',
    hr: 'Popis zaliha',
    lt: 'Atsargų inventorizacija',
    lv: 'Krājumu inventarizācija',
    et: 'Lao ülevaatus',
    sl: 'Popis zalog',
    ga: 'Láimhsiú Stoc',
    mt: 'Ħidma tal-Istokk',
    cy: 'Cyfrif Stoc',
    ro: 'Inventariere',
    it: 'Verifica dell’inventario',
    zh_cn: '库存盘点',
    hi: 'स्टॉक जांच',
    ar: 'جرد المخزون',
    bn: 'স্টক যাচাইকরণ',
    ru: 'Переучёт товаров',
    ja: '棚卸し',
    tr: 'Stok Sayımı',
    ko: '재고 조사',
    vi: 'Kiểm kê hàng tồn',
    id: 'Stok Opname',
    th: 'การตรวจนับสต็อก',
    ms: 'Pengiraan Stok',
    ar_eg: 'جرد المخزون',
    uk: 'Інвентаризація',
  },
  experience_levels: {
    en: 'Experience Levels',
    es: 'Niveles de experiencia',
    fr: "Niveaux d'expérience",
    de: 'Erfahrungsstufen',
    pt: 'Níveis de experiência',
    pl: 'Poziomy doświadczenia',
    nl: 'Ervaringsniveaus',
    el: 'Επίπεδα εμπειρίας',
    cs: 'Úrovně zkušeností',
    sv: 'Erfarenhetsnivåer',
    hu: 'Tapasztalati szintek',
    da: 'Erfaringsniveauer',
    fi: 'Kokemustasot',
    sk: 'Úrovne skúseností',
    bg: 'Нива на опит',
    hr: 'Razine iskustva',
    lt: 'Patirties lygiai',
    lv: 'Pieredzes līmeņi',
    et: 'Kogemustasemed',
    sl: 'Ravni izkušenj',
    ga: 'Leibhéil Taithí',
    mt: 'Livelli ta’ Esperjenza',
    cy: 'Lefelau Profiad',
    ro: 'Niveluri de experiență',
    it: 'Livelli di esperienza',
    zh_cn: '经验等级',
    hi: 'अनुभव स्तर',
    ar: 'مستويات الخبرة',
    bn: 'অভিজ্ঞতার স্তরসমূহ',
    ru: 'Уровни опыта',
    ja: '経験レベル',
    tr: 'Deneyim seviyeleri',
    ko: '경험 수준',
    vi: 'Cấp độ kinh nghiệm',
    id: 'Tingkat pengalaman',
    th: 'ระดับประสบการณ์',
    ms: 'Tahap pengalaman',
    ar_eg: 'مستويات الخبرة',
    uk: 'Рівні досвіду',
  },
  work_sections: {
    en: 'Work Sections',
    es: 'Secciones de Trabajo',
    fr: 'Sections de Travail',
    de: 'Arbeitsbereiche',
    pt: 'Seções de Trabalho',
    pl: 'Sekcje Pracy',
    nl: 'Werksecties',
    el: 'Ενότητες Εργασίας',
    cs: 'Pracovní Sekce',
    sv: 'Arbetssektioner',
    hu: 'Munkaszakaszok',
    da: 'Arbejdssektioner',
    fi: 'Työosiot',
    sk: 'Pracovné Sekcie',
    bg: 'Работни Секции',
    hr: 'Radni Odjeljci',
    lt: 'Darbo Skyriai',
    lv: 'Darba Sadaļas',
    et: 'Tööjaotused',
    sl: 'Delovni Oddelki',
    ga: 'Rannóga Oibre',
    mt: 'Taħditiet tax-Xogħol',
    cy: 'Adrannau Gwaith',
    ro: 'Secțiuni de Lucru',
    it: 'Sezioni di Lavoro',
    zh_cn: '工作部分',
    hi: 'कार्य अनुभाग',
    ar: 'أقسام العمل',
    bn: 'কাজের বিভাগসমূহ',
    ru: 'Разделы Работы',
    ja: '作業セクション',
    tr: 'İş Bölümleri',
    ko: '작업 섹션',
    vi: 'Phần Việc',
    id: 'Bagian Pekerjaan',
    th: 'ส่วนงาน',
    ms: 'Bahagian Kerja',
    ar_eg: 'أقسام الشغل',
    uk: 'Робочі Розділи',
  },

  select_date_range: {
    en: 'Select Date Range',
    es: 'Seleccionar rango de fechas',
    fr: 'Sélectionner une plage de dates',
    de: 'Datumsbereich auswählen',
    pt: 'Selecionar intervalo de datas',
    pl: 'Wybierz zakres dat',
    nl: 'Selecteer datumbereik',
    el: 'Επιλέξτε εύρος ημερομηνιών',
    cs: 'Vyberte rozsah data',
    sv: 'Välj datumintervall',
    hu: 'Válasszon dátumtartományt',
    da: 'Vælg datointerval',
    fi: 'Valitse päivämääräväli',
    sk: 'Vyberte rozsah dátumov',
    bg: 'Изберете период от дати',
    hr: 'Odaberite raspon datuma',
    lt: 'Pasirinkite datų intervalą',
    lv: 'Izvēlieties datumu diapazonu',
    et: 'Valige kuupäevavahemik',
    sl: 'Izberite datumskih razpon',
    ga: 'Roghnaigh Raon Dátaí',
    mt: "Agħżel firxa ta' dati",
    cy: 'Dewiswch ystod dyddiadau',
    ro: 'Selectați intervalul de date',
    it: "Seleziona l'intervallo di date",
    zh_cn: '选择日期范围',
    hi: 'तिथि सीमा चुनें',
    ar: 'اختر نطاق التواريخ',
    bn: 'তারিখের পরিসর নির্বাচন করুন',
    ru: 'Выберите диапазон дат',
    ja: '日付範囲を選択',
    tr: 'Tarih Aralığı Seçin',
    ko: '날짜 범위를 선택하세요',
    vi: 'Chọn khoảng ngày',
    id: 'Pilih rentang tanggal',
    th: 'เลือกช่วงวันที่',
    ms: 'Pilih julat tarikh',
    ar_eg: 'اختر نطاق التواريخ',
    uk: 'Виберіть діапазон дат',
  },

  choose_date_of_birth: {
    en: 'Select date of birth',
    es: 'Seleccionar fecha de nacimiento',
    fr: 'Sélectionner la date de naissance',
    de: 'Geburtsdatum auswählen',
    pt: 'Selecionar data de nascimento',
    pl: 'Wybierz datę urodzenia',
    nl: 'Selecteer geboortedatum',
    el: 'Επιλέξτε την ημερομηνία γέννησης',
    cs: 'Vyberte datum narození',
    sv: 'Välj födelsedatum',
    hu: 'Válassza ki a születési dátumot',
    da: 'Vælg fødselsdato',
    fi: 'Valitse syntymäpäivä',
    sk: 'Vyberte dátum narodenia',
    bg: 'Изберете дата на раждане',
    hr: 'Odaberite datum rođenja',
    lt: 'Pasirinkite gimimo datą',
    lv: 'Izvēlieties dzimšanas datumu',
    et: 'Valige sünnikuupäev',
    sl: 'Izberite datum rojstva',
    ga: 'Roghnaigh dáta breithe',
    mt: 'Agħżel id-data tat-twelid',
    cy: 'Dewiswch ddyddiad geni',
    ro: 'Selectați data nașterii',
    it: 'Seleziona la data di nascita',
    zh_cn: '选择出生日期',
    hi: 'जन्मतिथि चुनें',
    ar: 'اختر تاريخ الميلاد',
    bn: 'জন্মতারিখ নির্বাচন করুন',
    ru: 'Выберите дату рождения',
    ja: '生年月日を選択',
    tr: 'Doğum tarihi seçin',
    ko: '생년월일 선택',
    vi: 'Chọn ngày sinh',
    id: 'Pilih tanggal lahir',
    th: 'เลือกวันเกิด',
    ms: 'Pilih tarikh lahir',
    ar_eg: 'اختر تاريخ الميلاد',
    uk: 'Виберіть дату народження',
  },

  total_amount: {
    en: 'Total Amount',
    es: 'Importe Total',
    fr: 'Montant Total',
    de: 'Gesamtbetrag',
    pt: 'Valor Total',
    pl: 'Kwota Łączna',
    nl: 'Totaalbedrag',
    el: 'Συνολικό Ποσό',
    cs: 'Celková Částka',
    sv: 'Totalt Belopp',
    hu: 'Teljes Összeg',
    da: 'Samlet Beløb',
    fi: 'Kokonaissumma',
    sk: 'Celková Suma',
    bg: 'Обща Сума',
    hr: 'Ukupan Iznos',
    lt: 'Bendra Suma',
    lv: 'Kopējā Summa',
    et: 'Kogusumma',
    sl: 'Skupni Znesek',
    ga: 'Méid Iomlán',
    mt: 'Ammont Totali',
    cy: 'Cyfanswm Swm',
    ro: 'Sumă Totală',
    it: 'Importo Totale',
    zh_cn: '总金额',
    hi: 'कुल राशि',
    ar: 'المبلغ الإجمالي',
    bn: 'মোট পরিমাণ',
    ru: 'Итоговая Сумма',
    ja: '合計金額',
    tr: 'Toplam Tutar',
    ko: '총 금액',
    vi: 'Tổng Số Tiền',
    id: 'Jumlah Total',
    th: 'จำนวนเงินทั้งหมด',
    ms: 'Jumlah Keseluruhan',
    ar_eg: 'المبلغ الكلي',
    uk: 'Загальна Сума',
  },
  total_qty: {
    en: 'Total QTY',
    es: 'Cantidad Total',
    fr: 'Qté Totale',
    de: 'Gesamtmenge',
    pt: 'Quantidade Total',
    pl: 'Łączna Ilość',
    nl: 'Totale Hoeveelheid',
    el: 'Συνολική Ποσότητα',
    cs: 'Celkové Množství',
    sv: 'Total Kvantitet',
    hu: 'Teljes Mennyiség',
    da: 'Samlet Antal',
    fi: 'Kokonaismäärä',
    sk: 'Celkové Množstvo',
    bg: 'Общо Количество',
    hr: 'Ukupna Količina',
    lt: 'Bendras Kiekis',
    lv: 'Kopējais Daudzums',
    et: 'Kogukogus',
    sl: 'Skupna Količina',
    ga: 'Cainníocht Iomlán',
    mt: 'Kwantità Totali',
    cy: 'Cyfanswm Nifer',
    ro: 'Cantitate Totală',
    it: 'Q.tà Totale',
    zh_cn: '总数量',
    hi: 'कुल मात्रा',
    ar: 'إجمالي الكمية',
    bn: 'মোট পরিমাণ',
    ru: 'Общее Количество',
    ja: '総数量',
    tr: 'Toplam Miktar',
    ko: '총 수량',
    vi: 'Tổng Số Lượng',
    id: 'Jumlah Total',
    th: 'ปริมาณทั้งหมด',
    ms: 'Kuantiti Keseluruhan',
    ar_eg: 'إجمالي الكمية',
    uk: 'Загальна Кількість',
  },
  all_order_types: {
    en: 'All Order Types',
    es: 'Todos los Tipos de Pedidos',
    fr: 'Tous les Types de Commandes',
    de: 'Alle Bestellarten',
    pt: 'Todos os Tipos de Pedido',
    pl: 'Wszystkie Typy Zamówień',
    nl: 'Alle Ordertypes',
    el: 'Όλοι οι Τύποι Παραγγελιών',
    cs: 'Všechny Typy Objednávek',
    sv: 'Alla Ordertyper',
    hu: 'Minden Rendeléstípus',
    da: 'Alle Ordretyper',
    fi: 'Kaikki Tilaustyypit',
    sk: 'Všetky Typy Objednávok',
    bg: 'Всички Видове Поръчки',
    hr: 'Sve Vrste Narudžbi',
    lt: 'Visi Užsakymų Tipai',
    lv: 'Visi Pasūtījumu Veidi',
    et: 'Kõik Tellimuse Tüübid',
    sl: 'Vse Vrste Naročil',
    ga: 'Gach Cineál Ordaithe',
    mt: 'It-Tipi Kollha ta’ Ordni',
    cy: 'Pob Math o Archeb',
    ro: 'Toate Tipurile de Comenzi',
    it: 'Tutti i Tipi di Ordine',
    zh_cn: '所有订单类型',
    hi: 'सभी ऑर्डर प्रकार',
    ar: 'جميع أنواع الطلبات',
    bn: 'সমস্ত অর্ডারের ধরন',
    ru: 'Все Типы Заказов',
    ja: 'すべての注文タイプ',
    tr: 'Tüm Sipariş Türleri',
    ko: '모든 주문 유형',
    vi: 'Tất Cả Loại Đơn Hàng',
    id: 'Semua Jenis Pesanan',
    th: 'ประเภทคำสั่งซื้อทั้งหมด',
    ms: 'Semua Jenis Pesanan',
    ar_eg: 'كل أنواع الأوردرات',
    uk: 'Усі Типи Замовлень',
  },

  image_guidelines: {
    en: 'image guidelines',
    es: 'pautas de imagen',
    fr: "directives d'image",
    de: 'Bildrichtlinien',
    pt: 'diretrizes de imagem',
    pl: 'wytyczne dotyczące obrazów',
    nl: 'afbeeldingsrichtlijnen',
    el: 'οδηγίες εικόνας',
    cs: 'pokyny pro obrázky',
    sv: 'bildriktlinjer',
    hu: 'képi irányelvek',
    da: 'billedretningslinjer',
    fi: 'kuvaohjeet',
    sk: 'pokyny pre obrázky',
    bg: 'насоки за изображения',
    hr: 'smjernice za slike',
    lt: 'vaizdų gairės',
    lv: 'attēlu vadlīnijas',
    et: 'pildijuhised',
    sl: 'smernice za slike',
    ga: 'treoirlínte íomhá',
    mt: 'linji gwida tal-immaġini',
    cy: 'canllawiau delwedd',
    ro: 'ghiduri pentru imagini',
    it: 'linee guida per le immagini',
    zh_cn: '图片指南',
    hi: 'छवि दिशानिर्देश',
    ar: 'إرشادات الصور',
    bn: 'ছবির নির্দেশিকা',
    ru: 'рекомендации по изображениям',
    ja: '画像ガイドライン',
    tr: 'görsel yönergeleri',
    ko: '이미지 가이드라인',
    vi: 'hướng dẫn hình ảnh',
    id: 'panduan gambar',
    th: 'แนวทางการใช้รูปภาพ',
    ms: 'garis panduan imej',
    ar_eg: 'إرشادات الصور',
    uk: 'рекомендації щодо зображень',
  },
  date_range: {
    en: 'Date Range',
    es: 'Rango de fechas',
    fr: 'Plage de dates',
    de: 'Datumsbereich',
    pt: 'Intervalo de datas',
    pl: 'Zakres dat',
    nl: 'Datumbereik',
    el: 'Εύρος ημερομηνιών',
    cs: 'Časové období',
    sv: 'Datumintervall',
    hu: 'Dátumtartomány',
    da: 'Datointerval',
    fi: 'Päivämääräalue',
    sk: 'Rozsah dátumov',
    bg: 'Диапазон от дати',
    hr: 'Raspon datuma',
    lt: 'Datų intervalas',
    lv: 'Datumu diapazons',
    et: 'Kuupäevavahemik',
    ga: 'Raon Dáta',
    mt: 'Firxa ta’ Dati',
    cy: 'Ystod dyddiadau',
    ro: 'Interval de date',
    it: 'Intervallo di date',
    zh_cn: '日期范围',
    hi: 'तारीख सीमा',
    ar: 'نطاق التاريخ',
    bn: 'তারিখের পরিসর',
    ru: 'Диапазон дат',
    ja: '日付範囲',
    tr: 'Tarih aralığı',
    ko: '날짜 범위',
    vi: 'Khoảng ngày',
    id: 'Rentang tanggal',
    th: 'ช่วงวันที่',
    ms: 'Julat tarikh',
    ar_eg: 'نطاق التاريخ',
    uk: 'Діапазон дат',
  },
  date_ranges: {
    today: {
      en: 'Today',
      es: 'Hoy',
      fr: "Aujourd'hui",
      de: 'Heute',
      pt: 'Hoje',
      pl: 'Dzisiaj',
      nl: 'Vandaag',
      el: 'Σήμερα',
      cs: 'Dnes',
      sv: 'Idag',
      hu: 'Ma',
      da: 'I dag',
      fi: 'Tänään',
      sk: 'Dnes',
      bg: 'Днес',
      hr: 'Danas',
      lt: 'Šiandien',
      lv: 'Šodien',
      et: 'Täna',
      ga: 'Inniu',
      mt: 'Illum',
      cy: 'Heddiw',
      ro: 'Astăzi',
      it: 'Oggi',
      zh_cn: '今天',
      hi: 'आज',
      ar: 'اليوم',
      bn: 'আজ',
      ru: 'Сегодня',
      ja: '今日',
      tr: 'Bugün',
      ko: '오늘',
      vi: 'Hôm nay',
      id: 'Hari ini',
      th: 'วันนี้',
      ms: 'Hari ini',
      ar_eg: 'النهاردة',
      uk: 'Сьогодні',
    },
    yesterday: {
      en: 'Yesterday',
      es: 'Ayer',
      fr: 'Hier',
      de: 'Gestern',
      pt: 'Ontem',
      pl: 'Wczoraj',
      nl: 'Gisteren',
      el: 'Χθες',
      cs: 'Včera',
      sv: 'Igår',
      hu: 'Tegnap',
      da: 'I går',
      fi: 'Eilen',
      sk: 'Včera',
      bg: 'Вчера',
      hr: 'Jučer',
      lt: 'Vakar',
      lv: 'Vakar',
      et: 'Eile',
      ga: 'Inné',
      mt: 'Ilbieraħ',
      cy: 'Ddoe',
      ro: 'Ieri',
      it: 'Ieri',
      zh_cn: '昨天',
      hi: 'कल',
      ar: 'أمس',
      bn: 'গতকাল',
      ru: 'Вчера',
      ja: '昨日',
      tr: 'Dün',
      ko: '어제',
      vi: 'Hôm qua',
      id: 'Kemarin',
      th: 'เมื่อวานนี้',
      ms: 'Semalam',
      ar_eg: 'امبارح',
      uk: 'Вчора',
    },
    last_7_days: {
      en: 'Last 7 Days',
      es: 'Últimos 7 días',
      fr: '7 derniers jours',
      de: 'Letzte 7 Tage',
      pt: 'Últimos 7 dias',
      pl: 'Ostatnie 7 dni',
      nl: 'Afgelopen 7 dagen',
      el: 'Τελευταίες 7 ημέρες',
      cs: 'Posledních 7 dní',
      sv: 'Senaste 7 dagarna',
      hu: 'Elmúlt 7 nap',
      da: 'Seneste 7 dage',
      fi: 'Viimeiset 7 päivää',
      sk: 'Posledných 7 dní',
      bg: 'Последните 7 дни',
      hr: 'Zadnjih 7 dana',
      lt: 'Paskutinės 7 dienos',
      lv: 'Pēdējās 7 dienas',
      et: 'Viimased 7 päeva',
      ga: 'Na 7 Lá is Déanaí',
      mt: 'L-aħħar 7 ijiem',
      cy: '7 Diwethaf',
      ro: 'Ultimele 7 zile',
      it: 'Ultimi 7 giorni',
      zh_cn: '过去7天',
      hi: 'पिछले 7 दिन',
      ar: 'آخر 7 أيام',
      bn: 'গত ৭ দিন',
      ru: 'Последние 7 дней',
      ja: '過去7日間',
      tr: 'Son 7 gün',
      ko: '지난 7일',
      vi: '7 ngày qua',
      id: '7 hari terakhir',
      th: '7 วันที่ผ่านมา',
      ms: '7 hari terakhir',
      ar_eg: 'آخر 7 أيام',
      uk: 'Останні 7 днів',
    },
    last_30_days: {
      en: 'Last 30 Days',
      es: 'Últimos 30 días',
      fr: '30 derniers jours',
      de: 'Letzte 30 Tage',
      pt: 'Últimos 30 dias',
      pl: 'Ostatnie 30 dni',
      nl: 'Afgelopen 30 dagen',
      el: 'Τελευταίες 30 ημέρες',
      cs: 'Posledních 30 dní',
      sv: 'Senaste 30 dagarna',
      hu: 'Elmúlt 30 nap',
      da: 'Seneste 30 dage',
      fi: 'Viimeiset 30 päivää',
      sk: 'Posledných 30 dní',
      bg: 'Последните 30 дни',
      hr: 'Zadnjih 30 dana',
      lt: 'Paskutinės 30 dienų',
      lv: 'Pēdējās 30 dienas',
      et: 'Viimased 30 päeva',
      ga: 'Na 30 Lá is Déanaí',
      mt: 'L-aħħar 30 ġurnata',
      cy: '30 Diwethaf',
      ro: 'Ultimele 30 de zile',
      it: 'Ultimi 30 giorni',
      zh_cn: '过去30天',
      hi: 'पिछले 30 दिन',
      ar: 'آخر 30 يومًا',
      bn: 'গত ৩০ দিন',
      ru: 'Последние 30 дней',
      ja: '過去30日間',
      tr: 'Son 30 gün',
      ko: '지난 30일',
      vi: '30 ngày qua',
      id: '30 hari terakhir',
      th: '30 วันที่ผ่านมา',
      ms: '30 hari terakhir',
      ar_eg: 'آخر 30 يوم',
      uk: 'Останні 30 днів',
    },
    from_to: {
      en: '%s to %s',
      es: '%s a %s',
      fr: 'Du %s au %s',
      de: 'Von %s bis %s',
      pt: 'De %s até %s',
      pl: 'Od %s do %s',
      nl: 'Van %s tot %s',
      el: 'Από %s έως %s',
      cs: 'Od %s do %s',
      sv: 'Från %s till %s',
      hu: '%s-tól %s-ig',
      da: 'Fra %s til %s',
      fi: '%s–%s',
      sk: 'Od %s do %s',
      bg: 'От %s до %s',
      hr: 'Od %s do %s',
      lt: 'Nuo %s iki %s',
      lv: 'No %s līdz %s',
      et: 'Alates %s kuni %s',
      ga: 'Ó %s go %s',
      mt: 'Minn %s sa %s',
      cy: 'O %s i %s',
      ro: 'De la %s până la %s',
      it: 'Dal %s al %s',
      zh_cn: '%s 到 %s',
      hi: '%s से %s तक',
      ar: 'من %s إلى %s',
      bn: '%s থেকে %s',
      ru: 'С %s по %s',
      ja: '%s から %s まで',
      tr: '%s ile %s arası',
      ko: '%s부터 %s까지',
      vi: 'Từ %s đến %s',
      id: 'Dari %s sampai %s',
      th: 'ตั้งแต่ %s ถึง %s',
      ms: 'Dari %s ke %s',
      ar_eg: 'من %s لـ %s',
      uk: 'З %s по %s',
    },
    custom_range: {
      en: 'Custom Range',
      es: 'Rango personalizado',
      fr: 'Plage personnalisée',
      de: 'Benutzerdefinierter Bereich',
      pt: 'Intervalo personalizado',
      pl: 'Zakres niestandardowy',
      nl: 'Aangepast bereik',
      el: 'Προσαρμοσμένο εύρος',
      cs: 'Vlastní rozsah',
      sv: 'Anpassat intervall',
      hu: 'Egyéni tartomány',
      da: 'Brugerdefineret interval',
      fi: 'Mukautettu alue',
      sk: 'Vlastný rozsah',
      bg: 'Персонализиран диапазон',
      hr: 'Prilagođeni raspon',
      lt: 'Tinkintas intervalas',
      lv: 'Pielāgots diapazons',
      et: 'Kohandatud vahemik',
      ga: 'Raon Saincheaptha',
      mt: 'Firxa personalizzata',
      cy: 'Ystod personol',
      ro: 'Interval personalizat',
      it: 'Intervallo personalizzato',
      zh_cn: '自定义范围',
      hi: 'कस्टम सीमा',
      ar: 'نطاق مخصص',
      bn: 'কাস্টম পরিসর',
      ru: 'Пользовательский диапазон',
      ja: 'カスタム範囲',
      tr: 'Özel aralık',
      ko: '사용자 정의 범위',
      vi: 'Phạm vi tùy chỉnh',
      id: 'Rentang khusus',
      th: 'ช่วงที่กำหนดเอง',
      ms: 'Julat tersuai',
      ar_eg: 'نطاق مخصص',
      uk: 'Користувацький діапазон',
    },
    custom_date: {
      en: 'Custom Date',
      es: 'Fecha personalizada',
      fr: 'Date personnalisée',
      de: 'Benutzerdefiniertes Datum',
      pt: 'Data personalizada',
      pl: 'Niestandardowa data',
      nl: 'Aangepaste datum',
      el: 'Προσαρμοσμένη ημερομηνία',
      cs: 'Vlastní datum',
      sv: 'Anpassat datum',
      hu: 'Egyéni dátum',
      da: 'Brugerdefineret dato',
      fi: 'Mukautettu päivämäärä',
      sk: 'Vlastný dátum',
      bg: 'Персонализирана дата',
      hr: 'Prilagođeni datum',
      lt: 'Tinkinta data',
      lv: 'Pielāgots datums',
      et: 'Kohandatud kuupäev',
      sl: 'Datum po meri',
      ga: 'Dáta Saincheaptha',
      mt: 'Data Personalizzata',
      cy: 'Dyddiad Personol',
      ro: 'Dată personalizată',
      it: 'Data personalizzata',
      zh_cn: '自定义日期',
      hi: 'कस्टम दिनांक',
      ar: 'تاريخ مخصص',
      bn: 'কাস্টম তারিখ',
      ru: 'Произвольная дата',
      ja: 'カスタム日付',
      tr: 'Özel Tarih',
      ko: '사용자 지정 날짜',
      vi: 'Ngày tùy chỉnh',
      id: 'Tanggal Kustom',
      th: 'วันที่กำหนดเอง',
      ms: 'Tarikh Tersuai',
      ar_eg: 'تاريخ مخصص',
      uk: 'Користувацька дата',
    },
  },
  search: {
    en: 'Search',
    es: 'Buscar',
    fr: 'Rechercher',
    de: 'Suchen',
    pt: 'Pesquisar',
    pl: 'Szukaj',
    nl: 'Zoeken',
    el: 'Αναζήτηση',
    cs: 'Hledat',
    sv: 'Sök',
    hu: 'Keresés',
    da: 'Søg',
    fi: 'Hae',
    sk: 'Hľadať',
    bg: 'Търсене',
    hr: 'Traži',
    lt: 'Ieškoti',
    lv: 'Meklēt',
    et: 'Otsing',
    sl: 'Išči',
    ga: 'Cuardach',
    mt: 'Fittex',
    cy: 'Chwilio',
    ro: 'Căutare',
    it: 'Cerca',
    zh_cn: '搜索',
    hi: 'खोज',
    ar: 'بحث',
    bn: 'অনুসন্ধান',
    ru: 'Поиск',
    ja: '検索',
    tr: 'Arama',
    ko: '검색',
    vi: 'Tìm kiếm',
    id: 'Cari',
    th: 'ค้นหา',
    ms: 'Cari',
    ar_eg: 'بحث',
    uk: 'Пошук',
  },
  order_status_profiles: {
    en: 'Order Status Profiles',
    es: 'Perfiles de Estado del Pedido',
    fr: 'Profils de Statut de Commande',
    de: 'Bestellstatusprofile',
    pt: 'Perfis de Estado do Pedido',
    pl: 'Profile Statusu Zamówienia',
    nl: 'Bestelstatusprofielen',
    el: 'Προφίλ Κατάστασης Παραγγελιών',
    cs: 'Profily Stavu Objednávky',
    sv: 'Orderstatusprofiler',
    hu: 'Rendelési Állapot Profilok',
    da: 'Ordrestatusprofiler',
    fi: 'Tilauksen Tilan Profiilit',
    sk: 'Profily Stavu Objednávky',
    bg: 'Профили на Статуса на Поръчката',
    hr: 'Profili Statusa Narudžbe',
    lt: 'Užsakymo Būsenos Profiliai',
    lv: 'Pasūtījuma Statusa Profili',
    et: 'Tellimuse Oleku Profiilid',
    sl: 'Profili Stanja Naročila',
    ga: 'Próifílí Stádais Ordaithe',
    mt: 'Profili tal-Istatus tal-Ordnijiet',
    cy: 'Proffiliau Statws Archeb',
    ro: 'Profiluri Stare Comandă',
    it: 'Profili Stato Ordine',
    zh_cn: '订单状态配置',
    hi: 'ऑर्डर स्थिति प्रोफ़ाइल',
    ar: 'ملفات حالة الطلب',
    bn: 'অর্ডার স্ট্যাটাস প্রোফাইলসমূহ',
    ru: 'Профили Статуса Заказа',
    ja: '注文ステータスプロファイル',
    tr: 'Sipariş Durumu Profilleri',
    ko: '주문 상태 프로필',
    vi: 'Hồ sơ Trạng thái Đơn hàng',
    id: 'Profil Status Pesanan',
    th: 'โปรไฟล์สถานะคำสั่งซื้อ',
    ms: 'Profil Status Pesanan',
    ar_eg: 'ملفات حالة الأوردر',
    uk: 'Профілі Статусу Замовлення',
  },
  table_map: {
    en: 'Table Map',
    es: 'Mapa de mesas',
    fr: 'Plan des tables',
    de: 'Tischplan',
    pt: 'Mapa de mesas',
    pl: 'Mapa stolików',
    nl: 'Tafelkaart',
    el: 'Χάρτης τραπεζιών',
    cs: 'Mapa stolů',
    sv: 'Bordsplan',
    hu: 'Asztaltérkép',
    da: 'Bordkort',
    fi: 'Pöytäkartta',
    sk: 'Mapa stolov',
    bg: 'Карта на масите',
    hr: 'Mapa stolova',
    lt: 'Stalų žemėlapis',
    lv: 'Galdu karte',
    et: 'Lauakaart',
    sl: 'Zemljevid miz',
    ga: 'Léarscáil táblaí',
    mt: 'Mappa tal-imwejjed',
    cy: 'Map byrddau',
    ro: 'Harta meselor',
    it: 'Mappa dei tavoli',
    zh_cn: '桌位地图',
    hi: 'टेबल मैप',
    ar: 'خريطة الطاولات',
    bn: 'টেবিল ম্যাপ',
    ru: 'Карта столов',
    ja: 'テーブルマップ',
    tr: 'Masa Haritası',
    ko: '테이블 맵',
    vi: 'Sơ đồ bàn',
    id: 'Peta meja',
    th: 'แผนผังโต๊ะ',
    ms: 'Peta meja',
    ar_eg: 'خريطة الطاولات',
    uk: 'Карта столів',
  },
  table_map_setup: {
    en: 'Table Map Setup',
    es: 'Configuración del mapa de mesas',
    fr: 'Configuration du plan de tables',
    de: 'Tischplan-Einrichtung',
    pt: 'Configuração do mapa de mesas',
    pl: 'Konfiguracja mapy stolików',
    nl: 'Tafelkaart instellen',
    el: 'Ρύθμιση χάρτη τραπεζιών',
    cs: 'Nastavení mapy stolů',
    sv: 'Konfiguration av bordsplan',
    hu: 'Asztaltérkép beállítása',
    da: 'Opsætning af bordkort',
    fi: 'Pöytäkartan asetukset',
    sk: 'Nastavenie mapy stolov',
    bg: 'Настройка на карта на масите',
    hr: 'Postavljanje mape stolova',
    lt: 'Stalų žemėlapio nustatymas',
    lv: 'Galdu kartes iestatīšana',
    et: 'Lauakaardi seadistamine',
    sl: 'Nastavitev zemljevida miz',
    ga: 'Socrú léarscáil táblaí',
    mt: 'Setup tal-mappa tal-imwejjed',
    cy: 'Sefydlu map bwrdd',
    ro: 'Configurare hartă mese',
    it: 'Configurazione mappa tavoli',
    zh_cn: '桌位地图设置',
    hi: 'टेबल मैप सेटअप',
    ar: 'إعداد خريطة الطاولات',
    bn: 'টেবিল ম্যাপ সেটআপ',
    ru: 'Настройка карты столов',
    ja: 'テーブルマップの設定',
    tr: 'Masa Haritası Kurulumu',
    ko: '테이블 맵 설정',
    vi: 'Thiết lập sơ đồ bàn',
    id: 'Pengaturan peta meja',
    th: 'ตั้งค่าแผนผังโต๊ะ',
    ms: 'Persediaan peta meja',
    ar_eg: 'إعداد خريطة الطاولات',
    uk: 'Налаштування карти столів',
  },
  table_reservation: {
    en: 'Table Reservation',
    es: 'Reserva de mesa',
    fr: 'Réservation de table',
    de: 'Tischreservierung',
    pt: 'Reserva de mesa',
    pl: 'Rezerwacja stolika',
    nl: 'Tafelreservering',
    el: 'Κράτηση τραπεζιού',
    cs: 'Rezervace stolu',
    sv: 'Bordsbokning',
    hu: 'Asztalfoglalás',
    da: 'Bordreservation',
    fi: 'Pöytävaraus',
    sk: 'Rezervácia stola',
    bg: 'Резервация на маса',
    hr: 'Rezervacija stola',
    lt: 'Staliuko rezervacija',
    lv: 'Galdiņa rezervācija',
    et: 'Laua broneerimine',
    sl: 'Rezervacija mize',
    ga: 'Áirithint boird',
    mt: "Riżervazzjoni ta' mejda",
    cy: 'Archebu bwrdd',
    ro: 'Rezervare masă',
    it: 'Prenotazione tavolo',
    zh_cn: '餐桌预订',
    hi: 'टेबल आरक्षण',
    ar: 'حجز طاولة',
    bn: 'টেবিল রিজার্ভেশন',
    ru: 'Бронирование стола',
    ja: 'テーブル予約',
    tr: 'Masa Rezervasyonu',
    ko: '테이블 예약',
    vi: 'Đặt bàn',
    id: 'Reservasi Meja',
    th: 'การจองโต๊ะ',
    ms: 'Tempahan Meja',
    ar_eg: 'حجز ترابيزة',
    uk: 'Бронювання столу',
  },
  confirm: {
    en: 'Confirm',
    es: 'Confirmar',
    fr: 'Confirmer',
    de: 'Bestätigen',
    pt: 'Confirmar',
    pl: 'Potwierdź',
    nl: 'Bevestigen',
    el: 'Επιβεβαίωση',
    cs: 'Potvrdit',
    sv: 'Bekräfta',
    hu: 'Megerősítés',
    da: 'Bekræft',
    fi: 'Vahvista',
    sk: 'Potvrdiť',
    bg: 'Потвърди',
    hr: 'Potvrdi',
    lt: 'Patvirtinti',
    lv: 'Apstiprināt',
    et: 'Kinnita',
    sl: 'Potrdi',
    ga: 'Deimhnigh',
    mt: 'Ikkonferma',
    cy: 'Cadarnhau',
    ro: 'Confirmă',
    it: 'Conferma',
    zh_cn: '确认',
    hi: 'पुष्टि करें',
    ar: 'تأكيد',
    bn: 'নিশ্চিত করুন',
    ru: 'Подтвердить',
    ja: '確認',
    tr: 'Onayla',
    ko: '확인',
    vi: 'Xác nhận',
    id: 'Konfirmasi',
    th: 'ยืนยัน',
    ms: 'Sahkan',
    ar_eg: 'تأكيد',
    uk: 'Підтвердити',
  },
  order_fees_and_extra_cost: {
    en: 'Order Fees & Extra Cost',
    es: 'Tasas del Pedido y Costes Adicionales',
    fr: 'Frais de Commande et Coûts Supplémentaires',
    de: 'Bestellgebühren und Zusatzkosten',
    pt: 'Taxas do Pedido e Custos Adicionais',
    pl: 'Opłaty za Zamówienie i Dodatkowe Koszty',
    nl: 'Bestelkosten en Extra Kosten',
    el: 'Χρεώσεις Παραγγελίας και Επιπλέον Κόστος',
    cs: 'Poplatky za Objednávku a Dodatečné Náklady',
    sv: 'Orderavgifter och Extra Kostnader',
    hu: 'Rendelési Díjak és További Költségek',
    da: 'Ordregebyrer og Ekstra Omkostninger',
    fi: 'Tilausmaksut ja Lisäkustannukset',
    sk: 'Poplatky za Objednávku a Dodatočné Náklady',
    bg: 'Такси за Поръчка и Допълнителни Разходи',
    hr: 'Naknade za Narudžbu i Dodatni Troškovi',
    lt: 'Užsakymo Mokesčiai ir Papildomos Išlaidos',
    lv: 'Pasūtījuma Maksas un Papildu Izmaksas',
    et: 'Tellimuse Tasud ja Lisakulud',
    sl: 'Pristojbine za Naročilo in Dodatni Stroški',
    ga: 'Táillí Ordaithe agus Costais Bhreise',
    mt: 'Miżati tal-Ordni u Spejjeż Żejda',
    cy: 'Ffioedd Archeb a Chostau Ychwanegol',
    ro: 'Taxe de Comandă și Costuri Suplimentare',
    it: 'Commissioni dell’Ordine e Costi Aggiuntivi',
    zh_cn: '订单费用和额外成本',
    hi: 'ऑर्डर शुल्क और अतिरिक्त लागत',
    ar: 'رسوم الطلب والتكاليف الإضافية',
    bn: 'অর্ডার ফি ও অতিরিক্ত খরচ',
    ru: 'Сборы за Заказ и Дополнительные Расходы',
    ja: '注文手数料と追加費用',
    tr: 'Sipariş Ücretleri ve Ek Maliyetler',
    ko: '주문 수수료 및 추가 비용',
    vi: 'Phí Đơn hàng và Chi phí Bổ sung',
    id: 'Biaya Pesanan dan Biaya Tambahan',
    th: 'ค่าธรรมเนียมคำสั่งซื้อและค่าใช้จ่ายเพิ่มเติม',
    ms: 'Yuran Pesanan dan Kos Tambahan',
    ar_eg: 'رسوم الطلب والتكاليف الإضافية',
    uk: 'Збори за Замовлення та Додаткові Витрати',
  },
  unassigned: {
    en: 'Unassigned',
    es: 'Sin asignar',
    fr: 'Non attribué',
    de: 'Nicht zugewiesen',
    pt: 'Não atribuído',
    pl: 'Nieprzypisane',
    nl: 'Niet toegewezen',
    el: 'Μη ανατεθειμένο',
    cs: 'Nepřiřazeno',
    sv: 'Ej tilldelad',
    hu: 'Nincs hozzárendelve',
    da: 'Ikke tildelt',
    fi: 'Määrittämätön',
    sk: 'Nepriradené',
    bg: 'Неприсвоено',
    hr: 'Nedodijeljeno',
    lt: 'Nepriskirta',
    lv: 'Nepiešķirts',
    et: 'Määramata',
    sl: 'Nedodeljeno',
    ga: 'Neamhshannta',
    mt: 'Mhux assenjat',
    cy: 'Heb ei aseinio',
    ro: 'Neatribuit',
    it: 'Non assegnato',
    zh_cn: '未分配',
    hi: 'असाइन नहीं किया गया',
    ar: 'غير معيّن',
    bn: 'অ্যাসাইন করা হয়নি',
    ru: 'Не назначено',
    ja: '未割り当て',
    tr: 'Atanmamış',
    ko: '할당되지 않음',
    vi: 'Chưa được gán',
    id: 'Belum ditetapkan',
    th: 'ยังไม่ได้กำหนด',
    ms: 'Belum ditetapkan',
    ar_eg: 'غير معيّن',
    uk: 'Не призначено',
  },
  item_has_been_selected: {
    en: '%s Item has been selected',
    es: '%s Artículo ha sido seleccionado',
    fr: '%s Article a été sélectionné',
    de: '%s Artikel wurde ausgewählt',
    pt: '%s Item foi selecionado',
    pl: '%s Element został wybrany',
    nl: '%s Item is geselecteerd',
    el: '%s Αντικείμενο έχει επιλεγεί',
    cs: '%s Položka byla vybrána',
    sv: '%s Artikel har valts',
    hu: '%s Tétel ki van választva',
    da: '%s Vare er blevet valgt',
    fi: '%s Kohde on valittu',
    sk: '%s Položka bola vybraná',
    bg: '%s Елемент е избран',
    hr: '%s Stavka je odabrana',
    lt: '%s Elementas pasirinktas',
    lv: '%s Vienums ir izvēlēts',
    et: '%s Üksus on valitud',
    sl: '%s Element je izbran',
    ga: '%s Mír roghnaithe',
    mt: '%s Oġġett intgħażel',
    cy: '%s Eitem wedi’i dewis',
    ro: '%s Articol a fost selectat',
    it: '%s Articolo è stato selezionato',
    zh_cn: '已选择 %s 项',
    hi: '%s आइटम चयनित किया गया है',
    ar: 'تم تحديد %s عنصر',
    bn: '%s আইটেম নির্বাচিত হয়েছে',
    ru: '%s Элемент выбран',
    ja: '%s 件のアイテムが選択されました',
    tr: '%s Öğe seçildi',
    ko: '%s 개 항목이 선택되었습니다',
    vi: '%s Mục đã được chọn',
    id: '%s Item telah dipilih',
    th: 'เลือกแล้ว %s รายการ',
    ms: '%s Item telah dipilih',
    ar_eg: 'تم تحديد %s عنصر',
    uk: '%s Елемент вибрано',
  },
  items_have_been_selected: {
    en: '%s Items have been selected',
    es: '%s Artículos han sido seleccionados',
    fr: '%s Articles ont été sélectionnés',
    de: '%s Artikel wurden ausgewählt',
    pt: '%s Itens foram selecionados',
    pl: '%s Elementy zostały wybrane',
    nl: '%s Items zijn geselecteerd',
    el: '%s Αντικείμενα έχουν επιλεγεί',
    cs: '%s Položky byly vybrány',
    sv: '%s Artiklar har valts',
    hu: '%s Tétel ki van választva',
    da: '%s Varer er blevet valgt',
    fi: '%s Kohdetta on valittu',
    sk: '%s Položky boli vybrané',
    bg: '%s Елементи са избрани',
    hr: '%s Stavke su odabrane',
    lt: '%s Elementai pasirinkti',
    lv: '%s Vienumi ir izvēlēti',
    et: '%s Üksused on valitud',
    sl: '%s Elementi so izbrani',
    ga: '%s Míreanna roghnaithe',
    mt: '%s Oġġetti ntgħażlu',
    cy: '%s Eitemau wedi’u dewis',
    ro: '%s Articole au fost selectate',
    it: '%s Articoli sono stati selezionati',
    zh_cn: '已选择 %s 项',
    hi: '%s आइटम चयनित किए गए हैं',
    ar: 'تم تحديد %s عناصر',
    bn: '%s আইটেম নির্বাচিত হয়েছে',
    ru: '%s Элементов выбрано',
    ja: '%s 件のアイテムが選択されました',
    tr: '%s Öğe seçildi',
    ko: '%s 개 항목이 선택되었습니다',
    vi: '%s Mục đã được chọn',
    id: '%s Item telah dipilih',
    th: 'เลือกแล้ว %s รายการ',
    ms: '%s Item telah dipilih',
    ar_eg: 'تم تحديد %s عناصر',
    uk: '%s Елементів вибрано',
  },
  preview: {
    en: 'Preview',
    es: 'Vista previa',
    fr: 'Aperçu',
    de: 'Vorschau',
    pt: 'Pré-visualização',
    pl: 'Podgląd',
    nl: 'Voorbeeld',
    el: 'Προεπισκόπηση',
    cs: 'Náhled',
    sv: 'Förhandsgranskning',
    hu: 'Előnézet',
    da: 'Forhåndsvisning',
    fi: 'Esikatselu',
    sk: 'Náhľad',
    bg: 'Преглед',
    hr: 'Pregled',
    lt: 'Peržiūra',
    lv: 'Priekšskatījums',
    et: 'Eelvaade',
    sl: 'Predogled',
    ga: 'Réamhamharc',
    mt: 'Previżjoni',
    cy: 'Rhagolwg',
    ro: 'Previzualizare',
    it: 'Anteprima',
    zh_cn: '预览',
    hi: 'पूर्वावलोकन',
    ar: 'معاينة',
    bn: 'প্রিভিউ',
    ru: 'Предпросмотр',
    ja: 'プレビュー',
    tr: 'Önizleme',
    ko: '미리보기',
    vi: 'Xem trước',
    id: 'Pratinjau',
    th: 'ตัวอย่าง',
    ms: 'Pratonton',
    ar_eg: 'معاينة',
    uk: 'Попередній перегляд',
  },
  export_csv: {
    en: 'Export CSV',
    es: 'Exportar CSV',
    fr: 'Exporter CSV',
    de: 'CSV exportieren',
    pt: 'Exportar CSV',
    pl: 'Eksportuj CSV',
    nl: 'CSV exporteren',
    el: 'Εξαγωγή CSV',
    cs: 'Exportovat CSV',
    sv: 'Exportera CSV',
    hu: 'CSV exportálása',
    da: 'Eksportér CSV',
    fi: 'Vie CSV',
    sk: 'Exportovať CSV',
    bg: 'Експортиране на CSV',
    hr: 'Izvezi CSV',
    lt: 'Eksportuoti CSV',
    lv: 'Eksportēt CSV',
    et: 'Ekspordi CSV',
    sl: 'Izvozi CSV',
    ga: 'Easpórtáil CSV',
    mt: 'Esporta CSV',
    cy: 'Allforio CSV',
    ro: 'Exportă CSV',
    it: 'Esporta CSV',
    zh_cn: '导出 CSV',
    hi: 'CSV निर्यात करें',
    ar: 'تصدير CSV',
    bn: 'CSV এক্সপোর্ট করুন',
    ru: 'Экспорт CSV',
    ja: 'CSVをエクスポート',
    tr: 'CSV Dışa Aktar',
    ko: 'CSV 내보내기',
    vi: 'Xuất CSV',
    id: 'Ekspor CSV',
    th: 'ส่งออก CSV',
    ms: 'Eksport CSV',
    ar_eg: 'تصدير CSV',
    uk: 'Експорт CSV',
  },
  verifactu_monitoring: {
    en: 'VeriFactu Monitoring',
    es: 'Supervisión de VeriFactu',
    fr: 'Suivi VeriFactu',
    de: 'VeriFactu-Überwachung',
    pt: 'Monitorização VeriFactu',
    pl: 'Monitorowanie VeriFactu',
    nl: 'VeriFactu-monitoring',
    el: 'Παρακολούθηση VeriFactu',
    cs: 'Monitorování VeriFactu',
    sv: 'VeriFactu-övervakning',
    hu: 'VeriFactu-figyelés',
    da: 'VeriFactu-overvågning',
    fi: 'VeriFactu-valvonta',
    sk: 'Monitorovanie VeriFactu',
    bg: 'Наблюдение на VeriFactu',
    hr: 'Praćenje VeriFactu',
    lt: 'VeriFactu stebėjimas',
    lv: 'VeriFactu uzraudzība',
    et: 'VeriFactu jälgimine',
    sl: 'Spremljanje VeriFactu',
    ga: 'Monatóireacht VeriFactu',
    mt: 'Monitoraġġ VeriFactu',
    cy: 'Monitro VeriFactu',
    ro: 'Monitorizare VeriFactu',
    it: 'Monitoraggio VeriFactu',
    zh_cn: 'VeriFactu 监控',
    hi: 'VeriFactu निगरानी',
    ar: 'مراقبة VeriFactu',
    bn: 'VeriFactu পর্যবেক্ষণ',
    ru: 'Мониторинг VeriFactu',
    ja: 'VeriFactu モニタリング',
    tr: 'VeriFactu İzleme',
    ko: 'VeriFactu 모니터링',
    vi: 'Giám sát VeriFactu',
    id: 'Pemantauan VeriFactu',
    th: 'การตรวจสอบ VeriFactu',
    ms: 'Pemantauan VeriFactu',
    ar_eg: 'مراقبة VeriFactu',
    uk: 'Моніторинг VeriFactu',
  },
  unknown: {
    en: 'Unknown',
    es: 'Desconocido',
    fr: 'Inconnu',
    de: 'Unbekannt',
    pt: 'Desconhecido',
    pl: 'Nieznany',
    nl: 'Onbekend',
    el: 'Άγνωστο',
    cs: 'Neznámé',
    sv: 'Okänd',
    hu: 'Ismeretlen',
    da: 'Ukendt',
    fi: 'Tuntematon',
    sk: 'Neznáme',
    bg: 'Неизвестно',
    hr: 'Nepoznato',
    lt: 'Nežinoma',
    lv: 'Nezināms',
    et: 'Teadmata',
    sl: 'Neznano',
    ga: 'Anaithnid',
    mt: 'Mhux Magħruf',
    cy: 'Anhysbys',
    ro: 'Necunoscut',
    it: 'Sconosciuto',
    zh_cn: '未知',
    hi: 'अज्ञात',
    ar: 'غير معروف',
    bn: 'অজানা',
    ru: 'Неизвестно',
    ja: '不明',
    tr: 'Bilinmiyor',
    ko: '알 수 없음',
    vi: 'Không xác định',
    id: 'Tidak diketahui',
    th: 'ไม่ทราบ',
    ms: 'Tidak diketahui',
    ar_eg: 'غير معروف',
    uk: 'Невідомо',
  },
  date_and_time: {
    en: 'Date & Time',
    es: 'Fecha y Hora',
    fr: 'Date et Heure',
    de: 'Datum & Uhrzeit',
    pt: 'Data e Hora',
    pl: 'Data i Godzina',
    nl: 'Datum en Tijd',
    el: 'Ημερομηνία & Ώρα',
    cs: 'Datum a Čas',
    sv: 'Datum & Tid',
    hu: 'Dátum és Idő',
    da: 'Dato og Tid',
    fi: 'Päivämäärä ja Aika',
    sk: 'Dátum a Čas',
    bg: 'Дата и Час',
    hr: 'Datum i Vrijeme',
    lt: 'Data ir Laikas',
    lv: 'Datums un Laiks',
    et: 'Kuupäev ja Kellaaeg',
    sl: 'Datum in Čas',
    ga: 'Dáta & Am',
    mt: 'Data u Ħin',
    cy: 'Dyddiad a’r Amser',
    ro: 'Data și Ora',
    it: 'Data e Ora',
    zh_cn: '日期和时间',
    hi: 'तारीख और समय',
    ar: 'التاريخ والوقت',
    bn: 'তারিখ এবং সময়',
    ru: 'Дата и Время',
    ja: '日付と時刻',
    tr: 'Tarih ve Saat',
    ko: '날짜 및 시간',
    vi: 'Ngày & Giờ',
    id: 'Tanggal & Waktu',
    th: 'วันที่และเวลา',
    ms: 'Tarikh & Masa',
    ar_eg: 'التاريخ والوقت',
    uk: 'Дата та Час',
  },
  last_edited_date: {
    en: 'Last Edited Date',
    es: 'Fecha de Última Edición',
    fr: 'Date de Dernière Modification',
    de: 'Datum der letzten Bearbeitung',
    pt: 'Data da Última Edição',
    pl: 'Data Ostatniej Edycji',
    nl: 'Datum Laatst Bewerkt',
    el: 'Ημερομηνία Τελευταίας Επεξεργασίας',
    cs: 'Datum Poslední Úpravy',
    sv: 'Datum för Senaste Redigering',
    hu: 'Utolsó Szerkesztés Dátuma',
    da: 'Dato for Seneste Redigering',
    fi: 'Viimeisimmän Muokkauksen Päivämäärä',
    sk: 'Dátum Poslednej Úpravy',
    bg: 'Дата на Последна Редакция',
    hr: 'Datum Zadnje Izmjene',
    lt: 'Paskutinio Redagavimo Data',
    lv: 'Pēdējās Rediģēšanas Datums',
    et: 'Viimase Muutmise Kuupäev',
    sl: 'Datum Zadnje Urejanja',
    ga: 'Dáta an Eagair Dheireanaigh',
    mt: 'Data tal-Aħħar Editjar',
    cy: 'Dyddiad Diwygio Diwethaf',
    ro: 'Data Ultimei Editări',
    it: "Data dell'Ultima Modifica",
    zh_cn: '最后编辑日期',
    hi: 'अंतिम संपादन तिथि',
    ar: 'تاريخ آخر تعديل',
    bn: 'সর্বশেষ সম্পাদনার তারিখ',
    ru: 'Дата Последнего Редактирования',
    ja: '最終編集日',
    tr: 'Son Düzenleme Tarihi',
    ko: '최종 수정 날짜',
    vi: 'Ngày Chỉnh Sửa Cuối Cùng',
    id: 'Tanggal Terakhir Diedit',
    th: 'วันที่แก้ไขล่าสุด',
    ms: 'Tarikh Suntingan Terakhir',
    ar_eg: 'تاريخ آخر تعديل',
    uk: 'Дата Останнього Редагування',
  },
  filter_by: {
    en: 'Filter by',
    es: 'Filtrar por',
    fr: 'Filtrer par',
    de: 'Filtern nach',
    pt: 'Filtrar por',
    pl: 'Filtruj według',
    nl: 'Filteren op',
    el: 'Φιλτράρισμα κατά',
    cs: 'Filtrovat podle',
    sv: 'Filtrera efter',
    hu: 'Szűrés',
    da: 'Filtrer efter',
    fi: 'Suodata',
    sk: 'Filtrovať podľa',
    bg: 'Филтриране по',
    hr: 'Filtriraj po',
    lt: 'Filtruoti pagal',
    lv: 'Filtrēt pēc',
    et: 'Filtreeri',
    sl: 'Filtriraj po',
    ga: 'Scag de réir',
    mt: 'Iffiltra skont',
    cy: 'Hidlo yn ôl',
    ro: 'Filtrează după',
    it: 'Filtra per',
    zh_cn: '按条件筛选',
    hi: 'फ़िल्टर करें',
    ar: 'تصفية حسب',
    bn: 'ফিল্টার করুন',
    ru: 'Фильтр по',
    ja: 'フィルター',
    tr: 'Filtrele',
    ko: '필터',
    vi: 'Lọc theo',
    id: 'Filter berdasarkan',
    th: 'กรองตาม',
    ms: 'Tapis mengikut',
    ar_eg: 'تصفية حسب',
    uk: 'Фільтр за',
  },
  filtered_by: {
    en: 'Filtered by',
    es: 'Filtrado por',
    fr: 'Filtré par',
    de: 'Gefiltert nach',
    pt: 'Filtrado por',
    pl: 'Filtrowane według',
    nl: 'Gefilterd op',
    el: 'Φιλτραρισμένο κατά',
    cs: 'Filtrováno podle',
    sv: 'Filtrerat efter',
    hu: 'Szűrve ez alapján',
    da: 'Filtreret efter',
    fi: 'Suodatettu kohteella',
    sk: 'Filtrované podľa',
    bg: 'Филтрирано по',
    hr: 'Filtrirano po',
    lt: 'Filtruota pagal',
    lv: 'Filtrēts pēc',
    et: 'Filtreeritud alusel',
    sl: 'Filtrirano po',
    ga: 'Scagtha de réir',
    mt: 'Iffiltrat skont',
    cy: 'Wedi’i hidlo yn ôl',
    ro: 'Filtrat după',
    it: 'Filtrato per',
    zh_cn: '筛选条件',
    hi: 'इसके अनुसार फ़िल्टर किया गया',
    ar: 'تمت التصفية حسب',
    bn: 'ফিল্টার করা হয়েছে',
    ru: 'Отфильтровано по',
    ja: '絞り込み条件',
    tr: 'Şuna göre filtrelendi',
    ko: '필터 기준',
    vi: 'Được lọc theo',
    id: 'Difilter berdasarkan',
    th: 'กรองตาม',
    ms: 'Ditapis mengikut',
    ar_eg: 'تمت التصفية حسب',
    uk: 'Відфільтровано за',
  },
  apply: {
    en: 'Apply',
    es: 'Aplicar',
    fr: 'Appliquer',
    de: 'Anwenden',
    pt: 'Aplicar',
    pl: 'Zastosuj',
    nl: 'Toepassen',
    el: 'Εφαρμογή',
    cs: 'Použít',
    sv: 'Använd',
    hu: 'Alkalmaz',
    da: 'Anvend',
    fi: 'Käytä',
    sk: 'Použiť',
    bg: 'Приложи',
    hr: 'Primijeni',
    lt: 'Taikyti',
    lv: 'Piemērot',
    et: 'Rakenda',
    sl: 'Uporabi',
    ga: 'Cur i bhFeidhm',
    mt: 'Applika',
    cy: 'Gosod',
    ro: 'Aplică',
    it: 'Applica',
    zh_cn: '应用',
    hi: 'लागू करें',
    ar: 'تطبيق',
    bn: 'প্রয়োগ করুন',
    ru: 'Применить',
    ja: '適用',
    tr: 'Uygula',
    ko: '적용',
    vi: 'Áp dụng',
    id: 'Terapkan',
    th: 'นำไปใช้',
    ms: 'Gunakan',
    ar_eg: 'تطبيق',
    uk: 'Застосувати',
  },
  clear_all: {
    en: 'Clear All',
    es: 'Borrar Todo',
    fr: 'Tout Effacer',
    de: 'Alles Löschen',
    pt: 'Limpar Tudo',
    pl: 'Wyczyść Wszystko',
    nl: 'Alles Wissen',
    el: 'Εκκαθάριση Όλων',
    cs: 'Vymazat Vše',
    sv: 'Rensa Allt',
    hu: 'Összes Törlése',
    da: 'Ryd Alt',
    fi: 'Tyhjennä Kaikki',
    sk: 'Vymazať Všetko',
    bg: 'Изчисти Всичко',
    hr: 'Obriši Sve',
    lt: 'Išvalyti Visk',
    lv: 'Notīrīt Visu',
    et: 'Tühjenda Kõik',
    sl: 'Počisti Vse',
    ga: 'Glan Uile',
    mt: 'Ħassar Kollox',
    cy: 'Clirio Popeth',
    ro: 'Șterge Tot',
    it: 'Cancella Tutto',
    zh_cn: '清除全部',
    hi: 'सभी साफ़ करें',
    ar: 'مسح الكل',
    bn: 'সব সাফ করুন',
    ru: 'Очистить Всё',
    ja: 'すべてクリア',
    tr: 'Tümünü Temizle',
    ko: '모두 지우기',
    vi: 'Xóa Tất Cả',
    id: 'Hapus Semua',
    th: 'ล้างทั้งหมด',
    ms: 'Kosongkan Semua',
    ar_eg: 'مسح الكل',
    uk: 'Очистити Все',
  },
  filters_applied: {
    en: 'Filters Applied',
    es: 'Filtros Aplicados',
    fr: 'Filtres Appliqués',
    de: 'Angewendete Filter',
    pt: 'Filtros Aplicados',
    pl: 'Zastosowane Filtry',
    nl: 'Toegepaste Filters',
    el: 'Εφαρμοσμένα Φίλτρα',
    cs: 'Použité Filtry',
    sv: 'Tillämpade Filter',
    hu: 'Alkalmazott Szűrők',
    da: 'Anvendte Filtre',
    fi: 'Käytetyt Suodattimet',
    sk: 'Použité Filtre',
    bg: 'Приложени Филтри',
    hr: 'Primijenjeni Filtri',
    lt: 'Pritaikyti Filtrai',
    lv: 'Piemēroti Filtri',
    et: 'Rakendatud Filtrid',
    sl: 'Uporabljeni Filtri',
    ga: 'Scagairí Curtha i bhFeidhm',
    mt: 'Filtri Applikati',
    cy: "Hidlwyr wedi'u Gosod",
    ro: 'Filtre Aplicate',
    it: 'Filtri Applicati',
    zh_cn: '已应用的筛选条件',
    hi: 'लागू किए गए फ़िल्टर',
    ar: 'الفلاتر المطبقة',
    bn: 'প্রয়োগ করা ফিল্টার',
    ru: 'Применённые Фильтры',
    ja: '適用されたフィルター',
    tr: 'Uygulanan Filtreler',
    ko: '적용된 필터',
    vi: 'Bộ Lọc Đã Áp Dụng',
    id: 'Filter Diterapkan',
    th: 'ตัวกรองที่ใช้',
    ms: 'Penapis Digunakan',
    ar_eg: 'الفلاتر المطبقة',
    uk: 'Застосовані Фільтри',
  },
  variable: {
    en: 'Variable',
    es: 'Variable',
    fr: 'Variable',
    de: 'Variable',
    pt: 'Variável',
    pl: 'Zmienna',
    nl: 'Variabele',
    el: 'Μεταβλητή',
    cs: 'Proměnná',
    sv: 'Variabel',
    hu: 'Változó',
    da: 'Variabel',
    fi: 'Muuttuja',
    sk: 'Premenná',
    bg: 'Променлива',
    hr: 'Varijabla',
    lt: 'Kintamasis',
    lv: 'Mainīgais',
    et: 'Muutuja',
    sl: 'Spremenljivka',
    ga: 'Athróg',
    mt: 'Varjabbli',
    cy: 'Newidyn',
    ro: 'Variabilă',
    it: 'Variabile',
    zh_cn: '变量',
    hi: 'चर',
    ar: 'متغير',
    bn: 'চলক',
    ru: 'Переменная',
    ja: '変数',
    tr: 'Değişken',
    ko: '변수',
    vi: 'Biến',
    id: 'Variabel',
    th: 'ตัวแปร',
    ms: 'Pembolehubah',
    ar_eg: 'متغير',
    uk: 'Змінна',
  },
}

export default translate
